/**
 * Location data for dedicated suburb/city pages.
 * Each entry powers a page at /locations/:slug
 */
const locations = [
  // ─── NEW SOUTH WALES ───────────────────────────────────────────────────────

  {
    slug: "parramatta",
    suburb: "Parramatta",
    state: "NSW",
    postcode: "2150",
    council: "City of Parramatta Council",
    keyRoads: ["Church Street", "Parramatta Road", "Victoria Road", "James Ruse Drive"],
    intro:
      "Parramatta is Sydney's fastest-growing CBD and one of the most active construction corridors in New South Wales. High-density residential towers, major infrastructure upgrades and ongoing light rail works mean traffic management plan documentation is in constant demand and must meet both Transport for NSW and City of Parramatta Council standards.",
    bodyPara:
      "Focus Traffic Plans prepares all traffic management documentation for Parramatta projects with a standard 24-hour turnaround and same-day availability for urgent works.",
    industries: [
      "High-density residential construction",
      "Commercial and mixed-use development",
      "Infrastructure and light rail works",
      "Utility and services maintenance",
      "Government and council projects",
      "Events and public gatherings",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Westmead", "Granville", "Harris Park", "Merrylands", "Rosehill", "Homebush", "Auburn", "Silverwater", "Clyde", "Rydalmere", "North Parramatta", "Woodville"],
  },
  {
    slug: "sydney-cbd",
    suburb: "Sydney CBD",
    state: "NSW",
    postcode: "2000",
    council: "City of Sydney Council",
    keyRoads: ["George Street", "Pitt Street", "Elizabeth Street", "Broadway"],
    intro:
      "Sydney CBD is Australia's most congested urban centre, where even minor roadworks require meticulous traffic management plan documentation to satisfy City of Sydney Council and Transport for NSW requirements. Ongoing metro construction, utility upgrades and commercial fitouts generate a continuous need for compliant TMPs, TGS diagrams and road occupancy licences.",
    bodyPara:
      "Focus Traffic Plans has deep experience preparing documentation for inner-city Sydney worksites, navigating the strict approval frameworks that apply to the CBD core.",
    industries: [
      "Commercial tower construction",
      "Metro and transport infrastructure",
      "Retail and hospitality fitouts",
      "Utility and services upgrades",
      "Events and film production",
      "Road and footpath maintenance",
      "Government and council projects",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Surry Hills", "Darlinghurst", "Haymarket", "Pyrmont", "Ultimo", "Chippendale", "Woolloomooloo", "The Rocks", "Barangaroo", "Millers Point"],
  },
  {
    slug: "newtown",
    suburb: "Newtown",
    state: "NSW",
    postcode: "2042",
    council: "Inner West Council",
    keyRoads: ["King Street", "Enmore Road", "Erskineville Road", "Missenden Road"],
    intro:
      "Newtown's King Street is one of Sydney's busiest and most character-rich retail strips. Its narrow streets, high pedestrian volumes and constant utility and construction works make traffic management here a specialist task requiring detailed plans that account for the unique demands of inner-city Sydney environments.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs and TGS diagrams for Newtown projects, including complex pedestrian management plans for King Street and surrounding laneways.",
    industries: [
      "Residential and commercial construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Event traffic management",
      "Retail and hospitality fitouts",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Erskineville", "St Peters", "Glebe", "Camperdown", "Marrickville", "Enmore", "Redfern", "Chippendale", "Annandale", "Leichhardt"],
  },
  {
    slug: "north-sydney",
    suburb: "North Sydney",
    state: "NSW",
    postcode: "2060",
    council: "North Sydney Council",
    keyRoads: ["Pacific Highway", "Miller Street", "Berry Street", "Ridge Street"],
    intro:
      "North Sydney is a major commercial district directly across the harbour from the CBD, experiencing significant densification as older office towers are converted and new residential towers rise. The combination of steep terrain, high traffic volumes and proximity to key arterials makes TMP documentation here both essential and technically demanding.",
    bodyPara:
      "Focus Traffic Plans regularly prepares road occupancy licences and construction TMPs for North Sydney Council projects, with experience managing the unique constraints of the lower north shore road network.",
    industries: [
      "Commercial tower refurbishment",
      "High-density residential construction",
      "Utility and services upgrades",
      "Retail and hospitality fitouts",
      "Government and council projects",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Crows Nest", "St Leonards", "Neutral Bay", "Kirribilli", "Lavender Bay", "Milsons Point", "Cammeray", "Waverton", "McMahons Point", "Wollstonecraft"],
  },
  {
    slug: "chatswood",
    suburb: "Chatswood",
    state: "NSW",
    postcode: "2067",
    council: "Willoughby City Council",
    keyRoads: ["Victoria Avenue", "Pacific Highway", "Mowbray Road", "Fullers Road"],
    intro:
      "Chatswood is one of Sydney's most significant suburban CBDs, with ongoing high-rise residential development, Metro Northwest operations and a dense retail core driving constant demand for traffic management documentation. Willoughby City Council and Transport for NSW apply strict requirements to all works in the Chatswood town centre.",
    bodyPara:
      "Focus Traffic Plans prepares all TMP and TGS documentation for Chatswood construction and maintenance projects, with experience working around the busy Metro station precinct and Victoria Avenue retail strip.",
    industries: [
      "High-density residential construction",
      "Retail and shopping centre development",
      "Metro and transport infrastructure",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Artarmon", "Lane Cove", "Willoughby", "Roseville", "Gordon", "Lindfield", "St Leonards", "Longueville", "Castlecrag", "Middle Cove"],
  },
  {
    slug: "penrith",
    suburb: "Penrith",
    state: "NSW",
    postcode: "2750",
    council: "Penrith City Council",
    keyRoads: ["Great Western Highway", "Mulgoa Road", "High Street", "Castlereagh Road"],
    intro:
      "Penrith is Western Sydney's major regional city and a key growth corridor, with large-scale residential subdivisions, commercial precincts and significant infrastructure investment transforming the area. Traffic management plans for Penrith projects must comply with Penrith City Council requirements and account for the high traffic volumes on the Great Western Highway and surrounding arterials.",
    bodyPara:
      "Focus Traffic Plans supports builders, civil contractors and utilities providers across the Penrith region with fast, council-compliant TMP documentation and permit submissions.",
    industries: [
      "Residential subdivision and development",
      "Commercial and retail construction",
      "Infrastructure and road upgrades",
      "Utility and services maintenance",
      "Industrial and logistics development",
      "Government and council projects",
    ],
    nearbySuburbs: ["Kingswood", "St Marys", "Werrington", "Emu Plains", "Leonay", "Glenmore Park", "South Penrith", "Cambridge Park", "Jamisontown", "Regentville"],
  },
  {
    slug: "liverpool",
    suburb: "Liverpool",
    state: "NSW",
    postcode: "2170",
    council: "Liverpool City Council",
    keyRoads: ["Hume Highway", "Terminus Street", "Elizabeth Drive", "Hoxton Park Road"],
    intro:
      "Liverpool is one of South-Western Sydney's fastest-growing urban centres, with a booming health and education precinct, major residential construction and significant infrastructure investment. The Hume Highway and key arterials through Liverpool require carefully prepared traffic management plans to manage high freight and commuter volumes during roadworks and construction.",
    bodyPara:
      "Focus Traffic Plans works with developers, contractors and council on TMP documentation across the Liverpool LGA, with a strong understanding of the South-West Sydney road network and Liverpool City Council requirements.",
    industries: [
      "Health and hospital construction",
      "Residential development",
      "Commercial and retail projects",
      "Infrastructure and road upgrades",
      "Utility maintenance",
      "Industrial development",
    ],
    nearbySuburbs: ["Moorebank", "Casula", "Miller", "Green Valley", "Warwick Farm", "Carnes Hill", "Prestons", "Lurnea", "Cabramatta", "Chipping Norton"],
  },
  {
    slug: "surry-hills",
    suburb: "Surry Hills",
    state: "NSW",
    postcode: "2010",
    council: "City of Sydney Council",
    keyRoads: ["Crown Street", "Cleveland Street", "Foveaux Street", "Bourke Street"],
    intro:
      "Surry Hills is one of Sydney's most densely populated inner suburbs, where residential conversions, commercial refurbishments and utility works are a constant feature of the streetscape. Its narrow streets and high pedestrian volumes demand detailed pedestrian control plans and TMPs that meet City of Sydney Council's stringent requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Sydney-compliant traffic management documentation for Surry Hills projects, with particular expertise in managing pedestrian-heavy environments on Crown Street and surrounding laneways.",
    industries: [
      "Residential and commercial conversion",
      "Hospitality fitouts",
      "Utility maintenance",
      "Heritage building refurbishment",
      "Road and footpath maintenance",
      "Events and film production",
    ],
    nearbySuburbs: ["Darlinghurst", "Redfern", "Waterloo", "Paddington", "Chippendale", "Alexandria", "Moore Park", "Glebe", "Ultimo", "Newtown"],
  },
  {
    slug: "hornsby",
    suburb: "Hornsby",
    state: "NSW",
    postcode: "2077",
    council: "Hornsby Shire Council",
    keyRoads: ["Pacific Highway", "Peats Ferry Road", "Pennant Hills Road", "Purchase Road"],
    intro:
      "Hornsby serves as the Upper North Shore's major commercial and transport hub, with ongoing residential densification around the train station and significant road upgrade programs across the Shire. Traffic management plans for Hornsby projects must address the complex interchange of Pacific Highway and key local roads while complying with Hornsby Shire Council standards.",
    bodyPara:
      "Focus Traffic Plans provides TMP and council permit documentation for construction and maintenance projects throughout Hornsby and the broader Shire, with fast turnaround to keep projects on schedule.",
    industries: [
      "High-density residential construction",
      "Commercial and retail development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and council works",
      "Educational facility construction",
    ],
    nearbySuburbs: ["Waitara", "Asquith", "Mount Colah", "Beecroft", "Pennant Hills", "Westleigh", "Normanhurst", "Thornleigh", "Wahroonga", "Turramurra"],
  },
  {
    slug: "campbelltown",
    suburb: "Campbelltown",
    state: "NSW",
    postcode: "2560",
    council: "Campbelltown City Council",
    keyRoads: ["Narellan Road", "Hume Highway", "Queen Street", "Appin Road"],
    intro:
      "Campbelltown is South-West Sydney's major regional city and one of the fastest-growing areas in New South Wales, with large-scale residential estates, hospital expansions and significant road infrastructure investment creating a high demand for traffic management plan documentation across the LGA.",
    bodyPara:
      "Focus Traffic Plans supports the Campbelltown construction sector with fast-turnaround TMPs, council permit applications and TGS diagrams compliant with Campbelltown City Council and Transport for NSW requirements.",
    industries: [
      "Residential subdivision and development",
      "Health and hospital expansion",
      "Commercial and retail construction",
      "Road and infrastructure upgrades",
      "Utility and services maintenance",
      "Industrial and logistics development",
    ],
    nearbySuburbs: ["Macquarie Fields", "Minto", "Ingleburn", "Leumeah", "Glenfield", "Narellan", "Currans Hill", "Mount Annan", "Oran Park", "Gregory Hills"],
  },
  {
    slug: "wollongong",
    suburb: "Wollongong",
    state: "NSW",
    postcode: "2500",
    council: "Wollongong City Council",
    keyRoads: ["Crown Street", "Princes Highway", "Church Street", "Kembla Street"],
    intro:
      "Wollongong is the Illawarra's major city and a key industrial and residential centre, with significant port activity, university precincts and coastal development driving ongoing demand for traffic management plan documentation. Wollongong City Council requirements and the complex arterial network between the escarpment and coast require experienced TMP preparation.",
    bodyPara:
      "Focus Traffic Plans provides TMP, TGS and council permit documentation for Wollongong and the broader Illawarra region, supporting the full range of civil, commercial and infrastructure projects.",
    industries: [
      "Industrial and port-related construction",
      "Residential and coastal development",
      "University and educational projects",
      "Infrastructure and road upgrades",
      "Utility maintenance",
      "Commercial and retail development",
    ],
    nearbySuburbs: ["Fairy Meadow", "Thirroul", "Corrimal", "Figtree", "Unanderra", "Port Kembla", "Dapto", "Shellharbour", "Kiama", "Helensburgh"],
  },
  {
    slug: "newcastle",
    suburb: "Newcastle CBD",
    state: "NSW",
    postcode: "2300",
    council: "City of Newcastle Council",
    keyRoads: ["Hunter Street", "King Street", "Darby Street", "Wharf Road"],
    intro:
      "Newcastle CBD is undergoing one of Australia's most significant urban transformations, with the former rail corridor redeveloped into a light rail line, new residential and commercial towers rising along the foreshore and a vibrant arts and hospitality precinct driving constant construction activity that requires comprehensive traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans supports Newcastle's construction boom with fast-turnaround TMP and TGS documentation compliant with City of Newcastle Council and Transport for NSW requirements.",
    industries: [
      "High-density residential construction",
      "Commercial and hospitality development",
      "Light rail and transport infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["Hamilton", "Wickham", "Islington", "Mayfield", "Merewether", "The Junction", "Adamstown", "Wallsend", "Waratah", "Broadmeadow"],
  },
  {
    slug: "manly",
    suburb: "Manly",
    state: "NSW",
    postcode: "2095",
    council: "Northern Beaches Council",
    keyRoads: ["The Corso", "Pittwater Road", "Condamine Street", "Sydney Road"],
    intro:
      "Manly is one of Sydney's most iconic beachside destinations and a busy residential and tourism precinct where construction and maintenance works must be managed with particular care due to high pedestrian volumes, narrow streets and significant seasonal visitor traffic.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant traffic management documentation for Manly projects, with experience managing works in high-pedestrian coastal environments.",
    industries: [
      "Residential and boutique commercial construction",
      "Hospitality and tourism fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Fairlight", "Seaforth", "Balgowlah", "Queenscliff", "Brookvale", "Dee Why", "Narrabeen", "Collaroy", "Freshwater", "Curl Curl"],
  },
  {
    slug: "marrickville",
    suburb: "Marrickville",
    state: "NSW",
    postcode: "2204",
    council: "Inner West Council",
    keyRoads: ["Marrickville Road", "Illawarra Road", "Sydenham Road", "Victoria Road"],
    intro:
      "Marrickville is one of Sydney's most rapidly gentrifying inner suburbs, where industrial-to-residential conversions, new apartment developments and ongoing utility upgrades create a constant need for traffic management plans on narrow streets with high bicycle and pedestrian traffic.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs and pedestrian control plans for Marrickville projects, with an understanding of the unique demands of the Inner West's active transport environment.",
    industries: [
      "Industrial-to-residential conversion",
      "Residential apartment construction",
      "Hospitality and retail fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Sydenham", "Dulwich Hill", "Petersham", "Enmore", "St Peters", "Tempe", "Arncliffe", "Newtown", "Stanmore", "Camperdown"],
  },
  {
    slug: "bondi",
    suburb: "Bondi",
    state: "NSW",
    postcode: "2026",
    council: "Waverley Council",
    keyRoads: ["Campbell Parade", "Bondi Road", "Old South Head Road", "Hall Street"],
    intro:
      "Bondi is one of the world's most recognised beach destinations and a dense residential suburb where construction, utility works and events regularly require detailed traffic management planning. The combination of high tourist volumes, narrow streets and strict Waverley Council requirements makes TMP documentation here particularly demanding.",
    bodyPara:
      "Focus Traffic Plans produces Waverley Council-compliant TMPs and pedestrian control plans for Bondi projects, keeping works on schedule while maintaining safe pedestrian access on Campbell Parade and surrounding streets.",
    industries: [
      "Residential and boutique commercial construction",
      "Hospitality and retail fitouts",
      "Utility maintenance",
      "Events and festivals",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Bondi Junction", "Bondi Beach", "North Bondi", "Tamarama", "Bronte", "Coogee", "Rose Bay", "Double Bay", "Edgecliff", "Bellevue Hill"],
  },

  // ─── NEW SOUTH WALES (additional) ─────────────────────────────────────────

  {
    slug: "alexandria",
    suburb: "Alexandria",
    state: "NSW",
    postcode: "2015",
    council: "City of Sydney Council",
    keyRoads: ["Botany Road", "McEvoy Street", "O'Riordan Street", "Gardeners Road"],
    intro:
      "Alexandria is a rapidly transforming inner-south suburb of Sydney, transitioning from industrial uses to high-density residential and mixed-use development. The suburb's grid of busy arterial roads and proximity to the Sydney Airport precinct means traffic management plans must account for high freight and commuter volumes alongside construction activity.",
    bodyPara:
      "Focus Traffic Plans prepares City of Sydney-compliant TMPs for Alexandria projects, from warehouse conversions and apartment developments to utility upgrades along Botany Road.",
    industries: [
      "Mixed-use and residential development",
      "Industrial to residential conversion",
      "Utility and services maintenance",
      "Warehousing and logistics",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Waterloo", "Beaconsfield", "Erskineville", "St Peters", "Rosebery", "Zetland", "Newtown", "Surry Hills", "Botany", "Mascot"],
  },
  {
    slug: "ashfield",
    suburb: "Ashfield",
    state: "NSW",
    postcode: "2131",
    council: "Inner West Council",
    keyRoads: ["Parramatta Road", "Liverpool Road", "Frederick Street", "Charlotte Street"],
    intro:
      "Ashfield is a busy inner-west suburb sitting on the major Parramatta Road corridor, where ongoing urban renewal and the Sydney Metro West project drive sustained construction activity. Traffic management plans here must navigate the high-volume Parramatta Road environment and comply with Inner West Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles all TMP documentation for Ashfield projects, with specialist knowledge of Parramatta Road traffic conditions and Inner West Council permit requirements.",
    industries: [
      "Residential apartment development",
      "Retail and commercial fitouts",
      "Utility and services upgrades",
      "Road and footpath maintenance",
      "Metro-related civil works",
    ],
    nearbySuburbs: ["Summer Hill", "Croydon", "Burwood", "Strathfield", "Homebush", "Haberfield", "Leichhardt", "Petersham", "Dulwich Hill", "Marrickville"],
  },
  {
    slug: "auburn",
    suburb: "Auburn",
    state: "NSW",
    postcode: "2144",
    council: "Cumberland Council",
    keyRoads: ["Parramatta Road", "Auburn Road", "Duck River Road", "Rawson Street"],
    intro:
      "Auburn is a vibrant western Sydney suburb with a high concentration of residential development, commercial activity and light industrial uses. Its position on the Parramatta Road corridor and proximity to major rail infrastructure creates consistent demand for traffic management planning that meets both Cumberland Council and Transport for NSW standards.",
    bodyPara:
      "Focus Traffic Plans produces Cumberland Council-compliant traffic management documentation for Auburn, covering residential construction, commercial projects and utility works.",
    industries: [
      "Residential and mixed-use development",
      "Commercial construction",
      "Light industrial works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Granville", "Clyde", "Lidcombe", "Berala", "Regents Park", "Merrylands", "Parramatta", "Silverwater", "Woodville", "Chester Hill"],
  },
  {
    slug: "bankstown",
    suburb: "Bankstown",
    state: "NSW",
    postcode: "2200",
    council: "Canterbury-Bankstown Council",
    keyRoads: ["Chapel Road", "Stacey Street", "South Terrace", "The Appian Way"],
    intro:
      "Bankstown is one of south-western Sydney's major activity centres, undergoing significant urban renewal as part of the South West Metro corridor. High-density residential towers, a revitalised town centre and ongoing infrastructure upgrades mean traffic management plan documentation is in constant demand and must meet Canterbury-Bankstown Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares all traffic management documentation for Bankstown projects, with experience across metro-corridor construction, residential development and council infrastructure works.",
    industries: [
      "High-density residential development",
      "Metro corridor civil works",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Lakemba", "Punchbowl", "Greenacre", "Yagoona", "Chester Hill", "Condell Park", "Bass Hill", "Wiley Park", "Campsie", "Revesby"],
  },
  {
    slug: "blacktown",
    suburb: "Blacktown",
    state: "NSW",
    postcode: "2148",
    council: "Blacktown City Council",
    keyRoads: ["Richmond Road", "Main Street", "Flushcombe Road", "Kildare Road"],
    intro:
      "Blacktown is one of the largest and fastest-growing local government areas in Australia, with extensive residential subdivisions, commercial development and major infrastructure upgrades driving continuous demand for traffic management planning. Works must comply with Blacktown City Council and Transport for NSW standards across a wide variety of road environments.",
    bodyPara:
      "Focus Traffic Plans prepares Blacktown City Council-compliant TMPs for all project types across the LGA, from new housing estate roads to commercial centre upgrades.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and footpath construction",
    ],
    nearbySuburbs: ["Seven Hills", "Kings Langley", "Rooty Hill", "Mount Druitt", "Marayong", "Lalor Park", "Quakers Hill", "Parklea", "Stanhope Gardens", "Pendle Hill"],
  },
  {
    slug: "botany",
    suburb: "Botany",
    state: "NSW",
    postcode: "2019",
    council: "Bayside Council",
    keyRoads: ["Botany Road", "Bay Street", "Beauchamp Road", "Foreshore Road"],
    intro:
      "Botany sits adjacent to Port Botany, one of Australia's busiest container terminals, and is subject to significant heavy vehicle movements, industrial development and port-related infrastructure works. Traffic management plans in Botany must account for the unique challenges of high-frequency freight traffic and proximity to airport operations.",
    bodyPara:
      "Focus Traffic Plans produces Bayside Council and port authority-compliant TMPs for Botany projects, managing the complex interface between heavy freight routes, industrial development and residential areas.",
    industries: [
      "Port and logistics infrastructure",
      "Industrial and warehouse development",
      "Utility maintenance",
      "Road and pavement maintenance",
      "Commercial construction",
    ],
    nearbySuburbs: ["Mascot", "Rosebery", "Alexandria", "Eastlakes", "Pagewood", "Hillsdale", "Banksmeadow", "Port Botany", "Kingsford", "Kingsgrove"],
  },
  {
    slug: "burwood",
    suburb: "Burwood",
    state: "NSW",
    postcode: "2134",
    council: "Burwood Council",
    keyRoads: ["Burwood Road", "Parramatta Road", "The Avenue", "Railway Parade"],
    intro:
      "Burwood is a high-density inner-west suburb and a major retail and residential hub, where ongoing apartment development and commercial construction create consistent demand for traffic management planning. Its position on the Parramatta Road corridor and busy town centre environment require careful pedestrian and traffic management documentation.",
    bodyPara:
      "Focus Traffic Plans prepares Burwood Council-compliant TMPs for residential, commercial and utility projects, with experience managing works in the busy Burwood Road retail strip.",
    industries: [
      "High-density residential development",
      "Retail and commercial construction",
      "Utility and services maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Strathfield", "Croydon", "Ashfield", "Homebush", "Flemington", "Enfield", "Concord", "Drummoyne", "Five Dock", "Leichhardt"],
  },
  {
    slug: "canterbury",
    suburb: "Canterbury",
    state: "NSW",
    postcode: "2193",
    council: "Canterbury-Bankstown Council",
    keyRoads: ["Canterbury Road", "Beamish Street", "Cooks River", "Hector Street"],
    intro:
      "Canterbury is a diverse inner-south-west suburb undergoing significant residential and commercial renewal, with new apartment developments and ongoing Cooks River corridor improvements driving demand for traffic management plan documentation compliant with Canterbury-Bankstown Council standards.",
    bodyPara:
      "Focus Traffic Plans handles traffic management documentation for Canterbury development and infrastructure projects, navigating the suburb's mix of arterial roads and local residential streets.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Campsie", "Belmore", "Lakemba", "Hurlstone Park", "Dulwich Hill", "Marrickville", "Earlwood", "Roselands", "Kingsgrove", "Punchbowl"],
  },
  {
    slug: "castle-hill",
    suburb: "Castle Hill",
    state: "NSW",
    postcode: "2154",
    council: "The Hills Shire Council",
    keyRoads: ["Old Northern Road", "Castle Street", "Cecil Avenue", "Showground Road"],
    intro:
      "Castle Hill is the commercial and residential heart of The Hills Shire, experiencing rapid growth driven by the Sydney Metro Northwest line and a major town centre redevelopment. High-density residential towers and a revitalised retail precinct create strong ongoing demand for traffic management plans meeting The Hills Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares The Hills Shire Council-compliant TMPs for Castle Hill projects, with experience in the metro-corridor construction environment and the suburb's growing residential developments.",
    industries: [
      "High-density residential development",
      "Retail and town centre construction",
      "Metro corridor civil works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Norwest", "Baulkham Hills", "Kellyville", "Rouse Hill", "Cherrybrook", "Dural", "Round Corner", "West Pennant Hills", "Carlingford", "Winston Hills"],
  },
  {
    slug: "cronulla",
    suburb: "Cronulla",
    state: "NSW",
    postcode: "2230",
    council: "Sutherland Shire Council",
    keyRoads: ["Cronulla Street", "Kingsway", "Captain Cook Drive", "Elouera Road"],
    intro:
      "Cronulla is the Sutherland Shire's premier coastal suburb and a busy retail and residential destination, where beachside construction, hospitality fitouts and coastal infrastructure works require carefully considered traffic management plans compliant with Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Sutherland Shire Council-compliant TMPs for Cronulla projects, managing pedestrian flows in the busy beachside retail and entertainment precinct.",
    industries: [
      "Coastal residential development",
      "Hospitality and retail fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
    ],
    nearbySuburbs: ["Caringbah", "Woolooware", "Gymea", "Miranda", "Kurnell", "Burraneer", "Sylvania", "Taren Point", "Kirrawee", "Lilli Pilli"],
  },
  {
    slug: "drummoyne",
    suburb: "Drummoyne",
    state: "NSW",
    postcode: "2047",
    council: "Inner West Council",
    keyRoads: ["Victoria Road", "Lyons Road", "Henley Marine Drive", "Balmain Road"],
    intro:
      "Drummoyne is a sought-after inner-western harbour suburb where residential construction, boutique commercial projects and foreshore works require traffic management plans that carefully manage Victoria Road's high traffic volumes and comply with Inner West Council standards.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs for Drummoyne projects, with specialist knowledge of the Victoria Road corridor's complex traffic environment.",
    industries: [
      "Residential construction",
      "Boutique commercial development",
      "Foreshore and marine works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Five Dock", "Rodd Point", "Abbotsford", "Concord", "Rhodes", "Meadowbank", "Cabarita", "Chiswick", "Russell Lea", "Leichhardt"],
  },
  {
    slug: "eastwood",
    suburb: "Eastwood",
    state: "NSW",
    postcode: "2122",
    council: "Ryde City Council",
    keyRoads: ["Rowe Street", "Marsden Road", "West Parade", "Shaftsbury Road"],
    intro:
      "Eastwood is a vibrant north-western suburb and one of Sydney's major Asian dining and retail precincts, where residential apartment development and commercial construction generate consistent demand for traffic management documentation compliant with Ryde City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Eastwood construction and utility projects, managing the challenges of the suburb's busy retail core and surrounding residential streets.",
    industries: [
      "Residential apartment development",
      "Retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["West Ryde", "Meadowbank", "Carlingford", "Epping", "North Epping", "Denistone", "Ermington", "Ryde", "Putney", "Shepherds Hill"],
  },
  {
    slug: "five-dock",
    suburb: "Five Dock",
    state: "NSW",
    postcode: "2046",
    council: "Inner West Council",
    keyRoads: ["Great North Road", "Lyons Road", "First Avenue", "Kings Road"],
    intro:
      "Five Dock is a well-established inner-western suburb where residential construction, commercial development and ongoing utility upgrades require traffic management plans compliant with Inner West Council standards and considerate of the suburb's arterial road network.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs for Five Dock projects, covering residential builds, retail works and utility maintenance across the suburb.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Drummoyne", "Russell Lea", "Abbotsford", "Rodd Point", "Chiswick", "Burwood", "Croydon Park", "Concord", "Canada Bay", "Leichhardt"],
  },
  {
    slug: "hurstville",
    suburb: "Hurstville",
    state: "NSW",
    postcode: "2220",
    council: "Georges River Council",
    keyRoads: ["Forest Road", "MacMahon Street", "The Avenue", "Park Road"],
    intro:
      "Hurstville is the commercial and administrative heart of the Georges River area, with major retail development, high-density residential towers and ongoing infrastructure upgrades driving strong demand for traffic management planning. Works must comply with Georges River Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Georges River Council-compliant TMPs for Hurstville projects, from high-rise residential construction to retail centre works and council infrastructure upgrades.",
    industries: [
      "High-density residential development",
      "Retail and commercial construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Penshurst", "Allawah", "Carlton", "Kogarah", "Rockdale", "Beverly Hills", "Kingsgrove", "Riverwood", "Peakhurst", "Lugarno"],
  },
  {
    slug: "kogarah",
    suburb: "Kogarah",
    state: "NSW",
    postcode: "2217",
    council: "Georges River Council",
    keyRoads: ["Railway Parade", "Kingsway", "President Avenue", "Belgrave Street"],
    intro:
      "Kogarah is a major health, education and commercial precinct in southern Sydney, anchored by St George Hospital and a growing residential development pipeline. Traffic management plans for Kogarah must address the complex environment created by hospital traffic, a busy train station and surrounding construction activity.",
    bodyPara:
      "Focus Traffic Plans prepares Georges River Council-compliant TMPs for Kogarah projects, with experience managing the unique traffic challenges around St George Hospital and the Kogarah town centre.",
    industries: [
      "Health and hospital infrastructure",
      "Residential apartment development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Rockdale", "Hurstville", "Allawah", "Carlton", "Beverley Park", "Ramsgate", "Sans Souci", "Bexley", "Arncliffe", "Banksia"],
  },
  {
    slug: "macquarie-park",
    suburb: "Macquarie Park",
    state: "NSW",
    postcode: "2113",
    council: "Ryde City Council",
    keyRoads: ["Epping Road", "Herring Road", "Waterloo Road", "Lane Cove Road"],
    intro:
      "Macquarie Park is one of Sydney's most significant technology and education precincts, with major university campuses, research facilities and a rapidly growing residential development corridor along the Sydney Metro Northwest line. Traffic management documentation here must meet Ryde City Council and Transport for NSW requirements in a complex multi-modal environment.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Macquarie Park development projects, with experience in the precinct's demanding construction environment and high pedestrian volumes.",
    industries: [
      "Technology and research campus construction",
      "High-density residential development",
      "Metro corridor civil works",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["North Ryde", "Ryde", "Meadowbank", "Eastwood", "Epping", "West Ryde", "Marsfield", "Lane Cove", "Chatswood", "Artarmon"],
  },
  {
    slug: "miranda",
    suburb: "Miranda",
    state: "NSW",
    postcode: "2228",
    council: "Sutherland Shire Council",
    keyRoads: ["Kingsway", "Miranda Road", "Urunga Parade", "Port Hacking Road"],
    intro:
      "Miranda is the Sutherland Shire's major retail and commercial hub, centred on Westfield Miranda, where retail construction, car park upgrades and surrounding residential development generate consistent demand for traffic management plans compliant with Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sutherland Shire Council-compliant TMPs for Miranda projects, from large-scale retail construction to residential builds in the surrounding suburbs.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Car park and access works",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Caringbah", "Gymea", "Kirrawee", "Sutherland", "Woolooware", "Cronulla", "Taren Point", "Jannali", "Como", "Sylvania"],
  },
  {
    slug: "randwick",
    suburb: "Randwick",
    state: "NSW",
    postcode: "2031",
    council: "Randwick City Council",
    keyRoads: ["Anzac Parade", "Avoca Street", "High Street", "Rainbow Street"],
    intro:
      "Randwick is a major eastern suburbs health, education and residential precinct, home to Prince of Wales Hospital, UNSW and one of Sydney's largest racecourses. Ongoing hospital expansion, university construction and residential development create strong demand for traffic management plans meeting Randwick City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Randwick City Council-compliant TMPs for all project types in Randwick, with specialist knowledge of the precinct's complex pedestrian, hospital and construction traffic environment.",
    industries: [
      "Health and hospital infrastructure",
      "Education and university construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Kensington", "Kingsford", "Coogee", "Clovelly", "Maroubra", "Matraville", "Eastgardens", "Botany", "Redfern", "Zetland"],
  },
  {
    slug: "rhodes",
    suburb: "Rhodes",
    state: "NSW",
    postcode: "2138",
    council: "Canada Bay Council",
    keyRoads: ["Concord Road", "Walker Street", "Blaxland Road", "Rhodes Street"],
    intro:
      "Rhodes is a rapidly transforming peninsula suburb on the Parramatta River, where one of Australia's highest-density residential developments has created ongoing construction activity and infrastructure upgrades. Traffic management plans here must manage the unique challenges of a peninsula road network with limited access points.",
    bodyPara:
      "Focus Traffic Plans prepares Canada Bay Council-compliant TMPs for Rhodes residential and infrastructure projects, with experience navigating the suburb's constrained access environment.",
    industries: [
      "High-density residential construction",
      "Mixed-use development",
      "Infrastructure and civil works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Meadowbank", "Concord", "Drummoyne", "Homebush Bay", "Wentworth Point", "Homebush", "North Strathfield", "Ryde", "Putney", "Silverwater"],
  },
  {
    slug: "rockdale",
    suburb: "Rockdale",
    state: "NSW",
    postcode: "2216",
    council: "Bayside Council",
    keyRoads: ["Princes Highway", "Rocky Point Road", "Bestic Street", "West Botany Street"],
    intro:
      "Rockdale is a busy southern Sydney suburb on the Princes Highway corridor where residential development, commercial construction and utility upgrades generate consistent demand for traffic management documentation compliant with Bayside Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Rockdale projects, with knowledge of the Princes Highway corridor's high traffic volumes and Bayside Council permit requirements.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Arncliffe", "Banksia", "Bardwell Park", "Bexley", "Kogarah", "Carlton", "Wolli Creek", "Mascot", "Brighton-Le-Sands", "Kyeemagh"],
  },
  {
    slug: "strathfield",
    suburb: "Strathfield",
    state: "NSW",
    postcode: "2135",
    council: "Strathfield Municipal Council",
    keyRoads: ["The Boulevard", "Homebush Road", "Parramatta Road", "Albert Road"],
    intro:
      "Strathfield is a well-established inner-western suburb and major transport interchange, where medium and high-density residential development, commercial construction and rail precinct upgrades drive demand for traffic management plans meeting Strathfield Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Strathfield Council-compliant TMPs for residential, commercial and infrastructure projects, with experience across the suburb's arterial and local road network.",
    industries: [
      "Residential and mixed-use development",
      "Commercial construction",
      "Rail and transport infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Homebush", "Burwood", "Croydon", "Ashfield", "North Strathfield", "Flemington", "Concord", "Auburn", "Homebush West", "Greenacre"],
  },
  {
    slug: "westmead",
    suburb: "Westmead",
    state: "NSW",
    postcode: "2145",
    council: "City of Parramatta Council",
    keyRoads: ["Hawkesbury Road", "Darcy Road", "Mons Road", "Westmead Avenue"],
    intro:
      "Westmead is Australia's largest health precinct, home to multiple major hospitals, medical research institutes and the University of Western Sydney. Constant hospital expansion, medical facility construction and associated infrastructure upgrades require highly detailed traffic management plans compliant with City of Parramatta Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Parramatta Council-compliant TMPs for Westmead health and construction projects, with specialist knowledge of hospital precinct traffic management requirements.",
    industries: [
      "Health and hospital infrastructure",
      "Medical research facility construction",
      "Education and university development",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Parramatta", "Wentworthville", "Pendle Hill", "Toongabbie", "Girraween", "Greystanes", "Merrylands", "Woodville", "Mays Hill", "North Parramatta"],
  },
  {
    slug: "wolli-creek",
    suburb: "Wolli Creek",
    state: "NSW",
    postcode: "2205",
    council: "Bayside Council",
    keyRoads: ["Princes Highway", "Arncliffe Street", "King Street", "Tempe Road"],
    intro:
      "Wolli Creek is a high-density residential suburb that has grown rapidly around its train station, with ongoing apartment construction and infrastructure upgrades requiring traffic management documentation compliant with Bayside Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bayside Council-compliant TMPs for Wolli Creek residential and infrastructure projects, managing the suburb's constrained road network and high pedestrian volumes.",
    industries: [
      "High-density residential construction",
      "Mixed-use development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Arncliffe", "Turrella", "Bardwell Park", "Banksia", "Rockdale", "Mascot", "Tempe", "St Peters", "Alexandria", "Marrickville"],
  },
  // Western Sydney (additional)
  {
    slug: "fairfield",
    suburb: "Fairfield",
    state: "NSW",
    postcode: "2165",
    council: "Fairfield City Council",
    keyRoads: ["The Horsley Drive", "Smart Street", "Hamilton Road", "Fairfield Road"],
    intro:
      "Fairfield is a diverse western Sydney suburb and the commercial centre of Fairfield City, where residential development, commercial construction and council infrastructure upgrades create consistent demand for traffic management plans meeting Fairfield City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fairfield projects, with experience across the LGA's residential and commercial construction environment.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Cabramatta", "Canley Vale", "Wetherill Park", "Smithfield", "Bossley Park", "Villawood", "Yennora", "Prairiewood", "Bonnyrigg", "Lansvale"],
  },
  {
    slug: "merrylands",
    suburb: "Merrylands",
    state: "NSW",
    postcode: "2160",
    council: "Cumberland Council",
    keyRoads: ["Merrylands Road", "Cumberland Highway", "McFarlane Street", "Military Road"],
    intro:
      "Merrylands is a busy western Sydney suburb undergoing significant urban renewal, with high-density residential development and commercial construction along the Cumberland Highway corridor creating strong demand for traffic management plans compliant with Cumberland Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Cumberland Council-compliant TMPs for Merrylands residential and commercial projects, with experience in the suburb's growing high-density development environment.",
    industries: [
      "High-density residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Granville", "Guildford", "Woodville", "Pemulwuy", "Wentworthville", "Toongabbie", "Parramatta", "Auburn", "Berala", "Regents Park"],
  },
  {
    slug: "mount-druitt",
    suburb: "Mount Druitt",
    state: "NSW",
    postcode: "2770",
    council: "Blacktown City Council",
    keyRoads: ["Mount Druitt Road", "Carlisle Avenue", "Luxford Road", "Rooty Hill Road"],
    intro:
      "Mount Druitt is a major western Sydney centre undergoing significant infrastructure and residential renewal, with new housing developments, commercial construction and major road upgrades creating ongoing demand for traffic management plans compliant with Blacktown City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Blacktown City Council-compliant TMPs for Mount Druitt projects, covering residential construction, commercial development and infrastructure upgrades.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Rooty Hill", "Bidwill", "Blackett", "Whalan", "Willmot", "Shalvey", "Minchinbury", "Emerton", "Hebersham", "Tregear"],
  },
  {
    slug: "rouse-hill",
    suburb: "Rouse Hill",
    state: "NSW",
    postcode: "2155",
    council: "The Hills Shire Council",
    keyRoads: ["Windsor Road", "Samantha Riley Drive", "Stanhope Parkway", "Memorial Avenue"],
    intro:
      "Rouse Hill is one of Sydney's fastest-growing residential areas, anchored by a major regional shopping centre and well-served by the Sydney Metro Northwest. Rapid residential subdivision, new schools and community infrastructure create high demand for traffic management documentation meeting The Hills Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares The Hills Shire Council-compliant TMPs for Rouse Hill projects, covering new residential estates, civil infrastructure and commercial development.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Community and education infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Kellyville", "Stanhope Gardens", "Beaumont Hills", "Baulkham Hills", "Castle Hill", "Parklea", "Glenwood", "Quakers Hill", "Riverstone", "Box Hill"],
  },
  {
    slug: "seven-hills",
    suburb: "Seven Hills",
    state: "NSW",
    postcode: "2147",
    council: "Blacktown City Council",
    keyRoads: ["Seven Hills Road", "Old Windsor Road", "Prospect Highway", "Briens Road"],
    intro:
      "Seven Hills is a western Sydney suburb with a mix of residential, commercial and light industrial uses, where construction activity and ongoing road maintenance create consistent demand for traffic management plans compliant with Blacktown City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Blacktown City Council-compliant TMPs for Seven Hills projects, from residential construction to commercial and light industrial works.",
    industries: [
      "Residential development",
      "Light industrial and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Blacktown", "Wentworthville", "Toongabbie", "Kings Langley", "Pendle Hill", "Winston Hills", "Baulkham Hills", "Prospect", "Girraween", "Parramatta"],
  },
  {
    slug: "wentworthville",
    suburb: "Wentworthville",
    state: "NSW",
    postcode: "2145",
    council: "Cumberland Council",
    keyRoads: ["Great Western Highway", "Station Street", "Dunmore Street", "Mons Road"],
    intro:
      "Wentworthville is a western Sydney suburb on the Great Western Highway corridor where residential development, commercial construction and utility works generate demand for traffic management plans compliant with Cumberland Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wentworthville projects, with knowledge of the Great Western Highway environment and Cumberland Council permit requirements.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Toongabbie", "Pendle Hill", "Seven Hills", "Westmead", "Parramatta", "Girraween", "Greystanes", "Merrylands", "Woodville", "Winston Hills"],
  },
  {
    slug: "windsor",
    suburb: "Windsor",
    state: "NSW",
    postcode: "2756",
    council: "Hawkesbury City Council",
    keyRoads: ["Windsor Road", "George Street", "Macquarie Street", "Bridge Street"],
    intro:
      "Windsor is one of Australia's oldest European settlements and the gateway to the Hawkesbury region, where heritage conservation requirements, residential development and flood mitigation infrastructure projects create complex traffic management challenges that must meet Hawkesbury City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Hawkesbury City Council-compliant TMPs for Windsor projects, with awareness of the heritage overlay requirements and the town's role as a regional service centre.",
    industries: [
      "Heritage building refurbishment",
      "Residential development",
      "Flood mitigation infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Richmond", "Pitt Town", "McGraths Hill", "Vineyard", "South Windsor", "Wilberforce", "Clarendon", "Mulgrave", "Box Hill", "Rouse Hill"],
  },
  // Southern Sydney (additional)
  {
    slug: "caringbah",
    suburb: "Caringbah",
    state: "NSW",
    postcode: "2229",
    council: "Sutherland Shire Council",
    keyRoads: ["Kingsway", "Port Hacking Road", "President Avenue", "Willarong Road"],
    intro:
      "Caringbah is a major commercial and retail centre in the Sutherland Shire, where ongoing residential development and retail construction create demand for traffic management plans compliant with Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sutherland Shire Council-compliant TMPs for Caringbah projects, covering retail construction, residential development and utility works.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Miranda", "Gymea", "Woolooware", "Cronulla", "Kirrawee", "Taren Point", "Sylvania", "Bonnet Bay", "Lilli Pilli", "Port Hacking"],
  },
  {
    slug: "engadine",
    suburb: "Engadine",
    state: "NSW",
    postcode: "2233",
    council: "Sutherland Shire Council",
    keyRoads: ["Anzac Drive", "Caldarra Avenue", "Waratah Road", "Old Princes Highway"],
    intro:
      "Engadine is a residential suburb in the Sutherland Shire adjacent to the Royal National Park, where residential construction and utility works require traffic management plans compliant with Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Engadine residential and utility projects, managing the suburb's local road network effectively.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
      "Landscaping and civil works",
    ],
    nearbySuburbs: ["Heathcote", "Waterfall", "Loftus", "Grays Point", "Kirrawee", "Sutherland", "Menai", "Lucas Heights", "Alfords Point", "Bangor"],
  },
  {
    slug: "gymea",
    suburb: "Gymea",
    state: "NSW",
    postcode: "2227",
    council: "Sutherland Shire Council",
    keyRoads: ["Gymea Bay Road", "Port Hacking Road", "The Boulevarde", "Waratah Street"],
    intro:
      "Gymea is a suburban retail and residential centre in the Sutherland Shire, where commercial development and residential construction generate demand for traffic management plans meeting Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Sutherland Shire Council-compliant TMPs for Gymea projects, from village retail construction to residential builds in the surrounding streets.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Miranda", "Caringbah", "Kirrawee", "Gymea Bay", "Como", "Jannali", "Sutherland", "Bonnet Bay", "Yowie Bay", "Illawong"],
  },
  {
    slug: "sutherland",
    suburb: "Sutherland",
    state: "NSW",
    postcode: "2232",
    council: "Sutherland Shire Council",
    keyRoads: ["Flora Street", "Eton Street", "Linden Street", "Glencoe Street"],
    intro:
      "Sutherland is the administrative centre of the Sutherland Shire, where ongoing residential development, commercial construction and council infrastructure upgrades require traffic management documentation compliant with Sutherland Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sutherland Shire Council-compliant TMPs for all project types in Sutherland, from residential construction to commercial and infrastructure works.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Kirrawee", "Gymea", "Caringbah", "Miranda", "Jannali", "Como", "Woronora", "Loftus", "Engadine", "Heathcote"],
  },
  {
    slug: "taren-point",
    suburb: "Taren Point",
    state: "NSW",
    postcode: "2229",
    council: "Sutherland Shire Council",
    keyRoads: ["Taren Point Road", "Captain Cook Drive", "Kingsway", "The Boulevarde"],
    intro:
      "Taren Point is a light industrial and commercial suburb in the Sutherland Shire adjacent to Port Hacking, where industrial construction, warehouse development and utility works require traffic management plans compliant with Sutherland Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Taren Point industrial and commercial projects, with experience in the suburb's light industrial traffic environment.",
    industries: [
      "Light industrial and warehouse development",
      "Commercial construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Marine and waterfront works",
    ],
    nearbySuburbs: ["Caringbah", "Miranda", "Sylvania", "Woolooware", "Cronulla", "Gymea", "Kirrawee", "Bonnet Bay", "Oyster Bay", "Como"],
  },
  // Northern Sydney (additional)
  {
    slug: "dee-why",
    suburb: "Dee Why",
    state: "NSW",
    postcode: "2099",
    council: "Northern Beaches Council",
    keyRoads: ["Pittwater Road", "Fisher Road", "Howard Avenue", "The Strand"],
    intro:
      "Dee Why is a major coastal centre on Sydney's Northern Beaches, where beachside apartment development, retail construction and the Northern Beaches Hospital corridor drive demand for traffic management plans compliant with Northern Beaches Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Dee Why projects, managing the suburb's coastal road environment and high tourist and residential traffic.",
    industries: [
      "Coastal residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
    ],
    nearbySuburbs: ["Collaroy", "Narrabeen", "Curl Curl", "Freshwater", "Brookvale", "Allambie Heights", "Manly Vale", "Beacon Hill", "Wheeler Heights", "Cromer"],
  },
  {
    slug: "frenchs-forest",
    suburb: "Frenchs Forest",
    state: "NSW",
    postcode: "2086",
    council: "Northern Beaches Council",
    keyRoads: ["Warringah Road", "Forest Way", "Frenchs Forest Road", "Wakehurst Parkway"],
    intro:
      "Frenchs Forest is a significant employment and residential precinct on Sydney's Northern Beaches, currently undergoing transformation with the new Northern Beaches Hospital and associated health precinct development driving major construction and infrastructure upgrades requiring complex traffic management documentation.",
    bodyPara:
      "Focus Traffic Plans produces Northern Beaches Council-compliant TMPs for Frenchs Forest projects, with specialist knowledge of the health precinct development environment and Warringah Road corridor.",
    industries: [
      "Health and hospital infrastructure",
      "Commercial and business park development",
      "Residential construction",
      "Utility and services upgrades",
      "Road and civil infrastructure",
    ],
    nearbySuburbs: ["Belrose", "Davidson", "Terrey Hills", "Killarney Heights", "Forestville", "Allambie Heights", "Manly Vale", "Brookvale", "Cromer", "Narraweena"],
  },
  {
    slug: "gordon",
    suburb: "Gordon",
    state: "NSW",
    postcode: "2072",
    council: "Ku-ring-gai Council",
    keyRoads: ["Pacific Highway", "Gordon Avenue", "Park Road", "St Johns Avenue"],
    intro:
      "Gordon is an affluent upper north shore suburb and regional commercial centre within the Ku-ring-gai LGA, where residential construction and retail development require traffic management plans compliant with Ku-ring-gai Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gordon residential and commercial projects, navigating the suburb's tree-lined streets and Ku-ring-gai Council's strict development requirements.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Turramurra", "Pymble", "Killara", "Lindfield", "St Ives", "Wahroonga", "Warrawee", "North Turramurra", "Roseville", "East Killara"],
  },
  {
    slug: "mosman",
    suburb: "Mosman",
    state: "NSW",
    postcode: "2088",
    council: "Mosman Municipal Council",
    keyRoads: ["Military Road", "Spit Road", "Raglan Street", "Avenue Road"],
    intro:
      "Mosman is one of Sydney's most prestigious harbour suburbs where residential construction, boutique commercial development and foreshore works require traffic management plans that carefully manage Military Road's heavy traffic volumes and comply with Mosman Council's demanding standards.",
    bodyPara:
      "Focus Traffic Plans prepares Mosman Council-compliant TMPs for residential and commercial projects, with specialist knowledge of the Military Road corridor's traffic management challenges.",
    industries: [
      "Residential construction",
      "Boutique commercial development",
      "Foreshore and marine works",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Cremorne", "Neutral Bay", "Spit Junction", "Balmoral", "Clifton Gardens", "Beauty Point", "Sirius Cove", "Taronga Zoo", "North Sydney", "Cremorne Point"],
  },
  {
    slug: "pymble",
    suburb: "Pymble",
    state: "NSW",
    postcode: "2073",
    council: "Ku-ring-gai Council",
    keyRoads: ["Pacific Highway", "Pymble Avenue", "Grandview Street", "Ryde Road"],
    intro:
      "Pymble is an upper north shore suburb within the Ku-ring-gai LGA where residential construction and infrastructure works in a leafy, heritage-sensitive environment require traffic management documentation that meets Ku-ring-gai Council's detailed requirements.",
    bodyPara:
      "Focus Traffic Plans produces Ku-ring-gai Council-compliant TMPs for Pymble projects, with experience in the LGA's heritage-sensitive development environment.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
      "Education and institutional development",
    ],
    nearbySuburbs: ["Gordon", "Turramurra", "St Ives", "North Turramurra", "Killara", "Wahroonga", "East Killara", "West Pymble", "Lindfield", "Warrawee"],
  },
  {
    slug: "st-ives",
    suburb: "St Ives",
    state: "NSW",
    postcode: "2075",
    council: "Ku-ring-gai Council",
    keyRoads: ["Mona Vale Road", "Douglas Street", "Ramsay Road", "Cowan Road"],
    intro:
      "St Ives is a large, leafy upper north shore suburb with significant residential construction activity and a vibrant village centre, where development requires traffic management plans compliant with Ku-ring-gai Council requirements and sensitive to the area's tree canopy and heritage character.",
    bodyPara:
      "Focus Traffic Plans prepares Ku-ring-gai Council-compliant TMPs for St Ives residential and commercial projects, with knowledge of the suburb's road network and development constraints.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Education and institutional development",
    ],
    nearbySuburbs: ["Pymble", "Gordon", "Turramurra", "North Turramurra", "Terrey Hills", "Frenchs Forest", "Wahroonga", "St Ives Chase", "Killara", "Lindfield"],
  },
  {
    slug: "turramurra",
    suburb: "Turramurra",
    state: "NSW",
    postcode: "2074",
    council: "Ku-ring-gai Council",
    keyRoads: ["Pacific Highway", "Ray Road", "Kissing Point Road", "Rohini Street"],
    intro:
      "Turramurra is an upper north shore suburb within the Ku-ring-gai LGA where residential construction and dual occupancy development require traffic management plans compliant with Ku-ring-gai Council requirements in a quiet, heritage-sensitive residential environment.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Turramurra residential projects, with experience managing construction traffic in Ku-ring-gai Council's heritage-sensitive suburbs.",
    industries: [
      "Residential construction",
      "Dual occupancy and subdivision",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Wahroonga", "Pymble", "Gordon", "North Turramurra", "South Turramurra", "Warrawee", "East Killara", "St Ives", "Killara", "Lindfield"],
  },
  // Central Coast
  {
    slug: "bateau-bay",
    suburb: "Bateau Bay",
    state: "NSW",
    postcode: "2261",
    council: "Central Coast Council",
    keyRoads: ["The Entrance Road", "Wyong Road", "Carrington Avenue", "Bay Village Road"],
    intro:
      "Bateau Bay is a coastal suburb on the Central Coast where residential development, retail construction and utility works require traffic management plans compliant with Central Coast Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Bateau Bay projects, covering residential construction and commercial development in the suburb.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Shelly Beach", "Killarney Vale", "Toowoon Bay", "Long Jetty", "The Entrance", "Forresters Beach", "Tumbi Umbi", "Berkeley Vale", "Ourimbah", "Chittaway Bay"],
  },
  {
    slug: "erina",
    suburb: "Erina",
    state: "NSW",
    postcode: "2250",
    council: "Central Coast Council",
    keyRoads: ["The Entrance Road", "Erina Street", "Karalta Road", "Central Coast Highway"],
    intro:
      "Erina is the Central Coast's major retail and commercial hub, centred on Erina Fair Shopping Centre, where retail construction, commercial development and associated road upgrades create demand for traffic management documentation compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Erina commercial and retail projects, with knowledge of the suburb's major shopping centre environment and Central Coast Council requirements.",
    industries: [
      "Retail and commercial construction",
      "Mixed-use development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gosford", "Kincumber", "Terrigal", "Green Point", "Avoca Beach", "Wyoming", "Point Frederick", "East Gosford", "Narara", "Lisarow"],
  },
  {
    slug: "gosford",
    suburb: "Gosford",
    state: "NSW",
    postcode: "2250",
    council: "Central Coast Council",
    keyRoads: ["Mann Street", "Donnison Street", "Pacific Highway", "Showground Road"],
    intro:
      "Gosford is the Central Coast's administrative and commercial capital, undergoing significant urban renewal with high-density residential development and commercial construction creating strong demand for traffic management plans compliant with Central Coast Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Gosford city projects, with experience in the rapidly evolving high-density development environment.",
    industries: [
      "High-density residential development",
      "Commercial and retail construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["East Gosford", "Point Frederick", "Wyoming", "West Gosford", "Narara", "Lisarow", "Kariong", "Niagara Park", "Erina", "Springfield"],
  },
  {
    slug: "hamlyn-terrace",
    suburb: "Hamlyn Terrace",
    state: "NSW",
    postcode: "2259",
    council: "Central Coast Council",
    keyRoads: ["Pacific Highway", "Hamlyn Terrace Drive", "Arizona Road", "Sparks Road"],
    intro:
      "Hamlyn Terrace is a growing residential suburb in the Wyong area of the Central Coast where new housing estate development and associated infrastructure create demand for traffic management plans meeting Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hamlyn Terrace residential and civil infrastructure projects, with knowledge of Central Coast Council's subdivision requirements.",
    industries: [
      "Residential subdivision and housing",
      "Civil infrastructure",
      "Utility maintenance",
      "Road construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Wadalba", "Woongarrah", "Kanwal", "Gorokan", "Wyong", "Tuggerah", "Tuggerawong", "Blue Haven", "Toukley", "Lake Munmorah"],
  },
  {
    slug: "kariong",
    suburb: "Kariong",
    state: "NSW",
    postcode: "2250",
    council: "Central Coast Council",
    keyRoads: ["Central Coast Highway", "Kangoo Road", "Ridgeway Avenue", "The Avenue"],
    intro:
      "Kariong is a residential and semi-rural suburb at the entrance to the Central Coast, where residential construction and the proximity to the M1 Pacific Motorway interchange create traffic management requirements that must comply with Central Coast Council and Transport for NSW standards.",
    bodyPara:
      "Focus Traffic Plans produces Central Coast Council-compliant TMPs for Kariong residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Civil and infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gosford", "Somersby", "Point Clare", "Calga", "Narara", "West Gosford", "Springfield", "Niagara Park", "Mount White", "Peats Ridge"],
  },
  {
    slug: "terrigal",
    suburb: "Terrigal",
    state: "NSW",
    postcode: "2260",
    council: "Central Coast Council",
    keyRoads: ["Terrigal Drive", "Terrigal Esplanade", "Pine Tree Lane", "Willoughby Road"],
    intro:
      "Terrigal is the Central Coast's premier tourist and lifestyle destination, where beachside hospitality construction, residential development and coastal infrastructure works require traffic management plans compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Terrigal projects, managing pedestrian and tourist flows in this busy coastal precinct.",
    industries: [
      "Hospitality and tourism development",
      "Coastal residential construction",
      "Retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wamberal", "Avoca Beach", "North Avoca", "Erina", "Kincumber", "Matcham", "Holgate", "Fountaindale", "Green Point", "Copacabana"],
  },
  {
    slug: "the-entrance",
    suburb: "The Entrance",
    state: "NSW",
    postcode: "2261",
    council: "Central Coast Council",
    keyRoads: ["The Entrance Road", "Gosford Road", "Hutton Road", "Canton Beach Road"],
    intro:
      "The Entrance is a popular Central Coast tourist and residential suburb where seasonal visitor traffic, retail construction and coastal infrastructure works require traffic management documentation compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for The Entrance projects, with experience managing the suburb's tourist season traffic peaks and coastal construction environment.",
    industries: [
      "Tourism and hospitality construction",
      "Coastal residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Long Jetty", "Bateau Bay", "Killarney Vale", "Toowoon Bay", "Shelly Beach", "Chittaway Bay", "Berkeley Vale", "Tumbi Umbi", "Ourimbah", "Blue Bay"],
  },
  {
    slug: "tuggerah",
    suburb: "Tuggerah",
    state: "NSW",
    postcode: "2259",
    council: "Central Coast Council",
    keyRoads: ["Pacific Highway", "Wyong Road", "Anzac Road", "Gavenlock Road"],
    intro:
      "Tuggerah is a major commercial and industrial centre on the Central Coast, home to Westfield Tuggerah and extensive light industrial estates, where retail construction, warehouse development and infrastructure upgrades require traffic management plans compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Tuggerah commercial, retail and industrial projects.",
    industries: [
      "Retail and commercial construction",
      "Light industrial and warehouse development",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wyong", "Kanwal", "Hamlyn Terrace", "Woongarrah", "Wadalba", "Chittaway Bay", "Fountaindale", "Lisarow", "Ourimbah", "Bateau Bay"],
  },
  {
    slug: "umina-beach",
    suburb: "Umina Beach",
    state: "NSW",
    postcode: "2257",
    council: "Central Coast Council",
    keyRoads: ["Ocean Beach Road", "Sydney Avenue", "Brisbane Water Drive", "Trafalgar Avenue"],
    intro:
      "Umina Beach is a coastal suburb on the Gosford Peninsula where residential construction and beachside development create demand for traffic management plans compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Umina Beach residential and commercial projects.",
    industries: [
      "Coastal residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Woy Woy", "Ettalong Beach", "Patonga", "Pearl Beach", "Booker Bay", "Blackwall", "Hardys Bay", "Green Point", "Saratoga", "Davistown"],
  },
  {
    slug: "wyong",
    suburb: "Wyong",
    state: "NSW",
    postcode: "2259",
    council: "Central Coast Council",
    keyRoads: ["Pacific Highway", "Wyong Road", "Old Maitland Road", "Cutler Drive"],
    intro:
      "Wyong is a key service and residential centre in the northern Central Coast, where ongoing residential development and infrastructure upgrades require traffic management documentation compliant with Central Coast Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Wyong projects, covering residential, commercial and infrastructure works.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Tuggerah", "Hamlyn Terrace", "Kanwal", "Woongarrah", "Wadalba", "Jilliby", "Ourimbah", "Fountaindale", "Chittaway Bay", "Lake Munmorah"],
  },
  // Hunter Valley
  {
    slug: "cessnock",
    suburb: "Cessnock",
    state: "NSW",
    postcode: "2325",
    council: "Cessnock City Council",
    keyRoads: ["Vincent Street", "Allandale Road", "Wollombi Road", "Hunter Street"],
    intro:
      "Cessnock is the gateway to the Hunter Valley wine region and a significant residential and commercial centre, where tourism infrastructure, residential development and mining support industries create demand for traffic management plans compliant with Cessnock City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cessnock City Council-compliant TMPs for projects across the Cessnock LGA, from residential construction to tourism and industrial development.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Mining support infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Kurri Kurri", "Aberdare", "Neath", "Branxton", "Maitland", "Singleton", "Bellbird", "Kearsley", "Stanford Merthyr", "Weston"],
  },
  {
    slug: "hamilton",
    suburb: "Hamilton",
    state: "NSW",
    postcode: "2303",
    council: "Newcastle City Council",
    keyRoads: ["Beaumont Street", "Denison Street", "Broadmeadow Road", "Tudor Street"],
    intro:
      "Hamilton is Newcastle's most vibrant inner suburb and dining precinct, where residential construction, heritage building refurbishment and the famous Beaumont Street restaurant strip create demand for traffic management plans compliant with Newcastle City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hamilton projects, with specialist knowledge of the Beaumont Street environment and Newcastle City Council's heritage requirements.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Hospitality and retail fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Broadmeadow", "Islington", "Mayfield", "Wickham", "Carrington", "Waratah", "Newcastle CBD", "Adamstown", "Georgetown", "New Lambton"],
  },
  {
    slug: "lake-macquarie",
    suburb: "Lake Macquarie",
    state: "NSW",
    postcode: "2280",
    council: "Lake Macquarie City Council",
    keyRoads: ["Main Road", "Pacific Highway", "Toronto Road", "Avondale Road"],
    intro:
      "Lake Macquarie is Australia's largest coastal saltwater lake and a major residential and recreational area, where residential development, infrastructure upgrades and tourism construction across the lakeside suburbs require traffic management plans compliant with Lake Macquarie City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Lake Macquarie City Council-compliant TMPs for projects across the LGA's diverse residential and commercial environments.",
    industries: [
      "Residential development",
      "Tourism and recreation infrastructure",
      "Commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Charlestown", "Gateshead", "Cardiff", "Warners Bay", "Belmont", "Toronto", "Morisset", "Windale", "Edgeworth", "Kotara"],
  },
  {
    slug: "maitland",
    suburb: "Maitland",
    state: "NSW",
    postcode: "2320",
    council: "Maitland City Council",
    keyRoads: ["New England Highway", "High Street", "Ken Tubman Drive", "Lawes Street"],
    intro:
      "Maitland is the Hunter Valley's historic city and one of the fastest-growing local government areas in NSW, where rapid residential expansion, commercial development and flood mitigation infrastructure create strong demand for traffic management documentation compliant with Maitland City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Maitland City Council-compliant TMPs for all project types across the LGA's growing residential and commercial sectors.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Flood mitigation infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["East Maitland", "Thornton", "Rutherford", "Telarah", "Lorn", "Morpeth", "Cessnock", "Singleton", "Kurri Kurri", "Branxton"],
  },
  {
    slug: "merewether",
    suburb: "Merewether",
    state: "NSW",
    postcode: "2291",
    council: "Newcastle City Council",
    keyRoads: ["Glebe Road", "Dudley Road", "Belford Street", "Park Avenue"],
    intro:
      "Merewether is Newcastle's premier beachside suburb, a sought-after residential location where coastal construction, residential development and heritage property renovation create demand for traffic management plans compliant with Newcastle City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Merewether residential and construction projects, with knowledge of the suburb's local road network and coastal environment.",
    industries: [
      "Coastal residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
    ],
    nearbySuburbs: ["Bar Beach", "The Junction", "Hamilton South", "Cooks Hill", "Georgetown", "Adamstown Heights", "Dudley", "Whitebridge", "Redhead", "New Lambton Heights"],
  },
  {
    slug: "muswellbrook",
    suburb: "Muswellbrook",
    state: "NSW",
    postcode: "2333",
    council: "Muswellbrook Shire Council",
    keyRoads: ["Bridge Street", "Sydney Street", "Brook Street", "New England Highway"],
    intro:
      "Muswellbrook is the centre of the Upper Hunter coal and energy region, where mining infrastructure, power station maintenance and residential construction create significant traffic management requirements that must comply with Muswellbrook Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Muswellbrook Shire Council-compliant TMPs for mining, energy and residential construction projects in the Upper Hunter.",
    industries: [
      "Mining and resources infrastructure",
      "Power generation maintenance",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Singleton", "Aberdeen", "Scone", "Denman", "Murrurundi", "Sandy Hollow", "Wybong", "Baerami", "Merriwa", "Quirindi"],
  },
  {
    slug: "newcastle-cbd",
    suburb: "Newcastle CBD",
    state: "NSW",
    postcode: "2300",
    council: "Newcastle City Council",
    keyRoads: ["Hunter Street", "King Street", "Darby Street", "Scott Street"],
    intro:
      "Newcastle CBD is undergoing one of Australia's most significant urban renewal programs, with a new light rail, major hotel and commercial developments and foreshore revitalisation all driving complex traffic management requirements. Plans must meet both Newcastle City Council and Transport for NSW standards in a rapidly evolving urban environment.",
    bodyPara:
      "Focus Traffic Plans produces Newcastle City Council-compliant TMPs for CBD development projects, with specialist knowledge of the light rail interface and the city's evolving street network.",
    industries: [
      "Commercial and hotel development",
      "Light rail and transport infrastructure",
      "Retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility and services upgrades",
    ],
    nearbySuburbs: ["Hamilton", "Wickham", "Carrington", "Islington", "Mayfield", "Cooks Hill", "Bar Beach", "Merewether", "Georgetown", "Waratah"],
  },
  {
    slug: "rutherford",
    suburb: "Rutherford",
    state: "NSW",
    postcode: "2320",
    council: "Maitland City Council",
    keyRoads: ["New England Highway", "Aberglasslyn Road", "Hillsborough Road", "Lachlan Street"],
    intro:
      "Rutherford is a major residential and light industrial suburb in the Maitland LGA, where new housing estates, commercial development and light industrial construction create demand for traffic management plans compliant with Maitland City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Rutherford residential, commercial and industrial projects.",
    industries: [
      "Residential subdivision and housing",
      "Light industrial and commercial construction",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Maitland", "Thornton", "Telarah", "Aberglasslyn", "Metford", "Ashtonfield", "Bolwarra Heights", "Largs", "East Maitland", "Cessnock"],
  },
  {
    slug: "singleton",
    suburb: "Singleton",
    state: "NSW",
    postcode: "2330",
    council: "Singleton Council",
    keyRoads: ["New England Highway", "John Street", "Ryan Avenue", "Anzac Street"],
    intro:
      "Singleton is the administrative centre of the Hunter Valley's coal mining district, where mining infrastructure, residential development and military base logistics create significant traffic management requirements that must comply with Singleton Council and Transport for NSW standards.",
    bodyPara:
      "Focus Traffic Plans prepares Singleton Council-compliant TMPs for mining, residential and infrastructure projects in the Singleton area.",
    industries: [
      "Mining and resources infrastructure",
      "Residential development",
      "Defence and logistics",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Branxton", "Cessnock", "Muswellbrook", "Broke", "Bulga", "Camberwell", "Greta", "Loxford", "Hunterview", "Ravensworth"],
  },
  {
    slug: "wallsend",
    suburb: "Wallsend",
    state: "NSW",
    postcode: "2287",
    council: "Newcastle City Council",
    keyRoads: ["Maitland Road", "Wallsend Road", "Kokera Street", "Nelson Street"],
    intro:
      "Wallsend is a western Newcastle suburb with a mix of residential, commercial and industrial uses, where construction activity and utility works require traffic management plans compliant with Newcastle City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wallsend residential and commercial projects, with knowledge of the Maitland Road corridor and Newcastle City Council requirements.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Light industrial works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Jesmond", "Shortland", "Maryland", "Rankin Park", "Elermore Vale", "Waratah", "Cardiff", "Edgeworth", "Georgetown", "Hamilton North"],
  },
  // Blue Mountains
  {
    slug: "blackheath",
    suburb: "Blackheath",
    state: "NSW",
    postcode: "2785",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Hat Hill Road", "Wentworth Street", "Govetts Leap Road"],
    intro:
      "Blackheath is a heritage Blue Mountains village on the Great Western Highway where residential construction, tourism infrastructure and utility works in a constrained mountain environment require traffic management plans compliant with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Blue Mountains City Council-compliant TMPs for Blackheath projects, with experience managing the unique challenges of mountain town traffic environments.",
    industries: [
      "Residential construction",
      "Tourism and hospitality development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Medlow Bath", "Mount Victoria", "Bell", "Katoomba", "Leura", "Megalong Valley", "Hartley", "Lithgow", "Mount Irvine", "Clarence"],
  },
  {
    slug: "blaxland",
    suburb: "Blaxland",
    state: "NSW",
    postcode: "2774",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Blaxland Road", "Woodville Road", "Mitchell Street"],
    intro:
      "Blaxland is a lower Blue Mountains suburb at the foot of the escarpment, where residential construction and the proximity to the Great Western Highway create traffic management requirements that must comply with Blue Mountains City Council and Transport for NSW standards.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Blaxland residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
      "Commercial development",
    ],
    nearbySuburbs: ["Glenbrook", "Warrimoo", "Sun Valley", "Lapstone", "Emu Plains", "Penrith", "Yellow Rock", "Mount Riverview", "Winmalee", "Springwood"],
  },
  {
    slug: "glenbrook",
    suburb: "Glenbrook",
    state: "NSW",
    postcode: "2773",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Ross Street", "Burfitt Parade", "Levy Street"],
    intro:
      "Glenbrook is a lower Blue Mountains village adjacent to Blue Mountains National Park, where residential construction and utility works in a bush setting require traffic management plans compliant with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Blue Mountains City Council-compliant TMPs for Glenbrook residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Tourism and recreation infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Lapstone", "Blaxland", "Warrimoo", "Valley Heights", "Emu Plains", "Springwood", "Yellow Rock", "Sun Valley", "Mount Riverview", "Penrith"],
  },
  {
    slug: "katoomba",
    suburb: "Katoomba",
    state: "NSW",
    postcode: "2780",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Katoomba Street", "Lurline Street", "Bathurst Road"],
    intro:
      "Katoomba is the tourism capital of the Blue Mountains and the administrative centre of Blue Mountains City Council, where heritage buildings, tourist infrastructure and residential construction create demand for traffic management plans that comply with council requirements while managing the area's heavy tourism traffic.",
    bodyPara:
      "Focus Traffic Plans produces Blue Mountains City Council-compliant TMPs for Katoomba projects, with specialist knowledge of tourism precinct management and heritage construction requirements.",
    industries: [
      "Tourism and hospitality development",
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Leura", "Wentworth Falls", "Blackheath", "Medlow Bath", "Hazelbrook", "Woodford", "Linden", "Bullaburra", "Lawson", "Mount Victoria"],
  },
  {
    slug: "lawson",
    suburb: "Lawson",
    state: "NSW",
    postcode: "2783",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "New Street", "Honour Avenue", "Badgerys Crescent"],
    intro:
      "Lawson is a mid-mountains village with a strong community character where residential construction and utility works require traffic management plans compliant with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Lawson residential and infrastructure projects in the Blue Mountains.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Hazelbrook", "Bullaburra", "Woodford", "Linden", "Wentworth Falls", "Leura", "Katoomba", "Faulconbridge", "Springwood", "Valley Heights"],
  },
  {
    slug: "leura",
    suburb: "Leura",
    state: "NSW",
    postcode: "2780",
    council: "Blue Mountains City Council",
    keyRoads: ["Leura Mall", "Great Western Highway", "Valley Road", "Megalong Street"],
    intro:
      "Leura is one of the Blue Mountains' most picturesque villages, renowned for its gardens and heritage streetscapes, where boutique construction and utility works require traffic management plans that carefully manage the village's narrow streets and comply with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Blue Mountains City Council-compliant TMPs for Leura projects, sensitive to the village's heritage character and tourist environment.",
    industries: [
      "Heritage building refurbishment",
      "Tourism and hospitality construction",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Katoomba", "Wentworth Falls", "Lawson", "Medlow Bath", "Hazelbrook", "Bullaburra", "Gordon Falls", "Linden", "Woodford", "Faulconbridge"],
  },
  {
    slug: "lithgow",
    suburb: "Lithgow",
    state: "NSW",
    postcode: "2790",
    council: "Lithgow City Council",
    keyRoads: ["Main Street", "Lithgow Street", "Mort Street", "Great Western Highway"],
    intro:
      "Lithgow is a regional city west of the Blue Mountains with a history in coal mining and manufacturing, where ongoing residential development, energy infrastructure and industrial construction create demand for traffic management plans compliant with Lithgow City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Lithgow City Council-compliant TMPs for residential, industrial and infrastructure projects in the Lithgow area.",
    industries: [
      "Residential development",
      "Energy and industrial infrastructure",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Portland", "Wallerawang", "Marrangaroo", "South Bowenfels", "Hartley", "Blackheath", "Mount Victoria", "Oberon", "Bathurst", "Orange"],
  },
  {
    slug: "mount-victoria",
    suburb: "Mount Victoria",
    state: "NSW",
    postcode: "2786",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Montgomery Street", "Station Street", "Harley Avenue"],
    intro:
      "Mount Victoria is the highest village on the Blue Mountains railway and one of NSW's most intact Victorian-era heritage precincts, where heritage conservation, residential construction and utility works require traffic management plans compliant with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mount Victoria heritage and residential projects, with awareness of the village's conservation area requirements.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Tourism and hospitality development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Blackheath", "Hartley", "Bell", "Lithgow", "Medlow Bath", "Clarence", "Little Hartley", "Scenic Hill", "Kanimbla", "Megalong Valley"],
  },
  {
    slug: "springwood",
    suburb: "Springwood",
    state: "NSW",
    postcode: "2777",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Macquarie Road", "Birdwood Road", "Hawkesbury Road"],
    intro:
      "Springwood is the largest commercial centre in the lower Blue Mountains, where retail construction, residential development and utility works require traffic management plans compliant with Blue Mountains City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Blue Mountains City Council-compliant TMPs for Springwood commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Faulconbridge", "Winmalee", "Yellow Rock", "Valley Heights", "Blaxland", "Glenbrook", "Warrimoo", "Linden", "Lawson", "Hazelbrook"],
  },
  {
    slug: "wentworth-falls",
    suburb: "Wentworth Falls",
    state: "NSW",
    postcode: "2782",
    council: "Blue Mountains City Council",
    keyRoads: ["Great Western Highway", "Falls Road", "Station Street", "Wilson Glen Road"],
    intro:
      "Wentworth Falls is a popular mid-mountains village known for its dramatic waterfall and national park access, where residential construction and tourism infrastructure works require traffic management plans compliant with Blue Mountains City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wentworth Falls residential and tourism infrastructure projects.",
    industries: [
      "Residential construction",
      "Tourism and recreation infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Leura", "Katoomba", "Lawson", "Bullaburra", "Hazelbrook", "Linden", "Woodford", "Medlow Bath", "Blackheath", "Faulconbridge"],
  },
  // Illawarra & Wollongong (additional)
  {
    slug: "dapto",
    suburb: "Dapto",
    state: "NSW",
    postcode: "2530",
    council: "Wollongong City Council",
    keyRoads: ["Princes Highway", "Bong Bong Road", "Fowlers Road", "Marshall Road"],
    intro:
      "Dapto is one of Wollongong's fastest-growing residential corridors, with new housing estates, retail development and infrastructure upgrades creating strong demand for traffic management plans compliant with Wollongong City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wollongong City Council-compliant TMPs for Dapto residential, commercial and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Kembla Grange", "Horsley", "Avondale", "Wongawilli", "Albion Park", "Oak Flats", "Unanderra", "Figtree", "Wollongong CBD", "Shellharbour"],
  },
  {
    slug: "figtree",
    suburb: "Figtree",
    state: "NSW",
    postcode: "2525",
    council: "Wollongong City Council",
    keyRoads: ["Princes Highway", "Fowlers Road", "Memorial Drive", "Figtree Drive"],
    intro:
      "Figtree is a residential suburb south-west of Wollongong CBD adjacent to the University of Wollongong, where residential construction and utility works require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Figtree residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Education and university support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Unanderra", "Mount Saint Thomas", "Gwynneville", "Keiraville", "Wollongong CBD", "Fairy Meadow", "Balgownie", "Fernhill", "Kembla Grange", "Cordeaux Heights"],
  },
  {
    slug: "kiama",
    suburb: "Kiama",
    state: "NSW",
    postcode: "2533",
    council: "Kiama Municipal Council",
    keyRoads: ["Manning Street", "Bong Bong Street", "Minnamurra Street", "Terralong Street"],
    intro:
      "Kiama is a picturesque coastal town south of Wollongong renowned for its blowhole and heritage streetscapes, where tourism infrastructure, residential construction and utility works require traffic management plans compliant with Kiama Municipal Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Kiama Municipal Council-compliant TMPs for projects in Kiama and the surrounding Kiama LGA.",
    industries: [
      "Tourism and hospitality development",
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Gerringong", "Jamberoo", "Minnamurra", "Kiama Heights", "Bombo", "Saddleback Mountain", "Kiama Downs", "Foxground", "Berry", "Shellharbour"],
  },
  {
    slug: "nowra",
    suburb: "Nowra",
    state: "NSW",
    postcode: "2541",
    council: "Shoalhaven City Council",
    keyRoads: ["Princes Highway", "Junction Street", "Hyam Street", "Berry Street"],
    intro:
      "Nowra is the largest city in the Shoalhaven region and a major service centre for the South Coast, where residential development, defence infrastructure and commercial construction create demand for traffic management plans compliant with Shoalhaven City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shoalhaven City Council-compliant TMPs for Nowra and Shoalhaven projects, with experience across residential, defence and commercial sectors.",
    industries: [
      "Residential development",
      "Defence and HMAS Albatross infrastructure",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Bomaderry", "South Nowra", "Nowra Hill", "North Nowra", "Worrigee", "Mundamia", "Cambewarra Village", "Yerriyong", "Shoalhaven Heads", "Culburra Beach"],
  },
  {
    slug: "port-kembla",
    suburb: "Port Kembla",
    state: "NSW",
    postcode: "2505",
    council: "Wollongong City Council",
    keyRoads: ["King Street", "Wiseman Street", "Military Road", "Wentworth Street"],
    intro:
      "Port Kembla is Australia's third-largest port and a major heavy industrial precinct, where steelworks, port logistics and industrial construction create significant and complex traffic management requirements that must comply with Wollongong City Council, Transport for NSW and port authority standards.",
    bodyPara:
      "Focus Traffic Plans produces Wollongong City Council and port authority-compliant TMPs for Port Kembla industrial and infrastructure projects, with experience in heavy industrial traffic environments.",
    industries: [
      "Heavy industrial and steelworks",
      "Port and logistics infrastructure",
      "Industrial construction",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Wollongong CBD", "Warrawong", "Unanderra", "Cringila", "Lake Heights", "Berkeley", "Primbee", "Windang", "Barrack Heights", "Shellharbour"],
  },
  {
    slug: "shellharbour",
    suburb: "Shellharbour",
    state: "NSW",
    postcode: "2529",
    council: "Shellharbour City Council",
    keyRoads: ["Lake Entrance Road", "Shellharbour Road", "Tullimbar Drive", "Tongarra Road"],
    intro:
      "Shellharbour is a rapidly growing coastal city south of Wollongong, with major residential subdivisions, a new city centre and significant infrastructure investment creating strong demand for traffic management plans compliant with Shellharbour City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shellharbour City Council-compliant TMPs for residential, commercial and infrastructure projects across the LGA.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Albion Park", "Oak Flats", "Warilla", "Barrack Heights", "Mount Warrigal", "Flinders", "Blackbutt", "Dunmore", "Dapto", "Kiama"],
  },
  {
    slug: "thirroul",
    suburb: "Thirroul",
    state: "NSW",
    postcode: "2515",
    council: "Wollongong City Council",
    keyRoads: ["Lawrence Hargrave Drive", "Thirroul Road", "Balgownie Road", "Coleridge Street"],
    intro:
      "Thirroul is a sought-after coastal suburb north of Wollongong, known for its beaches and creative community, where residential construction and utility works along the Lawrence Hargrave Drive corridor require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Thirroul residential and coastal infrastructure projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Bulli", "Corrimal", "Austinmer", "Coledale", "Coalcliff", "Clifton", "Scarborough", "Wombarra", "Stanwell Park", "Wollongong CBD"],
  },
  {
    slug: "unanderra",
    suburb: "Unanderra",
    state: "NSW",
    postcode: "2526",
    council: "Wollongong City Council",
    keyRoads: ["Princes Highway", "Tompson Road", "Lysaght Street", "Industrial Road"],
    intro:
      "Unanderra is a light industrial and residential suburb south of Wollongong CBD, where industrial construction, warehouse development and utility works require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wollongong City Council-compliant TMPs for Unanderra industrial and residential projects.",
    industries: [
      "Light industrial and warehouse development",
      "Residential construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Commercial construction",
    ],
    nearbySuburbs: ["Figtree", "Kembla Grange", "Dapto", "Mount Saint Thomas", "Wollongong CBD", "Berkeley", "Port Kembla", "Cordeaux Heights", "Farmborough Heights", "West Wollongong"],
  },
  {
    slug: "wollongong-cbd",
    suburb: "Wollongong CBD",
    state: "NSW",
    postcode: "2500",
    council: "Wollongong City Council",
    keyRoads: ["Crown Street", "Keira Street", "Bourke Street", "Princes Highway"],
    intro:
      "Wollongong CBD is the commercial and cultural hub of the Illawarra region, where high-density residential development, commercial construction and infrastructure upgrades create demand for traffic management plans compliant with Wollongong City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Wollongong City Council-compliant TMPs for CBD projects, with experience in the city's compact urban environment and coastal setting.",
    industries: [
      "High-density residential development",
      "Commercial and retail construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wollongong", "North Wollongong", "Gwynneville", "Keiraville", "Fairy Meadow", "Port Kembla", "Figtree", "Mangerton", "Mount Pleasant", "Coniston"],
  },
  // Regional NSW
  {
    slug: "albury",
    suburb: "Albury",
    state: "NSW",
    postcode: "2640",
    council: "Albury City Council",
    keyRoads: ["Dean Street", "Hume Street", "Young Street", "Olive Street"],
    intro:
      "Albury is a major regional city on the Murray River and the New South Wales side of the Albury-Wodonga twin-city region, where residential development, commercial construction and cross-border infrastructure projects create demand for traffic management plans compliant with Albury City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Albury City Council-compliant TMPs for residential, commercial and infrastructure projects in the Albury-Wodonga corridor.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Cross-border infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Lavington", "Hamilton Valley", "West Albury", "East Albury", "Thurgoona", "Glenroy", "Table Top", "Wirlinga", "Jindera", "Wodonga"],
  },
  {
    slug: "armidale",
    suburb: "Armidale",
    state: "NSW",
    postcode: "2350",
    council: "Armidale Regional Council",
    keyRoads: ["Beardy Street", "Barney Street", "Kentucky Street", "New England Highway"],
    intro:
      "Armidale is a university city on the New England Tablelands, where university construction, residential development and regional infrastructure upgrades require traffic management plans compliant with Armidale Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Armidale Regional Council-compliant TMPs for university, residential and infrastructure projects in Armidale.",
    industries: [
      "University and education construction",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Uralla", "Guyra", "Hillgrove", "Ben Lomond", "Ebor", "Wollomombi", "Dumaresq", "Saumarez Ponds", "Invergowrie", "Dangarsleigh"],
  },
  {
    slug: "bathurst",
    suburb: "Bathurst",
    state: "NSW",
    postcode: "2795",
    council: "Bathurst Regional Council",
    keyRoads: ["William Street", "George Street", "Keppel Street", "Howick Street"],
    intro:
      "Bathurst is Australia's oldest inland city and the administrative centre of the Central Tablelands, where residential development, manufacturing and motorsport precinct infrastructure create demand for traffic management plans compliant with Bathurst Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bathurst Regional Council-compliant TMPs for residential, commercial and infrastructure projects in Bathurst.",
    industries: [
      "Residential development",
      "Manufacturing and industrial construction",
      "Motorsport and events infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Kelso", "Eglinton", "Perthville", "Windradyne", "Gormans Hill", "Llanarth", "Evans Plains", "Abercrombie", "Rockley", "Sofala"],
  },
  {
    slug: "broken-hill",
    suburb: "Broken Hill",
    state: "NSW",
    postcode: "2880",
    council: "Broken Hill City Council",
    keyRoads: ["Argent Street", "Chloride Street", "Oxide Street", "Iodide Street"],
    intro:
      "Broken Hill is an outback mining city and one of Australia's most distinctive heritage towns, where mining infrastructure, heritage building refurbishment and utility works in a remote environment require traffic management plans compliant with Broken Hill City Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Broken Hill City Council-compliant TMPs for mining, heritage and infrastructure projects in far western NSW.",
    industries: [
      "Mining and resources infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road maintenance",
      "Tourism infrastructure",
    ],
    nearbySuburbs: ["South Broken Hill", "North Broken Hill", "Silverton", "Menindee", "Wilcannia", "White Cliffs", "Tibooburra", "Milparinka", "Mutawintji", "Packsaddle"],
  },
  {
    slug: "coffs-harbour",
    suburb: "Coffs Harbour",
    state: "NSW",
    postcode: "2450",
    council: "Coffs Harbour City Council",
    keyRoads: ["Pacific Highway", "Harbour Drive", "Grafton Street", "High Street"],
    intro:
      "Coffs Harbour is a major regional city and tourist destination on the NSW mid-north coast, where residential development, tourism infrastructure and Pacific Highway bypass construction create significant demand for traffic management plans compliant with Coffs Harbour City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Coffs Harbour City Council-compliant TMPs for residential, commercial and infrastructure projects in the Coffs Harbour LGA.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Highway and road infrastructure",
      "Utility maintenance",
      "Commercial construction",
    ],
    nearbySuburbs: ["Woolgoolga", "Sawtell", "Toormina", "Moonee Beach", "Boambee East", "Kororo", "Bonville", "Nana Glen", "Dorrigo", "Bellingen"],
  },
  {
    slug: "dubbo",
    suburb: "Dubbo",
    state: "NSW",
    postcode: "2830",
    council: "Dubbo Regional Council",
    keyRoads: ["Cobra Street", "Macquarie Street", "Brisbane Street", "Mitchell Highway"],
    intro:
      "Dubbo is the regional capital of western NSW and a major agricultural, commercial and healthcare hub, where hospital expansion, residential development and commercial construction create demand for traffic management plans compliant with Dubbo Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Dubbo Regional Council-compliant TMPs for health, residential and commercial projects in the Dubbo region.",
    industries: [
      "Health and hospital infrastructure",
      "Residential development",
      "Commercial and retail construction",
      "Agricultural and logistics infrastructure",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Narromine", "Gilgandra", "Wellington", "Trangie", "Brocklehurst", "Minore", "Wongarbon", "Obley", "Ballimore", "Mendooran"],
  },
  {
    slug: "griffith",
    suburb: "Griffith",
    state: "NSW",
    postcode: "2680",
    council: "Griffith City Council",
    keyRoads: ["Banna Avenue", "Jondaryan Avenue", "Yambil Street", "Irrigation Way"],
    intro:
      "Griffith is the agricultural and wine industry capital of the NSW Riverina, where food processing infrastructure, cold storage facilities and residential development create demand for traffic management plans compliant with Griffith City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Griffith City Council-compliant TMPs for agricultural, industrial and residential projects in the Griffith LGA.",
    industries: [
      "Agricultural and food processing infrastructure",
      "Residential development",
      "Cold storage and logistics",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Leeton", "Narrandera", "Darlington Point", "Yenda", "Hanwood", "Bilbul", "Beelbangera", "Warburn", "Tharbogang", "Whitton"],
  },
  {
    slug: "lismore",
    suburb: "Lismore",
    state: "NSW",
    postcode: "2480",
    council: "Lismore City Council",
    keyRoads: ["Molesworth Street", "Conway Street", "Wyrallah Road", "Ballina Road"],
    intro:
      "Lismore is the commercial centre of the Northern Rivers region and a city undergoing significant reconstruction and resilience works following major flood events, creating strong demand for traffic management documentation compliant with Lismore City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Lismore City Council-compliant TMPs for flood recovery construction, residential development and infrastructure projects in the Northern Rivers.",
    industries: [
      "Flood recovery and resilience construction",
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Goonellabah", "South Lismore", "Wyrallah", "Nimbin", "Clunes", "Dunoon", "McLeans Ridges", "Lindendale", "Rosebank", "Georgica"],
  },
  {
    slug: "orange",
    suburb: "Orange",
    state: "NSW",
    postcode: "2800",
    council: "Orange City Council",
    keyRoads: ["Summer Street", "Lords Place", "Kite Street", "Mitchell Highway"],
    intro:
      "Orange is a thriving regional city in the Central Tablelands renowned for its cool-climate wines and growing population, where residential development, healthcare infrastructure and commercial construction create demand for traffic management plans compliant with Orange City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Orange City Council-compliant TMPs for residential, health and commercial projects in the Orange LGA.",
    industries: [
      "Residential development",
      "Health and hospital infrastructure",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Blayney", "Millthorpe", "Cabonne", "Lucknow", "Bloomfield", "Spring Hill", "Shadforth", "Borenore", "Nashdale", "Ophir"],
  },
  {
    slug: "port-macquarie",
    suburb: "Port Macquarie",
    state: "NSW",
    postcode: "2444",
    council: "Port Macquarie-Hastings Council",
    keyRoads: ["Horton Street", "Gordon Street", "Lake Road", "Hastings River Drive"],
    intro:
      "Port Macquarie is one of the fastest-growing regional cities in NSW, with major residential development, hospital expansion and coastal tourism infrastructure creating strong demand for traffic management plans compliant with Port Macquarie-Hastings Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Port Macquarie-Hastings Council-compliant TMPs for residential, health and tourism construction projects.",
    industries: [
      "Residential subdivision and housing",
      "Health and hospital infrastructure",
      "Tourism and hospitality development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Wauchope", "Laurieton", "Lake Cathie", "Bonny Hills", "North Haven", "Kendall", "Telegraph Point", "Thrumster", "Innes View", "Dunbogan"],
  },
  {
    slug: "tamworth",
    suburb: "Tamworth",
    state: "NSW",
    postcode: "2340",
    council: "Tamworth Regional Council",
    keyRoads: ["Peel Street", "Bridge Street", "White Street", "New England Highway"],
    intro:
      "Tamworth is the regional capital of north-western NSW and Australia's country music capital, where residential development, agricultural services, events infrastructure and healthcare construction create demand for traffic management plans compliant with Tamworth Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Tamworth Regional Council-compliant TMPs for residential, events and infrastructure projects in the Tamworth region.",
    industries: [
      "Residential development",
      "Events and festival infrastructure",
      "Health and hospital construction",
      "Agricultural services infrastructure",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Gunnedah", "Armidale", "Inverell", "Moree", "Narrabri", "Quirindi", "Manilla", "Barraba", "Walcha", "Uralla"],
  },
  {
    slug: "wagga-wagga",
    suburb: "Wagga Wagga",
    state: "NSW",
    postcode: "2650",
    council: "Wagga Wagga City Council",
    keyRoads: ["Baylis Street", "Fitzmaurice Street", "Trail Street", "Edward Street"],
    intro:
      "Wagga Wagga is the largest inland city in NSW and a major regional service centre, where residential development, RAAF Base Wagga infrastructure, university construction and commercial development create strong demand for traffic management plans compliant with Wagga Wagga City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Wagga Wagga City Council-compliant TMPs for residential, defence, education and commercial projects in the Riverina's major centre.",
    industries: [
      "Residential subdivision and housing",
      "Defence and RAAF infrastructure",
      "University and education construction",
      "Commercial and retail development",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Turvey Park", "Estella", "Bourkelands", "Lake Albert", "Forest Hill", "Tatton", "Glenfield Park", "Kooringal", "Tolland", "Springvale"],
  },

  // ─── NEW SOUTH WALES (further additions) ──────────────────────────────────

  // Greater Sydney — Inner suburbs
  {
    slug: "annandale",
    suburb: "Annandale",
    state: "NSW",
    postcode: "2038",
    council: "Inner West Council",
    keyRoads: ["Parramatta Road", "Johnston Street", "Nelson Street", "Bridge Road"],
    intro:
      "Annandale is a charming inner-western Sydney suburb known for its Victorian and Federation heritage homes, where residential construction, boutique commercial development and utility works require traffic management plans compliant with Inner West Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs for Annandale residential and heritage projects, with experience managing the high-volume Parramatta Road corridor.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Leichhardt", "Glebe", "Rozelle", "Balmain", "Pyrmont", "Ultimo", "Forest Lodge", "Newtown", "Petersham", "Stanmore"],
  },
  {
    slug: "artarmon",
    suburb: "Artarmon",
    state: "NSW",
    postcode: "2064",
    council: "Willoughby City Council",
    keyRoads: ["Pacific Highway", "Wilkes Avenue", "Reserve Road", "Hampden Road"],
    intro:
      "Artarmon is a north shore suburb with a strong light industrial and commercial character, where warehouse conversions, commercial development and utility works require traffic management plans compliant with Willoughby City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Artarmon commercial and light industrial projects, with experience on the Pacific Highway corridor.",
    industries: [
      "Light industrial and commercial construction",
      "Warehouse conversion and fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chatswood", "St Leonards", "Lane Cove", "Crows Nest", "Gore Hill", "North Sydney", "Willoughby", "Naremburn", "Cammeray", "Northbridge"],
  },
  {
    slug: "balmain",
    suburb: "Balmain",
    state: "NSW",
    postcode: "2041",
    council: "Inner West Council",
    keyRoads: ["Darling Street", "Beattie Street", "Victoria Road", "Terry Street"],
    intro:
      "Balmain is one of Sydney's most iconic inner-western peninsula suburbs, with a rich maritime and industrial heritage, where residential construction, heritage building refurbishment and boutique commercial works on the narrow heritage streetscape of Darling Street require traffic management plans compliant with Inner West Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs for Balmain residential and heritage projects, sensitive to the suburb's constrained peninsula road network.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Boutique retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Rozelle", "Birchgrove", "Annandale", "Leichhardt", "Drummoyne", "Pyrmont", "Lilyfield", "Camperdown", "Glebe", "Ultimo"],
  },
  {
    slug: "baulkham-hills",
    suburb: "Baulkham Hills",
    state: "NSW",
    postcode: "2153",
    council: "The Hills Shire Council",
    keyRoads: ["Old Northern Road", "Seven Hills Road", "Windsor Road", "Bella Vista Drive"],
    intro:
      "Baulkham Hills is the administrative heart of The Hills Shire, where ongoing residential development, commercial construction and infrastructure upgrades along major arterial roads require traffic management plans compliant with The Hills Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Baulkham Hills residential and commercial projects across The Hills Shire's arterial road network.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Castle Hill", "Norwest", "Bella Vista", "Winston Hills", "Seven Hills", "Pennant Hills", "Carlingford", "Kellyville", "Rouse Hill", "Blacktown"],
  },
  {
    slug: "bondi-junction",
    suburb: "Bondi Junction",
    state: "NSW",
    postcode: "2022",
    council: "Waverley Council",
    keyRoads: ["Oxford Street", "Bronte Road", "Spring Street", "Newland Street"],
    intro:
      "Bondi Junction is Sydney's eastern suburbs major retail and transport hub, anchored by Westfield and the terminus of the Eastern Suburbs Railway, where retail construction, commercial development and utility works create demand for traffic management plans compliant with Waverley Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Waverley Council-compliant TMPs for Bondi Junction retail and commercial projects, with experience in the precinct's busy pedestrian environment.",
    industries: [
      "Retail and commercial construction",
      "High-density residential development",
      "Utility and services upgrades",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Bondi", "Woollahra", "Paddington", "Edgecliff", "Double Bay", "Randwick", "Coogee", "Waverley", "Bronte", "Tamarama"],
  },
  {
    slug: "carlingford",
    suburb: "Carlingford",
    state: "NSW",
    postcode: "2118",
    council: "City of Parramatta Council",
    keyRoads: ["Pennant Hills Road", "Carlingford Road", "Marsden Road", "Church Street"],
    intro:
      "Carlingford is a north-western suburb on the Parramatta-Pennant Hills corridor, where residential development, the Carlingford Court retail precinct and metro corridor planning create demand for traffic management plans compliant with City of Parramatta Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Carlingford residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Epping", "Eastwood", "North Rocks", "West Pennant Hills", "Baulkham Hills", "Parramatta", "Rydalmere", "Oatlands", "Telopea", "Dundas"],
  },
  {
    slug: "concord",
    suburb: "Concord",
    state: "NSW",
    postcode: "2137",
    council: "Canada Bay Council",
    keyRoads: ["Concord Road", "Majors Bay Road", "Burwood Road", "Patterson Street"],
    intro:
      "Concord is an established inner-western suburb on the Parramatta River foreshore, where residential construction and utility works require traffic management plans compliant with Canada Bay Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Canada Bay Council-compliant TMPs for Concord residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Rhodes", "Drummoyne", "Strathfield", "North Strathfield", "Homebush", "Burwood", "Abbotsford", "Five Dock", "Cabarita", "Chiswick"],
  },
  {
    slug: "coogee",
    suburb: "Coogee",
    state: "NSW",
    postcode: "2034",
    council: "Randwick City Council",
    keyRoads: ["Coogee Bay Road", "Arden Street", "Brook Street", "Carr Street"],
    intro:
      "Coogee is a popular eastern suburbs beachside suburb, where coastal residential construction, hospitality fitouts and foreshore works require traffic management plans compliant with Randwick City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Coogee residential and coastal projects.",
    industries: [
      "Coastal residential construction",
      "Hospitality and retail fitouts",
      "Foreshore and coastal works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Randwick", "Maroubra", "Kingsford", "Bronte", "Clovelly", "South Coogee", "Kensington", "Zetland", "Eastgardens", "Botany"],
  },
  {
    slug: "epping",
    suburb: "Epping",
    state: "NSW",
    postcode: "2121",
    council: "City of Parramatta Council",
    keyRoads: ["Beecroft Road", "Carlingford Road", "Ray Road", "Rawson Street"],
    intro:
      "Epping is a major upper north shore and north-western Sydney junction suburb, where high-density residential development driven by the Sydney Metro Northwest line, and commercial construction around the town centre create demand for traffic management plans compliant with City of Parramatta Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Parramatta Council-compliant TMPs for Epping residential and commercial projects, with experience in the metro corridor construction environment.",
    industries: [
      "High-density residential development",
      "Metro corridor civil works",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Eastwood", "Carlingford", "North Epping", "West Ryde", "Meadowbank", "Macquarie Park", "Beecroft", "Cheltenham", "Pennant Hills", "Ryde"],
  },
  {
    slug: "gladesville",
    suburb: "Gladesville",
    state: "NSW",
    postcode: "2111",
    council: "Ryde City Council",
    keyRoads: ["Victoria Road", "Pittwater Road", "Wharf Road", "Ryde Road"],
    intro:
      "Gladesville is a vibrant north-shore suburb on the Parramatta River, known for its dining precinct and heritage bridge, where residential construction and commercial fitouts require traffic management plans compliant with Ryde City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gladesville residential and commercial projects, with knowledge of the Victoria Road arterial corridor.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Ryde", "Meadowbank", "West Ryde", "Putney", "Hunters Hill", "Drummoyne", "Abbotsford", "Cabarita", "Meadowbank", "Lane Cove"],
  },
  {
    slug: "glebe",
    suburb: "Glebe",
    state: "NSW",
    postcode: "2037",
    council: "City of Sydney Council",
    keyRoads: ["Glebe Point Road", "Parramatta Road", "Broadway", "Forest Lodge Road"],
    intro:
      "Glebe is a vibrant inner-city suburb adjacent to the University of Sydney, where residential construction, university-related development and heritage building refurbishment require traffic management plans compliant with City of Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Sydney-compliant TMPs for Glebe residential, education and heritage projects.",
    industries: [
      "Residential construction",
      "University and education support works",
      "Heritage building refurbishment",
      "Retail and hospitality fitouts",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Annandale", "Forest Lodge", "Ultimo", "Pyrmont", "Newtown", "Camperdown", "Leichhardt", "Rozelle", "Balmain", "Sydney CBD"],
  },
  {
    slug: "homebush",
    suburb: "Homebush",
    state: "NSW",
    postcode: "2140",
    council: "Strathfield Municipal Council",
    keyRoads: ["Parramatta Road", "Homebush Bay Drive", "Centenary Drive", "Underwood Road"],
    intro:
      "Homebush is the home of Sydney Olympic Park and a major residential and sporting precinct, where high-density residential construction, sporting venue infrastructure and utility works require traffic management plans compliant with Strathfield Municipal Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Homebush residential and sporting precinct projects.",
    industries: [
      "High-density residential development",
      "Sporting and events infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Strathfield", "North Strathfield", "Concord", "Rhodes", "Flemington", "Auburn", "Newington", "Wentworth Point", "Homebush West", "Burwood"],
  },
  {
    slug: "kellyville",
    suburb: "Kellyville",
    state: "NSW",
    postcode: "2155",
    council: "The Hills Shire Council",
    keyRoads: ["Samantha Riley Drive", "Windsor Road", "Old Windsor Road", "Wrights Road"],
    intro:
      "Kellyville is one of Sydney's fastest-growing suburbs in The Hills Shire, where large residential estates, new schools and the Sydney Metro Northwest line drive ongoing demand for traffic management documentation compliant with The Hills Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares The Hills Shire Council-compliant TMPs for Kellyville residential and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Metro corridor civil works",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Rouse Hill", "Bella Vista", "Norwest", "Baulkham Hills", "Castle Hill", "Glenhaven", "Stanhope Gardens", "Parklea", "Quakers Hill", "Winston Hills"],
  },
  {
    slug: "kingsford",
    suburb: "Kingsford",
    state: "NSW",
    postcode: "2032",
    council: "Randwick City Council",
    keyRoads: ["Anzac Parade", "Gardeners Road", "Barker Street", "Sturt Street"],
    intro:
      "Kingsford is a busy eastern suburbs hub adjacent to the University of New South Wales and Sydney Airport, where residential development, retail construction and utility works require traffic management plans compliant with Randwick City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kingsford residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "University support works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Randwick", "Maroubra", "Coogee", "Kensington", "Eastgardens", "Botany", "Mascot", "Zetland", "Rosebery", "Eastlakes"],
  },
  {
    slug: "lane-cove",
    suburb: "Lane Cove",
    state: "NSW",
    postcode: "2066",
    council: "Lane Cove Municipal Council",
    keyRoads: ["Pacific Highway", "Longueville Road", "Burns Bay Road", "Epping Road"],
    intro:
      "Lane Cove is a leafy north shore suburb known for its national park and thriving village centre, where residential construction and commercial development require traffic management plans compliant with Lane Cove Municipal Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Lane Cove Municipal Council-compliant TMPs for residential and commercial projects in the Lane Cove LGA.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Artarmon", "Chatswood", "Macquarie Park", "Ryde", "Gladesville", "North Ryde", "Longueville", "Linley Point", "St Leonards", "Willoughby"],
  },
  {
    slug: "leichhardt",
    suburb: "Leichhardt",
    state: "NSW",
    postcode: "2040",
    council: "Inner West Council",
    keyRoads: ["Norton Street", "Parramatta Road", "Marion Street", "Balmain Road"],
    intro:
      "Leichhardt is Sydney's 'Little Italy' and a bustling inner-western suburb, where residential construction, commercial fitouts on Norton Street and utility works require traffic management plans compliant with Inner West Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Leichhardt residential and commercial projects, with experience on the Norton Street and Parramatta Road corridors.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Annandale", "Balmain", "Rozelle", "Lilyfield", "Petersham", "Newtown", "Haberfield", "Five Dock", "Ashfield", "Glebe"],
  },
  {
    slug: "mascot",
    suburb: "Mascot",
    state: "NSW",
    postcode: "2020",
    council: "City of Sydney Council",
    keyRoads: ["Botany Road", "Bourke Road", "Coward Street", "Church Avenue"],
    intro:
      "Mascot is a rapidly transforming inner-south suburb adjacent to Sydney Airport, where high-density residential development, hotel construction and aviation-related infrastructure works require traffic management plans compliant with City of Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Sydney-compliant TMPs for Mascot residential, hotel and infrastructure projects, with experience in the airport precinct environment.",
    industries: [
      "High-density residential development",
      "Hotel and hospitality construction",
      "Airport-related infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Botany", "Rosebery", "Alexandria", "Zetland", "Eastlakes", "Kingsford", "Wolli Creek", "Arncliffe", "Marrickville", "Rockdale"],
  },
  {
    slug: "neutral-bay",
    suburb: "Neutral Bay",
    state: "NSW",
    postcode: "2089",
    council: "North Sydney Council",
    keyRoads: ["Military Road", "Kurraba Road", "Ben Boyd Road", "Hayes Street"],
    intro:
      "Neutral Bay is a popular lower north shore suburb with a thriving retail strip and foreshore access, where residential construction and commercial fitouts on Military Road require traffic management plans compliant with North Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Neutral Bay residential and commercial projects, with specialist knowledge of the Military Road corridor.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Cremorne", "Mosman", "Kirribilli", "North Sydney", "Cammeray", "Waverton", "Wollstonecraft", "Crows Nest", "Milsons Point", "Lavender Bay"],
  },
  {
    slug: "paddington",
    suburb: "Paddington",
    state: "NSW",
    postcode: "2021",
    council: "City of Sydney Council",
    keyRoads: ["Oxford Street", "Glenmore Road", "Queen Street", "Jersey Road"],
    intro:
      "Paddington is one of Sydney's most iconic inner suburbs, renowned for its Victorian terrace houses and boutique Oxford Street strip, where heritage building refurbishment, residential construction and retail fitouts require traffic management plans compliant with City of Sydney Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Sydney-compliant TMPs for Paddington heritage and residential projects, with sensitivity to the suburb's historic streetscape.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Boutique retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Woollahra", "Darlinghurst", "Surry Hills", "Bondi Junction", "Edgecliff", "Centennial Park", "Moore Park", "Randwick", "Redfern", "Newtown"],
  },
  {
    slug: "pyrmont",
    suburb: "Pyrmont",
    state: "NSW",
    postcode: "2009",
    council: "City of Sydney Council",
    keyRoads: ["Pyrmont Bridge Road", "Harris Street", "Miller Street", "Union Street"],
    intro:
      "Pyrmont is a densely populated inner-city peninsula suburb and Sydney's major casino and entertainment precinct, where high-rise residential construction, hotel development and the Star casino precinct create complex traffic management requirements compliant with City of Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Pyrmont high-rise, hotel and entertainment precinct projects.",
    industries: [
      "High-density residential development",
      "Hotel and casino construction",
      "Entertainment precinct works",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Ultimo", "Glebe", "Balmain", "Rozelle", "Annandale", "Sydney CBD", "Darling Harbour", "Forest Lodge", "Camperdown", "Haymarket"],
  },
  {
    slug: "rozelle",
    suburb: "Rozelle",
    state: "NSW",
    postcode: "2039",
    council: "Inner West Council",
    keyRoads: ["Victoria Road", "Darling Street", "Terry Street", "Balmain Road"],
    intro:
      "Rozelle is an inner-western suburb at the junction of the Victoria Road and Darling Street corridors, where residential construction and the major Rozelle Interchange WestConnex project drive significant traffic management requirements compliant with Inner West Council and Transport for NSW standards.",
    bodyPara:
      "Focus Traffic Plans prepares Inner West Council-compliant TMPs for Rozelle residential and infrastructure projects, with specialist experience around the WestConnex interchange environment.",
    industries: [
      "Residential construction",
      "Major road and tunnel infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Balmain", "Annandale", "Leichhardt", "Lilyfield", "Drummoyne", "Pyrmont", "Glebe", "Forest Lodge", "Birchgrove", "White Bay"],
  },
  {
    slug: "ryde",
    suburb: "Ryde",
    state: "NSW",
    postcode: "2112",
    council: "Ryde City Council",
    keyRoads: ["Victoria Road", "Devlin Street", "Top Ryde Drive", "Church Street"],
    intro:
      "Ryde is a major northern Sydney activity centre and the administrative heart of Ryde City Council, where high-density residential development, the Top Ryde City retail precinct and ongoing infrastructure upgrades create strong demand for traffic management documentation compliant with Ryde City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ryde residential, retail and infrastructure projects.",
    industries: [
      "High-density residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["West Ryde", "Meadowbank", "Eastwood", "Gladesville", "Macquarie Park", "North Ryde", "Putney", "Ermington", "Shepherd's Hill", "Shepherds Hill"],
  },
  {
    slug: "st-leonards",
    suburb: "St Leonards",
    state: "NSW",
    postcode: "2065",
    council: "North Sydney Council",
    keyRoads: ["Pacific Highway", "Berry Road", "Chandos Street", "William Street"],
    intro:
      "St Leonards is a major lower north shore health and commercial precinct, home to Royal North Shore Hospital and a growing high-density residential corridor, where hospital expansion, commercial construction and metro-related development create demand for traffic management plans compliant with North Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares North Sydney Council-compliant TMPs for St Leonards health, residential and commercial projects.",
    industries: [
      "Health and hospital infrastructure",
      "High-density residential development",
      "Commercial office construction",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Crows Nest", "Artarmon", "Chatswood", "North Sydney", "Waverton", "Wollstonecraft", "Lane Cove", "Neutral Bay", "Greenwich", "Naremburn"],
  },
  {
    slug: "zetland",
    suburb: "Zetland",
    state: "NSW",
    postcode: "2017",
    council: "City of Sydney Council",
    keyRoads: ["Botany Road", "Epsom Road", "O'Dea Avenue", "Joynton Avenue"],
    intro:
      "Zetland is one of Sydney's fastest-growing high-density residential precincts, where a wave of apartment construction, retail development and ongoing infrastructure upgrades create constant demand for traffic management documentation compliant with City of Sydney Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Zetland high-density residential and retail projects.",
    industries: [
      "High-density residential development",
      "Retail and commercial construction",
      "Utility and services upgrades",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Waterloo", "Rosebery", "Alexandria", "Mascot", "Kingsford", "Kensington", "Eastlakes", "Botany", "Beaconsfield", "Erskineville"],
  },
  // South West Sydney
  {
    slug: "cabramatta",
    suburb: "Cabramatta",
    state: "NSW",
    postcode: "2166",
    council: "Fairfield City Council",
    keyRoads: ["John Street", "Railway Parade", "Cabramatta Road", "Sully Street"],
    intro:
      "Cabramatta is a vibrant multicultural centre in south-western Sydney, known for its Vietnamese community and busy commercial precinct, where retail construction, residential development and utility works require traffic management plans compliant with Fairfield City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Fairfield City Council-compliant TMPs for Cabramatta commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Canley Vale", "Canley Heights", "Fairfield", "Bonnyrigg", "Lansvale", "Wetherill Park", "Prairiewood", "Smithfield", "Liverpool", "Villawood"],
  },
  {
    slug: "canley-vale",
    suburb: "Canley Vale",
    state: "NSW",
    postcode: "2166",
    council: "Fairfield City Council",
    keyRoads: ["Canley Vale Road", "Hector Street", "Railway Parade", "Wyong Street"],
    intro:
      "Canley Vale is a residential suburb in south-western Sydney where residential construction and utility works require traffic management plans compliant with Fairfield City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Canley Vale residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cabramatta", "Canley Heights", "Fairfield", "Lansvale", "Bonnyrigg", "Prairiewood", "Smithfield", "Wetherill Park", "Liverpool", "Yennora"],
  },
  {
    slug: "casula",
    suburb: "Casula",
    state: "NSW",
    postcode: "2170",
    council: "Liverpool City Council",
    keyRoads: ["Hume Highway", "Casula Road", "Kurrajong Road", "Camden Valley Way"],
    intro:
      "Casula is a southern Liverpool suburb with a mix of residential and light industrial uses, where construction activity along the Hume Highway corridor requires traffic management plans compliant with Liverpool City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Liverpool City Council-compliant TMPs for Casula residential and commercial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Liverpool", "Lurnea", "Warwick Farm", "Glenfield", "Moorebank", "Hammondville", "Wattle Grove", "Prestons", "Edmondson Park", "Carnes Hill"],
  },
  {
    slug: "edmondson-park",
    suburb: "Edmondson Park",
    state: "NSW",
    postcode: "2174",
    council: "Liverpool City Council",
    keyRoads: ["Gurner Avenue", "Ingleburn Road", "Campbelltown Road", "Edmondson Avenue"],
    intro:
      "Edmondson Park is one of Sydney's newest master-planned residential communities in the South West Growth Corridor, where large-scale estate construction, new schools and community infrastructure create high demand for traffic management documentation compliant with Liverpool City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Edmondson Park residential estate and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Education and community infrastructure",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Oran Park", "Leppington", "Catherine Field", "Harrington Park", "Narellan", "Campbelltown", "Bardia", "Denham Court", "Rossmore", "Gledswood Hills"],
  },
  {
    slug: "gregory-hills",
    suburb: "Gregory Hills",
    state: "NSW",
    postcode: "2557",
    council: "Camden Council",
    keyRoads: ["Gregory Hills Drive", "Mater Dei Drive", "Broughton Street", "Campbelltown Road"],
    intro:
      "Gregory Hills is a rapidly growing masterplanned suburb in the Camden LGA, where residential estate construction, new retail centres and civil infrastructure create demand for traffic management plans compliant with Camden Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Camden Council-compliant TMPs for Gregory Hills residential and civil projects.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Oran Park", "Narellan", "Camden", "Harrington Park", "Mount Annan", "Spring Farm", "Elderslie", "Kirkham", "Ellis Lane", "Currans Hill"],
  },
  {
    slug: "leppington",
    suburb: "Leppington",
    state: "NSW",
    postcode: "2171",
    council: "Camden Council",
    keyRoads: ["Camden Valley Way", "Leppington Road", "Bringelly Road", "Elizabeth Drive"],
    intro:
      "Leppington is a fast-growing greenfield suburb in the South West Growth Corridor, where large residential estates, the Western Sydney Airport precinct and major civil infrastructure create strong demand for traffic management documentation compliant with Camden Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Leppington residential and civil infrastructure projects in the South West Growth Corridor.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Edmondson Park", "Oran Park", "Catherine Field", "Denham Court", "Rossmore", "Cobbitty", "Gledswood Hills", "Luddenham", "Bringelly", "Badgerys Creek"],
  },
  {
    slug: "narellan",
    suburb: "Narellan",
    state: "NSW",
    postcode: "2567",
    council: "Camden Council",
    keyRoads: ["Camden Valley Way", "Narellan Road", "Somerset Avenue", "Elyard Street"],
    intro:
      "Narellan is the major commercial centre of the Camden LGA, anchored by Narellan Town Centre, where retail construction, residential development and infrastructure upgrades in one of Sydney's fastest-growing corridors create demand for traffic management documentation compliant with Camden Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Camden Council-compliant TMPs for Narellan retail, residential and infrastructure projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Infrastructure upgrades",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Camden", "Harrington Park", "Mount Annan", "Gregory Hills", "Spring Farm", "Currans Hill", "Elderslie", "Kirkham", "Ellis Lane", "Catherine Field"],
  },
  {
    slug: "oran-park",
    suburb: "Oran Park",
    state: "NSW",
    postcode: "2570",
    council: "Camden Council",
    keyRoads: ["Oran Park Drive", "Cobbitty Road", "South Circuit", "Greenoaks Avenue"],
    intro:
      "Oran Park is a purpose-built master-planned community on Sydney's south-western fringe, where ongoing residential estate construction, new schools and the expanding town centre create high demand for traffic management plans compliant with Camden Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Oran Park residential estate and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Education and community infrastructure",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Narellan", "Gregory Hills", "Leppington", "Catherine Field", "Harrington Park", "Camden", "Spring Farm", "Mount Annan", "Cobbitty", "Rossmore"],
  },
  // Northern Beaches
  {
    slug: "avalon-beach",
    suburb: "Avalon Beach",
    state: "NSW",
    postcode: "2107",
    council: "Northern Beaches Council",
    keyRoads: ["Barrenjoey Road", "Old Barrenjoey Road", "Bowling Club Road", "Avalon Parade"],
    intro:
      "Avalon Beach is one of Sydney's most beautiful northern beaches villages, where boutique residential construction, coastal infrastructure works and heritage building projects require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Avalon Beach residential and coastal projects.",
    industries: [
      "Coastal residential construction",
      "Boutique commercial development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Bilgola Beach", "Newport", "Mona Vale", "Palm Beach", "Pittwater", "Clareville", "Whale Beach", "Church Point", "Scotland Island", "Warriewood"],
  },
  {
    slug: "balgowlah",
    suburb: "Balgowlah",
    state: "NSW",
    postcode: "2093",
    council: "Northern Beaches Council",
    keyRoads: ["Condamine Street", "Sydney Road", "Beatrice Street", "Manly Road"],
    intro:
      "Balgowlah is a northern beaches suburb on the Condamine Street ridge, where residential construction and retail development around Stockland Balgowlah require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Balgowlah residential and retail projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Manly", "Seaforth", "Fairlight", "Manly Vale", "Brookvale", "Balgowlah Heights", "North Manly", "Queenscliff", "Curl Curl", "Freshwater"],
  },
  {
    slug: "brookvale",
    suburb: "Brookvale",
    state: "NSW",
    postcode: "2100",
    council: "Northern Beaches Council",
    keyRoads: ["Pittwater Road", "Condamine Street", "Warringah Road", "Orchard Road"],
    intro:
      "Brookvale is the Northern Beaches' major retail and light industrial hub, where commercial construction, warehouse development and the Warringah Mall precinct create demand for traffic management plans compliant with Northern Beaches Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Brookvale commercial and light industrial projects.",
    industries: [
      "Retail and commercial construction",
      "Light industrial and warehouse development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Dee Why", "Manly Vale", "Balgowlah", "Narraweena", "Beacon Hill", "Curl Curl", "Freshwater", "Wheeler Heights", "Allambie Heights", "Collaroy"],
  },
  {
    slug: "collaroy",
    suburb: "Collaroy",
    state: "NSW",
    postcode: "2097",
    council: "Northern Beaches Council",
    keyRoads: ["Pittwater Road", "Griffin Road", "The Strand", "Collaroy Street"],
    intro:
      "Collaroy is a beachside suburb on Sydney's Northern Beaches where coastal residential construction and foreshore infrastructure works require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Collaroy coastal residential and foreshore projects.",
    industries: [
      "Coastal residential construction",
      "Foreshore and coastal works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Narrabeen", "Dee Why", "Brookvale", "Long Reef", "Cromer", "Wheeler Heights", "Beacon Hill", "Narraweena", "Curl Curl", "Freshwater"],
  },
  {
    slug: "mona-vale",
    suburb: "Mona Vale",
    state: "NSW",
    postcode: "2103",
    council: "Northern Beaches Council",
    keyRoads: ["Pittwater Road", "Barrenjoey Road", "Mona Vale Road", "Golf Street"],
    intro:
      "Mona Vale is the administrative and commercial hub of Sydney's northern peninsula, where residential construction, retail development and the Mona Vale Hospital redevelopment create demand for traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Mona Vale residential, retail and health projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Health and hospital infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Narrabeen", "Warriewood", "Newport", "Avalon Beach", "Bayview", "Ingleside", "Terrey Hills", "Elanora Heights", "Scotland Island", "Church Point"],
  },
  {
    slug: "narrabeen",
    suburb: "Narrabeen",
    state: "NSW",
    postcode: "2101",
    council: "Northern Beaches Council",
    keyRoads: ["Pittwater Road", "Ocean Street", "Narrabeen Park Parade", "Powder Works Road"],
    intro:
      "Narrabeen is a popular Northern Beaches suburb on the shores of Narrabeen Lagoon, where residential construction, coastal works and the Narrabeen Sports High precinct create demand for traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Narrabeen residential and coastal infrastructure projects.",
    industries: [
      "Coastal residential construction",
      "Foreshore and lagoon works",
      "Education and sports infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Collaroy", "Mona Vale", "Warriewood", "Elanora Heights", "North Narrabeen", "Cromer", "Wheeler Heights", "Dee Why", "Brookvale", "Ingleside"],
  },
  {
    slug: "newport",
    suburb: "Newport",
    state: "NSW",
    postcode: "2106",
    council: "Northern Beaches Council",
    keyRoads: ["Barrenjoey Road", "Pittwater Road", "Kalinya Street", "Prince Alfred Parade"],
    intro:
      "Newport is a vibrant northern beaches village on the Pittwater foreshore, where residential construction, marina development and boutique commercial works require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Newport residential and foreshore projects.",
    industries: [
      "Residential construction",
      "Marina and foreshore works",
      "Boutique retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Avalon Beach", "Mona Vale", "Bilgola Beach", "Warriewood", "Bayview", "Pittwater", "Ingleside", "Church Point", "Scotland Island", "Narrabeen"],
  },
  {
    slug: "palm-beach",
    suburb: "Palm Beach",
    state: "NSW",
    postcode: "2108",
    council: "Northern Beaches Council",
    keyRoads: ["Barrenjoey Road", "Ocean Road", "Florida Road", "Iluka Road"],
    intro:
      "Palm Beach is Sydney's most exclusive beachside village at the tip of the northern peninsula, where luxury residential construction, boutique hospitality development and coastal works require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Palm Beach luxury residential and coastal projects.",
    industries: [
      "Luxury residential construction",
      "Boutique hospitality development",
      "Coastal and foreshore works",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Avalon Beach", "Whale Beach", "Bilgola Beach", "Newport", "Pittwater", "Mona Vale", "Clareville", "Church Point", "Scotland Island", "Bayview"],
  },
  {
    slug: "pittwater",
    suburb: "Pittwater",
    state: "NSW",
    postcode: "2105",
    council: "Northern Beaches Council",
    keyRoads: ["Barrenjoey Road", "McCarrs Creek Road", "Scotland Island Ferry", "West Head Road"],
    intro:
      "Pittwater is Sydney's premier waterway recreation and boating area on the western shores of the northern peninsula, where marina development, waterfront residential construction and environmental works require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Beaches Council-compliant TMPs for Pittwater waterfront and residential projects.",
    industries: [
      "Waterfront and marina construction",
      "Residential construction",
      "Environmental and foreshore works",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Palm Beach", "Newport", "Avalon Beach", "Mona Vale", "Church Point", "Scotland Island", "Bayview", "Clareville", "Whale Beach", "Ingleside"],
  },
  {
    slug: "warriewood",
    suburb: "Warriewood",
    state: "NSW",
    postcode: "2102",
    council: "Northern Beaches Council",
    keyRoads: ["Mona Vale Road", "Pittwater Road", "Jacksons Road", "Vuko Place"],
    intro:
      "Warriewood is a growing northern beaches suburb home to the Warriewood Shopping Square and a significant light industrial estate, where retail construction, residential development and warehouse works require traffic management plans compliant with Northern Beaches Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Warriewood retail, residential and industrial projects.",
    industries: [
      "Retail and commercial construction",
      "Light industrial and warehouse development",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Narrabeen", "Mona Vale", "Elanora Heights", "North Narrabeen", "Ingleside", "Collaroy", "Wheeler Heights", "Cromer", "Dee Why", "Newport"],
  },
  // Hunter Valley (additional)
  {
    slug: "adamstown",
    suburb: "Adamstown",
    state: "NSW",
    postcode: "2289",
    council: "Newcastle City Council",
    keyRoads: ["Brunker Road", "Glebe Road", "Adamstown Road", "Crompton Street"],
    intro:
      "Adamstown is a residential suburb in inner Newcastle where residential construction and utility works require traffic management plans compliant with Newcastle City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Newcastle City Council-compliant TMPs for Adamstown residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Hamilton", "Newcastle CBD", "New Lambton", "Kotara", "Georgetown", "Broadmeadow", "Merewether", "Islington", "Mayfield", "Waratah"],
  },
  {
    slug: "belmont-nsw",
    suburb: "Belmont",
    state: "NSW",
    postcode: "2280",
    council: "Lake Macquarie City Council",
    keyRoads: ["Pacific Highway", "Belmont Road", "Moroney Street", "Thompson Street"],
    intro:
      "Belmont is a major commercial centre on the shores of Lake Macquarie, where retail construction, residential development and utility works require traffic management plans compliant with Lake Macquarie City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Belmont retail and residential projects on the Lake Macquarie waterfront.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Charlestown", "Warners Bay", "Speers Point", "Carey Bay", "Jewells", "Whitebridge", "Gateshead", "Lake Macquarie", "Redhead", "Swansea"],
  },
  {
    slug: "cardiff",
    suburb: "Cardiff",
    state: "NSW",
    postcode: "2285",
    council: "Lake Macquarie City Council",
    keyRoads: ["Main Road", "Macquarie Road", "Munibung Road", "Spencer Street"],
    intro:
      "Cardiff is a light industrial and residential suburb in the Lake Macquarie LGA, where industrial construction and residential development require traffic management plans compliant with Lake Macquarie City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Lake Macquarie City Council-compliant TMPs for Cardiff industrial and residential projects.",
    industries: [
      "Light industrial and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gateshead", "Edgeworth", "Charlestown", "Warners Bay", "Booragul", "Speers Point", "Boolaroo", "Teralba", "Lake Macquarie", "Kotara"],
  },
  {
    slug: "charlestown",
    suburb: "Charlestown",
    state: "NSW",
    postcode: "2290",
    council: "Lake Macquarie City Council",
    keyRoads: ["Charlestown Road", "Pacific Highway", "Pearson Street", "Redhead Road"],
    intro:
      "Charlestown is a major retail and residential hub in Lake Macquarie, anchored by Charlestown Square, where retail construction and residential development create demand for traffic management plans compliant with Lake Macquarie City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Charlestown retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["New Lambton", "Kotara", "Gateshead", "Warners Bay", "Adamstown Heights", "Belmont", "Whitebridge", "Dudley", "Redhead", "Lake Macquarie"],
  },
  {
    slug: "edgeworth",
    suburb: "Edgeworth",
    state: "NSW",
    postcode: "2285",
    council: "Lake Macquarie City Council",
    keyRoads: ["Main Road", "Minmi Road", "Edgeworth David Avenue", "Weakleys Drive"],
    intro:
      "Edgeworth is a residential and light industrial suburb in the Lake Macquarie LGA where construction activity and utility works require traffic management plans compliant with Lake Macquarie City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Lake Macquarie City Council-compliant TMPs for Edgeworth residential and light industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cardiff", "Gateshead", "Charlestown", "Kotara", "Broadmeadow", "Maryland", "Wallsend", "Elermore Vale", "Cameron Park", "Rankin Park"],
  },
  {
    slug: "kotara",
    suburb: "Kotara",
    state: "NSW",
    postcode: "2289",
    council: "Newcastle City Council",
    keyRoads: ["Brunker Road", "Kotara Road", "Park Avenue", "Glebe Road"],
    intro:
      "Kotara is a major retail destination in Newcastle's inner west, home to Westfield Kotara, where retail construction, residential development and utility works create demand for traffic management plans compliant with Newcastle City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kotara retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["New Lambton", "Charlestown", "Adamstown", "Hamilton", "Georgetown", "Broadmeadow", "Waratah", "Merewether", "Islington", "Mayfield"],
  },
  {
    slug: "new-lambton",
    suburb: "New Lambton",
    state: "NSW",
    postcode: "2305",
    council: "Newcastle City Council",
    keyRoads: ["Lookout Road", "Glebe Road", "Elder Street", "Regent Street"],
    intro:
      "New Lambton is a well-established inner Newcastle suburb where residential construction and utility works require traffic management plans compliant with Newcastle City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Newcastle City Council-compliant TMPs for New Lambton residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kotara", "Charlestown", "Adamstown", "Hamilton", "Georgetown", "Newcastle CBD", "Waratah", "Rankin Park", "Garden Suburb", "Elermore Vale"],
  },
  {
    slug: "warners-bay",
    suburb: "Warners Bay",
    state: "NSW",
    postcode: "2282",
    council: "Lake Macquarie City Council",
    keyRoads: ["Lake Road", "Warners Bay Road", "King Street", "Baltimore Street"],
    intro:
      "Warners Bay is a popular lakeside suburb in Lake Macquarie, known for its foreshore dining strip and residential lifestyle, where residential construction and coastal infrastructure works require traffic management plans compliant with Lake Macquarie City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Warners Bay residential and foreshore projects.",
    industries: [
      "Residential construction",
      "Foreshore and lakeside works",
      "Retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Charlestown", "Belmont", "Speers Point", "Carey Bay", "Booragul", "Teralba", "Boolaroo", "Cardiff", "Lake Macquarie", "Gateshead"],
  },
  // Illawarra (additional)
  {
    slug: "albion-park",
    suburb: "Albion Park",
    state: "NSW",
    postcode: "2527",
    council: "Shellharbour City Council",
    keyRoads: ["Princes Highway", "Tongarra Road", "Albion Park Road", "Five Islands Road"],
    intro:
      "Albion Park is a major residential and industrial suburb in the Shellharbour LGA, where residential development, the Illawarra Regional Airport and light industrial construction create demand for traffic management plans compliant with Shellharbour City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shellharbour City Council-compliant TMPs for Albion Park residential and industrial projects.",
    industries: [
      "Residential development",
      "Light industrial and airport-related construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Shellharbour", "Oak Flats", "Dunmore", "Calderwood", "Flinders", "Tongarra", "Dapto", "Kembla Grange", "Horsley", "Wollongong CBD"],
  },
  {
    slug: "bulli",
    suburb: "Bulli",
    state: "NSW",
    postcode: "2516",
    council: "Wollongong City Council",
    keyRoads: ["Lawrence Hargrave Drive", "Princes Highway", "Bulli Pass", "Farrell Road"],
    intro:
      "Bulli is a coastal suburb north of Wollongong at the base of the Illawarra Escarpment, where residential construction and coastal infrastructure works require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bulli residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Thirroul", "Corrimal", "Woonona", "Bellambi", "Russell Vale", "Tarrawanna", "Fairy Meadow", "Austinmer", "Coledale", "Wollongong CBD"],
  },
  {
    slug: "corrimal",
    suburb: "Corrimal",
    state: "NSW",
    postcode: "2518",
    council: "Wollongong City Council",
    keyRoads: ["Princes Highway", "Corrimal Street", "Thomas Street", "Railway Street"],
    intro:
      "Corrimal is a residential and commercial suburb north of Wollongong CBD, where residential construction, retail development and utility works require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wollongong City Council-compliant TMPs for Corrimal residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bulli", "Woonona", "Bellambi", "Russell Vale", "Tarrawanna", "Fairy Meadow", "Balgownie", "Thirroul", "Wollongong CBD", "Towradgi"],
  },
  {
    slug: "fairy-meadow",
    suburb: "Fairy Meadow",
    state: "NSW",
    postcode: "2519",
    council: "Wollongong City Council",
    keyRoads: ["Princes Highway", "Crown Street", "Lawrence Hargrave Drive", "Bode Avenue"],
    intro:
      "Fairy Meadow is a beachside suburb immediately north of Wollongong CBD, adjacent to the University of Wollongong, where residential construction and university-related development require traffic management plans compliant with Wollongong City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fairy Meadow residential and education support projects.",
    industries: [
      "Residential construction",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Wollongong CBD", "Corrimal", "Bulli", "Gwynneville", "Keiraville", "Tarrawanna", "Balgownie", "North Wollongong", "Thirroul", "Towradgi"],
  },
  {
    slug: "oak-flats",
    suburb: "Oak Flats",
    state: "NSW",
    postcode: "2529",
    council: "Shellharbour City Council",
    keyRoads: ["Princes Highway", "Oak Flats Road", "Tullimbar Drive", "Railway Street"],
    intro:
      "Oak Flats is a residential suburb in the Shellharbour LGA where residential construction and utility works require traffic management plans compliant with Shellharbour City Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shellharbour City Council-compliant TMPs for Oak Flats residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Albion Park", "Shellharbour", "Warilla", "Barrack Heights", "Mount Warrigal", "Flinders", "Dunmore", "Dapto", "Kembla Grange", "Kiama"],
  },
  {
    slug: "warilla",
    suburb: "Warilla",
    state: "NSW",
    postcode: "2528",
    council: "Shellharbour City Council",
    keyRoads: ["Lake Entrance Road", "Shellharbour Road", "Berkeley Road", "Tongarra Road"],
    intro:
      "Warilla is a residential suburb adjacent to Lake Illawarra in the Shellharbour LGA, where residential construction and utility works require traffic management plans compliant with Shellharbour City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Warilla residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Shellharbour", "Oak Flats", "Albion Park", "Barrack Heights", "Mount Warrigal", "Flinders", "Windang", "Primbee", "Port Kembla", "Kiama"],
  },
  // Regional NSW (additional)
  {
    slug: "ballina",
    suburb: "Ballina",
    state: "NSW",
    postcode: "2478",
    council: "Ballina Shire Council",
    keyRoads: ["River Street", "Pacific Highway", "Cherry Street", "Ballina Road"],
    intro:
      "Ballina is the major coastal city of the Northern Rivers, a rapidly growing tourism and residential destination at the mouth of the Richmond River, where residential development, tourism infrastructure and the Ballina Byron Gateway Airport create demand for traffic management plans compliant with Ballina Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ballina Shire Council-compliant TMPs for residential, tourism and airport-related projects in the Northern Rivers.",
    industries: [
      "Residential subdivision and housing",
      "Tourism and hospitality construction",
      "Airport and aviation infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Lennox Head", "Byron Bay", "Lismore", "Casino", "Wardell", "Alstonville", "Wollongbar", "Cumbalum", "Tintenbar", "Broken Head"],
  },
  {
    slug: "batemans-bay",
    suburb: "Batemans Bay",
    state: "NSW",
    postcode: "2536",
    council: "Eurobodalla Shire Council",
    keyRoads: ["Beach Road", "Orient Street", "Princes Highway", "North Street"],
    intro:
      "Batemans Bay is the major coastal holiday and retirement city on the NSW South Coast, where residential development, tourism infrastructure and post-bushfire recovery construction create demand for traffic management plans compliant with Eurobodalla Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Batemans Bay residential and tourism projects on the South Coast.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Post-disaster recovery construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Moruya", "Broulee", "Malua Bay", "Surf Beach", "Tomakin", "Mogo", "Narooma", "Bermagui", "Bodalla", "Nelligen"],
  },
  {
    slug: "bega",
    suburb: "Bega",
    state: "NSW",
    postcode: "2550",
    council: "Bega Valley Shire Council",
    keyRoads: ["Carp Street", "Auckland Street", "Princes Highway", "Gipps Street"],
    intro:
      "Bega is the administrative and commercial capital of the Bega Valley, known for its dairy industry and proximity to the Sapphire Coast, where residential development, dairy infrastructure and commercial construction create demand for traffic management plans compliant with Bega Valley Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bega Valley Shire Council-compliant TMPs for residential, dairy and commercial projects in the Bega Valley.",
    industries: [
      "Residential development",
      "Dairy and agricultural infrastructure",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Merimbula", "Tathra", "Bermagui", "Eden", "Cobargo", "Wolumla", "Candelo", "Quaama", "Brogo", "Jellat Jellat"],
  },
  {
    slug: "byron-bay",
    suburb: "Byron Bay",
    state: "NSW",
    postcode: "2481",
    council: "Byron Shire Council",
    keyRoads: ["Jonson Street", "Bangalow Road", "Lawson Street", "Shirley Street"],
    intro:
      "Byron Bay is Australia's most iconic beach destination and one of the most visited tourist towns in the country, where luxury residential construction, boutique hospitality development and coastal infrastructure works in a heavily constrained development environment require traffic management plans compliant with Byron Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans produces Byron Shire Council-compliant TMPs for residential, hospitality and coastal projects, with awareness of the shire's strict environmental and development controls.",
    industries: [
      "Luxury residential construction",
      "Boutique hospitality and tourism development",
      "Coastal and foreshore works",
      "Heritage and environmental sensitive works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Ballina", "Lennox Head", "Suffolk Park", "Brunswick Heads", "Bangalow", "Mullumbimby", "Ocean Shores", "Brunswick Heads", "Ewingsdale", "Broken Head"],
  },
  {
    slug: "cooma",
    suburb: "Cooma",
    state: "NSW",
    postcode: "2630",
    council: "Snowy Monaro Regional Council",
    keyRoads: ["Sharp Street", "Bombala Street", "Commissioner Street", "Snowy Mountains Highway"],
    intro:
      "Cooma is the gateway city to the Snowy Mountains and the administrative centre of Snowy Monaro Regional Council, where Snowy 2.0 infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Snowy Monaro Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Cooma Snowy Hydro, residential and commercial projects in the Snowy Mountains gateway.",
    industries: [
      "Snowy Hydro and energy infrastructure",
      "Residential development",
      "Commercial construction",
      "Tourism infrastructure",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Berridale", "Jindabyne", "Adaminaby", "Bombala", "Nimmitabel", "Dalgety", "Bredbo", "Numeralla", "Chakola", "Canberra"],
  },
  {
    slug: "grafton",
    suburb: "Grafton",
    state: "NSW",
    postcode: "2460",
    council: "Clarence Valley Council",
    keyRoads: ["Prince Street", "Fitzroy Street", "Clarence Street", "Pacific Highway"],
    intro:
      "Grafton is the administrative centre of the Clarence Valley, known for its jacaranda trees and heritage streetscapes, where residential development, heritage building refurbishment and the Pacific Highway bypass drive demand for traffic management plans compliant with Clarence Valley Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Clarence Valley Council-compliant TMPs for residential, heritage and highway infrastructure projects.",
    industries: [
      "Residential development",
      "Heritage building refurbishment",
      "Highway and road infrastructure",
      "Utility maintenance",
      "Commercial construction",
    ],
    nearbySuburbs: ["South Grafton", "Coffs Harbour", "Maclean", "Yamba", "Lismore", "Casino", "Goonellabah", "Lawrence", "Copmanhurst", "Ulmarra"],
  },
  {
    slug: "gunnedah",
    suburb: "Gunnedah",
    state: "NSW",
    postcode: "2380",
    council: "Gunnedah Shire Council",
    keyRoads: ["Conadilly Street", "Marquis Street", "Bloomfield Street", "New England Highway"],
    intro:
      "Gunnedah is the koala capital of the world and a significant agricultural and mining service centre in north-west NSW, where coal mining infrastructure, agricultural construction and residential development create demand for traffic management plans compliant with Gunnedah Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gunnedah mining, agricultural and residential projects.",
    industries: [
      "Mining and resources infrastructure",
      "Agricultural construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Narrabri", "Tamworth", "Quirindi", "Boggabri", "Manilla", "Werris Creek", "Carroll", "Mullaley", "Curlewis", "Emerald Hill"],
  },
  {
    slug: "inverell",
    suburb: "Inverell",
    state: "NSW",
    postcode: "2360",
    council: "Inverell Shire Council",
    keyRoads: ["Byron Street", "Otho Street", "Evans Street", "New England Highway"],
    intro:
      "Inverell is the sapphire mining capital of Australia and a major agricultural service centre in north-west NSW, where mining infrastructure, rural construction and residential development create demand for traffic management plans compliant with Inverell Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Inverell Shire Council-compliant TMPs for mining, agricultural and residential projects.",
    industries: [
      "Mining and gemstone infrastructure",
      "Agricultural construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Glen Innes", "Armidale", "Moree", "Narrabri", "Bingara", "Warialda", "Tingha", "Bundarra", "Copeton", "Gilgai"],
  },
  {
    slug: "merimbula",
    suburb: "Merimbula",
    state: "NSW",
    postcode: "2548",
    council: "Bega Valley Shire Council",
    keyRoads: ["Market Street", "Merimbula Drive", "Sapphire Coast Drive", "Arthur Kaine Drive"],
    intro:
      "Merimbula is the Sapphire Coast's major holiday and retirement town with a busy regional airport, where coastal residential construction, tourism infrastructure and Merimbula Airport works create demand for traffic management plans compliant with Bega Valley Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Merimbula residential, tourism and airport projects on the Sapphire Coast.",
    industries: [
      "Coastal residential construction",
      "Tourism and hospitality development",
      "Airport and aviation infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Pambula", "Bega", "Eden", "Tathra", "Tura Beach", "Wolumla", "Pambula Beach", "Candelo", "Cobargo", "Bermagui"],
  },
  {
    slug: "moree",
    suburb: "Moree",
    state: "NSW",
    postcode: "2400",
    council: "Moree Plains Shire Council",
    keyRoads: ["Balo Street", "Frome Street", "Auburn Street", "Newell Highway"],
    intro:
      "Moree is a major agricultural city on the Newell Highway in north-west NSW, the centre of the cotton and grain belt, where agricultural infrastructure, irrigation construction and residential development create demand for traffic management plans compliant with Moree Plains Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Moree Plains Shire Council-compliant TMPs for agricultural, irrigation and residential projects in the Moree Plains.",
    industries: [
      "Cotton and grain industry infrastructure",
      "Irrigation and water infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Narrabri", "Inverell", "Gunnedah", "Walgett", "Collarenebri", "Mungindi", "Garah", "Boomi", "Warialda", "Gravesend"],
  },
  {
    slug: "narrabri",
    suburb: "Narrabri",
    state: "NSW",
    postcode: "2390",
    council: "Narrabri Shire Council",
    keyRoads: ["Maitland Street", "Tibbereena Street", "Newell Highway", "Barwan Street"],
    intro:
      "Narrabri is a major cotton-growing and gas industry service centre in north-west NSW, home to the Australia Telescope Compact Array, where agricultural infrastructure, gas industry construction and residential development create demand for traffic management plans compliant with Narrabri Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Narrabri agricultural, gas industry and residential projects.",
    industries: [
      "Cotton and agricultural infrastructure",
      "Gas industry construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Moree", "Gunnedah", "Walgett", "Boggabri", "Pilliga", "Bingara", "Warialda", "Gwabegar", "Bellata", "Bugilbone"],
  },
  {
    slug: "tweed-heads",
    suburb: "Tweed Heads",
    state: "NSW",
    postcode: "2485",
    council: "Tweed Shire Council",
    keyRoads: ["Wharf Street", "Griffith Street", "Boyd Street", "Gollan Drive"],
    intro:
      "Tweed Heads is the southernmost point of Queensland's Gold Coast and forms a twin city with Coolangatta, where cross-border residential construction, retail development and tourism infrastructure create demand for traffic management plans compliant with Tweed Shire Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Tweed Shire Council-compliant TMPs for Tweed Heads residential and commercial projects, with experience navigating the NSW-Queensland border construction environment.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Tourism and hospitality development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Coolangatta", "Banora Point", "Bilambil Heights", "Cobaki", "Terranora", "Chinderah", "Kingscliff", "Casuarina", "Murwillumbah", "Currumbin"],
  },

  // ─── VICTORIA ──────────────────────────────────────────────────────────────
  // ─── VICTORIA (further additions) ─────────────────────────────────────────

  // Melbourne CBD & Inner (additional)
  {
    slug: "abbotsford",
    suburb: "Abbotsford",
    state: "VIC",
    postcode: "3067",
    council: "City of Yarra",
    keyRoads: ["Johnston Street", "Victoria Street", "Hoddle Street", "Nicholson Street"],
    intro:
      "Abbotsford is a dynamic inner Melbourne suburb home to the Collingwood Children's Farm and a thriving creative precinct, where residential construction, heritage building conversion and commercial development require traffic management plans compliant with City of Yarra and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Yarra-compliant TMPs for Abbotsford residential and commercial projects.",
    industries: [
      "Residential and mixed-use development",
      "Heritage building conversion",
      "Creative industry fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Collingwood", "Fitzroy", "Richmond", "Clifton Hill", "Kew", "Hawthorn", "Burnley", "Cremorne", "North Fitzroy", "Carlton"],
  },
  {
    slug: "albert-park",
    suburb: "Albert Park",
    state: "VIC",
    postcode: "3206",
    council: "City of Port Phillip",
    keyRoads: ["Kingsway", "Canterbury Road", "Bridport Street", "Victoria Avenue"],
    intro:
      "Albert Park is a prestigious bayside suburb home to the Albert Park Formula 1 circuit, where residential construction, events infrastructure and foreshore works require traffic management plans compliant with City of Port Phillip and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Albert Park residential and events infrastructure projects, with experience managing the F1 precinct environment.",
    industries: [
      "Residential construction",
      "Events and motorsport infrastructure",
      "Foreshore and parkland works",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["South Melbourne", "St Kilda", "Middle Park", "Port Melbourne", "Southbank", "Prahran", "Windsor", "Elwood", "Balaclava", "Ripponlea"],
  },
  {
    slug: "east-melbourne",
    suburb: "East Melbourne",
    state: "VIC",
    postcode: "3002",
    council: "City of Melbourne",
    keyRoads: ["Punt Road", "Brunton Avenue", "Wellington Parade", "Lansdowne Street"],
    intro:
      "East Melbourne is an exclusive inner suburb adjacent to the MCG and Melbourne Cricket Ground precinct, where residential construction, sporting infrastructure and heritage building works require traffic management plans compliant with City of Melbourne and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melbourne-compliant TMPs for East Melbourne residential and sporting precinct projects.",
    industries: [
      "Residential construction",
      "Sports and entertainment infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Melbourne CBD", "Richmond", "Collingwood", "Fitzroy", "Carlton", "Abbotsford", "Jolimont", "Hawthorn", "Burnley", "South Yarra"],
  },
  {
    slug: "fitzroy-north",
    suburb: "Fitzroy North",
    state: "VIC",
    postcode: "3068",
    council: "City of Yarra",
    keyRoads: ["St Georges Road", "Nicholson Street", "Brunswick Street", "Queens Parade"],
    intro:
      "Fitzroy North is a popular inner Melbourne suburb where residential construction, heritage building renovation and retail development require traffic management plans compliant with City of Yarra and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fitzroy North residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Fitzroy", "Carlton North", "Northcote", "Clifton Hill", "Collingwood", "Brunswick", "Brunswick East", "Abbotsford", "Carlton", "North Melbourne"],
  },
  {
    slug: "flemington",
    suburb: "Flemington",
    state: "VIC",
    postcode: "3031",
    council: "City of Melbourne",
    keyRoads: ["Racecourse Road", "Epsom Road", "Mt Alexander Road", "Flemington Road"],
    intro:
      "Flemington is home to Flemington Racecourse and the Melbourne Cup, where events infrastructure, residential construction and utility works require traffic management plans compliant with City of Melbourne and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melbourne-compliant TMPs for Flemington residential and events infrastructure projects.",
    industries: [
      "Residential construction",
      "Events and racecourse infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kensington", "North Melbourne", "Moonee Ponds", "Ascot Vale", "Essendon", "Parkville", "Carlton", "West Melbourne", "Travancore", "Newmarket"],
  },
  {
    slug: "kensington-vic",
    suburb: "Kensington",
    state: "VIC",
    postcode: "3031",
    council: "City of Melbourne",
    keyRoads: ["Racecourse Road", "Bellair Street", "Macaulay Road", "Kensington Road"],
    intro:
      "Kensington is an inner Melbourne suburb undergoing rapid residential transformation, where high-density apartment construction and mixed-use development require traffic management plans compliant with City of Melbourne and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kensington residential and mixed-use development projects.",
    industries: [
      "High-density residential development",
      "Mixed-use construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Flemington", "North Melbourne", "Moonee Ponds", "Ascot Vale", "West Melbourne", "Footscray", "Parkville", "Carlton", "Newmarket", "Travancore"],
  },
  {
    slug: "middle-park",
    suburb: "Middle Park",
    state: "VIC",
    postcode: "3206",
    council: "City of Port Phillip",
    keyRoads: ["Richardson Street", "Canterbury Road", "Armstrong Street", "Beaconsfield Parade"],
    intro:
      "Middle Park is a prestigious bayside suburb with heritage-listed streetscapes, where residential construction and heritage building refurbishment require traffic management plans compliant with City of Port Phillip and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Phillip-compliant TMPs for Middle Park residential and heritage projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Albert Park", "St Kilda", "South Melbourne", "Port Melbourne", "Elwood", "Windsor", "Prahran", "Balaclava", "Ripponlea", "Southbank"],
  },
  {
    slug: "prahran",
    suburb: "Prahran",
    state: "VIC",
    postcode: "3181",
    council: "City of Stonnington",
    keyRoads: ["Chapel Street", "High Street", "Commercial Road", "Malvern Road"],
    intro:
      "Prahran is a vibrant inner Melbourne suburb and a key node on the Chapel Street retail and entertainment corridor, where residential construction, retail fitouts and utility works require traffic management plans compliant with City of Stonnington and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Prahran residential and commercial projects, with experience on the Chapel Street corridor.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["South Yarra", "Windsor", "St Kilda", "Armadale", "Malvern", "Toorak", "Balaclava", "Richmond", "Elwood", "Ripponlea"],
  },
  {
    slug: "toorak",
    suburb: "Toorak",
    state: "VIC",
    postcode: "3142",
    council: "City of Stonnington",
    keyRoads: ["Toorak Road", "Orrong Road", "Irving Road", "Kooyong Road"],
    intro:
      "Toorak is Melbourne's most prestigious suburb, where luxury residential construction, high-end retail fitouts and heritage building works require traffic management plans compliant with City of Stonnington and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stonnington-compliant TMPs for Toorak luxury residential and commercial projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "High-end retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["South Yarra", "Armadale", "Malvern", "Kooyong", "Hawthorn", "Prahran", "Glen Iris", "Kew", "Richmond", "Windsor"],
  },
  {
    slug: "west-melbourne",
    suburb: "West Melbourne",
    state: "VIC",
    postcode: "3003",
    council: "City of Melbourne",
    keyRoads: ["Spencer Street", "King Street", "Dudley Street", "Footscray Road"],
    intro:
      "West Melbourne is an inner suburb adjacent to the CBD and Docklands, undergoing rapid residential transformation, where high-density apartment construction and infrastructure upgrades require traffic management plans compliant with City of Melbourne and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for West Melbourne high-density residential and infrastructure projects.",
    industries: [
      "High-density residential development",
      "Mixed-use construction",
      "Utility and services upgrades",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Melbourne CBD", "Docklands", "North Melbourne", "Kensington", "Flemington", "Footscray", "Parkville", "Carlton", "Southbank", "Port Melbourne"],
  },
  {
    slug: "windsor",
    suburb: "Windsor",
    state: "VIC",
    postcode: "3181",
    council: "City of Stonnington",
    keyRoads: ["Chapel Street", "High Street", "Punt Road", "Williams Road"],
    intro:
      "Windsor is a trendy inner Melbourne suburb at the southern end of the Chapel Street strip, where residential construction, boutique retail fitouts and heritage building works require traffic management plans compliant with City of Stonnington and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stonnington-compliant TMPs for Windsor residential and commercial projects.",
    industries: [
      "Residential construction",
      "Boutique retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Prahran", "South Yarra", "St Kilda", "Armadale", "Balaclava", "Ripponlea", "Elwood", "Richmond", "Malvern", "Toorak"],
  },
  {
    slug: "yarraville",
    suburb: "Yarraville",
    state: "VIC",
    postcode: "3013",
    council: "Maribyrnong City Council",
    keyRoads: ["Hyde Street", "Anderson Road", "Somerville Road", "Francis Street"],
    intro:
      "Yarraville is a sought-after inner-western Melbourne suburb known for its village atmosphere and heritage cinema, where residential construction and boutique commercial development require traffic management plans compliant with Maribyrnong City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Yarraville residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Boutique retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Footscray", "Seddon", "Kingsville", "Spotswood", "Newport", "Williamstown", "West Footscray", "Sunshine", "Sunshine North", "Maribyrnong"],
  },
  // Inner East Melbourne
  {
    slug: "balwyn",
    suburb: "Balwyn",
    state: "VIC",
    postcode: "3103",
    council: "City of Boroondara",
    keyRoads: ["Whitehorse Road", "Balwyn Road", "Mont Albert Road", "Belmore Road"],
    intro:
      "Balwyn is an affluent eastern suburb in the City of Boroondara, where luxury residential construction and heritage building works require traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Boroondara-compliant TMPs for Balwyn residential and heritage projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
    ],
    nearbySuburbs: ["Box Hill", "Camberwell", "Canterbury", "Kew", "Mont Albert", "Surrey Hills", "Blackburn", "Doncaster", "Bulleen", "Templestowe Lower"],
  },
  {
    slug: "camberwell",
    suburb: "Camberwell",
    state: "VIC",
    postcode: "3124",
    council: "City of Boroondara",
    keyRoads: ["Burke Road", "Camberwell Road", "Riversdale Road", "Toorak Road"],
    intro:
      "Camberwell is a major eastern suburbs activity centre and one of Melbourne's most sought-after residential areas, where residential construction, the Burke Road retail strip and heritage building works create demand for traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Camberwell residential and commercial projects, with experience on the Burke Road corridor.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Hawthorn", "Kew", "Glen Iris", "Surrey Hills", "Canterbury", "Balwyn", "Box Hill", "Ashburton", "Malvern East", "Deepdene"],
  },
  {
    slug: "canterbury-vic",
    suburb: "Canterbury",
    state: "VIC",
    postcode: "3126",
    council: "City of Boroondara",
    keyRoads: ["Canterbury Road", "Balwyn Road", "Maling Road", "Prospect Hill Road"],
    intro:
      "Canterbury is one of Melbourne's most prestigious suburbs, known for its grand heritage homes and the Maling Road village, where luxury residential construction and heritage building refurbishment require traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Boroondara-compliant TMPs for Canterbury luxury residential and heritage projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Boutique retail fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Camberwell", "Balwyn", "Surrey Hills", "Box Hill", "Kew", "Mont Albert", "Deepdene", "Hawthorn East", "Wattle Park", "Blackburn"],
  },
  {
    slug: "glen-iris",
    suburb: "Glen Iris",
    state: "VIC",
    postcode: "3146",
    council: "City of Boroondara",
    keyRoads: ["High Street", "Malvern Road", "Burke Road", "Gardiners Creek Road"],
    intro:
      "Glen Iris is a large, established inner-eastern suburb where residential construction and dual occupancy development require traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Glen Iris residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Malvern", "Toorak", "Hawthorn East", "Camberwell", "Ashburton", "Malvern East", "Armadale", "Prahran", "Surrey Hills", "Gardiner"],
  },
  {
    slug: "hawthorn",
    suburb: "Hawthorn",
    state: "VIC",
    postcode: "3122",
    council: "City of Boroondara",
    keyRoads: ["Burwood Road", "Glenferrie Road", "Auburn Road", "Riversdale Road"],
    intro:
      "Hawthorn is a prestigious inner eastern suburb and the home of Hawthorn Football Club, where residential construction, heritage building refurbishment and the Glenferrie Road retail strip generate demand for traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Boroondara-compliant TMPs for Hawthorn residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Richmond", "Camberwell", "Kew", "Glen Iris", "Malvern", "South Yarra", "Toorak", "Abbotsford", "Auburn", "Balwyn"],
  },
  {
    slug: "kew",
    suburb: "Kew",
    state: "VIC",
    postcode: "3101",
    council: "City of Boroondara",
    keyRoads: ["Cotham Road", "High Street", "Burke Road", "Studley Park Road"],
    intro:
      "Kew is a prestigious inner eastern suburb on the Yarra River, where luxury residential construction, heritage building works and the Kew Junction activity centre create demand for traffic management plans compliant with City of Boroondara and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kew residential and commercial projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Hawthorn", "Camberwell", "Balwyn", "Abbotsford", "Fitzroy North", "Collingwood", "Carlton", "Richmond", "Clifton Hill", "Deepdene"],
  },
  {
    slug: "malvern",
    suburb: "Malvern",
    state: "VIC",
    postcode: "3144",
    council: "City of Stonnington",
    keyRoads: ["Glenferrie Road", "Malvern Road", "Waverley Road", "High Street"],
    intro:
      "Malvern is an affluent inner-eastern Melbourne suburb with the prestigious Glenferrie Road retail strip, where residential construction and heritage building works require traffic management plans compliant with City of Stonnington and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stonnington-compliant TMPs for Malvern residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Toorak", "South Yarra", "Armadale", "Glen Iris", "Malvern East", "Prahran", "Hawthorn East", "Caulfield North", "Carnegie", "Gardiner"],
  },
  // Eastern Melbourne (additional)
  {
    slug: "blackburn",
    suburb: "Blackburn",
    state: "VIC",
    postcode: "3130",
    council: "Whitehorse City Council",
    keyRoads: ["Whitehorse Road", "Blackburn Road", "Canterbury Road", "Railway Road"],
    intro:
      "Blackburn is a well-established eastern Melbourne suburb where residential construction and utility works require traffic management plans compliant with Whitehorse City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Blackburn residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Nunawading", "Mitcham", "Box Hill", "Forest Hill", "Blackburn North", "Blackburn South", "Ringwood", "Vermont", "Doncaster East", "Burwood East"],
  },
  {
    slug: "doncaster",
    suburb: "Doncaster",
    state: "VIC",
    postcode: "3108",
    council: "Manningham City Council",
    keyRoads: ["Doncaster Road", "Tram Road", "Manningham Road", "Williamsons Road"],
    intro:
      "Doncaster is a major eastern Melbourne activity centre anchored by Westfield Doncaster, where retail construction, residential development and utility works require traffic management plans compliant with Manningham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Manningham City Council-compliant TMPs for Doncaster retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Templestowe", "Warrandyte", "Balwyn", "Bulleen", "Donvale", "Park Orchards", "Doncaster East", "Blackburn", "Box Hill", "Nunawading"],
  },
  {
    slug: "forest-hill",
    suburb: "Forest Hill",
    state: "VIC",
    postcode: "3131",
    council: "Whitehorse City Council",
    keyRoads: ["Whitehorse Road", "Canterbury Road", "Springvale Road", "Forest Hill Chase"],
    intro:
      "Forest Hill is an eastern Melbourne suburb home to Forest Hill Chase Shopping Centre, where retail construction and residential development require traffic management plans compliant with Whitehorse City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Forest Hill retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Vermont", "Nunawading", "Mitcham", "Blackburn", "Ringwood", "Blackburn South", "Burwood East", "Wantirna", "Knox", "Heathmont"],
  },
  {
    slug: "glen-waverley",
    suburb: "Glen Waverley",
    state: "VIC",
    postcode: "3150",
    council: "Monash City Council",
    keyRoads: ["Springvale Road", "Blackburn Road", "Ferntree Gully Road", "Kingsway"],
    intro:
      "Glen Waverley is a major south-eastern activity centre and the administrative heart of Monash, anchored by The Glen shopping centre, where retail construction, residential development and infrastructure upgrades create demand for traffic management documentation compliant with Monash City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Monash City Council-compliant TMPs for Glen Waverley retail, residential and infrastructure projects.",
    industries: [
      "Retail and commercial construction",
      "High-density residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mount Waverley", "Wheelers Hill", "Rowville", "Wantirna South", "Forest Hill", "Burwood East", "Vermont South", "Syndal", "Brandon Park", "Mulgrave"],
  },
  {
    slug: "mount-waverley",
    suburb: "Mount Waverley",
    state: "VIC",
    postcode: "3149",
    council: "Monash City Council",
    keyRoads: ["Stephensons Road", "Pinewood Drive", "High Street Road", "Waverley Road"],
    intro:
      "Mount Waverley is a large, established south-eastern suburb where residential construction and utility works require traffic management plans compliant with Monash City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mount Waverley residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Glen Waverley", "Oakleigh", "Huntingdale", "Burwood East", "Chadstone", "Mulgrave", "Wheelers Hill", "Ashwood", "Chadstone", "Syndal"],
  },
  {
    slug: "rowville",
    suburb: "Rowville",
    state: "VIC",
    postcode: "3178",
    council: "Knox City Council",
    keyRoads: ["Wellington Road", "Stud Road", "Kelletts Road", "Fulham Road"],
    intro:
      "Rowville is a large outer eastern suburb where residential construction and utility works require traffic management plans compliant with Knox City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Knox City Council-compliant TMPs for Rowville residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ferntree Gully", "Knox", "Scoresby", "Lysterfield", "Knoxfield", "Wantirna South", "Glen Waverley", "Wheelers Hill", "Boronia", "Bayswater"],
  },
  {
    slug: "templestowe",
    suburb: "Templestowe",
    state: "VIC",
    postcode: "3106",
    council: "Manningham City Council",
    keyRoads: ["Manningham Road", "Templestowe Road", "Reynolds Road", "Porter Street"],
    intro:
      "Templestowe is a leafy eastern Melbourne suburb where residential construction and utility works require traffic management plans compliant with Manningham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Templestowe residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Doncaster", "Warrandyte", "Donvale", "Park Orchards", "Bulleen", "Eltham", "Templestowe Lower", "Doncaster East", "Ringwood North", "Mitcham"],
  },
  {
    slug: "warrandyte",
    suburb: "Warrandyte",
    state: "VIC",
    postcode: "3113",
    council: "Manningham City Council",
    keyRoads: ["Warrandyte Road", "Yarra Street", "Harris Gully Road", "Jumping Creek Road"],
    intro:
      "Warrandyte is a semi-rural riverside township in Melbourne's outer east on the Yarra River, where residential construction and bushfire-resilient building works in a heritage-sensitive environment require traffic management plans compliant with Manningham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Manningham City Council-compliant TMPs for Warrandyte residential and rural infrastructure projects.",
    industries: [
      "Residential construction",
      "Bushfire resilience works",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Templestowe", "Doncaster", "Park Orchards", "Donvale", "Ringwood North", "Croydon Hills", "Kangaroo Ground", "North Warrandyte", "Wonga Park", "Research"],
  },
  // Western Melbourne (additional)
  {
    slug: "caroline-springs",
    suburb: "Caroline Springs",
    state: "VIC",
    postcode: "3023",
    council: "Melton City Council",
    keyRoads: ["Caroline Springs Boulevard", "Ballarat Road", "Taylors Road", "Western Ring Road"],
    intro:
      "Caroline Springs is a large master-planned residential community in Melbourne's western growth corridor, where ongoing residential estate construction and retail development create demand for traffic management plans compliant with Melton City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Caroline Springs residential and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and civil construction",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Deer Park", "Taylors Hill", "Burnside", "Ravenhall", "Cairnlea", "Kings Park", "Sunshine West", "Delahey", "Rockbank", "Toolern Vale"],
  },
  {
    slug: "laverton",
    suburb: "Laverton",
    state: "VIC",
    postcode: "3028",
    council: "Hobsons Bay City Council",
    keyRoads: ["Dohertys Road", "Aviation Road", "Old Geelong Road", "Fitzgerald Road"],
    intro:
      "Laverton is a western Melbourne suburb with a significant defence presence at RAAF Base Williams, where defence construction, residential development and industrial works require traffic management plans compliant with Hobsons Bay City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Hobsons Bay City Council-compliant TMPs for Laverton defence, industrial and residential projects.",
    industries: [
      "Defence and RAAF infrastructure",
      "Industrial and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["Altona", "Altona North", "Hoppers Crossing", "Werribee", "Point Cook", "Seaholme", "Brooklyn", "Altona Meadows", "Williams Landing", "Truganina"],
  },
  {
    slug: "melton",
    suburb: "Melton",
    state: "VIC",
    postcode: "3337",
    council: "Melton City Council",
    keyRoads: ["High Street", "Coburn Avenue", "Brooklyn Road", "Barries Road"],
    intro:
      "Melton is one of Victoria's fastest-growing local government areas and a major western growth corridor city, where large residential estates, new schools and commercial development create strong demand for traffic management documentation compliant with Melton City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Melton residential, education and commercial projects in Victoria's fastest-growing western corridor.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Caroline Springs", "Taylors Hill", "Hillside", "Brookfield", "Kurunjang", "Toolern Vale", "Rockbank", "Eynesbury", "Bacchus Marsh", "Plumpton"],
  },
  {
    slug: "newport-vic",
    suburb: "Newport",
    state: "VIC",
    postcode: "3015",
    council: "Hobsons Bay City Council",
    keyRoads: ["Melbourne Road", "North Road", "Hall Street", "Paine Street"],
    intro:
      "Newport is an inner western Melbourne suburb known for its heritage streetscapes and proximity to Williamstown, where residential construction and heritage building refurbishment require traffic management plans compliant with Hobsons Bay City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Hobsons Bay City Council-compliant TMPs for Newport residential and heritage projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Williamstown", "Spotswood", "Yarraville", "Seddon", "Altona North", "Brooklyn", "Footscray", "Kingsville", "West Footscray", "South Kingsville"],
  },
  {
    slug: "seddon",
    suburb: "Seddon",
    state: "VIC",
    postcode: "3011",
    council: "Maribyrnong City Council",
    keyRoads: ["Victoria Street", "Charles Street", "Douglas Street", "Droop Street"],
    intro:
      "Seddon is a charming inner-western Melbourne suburb with a growing café and restaurant culture, where residential construction and boutique commercial development require traffic management plans compliant with Maribyrnong City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Seddon residential and commercial projects.",
    industries: [
      "Residential construction",
      "Boutique retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Yarraville", "Footscray", "West Footscray", "Kingsville", "Newport", "Spotswood", "Altona North", "Brooklyn", "Maidstone", "Sunshine"],
  },
  {
    slug: "tarneit",
    suburb: "Tarneit",
    state: "VIC",
    postcode: "3029",
    council: "Wyndham City Council",
    keyRoads: ["Derrimut Road", "Leakes Road", "Tarneit Road", "Sayers Road"],
    intro:
      "Tarneit is one of Melbourne's fastest-growing outer western suburbs, where large residential estate construction, new schools and retail centres create high demand for traffic management documentation compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wyndham City Council-compliant TMPs for Tarneit residential and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Hoppers Crossing", "Truganina", "Wyndham Vale", "Point Cook", "Werribee", "Laverton North", "Williams Landing", "Manor Lakes", "Mambourin", "Little River"],
  },
  {
    slug: "truganina",
    suburb: "Truganina",
    state: "VIC",
    postcode: "3029",
    council: "Wyndham City Council",
    keyRoads: ["Palmers Road", "Leakes Road", "Dohertys Road", "Princes Freeway"],
    intro:
      "Truganina is a rapidly growing outer western suburb in Wyndham City, where residential estate construction and major logistics and warehouse development create demand for traffic management plans compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Truganina residential and logistics/warehouse projects.",
    industries: [
      "Residential subdivision and housing",
      "Logistics and warehouse development",
      "Utility maintenance",
      "Road and civil construction",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Tarneit", "Hoppers Crossing", "Wyndham Vale", "Laverton North", "Point Cook", "Werribee", "Williams Landing", "Manor Lakes", "Ravenhall", "Deer Park"],
  },
  {
    slug: "wyndham-vale",
    suburb: "Wyndham Vale",
    state: "VIC",
    postcode: "3024",
    council: "Wyndham City Council",
    keyRoads: ["Ballan Road", "Honour Avenue", "Lonsdale Circuit", "Shadow Dance Drive"],
    intro:
      "Wyndham Vale is a growing outer western residential suburb where ongoing estate construction and civil infrastructure create demand for traffic management plans compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wyndham City Council-compliant TMPs for Wyndham Vale residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Hoppers Crossing", "Tarneit", "Truganina", "Werribee", "Manor Lakes", "Mambourin", "Little River", "Cocoroc", "Laverton", "Point Cook"],
  },
  // Northern Melbourne (additional)
  {
    slug: "bundoora",
    suburb: "Bundoora",
    state: "VIC",
    postcode: "3083",
    council: "Whittlesea City Council",
    keyRoads: ["Plenty Road", "Kingsbury Drive", "McKimmies Road", "Dundas Street"],
    intro:
      "Bundoora is a northern Melbourne suburb home to La Trobe University and RMIT's Bundoora campus, where university construction, residential development and health infrastructure works create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bundoora university, health and residential projects.",
    industries: [
      "University and education construction",
      "Health infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Mill Park", "South Morang", "Thomastown", "Lalor", "Reservoir", "Preston", "Kingsbury", "Heidelberg West", "Watsonia", "Greensborough"],
  },
  {
    slug: "doreen",
    suburb: "Doreen",
    state: "VIC",
    postcode: "3754",
    council: "Whittlesea City Council",
    keyRoads: ["Hazel Glen Drive", "Bridge Inn Road", "Yan Yean Road", "Donnybrook Road"],
    intro:
      "Doreen is a fast-growing outer northern suburb where large residential estate construction and associated civil infrastructure create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whittlesea City Council-compliant TMPs for Doreen residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mernda", "South Morang", "Mill Park", "Wollert", "Yarrambat", "Whittlesea", "Plenty", "Hurstbridge", "Eltham", "Research"],
  },
  {
    slug: "eltham",
    suburb: "Eltham",
    state: "VIC",
    postcode: "3095",
    council: "Nillumbik Shire Council",
    keyRoads: ["Main Road", "Diamond Creek Road", "Eltham-Yarra Glen Road", "Arthur Street"],
    intro:
      "Eltham is a leafy outer northern suburb known for its arts community and natural environment, where residential construction and community infrastructure works in a bushland setting require traffic management plans compliant with Nillumbik Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Eltham residential and community infrastructure projects.",
    industries: [
      "Residential construction",
      "Arts and cultural infrastructure",
      "Community infrastructure",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Greensborough", "Diamond Creek", "Montmorency", "Research", "Watsonia", "Briar Hill", "St Helena", "Hurstbridge", "Kangaroo Ground", "Doreen"],
  },
  {
    slug: "greensborough",
    suburb: "Greensborough",
    state: "VIC",
    postcode: "3088",
    council: "Banyule City Council",
    keyRoads: ["Main Street", "Diamond Creek Road", "Grimshaw Street", "Sherbourne Road"],
    intro:
      "Greensborough is a major northern suburban centre with Greensborough Plaza, where retail construction, residential development and utility works require traffic management plans compliant with Banyule City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Banyule City Council-compliant TMPs for Greensborough retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Eltham", "Diamond Creek", "Watsonia", "St Helena", "Briar Hill", "Montmorency", "Research", "Bundoora", "Mill Park", "South Morang"],
  },
  {
    slug: "heidelberg",
    suburb: "Heidelberg",
    state: "VIC",
    postcode: "3084",
    council: "Banyule City Council",
    keyRoads: ["Burgundy Street", "Lower Heidelberg Road", "Manningham Road", "Bell Street"],
    intro:
      "Heidelberg is a northern Melbourne suburb home to Austin Hospital, where health infrastructure construction, residential development and commercial works require traffic management plans compliant with Banyule City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Heidelberg health, residential and commercial projects.",
    industries: [
      "Health and hospital infrastructure",
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Rosanna", "Eaglemont", "Ivanhoe", "Viewbank", "Watsonia", "Bundoora", "Macleod", "Bellfield", "Alphington", "Fitzroy North"],
  },
  {
    slug: "mernda",
    suburb: "Mernda",
    state: "VIC",
    postcode: "3754",
    council: "Whittlesea City Council",
    keyRoads: ["Bridge Inn Road", "Plenty Road", "Donnybrook Road", "Mernda Village Drive"],
    intro:
      "Mernda is a rapidly growing northern suburb served by the Mernda rail extension, where large residential estate construction and associated infrastructure create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whittlesea City Council-compliant TMPs for Mernda residential and civil projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Rail and transport infrastructure",
      "Utility maintenance",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Doreen", "South Morang", "Mill Park", "Wollert", "Epping", "Lalor", "Thomastown", "Yarrambat", "Whittlesea", "Plenty"],
  },
  {
    slug: "mill-park",
    suburb: "Mill Park",
    state: "VIC",
    postcode: "3082",
    council: "Whittlesea City Council",
    keyRoads: ["Plenty Road", "Childs Road", "McKimmies Road", "Gordons Road"],
    intro:
      "Mill Park is a northern Melbourne suburb where residential construction and utility works require traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mill Park residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["South Morang", "Lalor", "Epping", "Bundoora", "Reservoir", "Thomastown", "Mernda", "Doreen", "Wollert", "Watsonia North"],
  },
  {
    slug: "south-morang",
    suburb: "South Morang",
    state: "VIC",
    postcode: "3752",
    council: "Whittlesea City Council",
    keyRoads: ["Plenty Road", "Bridge Inn Road", "Gorge Road", "Yan Yean Road"],
    intro:
      "South Morang is the terminus of Melbourne's Mernda rail line and a major northern growth suburb, where large residential estate construction and rail corridor infrastructure create strong demand for traffic management documentation compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whittlesea City Council-compliant TMPs for South Morang residential and rail-adjacent projects.",
    industries: [
      "Residential subdivision and housing",
      "Rail and transport infrastructure",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Mernda", "Mill Park", "Doreen", "Epping", "Lalor", "Thomastown", "Wollert", "Bundoora", "Plenty", "Yarrambat"],
  },
  {
    slug: "wollert",
    suburb: "Wollert",
    state: "VIC",
    postcode: "3750",
    council: "Whittlesea City Council",
    keyRoads: ["Donnybrook Road", "Epping Road", "Bridge Inn Road", "Hume Freeway"],
    intro:
      "Wollert is a greenfield growth suburb in Melbourne's northern corridor, where large residential estate construction and civil infrastructure create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wollert residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mernda", "Doreen", "South Morang", "Epping", "Lalor", "Craigieburn", "Donnybrook", "Kalkallo", "Somerton", "Mickleham"],
  },
  // Southern Melbourne (additional)
  {
    slug: "berwick",
    suburb: "Berwick",
    state: "VIC",
    postcode: "3806",
    council: "Casey City Council",
    keyRoads: ["Princes Highway", "Bunjil Way", "Clyde Road", "Kangan Drive"],
    intro:
      "Berwick is a major outer south-eastern activity centre and one of Casey's established residential hubs, where retail construction, residential development and the Casey Hospital precinct create demand for traffic management plans compliant with Casey City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Casey City Council-compliant TMPs for Berwick retail, health and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Health and hospital infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Cranbourne", "Narre Warren", "Lyndhurst", "Harkaway", "Officer", "Beaconsfield", "Clyde", "Clyde North", "Guys Hill", "Botanic Ridge"],
  },
  {
    slug: "carrum-downs",
    suburb: "Carrum Downs",
    state: "VIC",
    postcode: "3201",
    council: "Frankston City Council",
    keyRoads: ["Frankston-Dandenong Road", "Hall Road", "Wedge Road", "McCormicks Road"],
    intro:
      "Carrum Downs is a residential and light industrial suburb in Frankston City where residential construction and industrial development require traffic management plans compliant with Frankston City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Carrum Downs residential and light industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Frankston", "Seaford", "Langwarrin", "Skye", "Patterson Lakes", "Chelsea Heights", "Karingal", "Baxter", "Sandhurst", "Cranbourne West"],
  },
  {
    slug: "caulfield",
    suburb: "Caulfield",
    state: "VIC",
    postcode: "3162",
    council: "Glen Eira City Council",
    keyRoads: ["Balaclava Road", "Hawthorn Road", "Dandenong Road", "Booran Road"],
    intro:
      "Caulfield is an inner south-eastern Melbourne suburb home to Caulfield Racecourse and Monash University's Caulfield campus, where residential construction, university development and utility works require traffic management plans compliant with Glen Eira City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Glen Eira City Council-compliant TMPs for Caulfield residential, university and commercial projects.",
    industries: [
      "Residential construction",
      "University and education development",
      "Racecourse and events infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["St Kilda East", "Balaclava", "Ripponlea", "Elsternwick", "Carnegie", "Glen Huntly", "Malvern East", "Ormond", "Bentleigh", "Brighton East"],
  },
  {
    slug: "clayton",
    suburb: "Clayton",
    state: "VIC",
    postcode: "3168",
    council: "Monash City Council",
    keyRoads: ["Clayton Road", "Carinish Road", "Dandenong Road", "Wellington Road"],
    intro:
      "Clayton is a major south-eastern Melbourne precinct home to Monash University's main campus and Monash Medical Centre, where university construction, health infrastructure and residential development create strong demand for traffic management documentation compliant with Monash City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Clayton university, health and residential projects.",
    industries: [
      "University and education construction",
      "Health and hospital infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Oakleigh", "Huntingdale", "Springvale", "Mulgrave", "Notting Hill", "Wheelers Hill", "Mount Waverley", "Glen Waverley", "Clarinda", "Moorabbin"],
  },
  {
    slug: "hampton",
    suburb: "Hampton",
    state: "VIC",
    postcode: "3188",
    council: "Bayside City Council",
    keyRoads: ["Hampton Street", "Beach Road", "Bay Street", "Bluff Road"],
    intro:
      "Hampton is a sought-after bayside suburb in the City of Bayside, where residential construction and coastal infrastructure works require traffic management plans compliant with Bayside City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bayside City Council-compliant TMPs for Hampton residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Brighton", "Sandringham", "Cheltenham", "Highett", "Moorabbin", "Bentleigh", "Black Rock", "Beaumaris", "Mentone", "Parkdale"],
  },
  {
    slug: "keysborough",
    suburb: "Keysborough",
    state: "VIC",
    postcode: "3173",
    council: "Greater Dandenong Council",
    keyRoads: ["Springvale Road", "Cheltenham Road", "Hutton Road", "Perry Road"],
    intro:
      "Keysborough is a major industrial and residential suburb in Greater Dandenong, where industrial construction, warehouse development and residential works require traffic management plans compliant with Greater Dandenong Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Keysborough industrial and residential projects.",
    industries: [
      "Industrial and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Dandenong", "Noble Park", "Springvale", "Cheltenham", "Moorabbin", "Dingley Village", "Braeside", "Lyndhurst", "Bangholme", "Heatherton"],
  },
  {
    slug: "narre-warren",
    suburb: "Narre Warren",
    state: "VIC",
    postcode: "3805",
    council: "Casey City Council",
    keyRoads: ["Princes Highway", "Narre Warren-Cranbourne Road", "Pound Road", "Victor Crescent"],
    intro:
      "Narre Warren is home to Westfield Fountain Gate, one of Victoria's largest shopping centres, and a major residential hub in the City of Casey, where retail construction and residential development create demand for traffic management documentation compliant with Casey City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Casey City Council-compliant TMPs for Narre Warren retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Berwick", "Cranbourne", "Lyndhurst", "Hallam", "Hampton Park", "Endeavour Hills", "Doveton", "Dandenong", "Keysborough", "Clyde"],
  },
  {
    slug: "noble-park",
    suburb: "Noble Park",
    state: "VIC",
    postcode: "3174",
    council: "Greater Dandenong Council",
    keyRoads: ["Princes Highway", "Douglas Street", "Corrigan Road", "Noble Park Road"],
    intro:
      "Noble Park is a diverse residential and commercial suburb in Greater Dandenong where residential construction and commercial development require traffic management plans compliant with Greater Dandenong Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Noble Park residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Dandenong", "Springvale", "Keysborough", "Bangholme", "Lyndhurst", "Hallam", "Hampton Park", "Endeavour Hills", "Doveton", "Rowville"],
  },
  {
    slug: "pakenham",
    suburb: "Pakenham",
    state: "VIC",
    postcode: "3810",
    council: "Cardinia Shire Council",
    keyRoads: ["Princes Highway", "Main Street", "O'Shea Road", "Henry Road"],
    intro:
      "Pakenham is one of Victoria's fastest-growing outer south-eastern towns, where large residential estates, a major retail precinct and infrastructure upgrades create strong demand for traffic management documentation compliant with Cardinia Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cardinia Shire Council-compliant TMPs for Pakenham residential, retail and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Officer", "Beaconsfield", "Berwick", "Drouin", "Warragul", "Bunyip", "Nar Nar Goon", "Tynong", "Garfield", "Koo Wee Rup"],
  },
  {
    slug: "seaford-vic",
    suburb: "Seaford",
    state: "VIC",
    postcode: "3198",
    council: "Frankston City Council",
    keyRoads: ["Nepean Highway", "Wells Road", "Station Street", "Seaford Road"],
    intro:
      "Seaford is a coastal suburb in Frankston City where residential construction and coastal infrastructure works require traffic management plans compliant with Frankston City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Seaford residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Frankston", "Carrum", "Carrum Downs", "Chelsea", "Edithvale", "Bonbeach", "Langwarrin", "Karingal", "Leawarra", "Baxter"],
  },
  // Geelong region (additional)
  {
    slug: "armstrong-creek",
    suburb: "Armstrong Creek",
    state: "VIC",
    postcode: "3217",
    council: "City of Greater Geelong",
    keyRoads: ["Surf Coast Highway", "Boundary Road", "Horseshoe Bend Road", "Warralily Boulevard"],
    intro:
      "Armstrong Creek is Geelong's major southern growth corridor, where large residential estate construction and associated civil infrastructure create strong demand for traffic management documentation compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Armstrong Creek residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Grovedale", "Charlemont", "Mount Duneed", "Torquay", "Jan Juc", "Waurn Ponds", "Marshall", "Highton", "Belmont", "Freshwater Creek"],
  },
  {
    slug: "clifton-springs",
    suburb: "Clifton Springs",
    state: "VIC",
    postcode: "3222",
    council: "City of Greater Geelong",
    keyRoads: ["Clifton Springs Road", "Morningtons Road", "Murradoc Road", "Grubb Road"],
    intro:
      "Clifton Springs is a growing Bellarine Peninsula suburb where residential construction and coastal infrastructure works require traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Clifton Springs residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Drysdale", "Portarlington", "Leopold", "Indented Head", "St Leonards", "Curlewis", "Bellarine", "Ocean Grove", "Barwon Heads", "Geelong CBD"],
  },
  {
    slug: "drysdale",
    suburb: "Drysdale",
    state: "VIC",
    postcode: "3222",
    council: "City of Greater Geelong",
    keyRoads: ["Bellarine Highway", "Murradoc Road", "High Street", "Marcus Hill Road"],
    intro:
      "Drysdale is the main service town of the Bellarine Peninsula where residential development and rural lifestyle construction require traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Drysdale residential and rural infrastructure projects.",
    industries: [
      "Residential construction",
      "Rural lifestyle development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Clifton Springs", "Portarlington", "Leopold", "Ocean Grove", "Barwon Heads", "St Leonards", "Indented Head", "Curlewis", "Bellarine", "Geelong CBD"],
  },
  {
    slug: "newtown-vic",
    suburb: "Newtown",
    state: "VIC",
    postcode: "3220",
    council: "City of Greater Geelong",
    keyRoads: ["Pakington Street", "Shannon Avenue", "West Fyans Street", "Minerva Road"],
    intro:
      "Newtown is one of Geelong's most prestigious residential suburbs, home to the famous Pakington Street café and retail strip, where residential construction and commercial fitouts require traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Newtown residential and commercial projects, with experience on the Pakington Street corridor.",
    industries: [
      "Residential construction",
      "Boutique retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Geelong CBD", "South Geelong", "Manifold Heights", "Geelong West", "Herne Hill", "Hamlyn Heights", "Belmont", "Highton", "Drumcondra", "Rippleside"],
  },
  {
    slug: "portarlington",
    suburb: "Portarlington",
    state: "VIC",
    postcode: "3223",
    council: "City of Greater Geelong",
    keyRoads: ["Jetty Road", "Queenscliff Road", "Arthur Street", "The Esplanade"],
    intro:
      "Portarlington is a coastal township on the Bellarine Peninsula and a popular mussel farming and tourism destination, where residential construction and foreshore infrastructure works require traffic management plans compliant with City of Greater Geelong requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Portarlington residential and coastal projects.",
    industries: [
      "Residential construction",
      "Tourism and foreshore infrastructure",
      "Marine and aquaculture works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Clifton Springs", "Drysdale", "Indented Head", "St Leonards", "Leopold", "Queenscliff", "Ocean Grove", "Barwon Heads", "Bellarine", "Geelong CBD"],
  },
  // Bendigo (additional)
  {
    slug: "golden-square",
    suburb: "Golden Square",
    state: "VIC",
    postcode: "3555",
    council: "City of Greater Bendigo",
    keyRoads: ["High Street", "Mackenzie Street", "McIvor Road", "Midland Highway"],
    intro:
      "Golden Square is a major commercial and residential suburb south of Bendigo CBD where retail construction and residential development require traffic management plans compliant with City of Greater Bendigo and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Golden Square commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bendigo CBD", "Kangaroo Flat", "California Gully", "Eaglehawk", "Long Gully", "Flora Hill", "Strathdale", "Spring Gully", "Quarry Hill", "Kennington"],
  },
  {
    slug: "kennington",
    suburb: "Kennington",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["McIvor Road", "Napier Street", "Burns Street", "Neale Street"],
    intro:
      "Kennington is a residential suburb adjacent to La Trobe University's Bendigo campus where residential construction and university-related works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Kennington residential and education support projects.",
    industries: [
      "Residential construction",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Flora Hill", "Strathdale", "Epsom", "Bendigo CBD", "Golden Square", "Spring Gully", "Kangaroo Flat", "White Hills", "Maiden Gully", "Junortoun"],
  },
  {
    slug: "quarry-hill",
    suburb: "Quarry Hill",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Napier Street", "Arnold Street", "Baxter Street", "Mollison Street"],
    intro:
      "Quarry Hill is a residential suburb close to Bendigo CBD where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Quarry Hill residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bendigo CBD", "California Gully", "Eaglehawk", "Long Gully", "Golden Square", "Kangaroo Flat", "Flora Hill", "Spring Gully", "Kennington", "West Bendigo"],
  },
  {
    slug: "spring-gully",
    suburb: "Spring Gully",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Spring Gully Road", "High Street", "McIvor Road", "Neale Street"],
    intro:
      "Spring Gully is a residential suburb south-east of Bendigo CBD where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Spring Gully residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Golden Square", "Kangaroo Flat", "Flora Hill", "Kennington", "Strathdale", "Bendigo CBD", "Junortoun", "Quarry Hill", "Big Hill", "California Gully"],
  },
  {
    slug: "white-hills",
    suburb: "White Hills",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Northern Highway", "Napier Street", "Midland Highway", "Shearer Street"],
    intro:
      "White Hills is a northern residential suburb of Bendigo where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for White Hills residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bendigo CBD", "Strathdale", "Kennington", "Epsom", "Junortoun", "Maiden Gully", "Golden Square", "Kangaroo Flat", "Huntly", "Long Gully"],
  },
  // Regional Victoria (additional)
  {
    slug: "castlemaine",
    suburb: "Castlemaine",
    state: "VIC",
    postcode: "3450",
    council: "Mount Alexander Shire Council",
    keyRoads: ["Barker Street", "Templeton Street", "Forest Street", "Kennedy Street"],
    intro:
      "Castlemaine is the heritage gold rush capital of Central Victoria and a vibrant arts town, where residential construction, heritage building refurbishment and tourism infrastructure require traffic management plans compliant with Mount Alexander Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Mount Alexander Shire Council-compliant TMPs for Castlemaine heritage, residential and tourism projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Arts and tourism infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Chewton", "Maldon", "Harcourt", "Newstead", "Guildford", "Campbells Creek", "Vaughan", "Taradale", "Elphinstone", "Kyneton"],
  },
  {
    slug: "echuca",
    suburb: "Echuca",
    state: "VIC",
    postcode: "3564",
    council: "Campaspe Shire Council",
    keyRoads: ["High Street", "Ogilvie Avenue", "Murray Esplanade", "Cobb Highway"],
    intro:
      "Echuca is the paddle steamer capital of Australia on the Murray River, a major tourist destination and agricultural service centre, where tourism infrastructure, irrigation construction and residential development create demand for traffic management plans compliant with Campaspe Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Echuca tourism, agricultural and residential projects on the Murray River.",
    industries: [
      "Tourism and hospitality construction",
      "Agricultural and irrigation infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Moama", "Tongala", "Rochester", "Kyabram", "Gunbower", "Lockington", "Stanhope", "Bamawm", "Elmore", "Pyramid Hill"],
  },
  {
    slug: "hamilton-vic",
    suburb: "Hamilton",
    state: "VIC",
    postcode: "3300",
    council: "Southern Grampians Shire Council",
    keyRoads: ["Gray Street", "Brown Street", "Thompson Street", "Ballarat Road"],
    intro:
      "Hamilton is the regional capital of south-west Victoria and a major wool industry service centre, where agricultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Southern Grampians Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Southern Grampians Shire Council-compliant TMPs for Hamilton agricultural, residential and commercial projects.",
    industries: [
      "Agricultural and wool industry infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Coleraine", "Dunkeld", "Penshurst", "Macarthur", "Cavendish", "Glenthompson", "Balmoral", "Casterton", "Merino", "Dartmoor"],
  },
  {
    slug: "morwell",
    suburb: "Morwell",
    state: "VIC",
    postcode: "3840",
    council: "Latrobe City Council",
    keyRoads: ["Commercial Road", "Princes Drive", "Church Street", "Hazelwood Road"],
    intro:
      "Morwell is the commercial centre of the Latrobe Valley and the Latrobe City administrative hub, where energy infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Latrobe City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Morwell energy, residential and commercial projects in the Latrobe Valley.",
    industries: [
      "Energy and industrial infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Traralgon", "Moe", "Churchill", "Newborough", "Yallourn North", "Hernes Oak", "Boolarra", "Yinnar", "Mirboo North", "Toongabbie"],
  },
  {
    slug: "seymour",
    suburb: "Seymour",
    state: "VIC",
    postcode: "3660",
    council: "Mitchell Shire Council",
    keyRoads: ["Emily Street", "High Street", "Wallis Street", "Goulburn Valley Highway"],
    intro:
      "Seymour is a major service centre in the Mitchell Shire, home to the Puckapunyal military area and a significant agricultural hub, where defence construction, agricultural infrastructure and residential development create demand for traffic management plans compliant with Mitchell Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Mitchell Shire Council-compliant TMPs for Seymour defence, agricultural and residential projects.",
    industries: [
      "Defence and military infrastructure",
      "Agricultural construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Puckapunyal", "Tallarook", "Broadford", "Kilmore", "Yea", "Nagambie", "Euroa", "Avenel", "Alexandra", "Molesworth"],
  },
  {
    slug: "swan-hill",
    suburb: "Swan Hill",
    state: "VIC",
    postcode: "3585",
    council: "Swan Hill Rural City Council",
    keyRoads: ["Campbell Street", "Curlewis Street", "Beveridge Street", "Murlong Street"],
    intro:
      "Swan Hill is a major Murray River city and the agricultural hub of the Mallee region, where irrigation infrastructure, horticultural construction and residential development create demand for traffic management plans compliant with Swan Hill Rural City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Swan Hill agricultural, irrigation and residential projects in the Murray Mallee.",
    industries: [
      "Irrigation and agricultural infrastructure",
      "Horticultural construction",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Kerang", "Robinvale", "Mildura", "Sea Lake", "Nyah", "Woorinen", "Lake Boga", "Ultima", "Donald", "Quambatook"],
  },
  {
    slug: "wonthaggi",
    suburb: "Wonthaggi",
    state: "VIC",
    postcode: "3995",
    council: "Bass Coast Shire Council",
    keyRoads: ["Graham Street", "McBride Avenue", "Murray Street", "South Dudley Road"],
    intro:
      "Wonthaggi is the major service centre of Bass Coast Shire and the gateway to Phillip Island, where residential development, tourism infrastructure and coastal works create demand for traffic management plans compliant with Bass Coast Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bass Coast Shire Council-compliant TMPs for Wonthaggi residential, tourism and infrastructure projects.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Inverloch", "Cape Paterson", "Dalyston", "Coronet Bay", "Kilcunda", "Leongatha", "Korumburra", "San Remo", "Phillip Island", "Cowes"],
  },

  {
    slug: "melbourne-cbd",
    suburb: "Melbourne CBD",
    state: "VIC",
    postcode: "3000",
    council: "City of Melbourne",
    keyRoads: ["Swanston Street", "Flinders Street", "Collins Street", "Spencer Street"],
    intro:
      "Melbourne CBD is Australia's second-largest central business district and one of the most complex urban environments for traffic management, with tram networks, pedestrian-priority zones, underground rail construction and constant commercial development demanding meticulous TMP and TGS documentation compliant with City of Melbourne and VicRoads standards.",
    bodyPara:
      "Focus Traffic Plans prepares all traffic management plan documentation for Melbourne CBD projects, with experience navigating the unique challenges of tram interface, pedestrian management and City of Melbourne permit requirements.",
    industries: [
      "Commercial tower construction",
      "Tram and rail infrastructure",
      "Retail and hospitality fitouts",
      "Utility and services upgrades",
      "Events and public gatherings",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Southbank", "Docklands", "North Melbourne", "Carlton", "Fitzroy", "Collingwood", "East Melbourne", "West Melbourne", "Parkville", "South Yarra"],
  },
  {
    slug: "southbank",
    suburb: "Southbank",
    state: "VIC",
    postcode: "3006",
    council: "City of Melbourne",
    keyRoads: ["City Road", "Sturt Street", "St Kilda Road", "Kings Way"],
    intro:
      "Southbank is Melbourne's premium arts and entertainment precinct, where high-rise apartment towers, hotel developments and arts infrastructure projects sit alongside one of Australia's busiest pedestrian promenades. Traffic management plans for Southbank must carefully manage pedestrian flows along the Yarra riverwalk and comply with City of Melbourne requirements.",
    bodyPara:
      "Focus Traffic Plans produces TMP and pedestrian control plan documentation for Southbank construction projects, with a focus on protecting the heavy pedestrian and cycling traffic along the riverside precinct.",
    industries: [
      "High-density residential construction",
      "Hotel and hospitality development",
      "Arts and cultural infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["Melbourne CBD", "South Melbourne", "Port Melbourne", "Albert Park", "St Kilda Road", "Docklands", "Richmond", "South Yarra", "Prahran", "Windsor"],
  },
  {
    slug: "st-kilda",
    suburb: "St Kilda",
    state: "VIC",
    postcode: "3182",
    council: "City of Port Phillip",
    keyRoads: ["Fitzroy Street", "St Kilda Road", "Carlisle Street", "Barkly Street"],
    intro:
      "St Kilda is Melbourne's iconic beachside suburb, combining a dense residential population with major tourist attractions, an active events calendar and ongoing apartment construction. Traffic management plans must account for tram routes, high pedestrian volumes and the City of Port Phillip's requirements for works near the foreshore and entertainment precincts.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Phillip-compliant TMPs and pedestrian management plans for St Kilda projects, with experience on Fitzroy Street and the foreshore precinct.",
    industries: [
      "Residential apartment construction",
      "Hospitality and events fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Balaclava", "Elwood", "South Yarra", "Prahran", "Windsor", "Albert Park", "Middle Park", "Ripponlea", "Brighton", "Caulfield"],
  },
  {
    slug: "fitzroy",
    suburb: "Fitzroy",
    state: "VIC",
    postcode: "3065",
    council: "City of Yarra",
    keyRoads: ["Brunswick Street", "Smith Street", "Johnston Street", "Alexandra Parade"],
    intro:
      "Fitzroy is one of Melbourne's most densely built inner suburbs, with heritage-listed streetscapes, high pedestrian and cycling traffic, and constant construction and maintenance activity. The City of Yarra applies detailed requirements to works on Brunswick Street and the surrounding laneways, demanding carefully prepared traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans produces City of Yarra-compliant TMP and pedestrian control plan documentation for Fitzroy projects, including complex heritage streetscape works and mixed-use developments.",
    industries: [
      "Heritage building refurbishment",
      "Residential conversion and development",
      "Hospitality and retail fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and cultural activities",
    ],
    nearbySuburbs: ["Collingwood", "Carlton", "Brunswick", "Northcote", "Richmond", "Clifton Hill", "Abbotsford", "Fitzroy North", "East Melbourne", "Melbourne CBD"],
  },
  {
    slug: "box-hill",
    suburb: "Box Hill",
    state: "VIC",
    postcode: "3128",
    council: "Whitehorse City Council",
    keyRoads: ["Whitehorse Road", "Station Street", "Elgar Road", "Nelson Road"],
    intro:
      "Box Hill is Melbourne's eastern activity centre and one of metropolitan Melbourne's fastest-growing urban hubs, with major hospital expansion, high-density residential development and a significant tram and rail interchange creating consistent demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans supports Box Hill construction projects with Whitehorse City Council-compliant TMPs and TGS documentation, with experience managing works around the busy Box Hill Central interchange and Whitehorse Road corridor.",
    industries: [
      "Hospital and healthcare construction",
      "High-density residential development",
      "Retail and commercial development",
      "Transport infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Blackburn", "Nunawading", "Mitcham", "Mont Albert", "Surrey Hills", "Wantirna", "Vermont", "Burwood", "Ringwood", "Doncaster"],
  },
  {
    slug: "dandenong",
    suburb: "Dandenong",
    state: "VIC",
    postcode: "3175",
    council: "Greater Dandenong Council",
    keyRoads: ["Princes Highway", "Foster Street", "Lonsdale Street", "Cheltenham Road"],
    intro:
      "Dandenong is Melbourne's largest industrial and commercial activity centre outside the CBD, with extensive manufacturing, warehousing and logistics operations alongside significant urban renewal creating ongoing demand for traffic management plans suited to a high-frequency heavy vehicle environment.",
    bodyPara:
      "Focus Traffic Plans prepares Greater Dandenong Council-compliant TMP documentation for industrial, commercial and civil projects in Dandenong, with experience managing heavy vehicle interfaces and complex arterial road environments.",
    industries: [
      "Industrial and logistics construction",
      "Commercial and retail development",
      "Urban renewal and residential projects",
      "Utility maintenance",
      "Road and infrastructure upgrades",
      "Government and council projects",
    ],
    nearbySuburbs: ["Noble Park", "Springvale", "Keysborough", "Doveton", "Hallam", "Rowville", "Lyndhurst", "Cranbourne", "Berwick", "Narre Warren"],
  },
  {
    slug: "geelong",
    suburb: "Geelong CBD",
    state: "VIC",
    postcode: "3220",
    council: "City of Greater Geelong",
    keyRoads: ["Moorabool Street", "Ryrie Street", "Malop Street", "Princes Highway"],
    intro:
      "Geelong CBD is undergoing a major urban renaissance, with significant waterfront redevelopment, commercial precinct upgrades and growing residential density transforming the city centre. Traffic management plans for Geelong projects must comply with City of Greater Geelong requirements and address the city's key arterial network.",
    bodyPara:
      "Focus Traffic Plans provides TMP, TGS and council permit documentation for Geelong CBD and the broader Greater Geelong region, supporting the city's strong construction pipeline.",
    industries: [
      "Waterfront and commercial redevelopment",
      "Residential construction",
      "Educational facility development",
      "Utility maintenance",
      "Road and infrastructure upgrades",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["Newtown", "South Geelong", "North Geelong", "Corio", "Belmont", "Grovedale", "Lara", "Torquay", "Ocean Grove", "Leopold"],
  },
  {
    slug: "ballarat",
    suburb: "Ballarat",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Sturt Street", "Lydiard Street", "Mair Street", "Macarthur Street"],
    intro:
      "Ballarat is Victoria's third-largest city and a significant regional centre, with active residential development, heritage precinct maintenance and major road upgrades creating consistent demand for traffic management plan documentation across the city and its growing outer suburbs.",
    bodyPara:
      "Focus Traffic Plans delivers fast-turnaround TMP and TGS documentation for Ballarat projects, compliant with City of Ballarat requirements and the heritage streetscape standards that apply to much of the CBD.",
    industries: [
      "Heritage building refurbishment",
      "Residential and commercial construction",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and council projects",
      "Educational facility development",
    ],
    nearbySuburbs: ["Wendouree", "Sebastopol", "Lucas", "Mount Clear", "Alfredton", "Delacombe", "Ballarat East", "Ballarat North", "Buninyong", "Smythesdale"],
  },
  {
    slug: "frankston",
    suburb: "Frankston",
    state: "VIC",
    postcode: "3199",
    council: "Frankston City Council",
    keyRoads: ["Nepean Highway", "Frankston-Dandenong Road", "Playne Street", "Wells Street"],
    intro:
      "Frankston is Melbourne's southern gateway and a major activity centre, with significant residential development, hospital expansion and growing commercial investment creating ongoing demand for traffic management plans on the Nepean Highway and local arterial network.",
    bodyPara:
      "Focus Traffic Plans supports Frankston contractors and developers with Frankston City Council-compliant TMP documentation and council permit applications for all project types.",
    industries: [
      "Residential construction and subdivision",
      "Hospital and healthcare development",
      "Commercial and retail projects",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Industrial development",
    ],
    nearbySuburbs: ["Seaford", "Carrum", "Langwarrin", "Skye", "Karingal", "Frankston South", "Mornington", "Mount Eliza", "Baxter", "Carrum Downs"],
  },

  // ─── VICTORIA (additional) ─────────────────────────────────────────────────

  // Melbourne CBD & Inner
  {
    slug: "carlton",
    suburb: "Carlton",
    state: "VIC",
    postcode: "3053",
    council: "City of Melbourne",
    keyRoads: ["Lygon Street", "Swanston Street", "Grattan Street", "Queensberry Street"],
    intro:
      "Carlton is Melbourne's university and café culture precinct, home to the University of Melbourne and bordered by the Royal Melbourne Hospital, where ongoing campus construction, hospital upgrades and residential development require traffic management plans compliant with City of Melbourne and VicRoads standards.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melbourne-compliant TMPs for Carlton projects, with experience managing pedestrian-heavy construction environments around university precincts and hospital sites.",
    industries: [
      "University and education construction",
      "Health and hospital infrastructure",
      "Residential and mixed-use development",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Fitzroy", "Parkville", "Melbourne CBD", "North Melbourne", "Brunswick", "Princes Hill", "Flemington", "Kensington", "Clifton Hill", "Collingwood"],
  },
  {
    slug: "collingwood",
    suburb: "Collingwood",
    state: "VIC",
    postcode: "3066",
    council: "City of Yarra",
    keyRoads: ["Smith Street", "Johnston Street", "Wellington Street", "Hoddle Street"],
    intro:
      "Collingwood is one of Melbourne's most dynamic inner suburbs, where creative industry offices, residential conversions and retail construction generate constant demand for traffic management plans compliant with City of Yarra and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Collingwood construction and utility projects, navigating the suburb's dense street grid and City of Yarra permit requirements.",
    industries: [
      "Residential and mixed-use development",
      "Office and creative industry fitouts",
      "Heritage building refurbishment",
      "Retail and hospitality construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Fitzroy", "Abbotsford", "Richmond", "East Melbourne", "Carlton", "Clifton Hill", "North Fitzroy", "Northcote", "Cremorne", "Burnley"],
  },
  {
    slug: "docklands",
    suburb: "Docklands",
    state: "VIC",
    postcode: "3008",
    council: "City of Melbourne",
    keyRoads: ["Docklands Drive", "Harbour Esplanade", "Collins Street", "Bourke Street"],
    intro:
      "Docklands is Melbourne's major waterfront urban renewal precinct, with ongoing commercial tower construction, residential development and public realm upgrades requiring detailed traffic management plans compliant with City of Melbourne requirements in a mixed pedestrian and vehicle environment.",
    bodyPara:
      "Focus Traffic Plans produces City of Melbourne-compliant TMPs for Docklands projects, with experience in the precinct's unique shared-path and waterfront construction environment.",
    industries: [
      "Commercial tower construction",
      "Residential and mixed-use development",
      "Public realm and waterfront works",
      "Utility and services upgrades",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["Melbourne CBD", "West Melbourne", "North Melbourne", "Southbank", "Port Melbourne", "Kensington", "Flemington", "Footscray", "Yarraville", "Spotswood"],
  },
  {
    slug: "north-melbourne",
    suburb: "North Melbourne",
    state: "VIC",
    postcode: "3051",
    council: "City of Melbourne",
    keyRoads: ["Flemington Road", "Abbotsford Street", "Victoria Street", "Racecourse Road"],
    intro:
      "North Melbourne is an inner suburb of Melbourne undergoing rapid residential densification, with apartment construction, hospital precinct expansion and tram corridor upgrades driving demand for traffic management documentation compliant with City of Melbourne and VicRoads standards.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melbourne-compliant TMPs for North Melbourne residential and infrastructure projects, with experience on the Flemington Road tram corridor.",
    industries: [
      "High-density residential development",
      "Health and hospital infrastructure",
      "Tram and transport infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Melbourne CBD", "Carlton", "Parkville", "Flemington", "Kensington", "West Melbourne", "Docklands", "Ascot Vale", "Moonee Ponds", "Essendon"],
  },
  {
    slug: "parkville",
    suburb: "Parkville",
    state: "VIC",
    postcode: "3052",
    council: "City of Melbourne",
    keyRoads: ["Royal Parade", "Flemington Road", "Park Drive", "Story Street"],
    intro:
      "Parkville is Melbourne's premier biomedical and research precinct, home to the Royal Melbourne Hospital, Melbourne Biomedical Campus, Royal Park and the University of Melbourne. Major hospital expansion and research facility construction create complex traffic management requirements on Royal Parade and Flemington Road.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Parkville health, research and university projects, with specialist knowledge of the biomedical precinct's demanding construction traffic environment.",
    industries: [
      "Health and hospital infrastructure",
      "Biomedical and research construction",
      "University and education development",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Carlton", "North Melbourne", "Flemington", "Royal Park", "Fitzroy North", "Brunswick", "Princes Hill", "Ascot Vale", "Kensington", "Melbourne CBD"],
  },
  {
    slug: "port-melbourne",
    suburb: "Port Melbourne",
    state: "VIC",
    postcode: "3207",
    council: "City of Port Phillip",
    keyRoads: ["Bay Street", "Williamstown Road", "Graham Street", "Plummer Street"],
    intro:
      "Port Melbourne is a vibrant bayside suburb transitioning from its industrial port origins to a sought-after residential and commercial destination, where apartment development, waterfront construction and port-related infrastructure works require traffic management plans compliant with City of Port Phillip and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Phillip-compliant TMPs for Port Melbourne residential, commercial and waterfront infrastructure projects.",
    industries: [
      "Residential and mixed-use development",
      "Waterfront and marine works",
      "Commercial construction",
      "Port and logistics infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["South Melbourne", "Albert Park", "Southbank", "Docklands", "Williamstown", "Fishermans Bend", "St Kilda", "Elwood", "Middle Park", "West Melbourne"],
  },
  {
    slug: "richmond",
    suburb: "Richmond",
    state: "VIC",
    postcode: "3121",
    council: "City of Yarra",
    keyRoads: ["Bridge Road", "Church Street", "Swan Street", "Punt Road"],
    intro:
      "Richmond is one of Melbourne's most densely populated inner suburbs, where high-rise residential development, major sporting precinct works around the MCG and Punt Road's heavy traffic volumes create complex traffic management requirements that must comply with City of Yarra and VicRoads standards.",
    bodyPara:
      "Focus Traffic Plans produces City of Yarra-compliant TMPs for Richmond construction and utility projects, with specialist knowledge of the Swan Street and Bridge Road retail corridors and major event impacts.",
    industries: [
      "High-density residential development",
      "Sports and entertainment infrastructure",
      "Retail and hospitality fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Cremorne", "Collingwood", "East Melbourne", "Hawthorn", "Burnley", "Abbotsford", "Fitzroy", "South Yarra", "Prahran", "Toorak"],
  },
  {
    slug: "south-melbourne",
    suburb: "South Melbourne",
    state: "VIC",
    postcode: "3205",
    council: "City of Port Phillip",
    keyRoads: ["Clarendon Street", "Kings Way", "City Road", "Albert Road"],
    intro:
      "South Melbourne is an inner suburb with a mix of residential, commercial and light industrial uses, where the South Melbourne Market precinct, apartment development and conversion projects create ongoing demand for traffic management plans compliant with City of Port Phillip and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Phillip-compliant TMPs for South Melbourne projects, with experience managing works around the busy Clarendon Street corridor.",
    industries: [
      "Residential and mixed-use development",
      "Retail and market precinct works",
      "Commercial and office construction",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Southbank", "Port Melbourne", "Albert Park", "Middle Park", "St Kilda", "Prahran", "Windsor", "Melbourne CBD", "Docklands", "West Melbourne"],
  },
  {
    slug: "south-yarra",
    suburb: "South Yarra",
    state: "VIC",
    postcode: "3141",
    council: "City of Stonnington",
    keyRoads: ["Chapel Street", "Toorak Road", "Domain Road", "Punt Road"],
    intro:
      "South Yarra is Melbourne's premier shopping and lifestyle precinct, where high-end residential construction, retail fitouts and Chapel Street commercial works create demand for traffic management plans compliant with City of Stonnington and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for South Yarra residential and retail projects, with knowledge of the Chapel Street and Toorak Road corridors' high-volume traffic environments.",
    industries: [
      "High-end residential construction",
      "Retail and hospitality fitouts",
      "Commercial office development",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Prahran", "Toorak", "Richmond", "Windsor", "Armadale", "Hawthorn", "Malvern", "St Kilda", "Albert Park", "Cremorne"],
  },
  // Eastern Melbourne
  {
    slug: "bayswater",
    suburb: "Bayswater",
    state: "VIC",
    postcode: "3153",
    council: "Knox City Council",
    keyRoads: ["Mountain Highway", "Dorset Road", "Scoresby Road", "Canterbury Road"],
    intro:
      "Bayswater is a busy eastern Melbourne suburb with a mix of residential and light industrial uses, where construction activity and utility works require traffic management plans compliant with Knox City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Knox City Council-compliant TMPs for Bayswater residential and commercial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Boronia", "Wantirna", "Ringwood", "Croydon", "Upper Ferntree Gully", "Kilsyth", "Mooroolbark", "Knoxfield", "Ferntree Gully", "Knox City"],
  },
  {
    slug: "boronia",
    suburb: "Boronia",
    state: "VIC",
    postcode: "3155",
    council: "Knox City Council",
    keyRoads: ["Boronia Road", "Dorset Road", "Scoresby Road", "Colchester Road"],
    intro:
      "Boronia is a residential suburb in Melbourne's eastern foothills where residential construction, dual occupancy development and utility works require traffic management plans compliant with Knox City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Boronia residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bayswater", "Upper Ferntree Gully", "Ferntree Gully", "Wantirna", "Kilsyth", "The Basin", "Scoresby", "Ringwood East", "Heathmont", "Knox City"],
  },
  {
    slug: "croydon",
    suburb: "Croydon",
    state: "VIC",
    postcode: "3136",
    council: "Maroondah City Council",
    keyRoads: ["Maroondah Highway", "Mt Dandenong Road", "Croydon Road", "Dorset Road"],
    intro:
      "Croydon is a major activity centre in Melbourne's outer east, where residential development and retail construction around the Croydon Central precinct create demand for traffic management plans compliant with Maroondah City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Maroondah City Council-compliant TMPs for Croydon residential and commercial projects.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ringwood", "Mooroolbark", "Kilsyth", "Bayswater North", "Ringwood East", "Heathmont", "Warranwood", "Chirnside Park", "Lilydale", "Mitcham"],
  },
  {
    slug: "ferntree-gully",
    suburb: "Ferntree Gully",
    state: "VIC",
    postcode: "3156",
    council: "Knox City Council",
    keyRoads: ["Burwood Highway", "Stud Road", "Mountain Highway", "Dorset Road"],
    intro:
      "Ferntree Gully is a residential suburb at the edge of the Dandenong Ranges where residential construction and utility works in a foothills environment require traffic management plans compliant with Knox City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ferntree Gully residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Landscaping and civil works",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Upper Ferntree Gully", "Boronia", "Bayswater", "Scoresby", "Knoxfield", "Rowville", "Lysterfield", "Belgrave", "The Basin", "Knox City"],
  },
  {
    slug: "knox",
    suburb: "Knox",
    state: "VIC",
    postcode: "3152",
    council: "Knox City Council",
    keyRoads: ["Stud Road", "Burwood Highway", "Ferntree Gully Road", "Wellington Road"],
    intro:
      "Knox is a major retail and commercial hub in Melbourne's south-east anchored by Westfield Knox, where retail construction, car park upgrades and surrounding residential development generate demand for traffic management documentation compliant with Knox City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Knox City Council-compliant TMPs for Knox commercial, retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Car park and access works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wantirna", "Bayswater", "Boronia", "Ferntree Gully", "Scoresby", "Rowville", "Knoxfield", "Wantirna South", "Ringwood", "Heathmont"],
  },
  {
    slug: "lilydale",
    suburb: "Lilydale",
    state: "VIC",
    postcode: "3140",
    council: "Yarra Ranges Council",
    keyRoads: ["Maroondah Highway", "Anderson Street", "Main Street", "Swansea Road"],
    intro:
      "Lilydale is the gateway to the Yarra Valley and a growing outer eastern suburb, where residential development and commercial construction at the terminus of the Lilydale rail line create demand for traffic management plans compliant with Yarra Ranges Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Yarra Ranges Council-compliant TMPs for Lilydale residential and commercial projects.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mooroolbark", "Croydon", "Chirnside Park", "Coldstream", "Yering", "Gruyere", "Seville", "Mount Evelyn", "Kilsyth South", "Bayswater North"],
  },
  {
    slug: "mitcham",
    suburb: "Mitcham",
    state: "VIC",
    postcode: "3132",
    council: "Whitehorse City Council",
    keyRoads: ["Whitehorse Road", "Mitcham Road", "Springvale Road", "Canterbury Road"],
    intro:
      "Mitcham is a residential suburb in Melbourne's eastern corridor where residential construction and utility works require traffic management plans compliant with Whitehorse City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mitcham residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Nunawading", "Blackburn", "Ringwood", "Vermont", "Forest Hill", "Croydon South", "Ringwood East", "Heathmont", "Box Hill South", "Blackburn South"],
  },
  {
    slug: "nunawading",
    suburb: "Nunawading",
    state: "VIC",
    postcode: "3131",
    council: "Whitehorse City Council",
    keyRoads: ["Whitehorse Road", "Springvale Road", "Maroondah Highway", "Middleborough Road"],
    intro:
      "Nunawading is a major retail and commercial strip along the Whitehorse Road corridor in Melbourne's east, where commercial construction and residential development create demand for traffic management documentation compliant with Whitehorse City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whitehorse City Council-compliant TMPs for Nunawading commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mitcham", "Box Hill", "Blackburn", "Vermont", "Forest Hill", "Ringwood", "Blackburn North", "Blackburn South", "Croydon South", "Heathmont"],
  },
  {
    slug: "ringwood",
    suburb: "Ringwood",
    state: "VIC",
    postcode: "3134",
    council: "Maroondah City Council",
    keyRoads: ["Maroondah Highway", "Canterbury Road", "Mount Dandenong Road", "Warrandyte Road"],
    intro:
      "Ringwood is Melbourne's major outer-eastern activity centre, anchored by Eastland shopping centre and well-served by the Ringwood rail hub, where significant retail construction, residential development and the recently completed Eastlink interchange create ongoing demand for traffic management plans compliant with Maroondah City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Maroondah City Council-compliant TMPs for Ringwood retail, residential and infrastructure projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Transport and infrastructure works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Croydon", "Heathmont", "Mitcham", "Nunawading", "Ringwood East", "Ringwood North", "Bayswater North", "Mooroolbark", "Warranwood", "Vermont"],
  },
  {
    slug: "vermont",
    suburb: "Vermont",
    state: "VIC",
    postcode: "3133",
    council: "Whitehorse City Council",
    keyRoads: ["Canterbury Road", "Boronia Road", "Mahoneys Road", "Mitcham Road"],
    intro:
      "Vermont is a quiet residential suburb in Melbourne's east where residential construction and utility works require traffic management plans compliant with Whitehorse City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Vermont residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Nunawading", "Mitcham", "Forest Hill", "Ringwood", "Blackburn South", "Wantirna", "Bayswater North", "Heathmont", "Vermont South", "Knox City"],
  },
  {
    slug: "wantirna",
    suburb: "Wantirna",
    state: "VIC",
    postcode: "3152",
    council: "Knox City Council",
    keyRoads: ["Boronia Road", "Stud Road", "Mountain Highway", "Lewis Road"],
    intro:
      "Wantirna is a residential suburb in the Knox LGA where residential construction and utility works require traffic management plans compliant with Knox City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Knox City Council-compliant TMPs for Wantirna residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Knox", "Bayswater", "Boronia", "Heathmont", "Ringwood East", "Vermont", "Scoresby", "Knoxfield", "Ferntree Gully", "Upper Ferntree Gully"],
  },
  // Western Melbourne
  {
    slug: "altona",
    suburb: "Altona",
    state: "VIC",
    postcode: "3018",
    council: "Hobsons Bay City Council",
    keyRoads: ["Millers Road", "Kororoit Creek Road", "Maidstone Street", "Civic Parade"],
    intro:
      "Altona is a bayside suburb with a significant petrochemical and industrial precinct, where industrial plant maintenance, residential development and coastal infrastructure works require traffic management plans compliant with Hobsons Bay City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Altona industrial and residential projects, with experience in the suburb's heavy industrial environment.",
    industries: [
      "Petrochemical and industrial maintenance",
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Laverton", "Hoppers Crossing", "Williamstown", "Seaholme", "Altona North", "Altona Meadows", "Brooklyn", "Truganina", "Point Cook", "Werribee"],
  },
  {
    slug: "deer-park",
    suburb: "Deer Park",
    state: "VIC",
    postcode: "3023",
    council: "Brimbank City Council",
    keyRoads: ["Western Ring Road", "Ballarat Road", "Station Road", "Greens Road"],
    intro:
      "Deer Park is a major logistics and industrial hub in Melbourne's west, where warehouse construction, distribution centre development and Western Ring Road interchange works create demand for traffic management documentation compliant with Brimbank City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brimbank City Council-compliant TMPs for Deer Park industrial, logistics and residential projects.",
    industries: [
      "Logistics and warehouse development",
      "Industrial construction",
      "Residential development",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["Sunshine", "Sunshine West", "Ardeer", "Cairnlea", "Ravenhall", "Caroline Springs", "Tarneit", "Hoppers Crossing", "Brookfield", "Albion"],
  },
  {
    slug: "footscray",
    suburb: "Footscray",
    state: "VIC",
    postcode: "3011",
    council: "Maribyrnong City Council",
    keyRoads: ["Hopkins Street", "Barkly Street", "Geelong Road", "Hyde Street"],
    intro:
      "Footscray is one of Melbourne's most vibrant inner-western suburbs, undergoing rapid urban transformation with high-density residential towers, university expansion and commercial renewal creating strong demand for traffic management plans compliant with Maribyrnong City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Maribyrnong City Council-compliant TMPs for Footscray residential, university and commercial projects, with experience managing the suburb's busy road network.",
    industries: [
      "High-density residential development",
      "University and education construction",
      "Retail and commercial fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Yarraville", "Seddon", "Maribyrnong", "West Footscray", "Sunshine", "Sunshine North", "Braybrook", "Kingsville", "Maidstone", "Altona North"],
  },
  {
    slug: "hoppers-crossing",
    suburb: "Hoppers Crossing",
    state: "VIC",
    postcode: "3029",
    council: "Wyndham City Council",
    keyRoads: ["Princes Freeway", "Hogans Road", "Morris Road", "Old Geelong Road"],
    intro:
      "Hoppers Crossing is a major residential and retail suburb in the rapidly growing Wyndham LGA, where residential development and commercial construction around the Pacific Werribee shopping precinct create demand for traffic management plans compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wyndham City Council-compliant TMPs for Hoppers Crossing residential and commercial projects.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Werribee", "Point Cook", "Tarneit", "Truganina", "Laverton", "Altona Meadows", "Williams Landing", "Wyndham Vale", "Manor Lakes", "Cocoroc"],
  },
  {
    slug: "point-cook",
    suburb: "Point Cook",
    state: "VIC",
    postcode: "3030",
    council: "Wyndham City Council",
    keyRoads: ["Princes Freeway", "Point Cook Road", "Sneydes Road", "Dunnings Road"],
    intro:
      "Point Cook is one of Australia's fastest-growing residential suburbs, with large-scale housing estate construction, new school and community infrastructure and retail development creating strong demand for traffic management documentation compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Wyndham City Council-compliant TMPs for Point Cook residential, education and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Hoppers Crossing", "Werribee", "Williams Landing", "Altona Meadows", "Laverton", "Tarneit", "Truganina", "Sanctuary Lakes", "Seabrook", "Williamstown"],
  },
  {
    slug: "sunshine",
    suburb: "Sunshine",
    state: "VIC",
    postcode: "3020",
    council: "Brimbank City Council",
    keyRoads: ["Ballarat Road", "Hampshire Road", "Sunshine Road", "Glengala Road"],
    intro:
      "Sunshine is Melbourne's major western activity centre and a future Melbourne Airport Rail hub, with significant urban renewal, high-density residential development and major infrastructure investment creating strong demand for traffic management plans compliant with Brimbank City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sunshine residential, commercial and infrastructure projects, with experience in the suburb's arterial road environment.",
    industries: [
      "High-density residential development",
      "Commercial and retail construction",
      "Transport and rail infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Footscray", "Deer Park", "St Albans", "Sunshine West", "Sunshine North", "Albion", "Ardeer", "Braybrook", "Maidstone", "Tottenham"],
  },
  {
    slug: "werribee",
    suburb: "Werribee",
    state: "VIC",
    postcode: "3030",
    council: "Wyndham City Council",
    keyRoads: ["Princes Highway", "Cherry Street", "Watton Street", "Duncans Road"],
    intro:
      "Werribee is the regional centre of Melbourne's outer west and the administrative heart of Wyndham, one of Australia's fastest-growing LGAs, where residential development, commercial construction and health infrastructure projects create strong demand for traffic management documentation compliant with Wyndham City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wyndham City Council-compliant TMPs for Werribee and wider Wyndham LGA projects.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Health infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Hoppers Crossing", "Point Cook", "Wyndham Vale", "Tarneit", "Truganina", "Little River", "Mambourin", "Manor Lakes", "Cocoroc", "Laverton"],
  },
  {
    slug: "williamstown",
    suburb: "Williamstown",
    state: "VIC",
    postcode: "3016",
    council: "Hobsons Bay City Council",
    keyRoads: ["Nelson Place", "Ferguson Street", "Douglas Parade", "Williamstown Road"],
    intro:
      "Williamstown is a historic bayside suburb with a significant maritime heritage and naval precinct, where residential construction, heritage building refurbishment and foreshore works require traffic management plans compliant with Hobsons Bay City Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Hobsons Bay City Council-compliant TMPs for Williamstown residential, heritage and marine projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Marine and naval infrastructure",
      "Foreshore and coastal works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Newport", "Spotswood", "Port Melbourne", "Altona", "Seaholme", "Laverton", "Point Cook", "Altona North", "Brooklyn", "Footscray"],
  },
  // Northern Melbourne
  {
    slug: "brunswick",
    suburb: "Brunswick",
    state: "VIC",
    postcode: "3056",
    council: "Moreland City Council",
    keyRoads: ["Sydney Road", "Lygon Street", "Nicholson Street", "Moreland Road"],
    intro:
      "Brunswick is Melbourne's creative and cultural inner-north hub, where high-density residential development, heritage building conversion and the busy Sydney Road strip create ongoing demand for traffic management plans compliant with Moreland City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Brunswick residential and commercial projects, with experience on the Sydney Road tram corridor.",
    industries: [
      "High-density residential development",
      "Heritage building conversion",
      "Retail and hospitality fitouts",
      "Tram corridor works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Coburg", "Fitzroy North", "Carlton North", "Northcote", "Thornbury", "Preston", "Pascoe Vale South", "Parkville", "Brunswick West", "Brunswick East"],
  },
  {
    slug: "coburg",
    suburb: "Coburg",
    state: "VIC",
    postcode: "3058",
    council: "Moreland City Council",
    keyRoads: ["Sydney Road", "Bell Street", "Moreland Road", "Harding Street"],
    intro:
      "Coburg is a vibrant inner-northern suburb undergoing significant residential and commercial renewal, with apartment construction, heritage precinct development and the Sydney Road corridor generating demand for traffic management documentation compliant with Moreland City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Moreland City Council-compliant TMPs for Coburg residential and commercial projects.",
    industries: [
      "Residential and mixed-use development",
      "Heritage building refurbishment",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Brunswick", "Pascoe Vale", "Hadfield", "Batman", "Fawkner", "Glenroy", "Northcote", "Preston", "Reservoir", "Oak Park"],
  },
  {
    slug: "craigieburn",
    suburb: "Craigieburn",
    state: "VIC",
    postcode: "3064",
    council: "Hume City Council",
    keyRoads: ["Hume Freeway", "Craigieburn Road", "Aitken Boulevard", "Newpark Boulevard"],
    intro:
      "Craigieburn is one of Melbourne's fastest-growing outer northern suburbs, with large-scale residential estates, new schools and retail centres creating high demand for traffic management documentation compliant with Hume City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Hume City Council-compliant TMPs for Craigieburn residential, education and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Donnybrook", "Mickleham", "Kalkallo", "Roxburgh Park", "Greenvale", "Meadow Heights", "Campbellfield", "Somerton", "Wollert", "Mernda"],
  },
  {
    slug: "epping-vic",
    suburb: "Epping",
    state: "VIC",
    postcode: "3076",
    council: "Whittlesea City Council",
    keyRoads: ["High Street", "Cooper Street", "O'Herns Road", "Dalton Road"],
    intro:
      "Epping is a major northern Melbourne activity centre and one of Victoria's fastest-growing suburbs, where residential development, the Northern Hospital precinct and significant retail construction create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whittlesea City Council-compliant TMPs for Epping residential, health and commercial projects.",
    industries: [
      "Residential development",
      "Health and hospital infrastructure",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["South Morang", "Mill Park", "Lalor", "Thomastown", "Wollert", "Doreen", "Mernda", "Bundoora", "Campbellfield", "Somerton"],
  },
  {
    slug: "lalor",
    suburb: "Lalor",
    state: "VIC",
    postcode: "3075",
    council: "Whittlesea City Council",
    keyRoads: ["Plenty Road", "Station Street", "Childs Road", "McKimmies Road"],
    intro:
      "Lalor is a residential suburb in Melbourne's northern growth corridor where residential construction and infrastructure works require traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Lalor residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Thomastown", "Epping", "Bundoora", "Kingsbury", "Reservoir", "Preston", "Watsonia North", "Greenborough", "Mill Park", "South Morang"],
  },
  {
    slug: "northcote",
    suburb: "Northcote",
    state: "VIC",
    postcode: "3070",
    council: "Darebin City Council",
    keyRoads: ["High Street", "St Georges Road", "Separation Street", "Westgarth Street"],
    intro:
      "Northcote is a sought-after inner-northern suburb where residential construction, heritage building renovation and the High Street retail strip generate consistent demand for traffic management plans compliant with Darebin City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Darebin City Council-compliant TMPs for Northcote residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Retail and hospitality fitouts",
      "Tram corridor works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Thornbury", "Fitzroy North", "Brunswick", "Clifton Hill", "Fairfield", "Alphington", "Preston", "Reservoir", "Coburg", "Carlton North"],
  },
  {
    slug: "preston",
    suburb: "Preston",
    state: "VIC",
    postcode: "3072",
    council: "Darebin City Council",
    keyRoads: ["High Street", "Bell Street", "Tyler Street", "Gilbert Road"],
    intro:
      "Preston is a busy inner-northern suburb with significant residential development and the Preston Market retail precinct, where construction and utility works create demand for traffic management plans compliant with Darebin City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Darebin City Council-compliant TMPs for Preston residential and commercial projects.",
    industries: [
      "Residential and mixed-use development",
      "Retail and market precinct works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Thornbury", "Northcote", "Reservoir", "Coburg", "Bundoora", "Kingsbury", "Fairfield", "Alphington", "Heidelberg West", "Watsonia"],
  },
  {
    slug: "reservoir",
    suburb: "Reservoir",
    state: "VIC",
    postcode: "3073",
    council: "Darebin City Council",
    keyRoads: ["Broadway", "Spring Street", "Edwardes Street", "Gilbert Road"],
    intro:
      "Reservoir is one of Melbourne's most populous northern suburbs, where residential construction and urban renewal create ongoing demand for traffic management plans compliant with Darebin City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Reservoir residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Urban renewal and mixed-use development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Preston", "Thomastown", "Bundoora", "Kingsbury", "Coburg", "Coburg North", "Lalor", "Epping", "Mill Park", "Watsonia"],
  },
  {
    slug: "thomastown",
    suburb: "Thomastown",
    state: "VIC",
    postcode: "3074",
    council: "Whittlesea City Council",
    keyRoads: ["Settlement Road", "Dalton Road", "Mahoneys Road", "Edgars Road"],
    intro:
      "Thomastown is an established northern Melbourne suburb with a mix of residential and light industrial uses, where construction activity and utility works require traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whittlesea City Council-compliant TMPs for Thomastown residential and light industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Lalor", "Epping", "Reservoir", "Bundoora", "Mill Park", "Kingsbury", "Campbellfield", "Somerton", "Watsonia North", "Preston"],
  },
  {
    slug: "whittlesea",
    suburb: "Whittlesea",
    state: "VIC",
    postcode: "3757",
    council: "Whittlesea City Council",
    keyRoads: ["Plenty Road", "Whittlesea-Wallan Road", "Laurens Road", "Beech Street"],
    intro:
      "Whittlesea is a semi-rural township at the northern edge of Melbourne's urban growth boundary, where residential development and agricultural infrastructure create demand for traffic management plans compliant with Whittlesea City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Whittlesea residential and rural infrastructure projects.",
    industries: [
      "Residential development",
      "Agricultural and rural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["South Morang", "Mernda", "Doreen", "Yarrambat", "Wollert", "Epping", "Beveridge", "Wallan", "Eden Park", "Woodstock"],
  },
  // Southern Melbourne (additional)
  {
    slug: "brighton",
    suburb: "Brighton",
    state: "VIC",
    postcode: "3186",
    council: "Bayside City Council",
    keyRoads: ["Bay Street", "Church Street", "New Street", "North Road"],
    intro:
      "Brighton is one of Melbourne's most affluent bayside suburbs, where high-end residential construction, boutique retail fitouts and coastal infrastructure works require traffic management plans compliant with Bayside City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bayside City Council-compliant TMPs for Brighton residential and commercial projects.",
    industries: [
      "High-end residential construction",
      "Boutique retail and commercial fitouts",
      "Coastal and foreshore works",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Elsternwick", "Hampton", "Sandringham", "Cheltenham", "Bentleigh", "Moorabbin", "Black Rock", "Beaumaris", "Mentone", "Ormond"],
  },
  {
    slug: "cheltenham",
    suburb: "Cheltenham",
    state: "VIC",
    postcode: "3192",
    council: "Kingston City Council",
    keyRoads: ["Nepean Highway", "Charman Road", "Centre Dandenong Road", "Station Street"],
    intro:
      "Cheltenham is a busy activity centre along the Nepean Highway corridor, where residential development, retail construction and the Cheltenham TAFE precinct create demand for traffic management plans compliant with Kingston City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Kingston City Council-compliant TMPs for Cheltenham residential and commercial projects.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Education and TAFE construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Moorabbin", "Mentone", "Highett", "Beaumaris", "Black Rock", "Heatherton", "Parkdale", "Braeside", "Dingley Village", "Bentleigh East"],
  },
  {
    slug: "cranbourne",
    suburb: "Cranbourne",
    state: "VIC",
    postcode: "3977",
    council: "Casey City Council",
    keyRoads: ["South Gippsland Highway", "Thompsons Road", "Cranbourne-Frankston Road", "Ballarto Road"],
    intro:
      "Cranbourne is a major activity centre and one of Melbourne's fastest-growing outer-southern suburbs, where large residential estates, the Cranbourne Racecourse precinct and significant retail development create strong demand for traffic management documentation compliant with Casey City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Casey City Council-compliant TMPs for Cranbourne residential, commercial and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial development",
      "Community and education infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Berwick", "Narre Warren", "Lyndhurst", "Clyde", "Clyde North", "Botanic Ridge", "Pearcedale", "Skye", "Langwarrin", "Frankston"],
  },
  {
    slug: "mentone",
    suburb: "Mentone",
    state: "VIC",
    postcode: "3194",
    council: "Kingston City Council",
    keyRoads: ["Nepean Highway", "Mentone Parade", "Como Parade", "Beach Road"],
    intro:
      "Mentone is a sought-after bayside suburb in Kingston where residential construction and coastal infrastructure works require traffic management plans compliant with Kingston City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mentone residential and coastal infrastructure projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Cheltenham", "Parkdale", "Moorabbin", "Highett", "Beaumaris", "Black Rock", "Bonbeach", "Carrum", "Mordialloc", "Braeside"],
  },
  {
    slug: "moorabbin",
    suburb: "Moorabbin",
    state: "VIC",
    postcode: "3189",
    council: "Kingston City Council",
    keyRoads: ["Centre Road", "South Road", "Nepean Highway", "Warrigal Road"],
    intro:
      "Moorabbin is a busy industrial and commercial suburb in Melbourne's south, where light industrial construction, warehouse development and retail works generate demand for traffic management plans compliant with Kingston City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Kingston City Council-compliant TMPs for Moorabbin industrial and commercial projects.",
    industries: [
      "Light industrial and warehouse development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cheltenham", "Highett", "Bentleigh East", "Oakleigh South", "Clarinda", "Clayton South", "Heatherton", "Braeside", "Mentone", "Parkdale"],
  },
  {
    slug: "mornington",
    suburb: "Mornington",
    state: "VIC",
    postcode: "3931",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Mornington-Tyabb Road", "Main Street", "Nepean Highway", "Dunns Road"],
    intro:
      "Mornington is the major service and retail centre of the Mornington Peninsula, where residential development, tourism infrastructure and coastal works require traffic management plans compliant with Mornington Peninsula Shire and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Mornington Peninsula Shire-compliant TMPs for Mornington residential, commercial and coastal projects.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Retail and commercial construction",
      "Coastal and foreshore works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Mount Eliza", "Moorooduc", "Baxter", "Frankston", "Tyabb", "Pearcedale", "Mount Martha", "Safety Beach", "Dromana", "Rosebud"],
  },
  {
    slug: "oakleigh",
    suburb: "Oakleigh",
    state: "VIC",
    postcode: "3166",
    council: "Monash City Council",
    keyRoads: ["Dandenong Road", "Warrigal Road", "Huntingdale Road", "Hanover Street"],
    intro:
      "Oakleigh is a busy south-eastern activity centre with a vibrant Greek dining precinct, where residential development and commercial construction create demand for traffic management plans compliant with Monash City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Oakleigh residential and commercial projects.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage precinct works",
    ],
    nearbySuburbs: ["Huntingdale", "Clarinda", "Moorabbin", "Bentleigh East", "Clayton", "Chadstone", "Murrumbeena", "Carnegie", "Hughesdale", "Mount Waverley"],
  },
  {
    slug: "springvale",
    suburb: "Springvale",
    state: "VIC",
    postcode: "3171",
    council: "Greater Dandenong Council",
    keyRoads: ["Princes Highway", "Springvale Road", "Lightwood Road", "Sandown Road"],
    intro:
      "Springvale is a diverse commercial and residential suburb in Melbourne's south-east, where Asian retail precinct works, residential development and utility upgrades require traffic management plans compliant with Greater Dandenong Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Greater Dandenong Council-compliant TMPs for Springvale commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Noble Park", "Dandenong", "Keysborough", "Clayton South", "Moorabbin", "Dingley Village", "Lyndhurst", "Braeside", "Heatherton", "Mulgrave"],
  },
  // Geelong region (additional)
  {
    slug: "barwon-heads",
    suburb: "Barwon Heads",
    state: "VIC",
    postcode: "3227",
    council: "City of Greater Geelong",
    keyRoads: ["Barwon Heads Road", "Bridge Road", "Hitchcock Avenue", "Golf Links Road"],
    intro:
      "Barwon Heads is a popular coastal village on the Barwon River estuary, where beachside residential construction and tourism infrastructure works require traffic management plans compliant with City of Greater Geelong requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Barwon Heads residential and tourism projects.",
    industries: [
      "Coastal residential construction",
      "Tourism and hospitality development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ocean Grove", "Clifton Springs", "Portarlington", "Indented Head", "St Leonards", "Bellarine", "Leopold", "Queenscliff", "Point Lonsdale", "Drysdale"],
  },
  {
    slug: "belmont-vic",
    suburb: "Belmont",
    state: "VIC",
    postcode: "3216",
    council: "City of Greater Geelong",
    keyRoads: ["High Street", "Surf Coast Highway", "Reserve Road", "Roslyn Road"],
    intro:
      "Belmont is Geelong's major retail and residential hub south of the city, where commercial construction and residential development along the High Street corridor require traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Greater Geelong-compliant TMPs for Belmont commercial and residential projects.",
    industries: [
      "Residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["South Geelong", "Grovedale", "Highton", "Waurn Ponds", "Marshall", "Hamlyn Heights", "Manifold Heights", "Newtown", "Geelong West", "Clifton Springs"],
  },
  {
    slug: "corio",
    suburb: "Corio",
    state: "VIC",
    postcode: "3214",
    council: "City of Greater Geelong",
    keyRoads: ["Princes Freeway", "Bacchus Marsh Road", "Cox Road", "Thompson Road"],
    intro:
      "Corio is a major industrial and residential suburb north of Geelong, home to the Novatek industrial estate and a significant residential population, where industrial construction, warehouse development and residential works require traffic management plans compliant with City of Greater Geelong requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Corio industrial and residential projects.",
    industries: [
      "Industrial and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Norlane", "North Geelong", "Lara", "Avalon", "North Shore", "Bell Post Hill", "Lovely Banks", "Hamlyn Heights", "Geelong CBD", "St Albans Park"],
  },
  {
    slug: "grovedale",
    suburb: "Grovedale",
    state: "VIC",
    postcode: "3216",
    council: "City of Greater Geelong",
    keyRoads: ["Surf Coast Highway", "Reserve Road", "Torquay Road", "Heyers Road"],
    intro:
      "Grovedale is a growing residential suburb in Geelong's south-east where residential construction and commercial development require traffic management plans compliant with City of Greater Geelong requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Grovedale residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Belmont", "Waurn Ponds", "Marshall", "Highton", "Wandana Heights", "Mount Duneed", "Charlemont", "Armstrong Creek", "Torquay", "Jan Juc"],
  },
  {
    slug: "lara",
    suburb: "Lara",
    state: "VIC",
    postcode: "3212",
    council: "City of Greater Geelong",
    keyRoads: ["Princes Freeway", "Patullos Road", "Forest Road", "Windermere Road"],
    intro:
      "Lara is a rapidly growing satellite suburb between Geelong and Melbourne, where large residential estate development and infrastructure upgrades create demand for traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Lara residential and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Corio", "Avalon", "Little River", "Lara Lake", "Lovely Banks", "Anakie", "Geelong CBD", "North Geelong", "Clifton Springs", "Portarlington"],
  },
  {
    slug: "leopold",
    suburb: "Leopold",
    state: "VIC",
    postcode: "3224",
    council: "City of Greater Geelong",
    keyRoads: ["Bellarine Highway", "Clifton Springs Road", "McClelland Road", "Jetty Road"],
    intro:
      "Leopold is a growing residential suburb on the Bellarine Peninsula where large residential developments and associated civil infrastructure create demand for traffic management documentation compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Leopold residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Clifton Springs", "Portarlington", "Drysdale", "Ocean Grove", "Barwon Heads", "Geelong CBD", "Lara", "Bellarine", "St Leonards", "Indented Head"],
  },
  {
    slug: "norlane",
    suburb: "Norlane",
    state: "VIC",
    postcode: "3214",
    council: "City of Greater Geelong",
    keyRoads: ["Princes Freeway", "Cox Road", "Plantation Road", "Bacchus Marsh Road"],
    intro:
      "Norlane is an established industrial and residential suburb north of Geelong where industrial construction, residential development and utility works require traffic management plans compliant with City of Greater Geelong and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Geelong-compliant TMPs for Norlane industrial and residential projects.",
    industries: [
      "Industrial and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Corio", "North Geelong", "North Shore", "Bell Post Hill", "Lara", "Geelong CBD", "Hamlyn Heights", "St Albans Park", "Rippleside", "Breakwater"],
  },
  {
    slug: "ocean-grove",
    suburb: "Ocean Grove",
    state: "VIC",
    postcode: "3226",
    council: "City of Greater Geelong",
    keyRoads: ["Bellarine Highway", "Shell Road", "Grubb Road", "Sunset Strip"],
    intro:
      "Ocean Grove is the Bellarine Peninsula's largest town and a popular coastal destination, where residential development and tourism infrastructure generate demand for traffic management plans compliant with City of Greater Geelong requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Greater Geelong-compliant TMPs for Ocean Grove residential and tourism projects.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Barwon Heads", "Clifton Springs", "Portarlington", "Drysdale", "Leopold", "Queenscliff", "Point Lonsdale", "Geelong CBD", "St Leonards", "Indented Head"],
  },
  {
    slug: "torquay",
    suburb: "Torquay",
    state: "VIC",
    postcode: "3228",
    council: "Surf Coast Shire",
    keyRoads: ["Surf Coast Highway", "Geelong Road", "The Esplanade", "Boston Road"],
    intro:
      "Torquay is the gateway to the Great Ocean Road and Australia's surf capital, where rapid residential growth, tourism infrastructure and coastal works require traffic management plans compliant with Surf Coast Shire and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Surf Coast Shire-compliant TMPs for Torquay residential, tourism and coastal projects.",
    industries: [
      "Residential subdivision and housing",
      "Tourism and hospitality construction",
      "Coastal and foreshore infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Jan Juc", "Bells Beach", "Anglesea", "Aireys Inlet", "Grovedale", "Mount Duneed", "Charlemont", "Armstrong Creek", "Ocean Grove", "Geelong CBD"],
  },
  // Ballarat region (additional)
  {
    slug: "alfredton",
    suburb: "Alfredton",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Remembrance Drive", "Victoria Street", "Gillies Street", "Ripon Street"],
    intro:
      "Alfredton is one of Ballarat's fastest-growing residential suburbs where new housing estates and associated civil infrastructure create demand for traffic management plans compliant with City of Ballarat and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Alfredton residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ballarat CBD", "Delacombe", "Lucas", "Winter Valley", "Smythes Creek", "Bonshaw", "Bakery Hill", "Wendouree", "Ballarat East", "Brown Hill"],
  },
  {
    slug: "ballarat-east",
    suburb: "Ballarat East",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Humffray Street", "Barkly Street", "Dana Street", "Norman Street"],
    intro:
      "Ballarat East is a heritage-rich suburb adjacent to the Ballarat CBD where residential construction and heritage building refurbishment require traffic management plans compliant with City of Ballarat requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Ballarat-compliant TMPs for Ballarat East residential and heritage projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ballarat CBD", "Bakery Hill", "Mount Pleasant", "Ballarat North", "Black Hill", "Soldiers Hill", "Newington", "Sebastopol", "Wendouree", "Ballarat"],
  },
  {
    slug: "ballarat-north",
    suburb: "Ballarat North",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Doveton Street", "Errard Street", "Stawell Street", "Heinz Street"],
    intro:
      "Ballarat North is a residential suburb north of the Ballarat CBD where residential construction and utility works require traffic management plans compliant with City of Ballarat requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ballarat North residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ballarat CBD", "Wendouree", "Soldiers Hill", "Newington", "Black Hill", "Ballarat East", "Mount Pleasant", "Alfredton", "Lake Gardens", "Lake Wendouree"],
  },
  {
    slug: "delacombe",
    suburb: "Delacombe",
    state: "VIC",
    postcode: "3356",
    council: "City of Ballarat",
    keyRoads: ["Remembrance Drive", "Glenelg Highway", "MacArthur Street", "Delacombe Drive"],
    intro:
      "Delacombe is a rapidly growing southern suburb of Ballarat where large residential estate development and associated civil infrastructure create demand for traffic management plans compliant with City of Ballarat and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Ballarat-compliant TMPs for Delacombe residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alfredton", "Lucas", "Smythes Creek", "Bonshaw", "Winter Valley", "Ballarat CBD", "Brown Hill", "Canadian", "Mitchell Park", "Sebastopol"],
  },
  {
    slug: "lucas",
    suburb: "Lucas",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Remembrance Drive", "Garland Road", "Hopkins Street", "Gisbey Road"],
    intro:
      "Lucas is a modern master-planned suburb west of Ballarat where ongoing residential estate construction requires traffic management plans compliant with City of Ballarat and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Lucas residential and civil projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alfredton", "Delacombe", "Smythes Creek", "Ballarat CBD", "Winter Valley", "Bonshaw", "Brown Hill", "Sebastopol", "Canadian", "Mount Clear"],
  },
  {
    slug: "mount-clear",
    suburb: "Mount Clear",
    state: "VIC",
    postcode: "3350",
    council: "City of Ballarat",
    keyRoads: ["Sturt Street", "Gillies Street", "MacArthur Street", "Dawson Street"],
    intro:
      "Mount Clear is a residential suburb south of Ballarat CBD where residential construction and utility works require traffic management plans compliant with City of Ballarat requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Ballarat-compliant TMPs for Mount Clear residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alfredton", "Delacombe", "Lucas", "Canadian", "Ballarat CBD", "Brown Hill", "Sebastopol", "Mount Pleasant", "Smythes Creek", "Bonshaw"],
  },
  {
    slug: "sebastopol",
    suburb: "Sebastopol",
    state: "VIC",
    postcode: "3356",
    council: "City of Ballarat",
    keyRoads: ["Sebastopol Street", "Albert Street", "Scott Parade", "Glenelg Highway"],
    intro:
      "Sebastopol is an established suburb south of Ballarat CBD where residential construction and commercial development require traffic management plans compliant with City of Ballarat requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sebastopol residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mount Clear", "Delacombe", "Canadian", "Brown Hill", "Alfredton", "Lucas", "Ballarat CBD", "Smythes Creek", "Mitchell Park", "Bonshaw"],
  },
  {
    slug: "wendouree",
    suburb: "Wendouree",
    state: "VIC",
    postcode: "3355",
    council: "City of Ballarat",
    keyRoads: ["Howitt Street", "Gillies Street", "Learmonth Road", "Norman Street"],
    intro:
      "Wendouree is Ballarat's largest suburb and home to the city's major retail strip on Howitt Street, where commercial construction and residential development create demand for traffic management plans compliant with City of Ballarat requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Ballarat-compliant TMPs for Wendouree commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ballarat CBD", "Ballarat North", "Lake Gardens", "Lake Wendouree", "Alfredton", "Soldiers Hill", "Newington", "Black Hill", "Ballarat East", "Mount Pleasant"],
  },
  // Bendigo
  {
    slug: "bendigo-cbd",
    suburb: "Bendigo CBD",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Hargreaves Street", "Pall Mall", "Mitchell Street", "Williamson Street"],
    intro:
      "Bendigo CBD is the commercial and cultural heart of regional Victoria's second-largest city, where ongoing commercial development, heritage precinct maintenance and infrastructure upgrades require traffic management plans compliant with City of Greater Bendigo and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Bendigo CBD and surrounding suburb projects, supporting the city's growing construction pipeline.",
    industries: [
      "Commercial and retail construction",
      "Heritage building refurbishment",
      "Health and hospital infrastructure",
      "Utility maintenance",
      "Road and infrastructure upgrades",
    ],
    nearbySuburbs: ["White Hills", "Kangaroo Flat", "Flora Hill", "Strathdale", "Golden Square", "Eaglehawk", "Epsom", "California Gully", "Long Gully", "Kennington"],
  },
  {
    slug: "california-gully",
    suburb: "California Gully",
    state: "VIC",
    postcode: "3556",
    council: "City of Greater Bendigo",
    keyRoads: ["Midland Highway", "Crusoe Road", "Panton Street", "California Gully Road"],
    intro:
      "California Gully is a residential suburb north-west of Bendigo CBD where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for California Gully residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Eaglehawk", "Bendigo CBD", "Long Gully", "Quarry Hill", "Kangaroo Flat", "Golden Square", "West Bendigo", "Huntly", "Raywood", "Lockwood South"],
  },
  {
    slug: "eaglehawk",
    suburb: "Eaglehawk",
    state: "VIC",
    postcode: "3556",
    council: "City of Greater Bendigo",
    keyRoads: ["Midland Highway", "Sailors Gully Road", "Myers Street", "Crusoe Road"],
    intro:
      "Eaglehawk is a heritage suburb north-west of Bendigo CBD with a significant gold mining history, where residential construction and heritage building refurbishment require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Eaglehawk residential and heritage projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["California Gully", "Bendigo CBD", "Long Gully", "Quarry Hill", "West Bendigo", "Golden Square", "Huntly", "Kangaroo Flat", "Maiden Gully", "Lockwood South"],
  },
  {
    slug: "epsom",
    suburb: "Epsom",
    state: "VIC",
    postcode: "3551",
    council: "City of Greater Bendigo",
    keyRoads: ["Northern Highway", "Midland Highway", "Epsom Road", "Wills Street"],
    intro:
      "Epsom is a growing residential suburb north of Bendigo CBD where residential development and associated civil infrastructure create demand for traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Epsom residential and civil projects.",
    industries: [
      "Residential development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Strathdale", "Junortoun", "Kennington", "Kangaroo Flat", "Bendigo CBD", "White Hills", "Maiden Gully", "Huntly", "Goornong", "Bagshot"],
  },
  {
    slug: "flora-hill",
    suburb: "Flora Hill",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Napier Street", "McIvor Road", "Burns Street", "Edwards Road"],
    intro:
      "Flora Hill is a residential suburb adjacent to La Trobe University's Bendigo campus where residential construction and university-related works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Flora Hill residential and education-related projects.",
    industries: [
      "Residential construction",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kennington", "Strathdale", "Epsom", "Bendigo CBD", "Junortoun", "Kangaroo Flat", "Golden Square", "White Hills", "Maiden Gully", "Spring Gully"],
  },
  {
    slug: "kangaroo-flat",
    suburb: "Kangaroo Flat",
    state: "VIC",
    postcode: "3555",
    council: "City of Greater Bendigo",
    keyRoads: ["High Street", "McIvor Road", "Mackenzie Street", "Midland Highway"],
    intro:
      "Kangaroo Flat is a major commercial and residential suburb south of Bendigo CBD where retail construction and residential development create demand for traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kangaroo Flat commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bendigo CBD", "Golden Square", "California Gully", "Eaglehawk", "Long Gully", "Maiden Gully", "Big Hill", "Lockwood South", "Harcourt North", "Junortoun"],
  },
  {
    slug: "long-gully",
    suburb: "Long Gully",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Napier Street", "Vine Street", "Retreat Road", "Breen Street"],
    intro:
      "Long Gully is a residential suburb close to Bendigo CBD where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Greater Bendigo-compliant TMPs for Long Gully residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["California Gully", "Eaglehawk", "Quarry Hill", "Bendigo CBD", "Golden Square", "Kangaroo Flat", "West Bendigo", "Flora Hill", "Spring Gully", "Kennington"],
  },
  {
    slug: "strathdale",
    suburb: "Strathdale",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["McIvor Road", "Strathdale Road", "Taylors Lane", "Burns Street"],
    intro:
      "Strathdale is an established residential suburb north-east of Bendigo CBD where residential construction and utility works require traffic management plans compliant with City of Greater Bendigo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Strathdale residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kennington", "Flora Hill", "Epsom", "Junortoun", "Bendigo CBD", "Kangaroo Flat", "Golden Square", "White Hills", "Maiden Gully", "Spring Gully"],
  },
  // Regional Victoria
  {
    slug: "bairnsdale",
    suburb: "Bairnsdale",
    state: "VIC",
    postcode: "3875",
    council: "East Gippsland Shire",
    keyRoads: ["Main Street", "Princes Highway", "Dalmahoy Street", "McLeod Street"],
    intro:
      "Bairnsdale is the regional capital of East Gippsland, where residential development, commercial construction and infrastructure upgrades serving the broader East Gippsland region require traffic management plans compliant with East Gippsland Shire and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares East Gippsland Shire-compliant TMPs for Bairnsdale and East Gippsland regional projects.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Agricultural and rural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Paynesville", "Eagle Point", "Bruthen", "Metung", "Lakes Entrance", "Nicholson", "Lindenow", "Johnsonville", "Buchan", "Orbost"],
  },
  {
    slug: "horsham",
    suburb: "Horsham",
    state: "VIC",
    postcode: "3400",
    council: "Horsham Rural City Council",
    keyRoads: ["Wimmera Highway", "Dimboola Road", "Donald Street", "McPherson Street"],
    intro:
      "Horsham is the major service centre of the Wimmera region, where agricultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Horsham Rural City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Horsham Rural City Council-compliant TMPs for residential, commercial and agricultural infrastructure projects in the Wimmera.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Agricultural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Natimuk", "Dimboola", "Murtoa", "Nhill", "Warracknabeal", "Stawell", "St Arnaud", "Donald", "Rainbow", "Hopetoun"],
  },
  {
    slug: "mildura",
    suburb: "Mildura",
    state: "VIC",
    postcode: "3500",
    council: "Mildura Rural City Council",
    keyRoads: ["Deakin Avenue", "Fifteenth Street", "Madden Avenue", "San Mateo Avenue"],
    intro:
      "Mildura is the major city of the Sunraysia region and an important agricultural and tourism hub on the Murray River, where residential development, irrigation infrastructure and commercial construction create demand for traffic management plans compliant with Mildura Rural City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Mildura Rural City Council-compliant TMPs for residential, agricultural and commercial projects in the Sunraysia region.",
    industries: [
      "Residential development",
      "Irrigation and agricultural infrastructure",
      "Commercial and retail construction",
      "Tourism infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Merbein", "Red Cliffs", "Irymple", "Cardross", "Nichols Point", "Gol Gol", "Buronga", "Wentworth", "Dareton", "Nangiloc"],
  },
  {
    slug: "sale",
    suburb: "Sale",
    state: "VIC",
    postcode: "3850",
    council: "Wellington Shire Council",
    keyRoads: ["Princes Highway", "Foster Street", "Raymond Street", "Cunninghame Street"],
    intro:
      "Sale is the administrative centre of Gippsland's Wellington Shire and a service hub for the region's oil and gas industry, where energy infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Wellington Shire Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sale energy, residential and commercial projects in the Gippsland region.",
    industries: [
      "Oil and gas infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Maffra", "Heyfield", "Stratford", "Rosedale", "Longford", "Seaspray", "Briagolong", "Tinamba", "Wurruk", "Cobains"],
  },
  {
    slug: "shepparton",
    suburb: "Shepparton",
    state: "VIC",
    postcode: "3630",
    council: "Greater Shepparton City Council",
    keyRoads: ["Maude Street", "High Street", "Benalla Road", "Wyndham Street"],
    intro:
      "Shepparton is the major city of the Goulburn Valley and the agricultural processing capital of Victoria, where food processing facilities, residential development and commercial construction create demand for traffic management plans compliant with Greater Shepparton City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Greater Shepparton City Council-compliant TMPs for food processing, residential and commercial projects in the Goulburn Valley.",
    industries: [
      "Food processing and industrial construction",
      "Residential development",
      "Commercial and retail construction",
      "Agricultural infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Mooroopna", "Kialla", "Congupna", "Grahamvale", "Katandra West", "Tallygaroopna", "Tatura", "Murchison", "Dookie", "Merrigum"],
  },
  {
    slug: "traralgon",
    suburb: "Traralgon",
    state: "VIC",
    postcode: "3844",
    council: "Latrobe City Council",
    keyRoads: ["Franklin Street", "Princes Highway", "Breed Street", "Kay Street"],
    intro:
      "Traralgon is the largest city in the Latrobe Valley and a major industrial centre, where energy infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Latrobe City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Latrobe City Council-compliant TMPs for energy, residential and commercial projects in the Latrobe Valley.",
    industries: [
      "Energy and industrial infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Morwell", "Moe", "Churchill", "Newborough", "Tyers", "Hernes Oak", "Toongabbie", "Glengarry", "Rosedale", "Yarram"],
  },
  {
    slug: "wangaratta",
    suburb: "Wangaratta",
    state: "VIC",
    postcode: "3677",
    council: "Rural City of Wangaratta",
    keyRoads: ["Murphy Street", "Ford Street", "Ovens Street", "Tone Road"],
    intro:
      "Wangaratta is the major service centre of north-east Victoria and the gateway to the Alpine region, where residential development, agricultural infrastructure and commercial construction create demand for traffic management plans compliant with Rural City of Wangaratta and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Rural City of Wangaratta-compliant TMPs for residential, commercial and agricultural projects in north-east Victoria.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Agricultural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Moyhu", "Milawa", "Beechworth", "Rutherglen", "Chiltern", "Glenrowan", "Oxley", "Tarrawingee", "Bowser", "Docker"],
  },
  {
    slug: "warrnambool",
    suburb: "Warrnambool",
    state: "VIC",
    postcode: "3280",
    council: "Warrnambool City Council",
    keyRoads: ["Raglan Parade", "Timor Street", "Koroit Street", "Hopkins Road"],
    intro:
      "Warrnambool is the major city of south-west Victoria and the tourism gateway to the Great Ocean Road, where residential development, dairy industry infrastructure and commercial construction create demand for traffic management plans compliant with Warrnambool City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans produces Warrnambool City Council-compliant TMPs for residential, dairy industry and commercial projects in south-west Victoria.",
    industries: [
      "Residential development",
      "Dairy and agricultural infrastructure",
      "Commercial and retail construction",
      "Tourism infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Allansford", "Koroit", "Port Fairy", "Dennington", "Terang", "Camperdown", "Colac", "Hamilton", "Portland", "Mortlake"],
  },
  {
    slug: "wodonga",
    suburb: "Wodonga",
    state: "VIC",
    postcode: "3690",
    council: "Wodonga City Council",
    keyRoads: ["High Street", "Lawrence Street", "Hume Freeway", "Hovell Street"],
    intro:
      "Wodonga is the Victorian half of the Albury-Wodonga twin-city region and one of the most significant regional growth corridors in south-eastern Australia, where residential development, defence infrastructure and commercial construction create demand for traffic management plans compliant with Wodonga City Council and VicRoads requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wodonga City Council-compliant TMPs for residential, defence and commercial projects in the Albury-Wodonga corridor.",
    industries: [
      "Residential subdivision and housing",
      "Defence infrastructure",
      "Commercial and retail development",
      "Cross-border infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Albury", "Lavington", "Thurgoona", "West Wodonga", "Baranduda", "Bandiana", "Leneva", "Barnawartha", "Chiltern", "Beechworth"],
  },

  // ─── QUEENSLAND ────────────────────────────────────────────────────────────

  {
    slug: "brisbane-cbd",
    suburb: "Brisbane CBD",
    state: "QLD",
    postcode: "4000",
    council: "Brisbane City Council",
    keyRoads: ["Queen Street", "George Street", "Ann Street", "Adelaide Street"],
    intro:
      "Brisbane CBD is one of Australia's fastest-growing city centres, with a major construction boom driven by Olympic 2032 infrastructure, commercial towers, residential conversions and utility upgrades. Traffic management plan documentation must satisfy Brisbane City Council's detailed requirements and the high pedestrian, cycling and bus traffic of the inner city.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMP and TGS documentation for CBD projects, with experience managing works in Brisbane's tightly controlled central road network.",
    industries: [
      "Commercial tower construction",
      "Olympic and sports infrastructure",
      "Residential conversion",
      "Retail and hospitality fitouts",
      "Utility and services upgrades",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["South Brisbane", "Fortitude Valley", "Spring Hill", "New Farm", "Kangaroo Point", "West End", "Petrie Terrace", "Milton", "Kelvin Grove", "Newstead"],
  },
  {
    slug: "south-brisbane",
    suburb: "South Brisbane",
    state: "QLD",
    postcode: "4101",
    council: "Brisbane City Council",
    keyRoads: ["Melbourne Street", "Grey Street", "Montague Road", "Tribune Street"],
    intro:
      "South Brisbane is Brisbane's cultural heart, home to the Gallery of Modern Art, Queensland Performing Arts Centre and South Bank Parklands, where construction and maintenance works must be carefully managed around year-round events and one of Queensland's busiest pedestrian precincts.",
    bodyPara:
      "Focus Traffic Plans produces TMP and pedestrian control plan documentation for South Brisbane projects, with experience managing works in the South Bank entertainment and tourism precinct.",
    industries: [
      "Cultural and arts infrastructure",
      "High-density residential construction",
      "Hospitality and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["West End", "Highgate Hill", "Kangaroo Point", "Woolloongabba", "Dutton Park", "Annerley", "Brisbane CBD", "Fairfield", "Moorooka", "Yeronga"],
  },
  {
    slug: "fortitude-valley",
    suburb: "Fortitude Valley",
    state: "QLD",
    postcode: "4006",
    council: "Brisbane City Council",
    keyRoads: ["Brunswick Street", "Ann Street", "Wickham Street", "James Street"],
    intro:
      "Fortitude Valley is Brisbane's entertainment and creative industries precinct, with a dense mix of residential towers, boutique commercial buildings and heritage-listed venues where utility works, construction and events require detailed traffic management plan documentation throughout the year.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs and pedestrian management plans for Fortitude Valley projects, with experience managing works on Brunswick Street and the Valley entertainment strip.",
    industries: [
      "Residential apartment construction",
      "Hospitality and entertainment fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Events and festivals",
      "Commercial development",
    ],
    nearbySuburbs: ["New Farm", "Newstead", "Teneriffe", "Bowen Hills", "Spring Hill", "Brisbane CBD", "Herston", "Windsor", "Albion", "Lutwyche"],
  },
  {
    slug: "gold-coast",
    suburb: "Gold Coast",
    state: "QLD",
    postcode: "4217",
    council: "City of Gold Coast",
    keyRoads: ["Gold Coast Highway", "Surfers Paradise Boulevard", "Cavill Avenue", "Broadbeach Mall"],
    intro:
      "The Gold Coast is Australia's largest regional city and a year-round construction hotspot, with high-rise residential towers, hotel developments, light rail expansion and major road upgrades creating a constant demand for traffic management plan documentation along the coastal strip and key arterials.",
    bodyPara:
      "Focus Traffic Plans supports Gold Coast contractors and developers with City of Gold Coast-compliant TMP, TGS and council permit documentation, with experience managing works around tourist precincts and the busy Pacific Motorway corridor.",
    industries: [
      "High-rise residential construction",
      "Hotel and resort development",
      "Light rail infrastructure",
      "Retail and hospitality fitouts",
      "Road and infrastructure upgrades",
      "Events and tourism management",
    ],
    nearbySuburbs: ["Surfers Paradise", "Broadbeach", "Burleigh Heads", "Robina", "Southport", "Labrador", "Hope Island", "Coolangatta", "Nerang", "Coomera"],
  },
  {
    slug: "maroochydore",
    suburb: "Maroochydore",
    state: "QLD",
    postcode: "4558",
    council: "Sunshine Coast Council",
    keyRoads: ["Aerodrome Road", "Horton Parade", "Maroochydore Road", "Sunshine Motorway"],
    intro:
      "Maroochydore is the Sunshine Coast's new CBD and commercial hub, with a purpose-built city centre, major retail development, new hospital works and strong residential growth making it one of Queensland's most active construction markets outside Brisbane.",
    bodyPara:
      "Focus Traffic Plans provides Sunshine Coast Council-compliant TMP and TGS documentation for Maroochydore and the broader Sunshine Coast region, supporting the area's strong infrastructure pipeline.",
    industries: [
      "City centre and commercial development",
      "Residential construction",
      "Hospital and healthcare projects",
      "Road and infrastructure upgrades",
      "Retail and hospitality fitouts",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Mooloolaba", "Buderim", "Kawana", "Caloundra", "Nambour", "Palmview", "Mountain Creek", "Bokarina", "Sippy Downs", "Coolum"],
  },
  {
    slug: "townsville",
    suburb: "Townsville",
    state: "QLD",
    postcode: "4810",
    council: "Townsville City Council",
    keyRoads: ["Flinders Street", "Ross River Road", "Bowen Road", "Bruce Highway"],
    intro:
      "Townsville is North Queensland's major city and a significant industrial and defence hub, with major port expansion, hospital redevelopment, road upgrades and a growing residential sector creating consistent demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans provides Townsville City Council-compliant TMP documentation for North Queensland projects, offering the same fast turnaround as our southern-based clients.",
    industries: [
      "Industrial and port construction",
      "Defence infrastructure",
      "Hospital and healthcare development",
      "Residential construction",
      "Road and infrastructure upgrades",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Kirwan", "Aitkenvale", "Thuringowa", "Mundingburra", "Willows", "Annandale", "Hyde Park", "Garbutt", "Mount Louisa", "Rasmussen"],
  },
  {
    slug: "cairns",
    suburb: "Cairns",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Sheridan Street", "Spence Street", "Mulgrave Road", "Bruce Highway"],
    intro:
      "Cairns is Far North Queensland's gateway city and a growing tourism and residential centre, where road maintenance, utility upgrades, hotel developments and port-related construction regularly require traffic management plan documentation under Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares TMP and TGS documentation for Cairns and Far North Queensland projects, providing the same 24-hour turnaround available to clients across Australia.",
    industries: [
      "Tourism and hospitality development",
      "Port and marine construction",
      "Residential construction",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and council works",
    ],
    nearbySuburbs: ["Smithfield", "Edge Hill", "Manunda", "Manoora", "Westcourt", "Brinsmead", "Cairns North", "Gordonvale", "Redlynch", "Trinity Beach"],
  },
  {
    slug: "toowoomba",
    suburb: "Toowoomba",
    state: "QLD",
    postcode: "4350",
    council: "Toowoomba Regional Council",
    keyRoads: ["Ruthven Street", "Herries Street", "James Street", "Warrego Highway"],
    intro:
      "Toowoomba is Queensland's largest inland city and the gateway to the Darling Downs, with significant agricultural supply chain infrastructure, residential growth, major new hospital works and road upgrades creating strong demand for traffic management plan documentation across the region.",
    bodyPara:
      "Focus Traffic Plans supports Toowoomba's construction sector with fast-turnaround TMP and council permit documentation compliant with Toowoomba Regional Council and Queensland Department of Transport and Main Roads requirements.",
    industries: [
      "Agricultural and industrial development",
      "Hospital and healthcare construction",
      "Residential construction",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Commercial and retail development",
    ],
    nearbySuburbs: ["Drayton", "Newtown", "Harristown", "Wilsonton", "Highfields", "Rangeville", "Kearneys Spring", "Middle Ridge", "Darling Heights", "Glenvale"],
  },

  // ─── QUEENSLAND (additional) ───────────────────────────────────────────────

  // Greater Brisbane (additional)
  {
    slug: "herston",
    suburb: "Herston",
    state: "QLD",
    postcode: "4006",
    council: "Brisbane City Council",
    keyRoads: ["Herston Road", "Bowen Bridge Road", "Gilchrist Avenue", "Royal Brisbane Hospital Drive"],
    intro:
      "Herston is Brisbane's major health and biomedical precinct, anchored by the Royal Brisbane and Women's Hospital and the Queensland Institute of Medical Research, where ongoing hospital expansion and biomedical facility construction create complex traffic management requirements that must comply with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Herston health and construction projects, with specialist knowledge of hospital precinct traffic management and the Bowen Bridge Road corridor.",
    industries: [
      "Health and hospital infrastructure",
      "Biomedical and research construction",
      "University and education development",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Kelvin Grove", "Spring Hill", "Bowen Hills", "Windsor", "Lutwyche", "Fortitude Valley", "Brisbane CBD", "Newstead", "Ashgrove", "Red Hill"],
  },
  {
    slug: "kelvin-grove",
    suburb: "Kelvin Grove",
    state: "QLD",
    postcode: "4059",
    council: "Brisbane City Council",
    keyRoads: ["Kelvin Grove Road", "Musgrave Road", "Victoria Park Road", "Hale Street"],
    intro:
      "Kelvin Grove is home to the QUT Kelvin Grove campus and an extensive urban village redevelopment, where university construction, residential development and the nearby RBWH precinct create demand for traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kelvin Grove university and residential projects, with experience in the urban village construction environment.",
    industries: [
      "University and education construction",
      "Residential and mixed-use development",
      "Retail and commercial fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Herston", "Red Hill", "Ashgrove", "Spring Hill", "Windsor", "Paddington", "Brisbane CBD", "Fortitude Valley", "Lutwyche", "Newmarket"],
  },
  {
    slug: "kangaroo-point",
    suburb: "Kangaroo Point",
    state: "QLD",
    postcode: "4169",
    council: "Brisbane City Council",
    keyRoads: ["Main Street", "River Terrace", "Shafston Avenue", "Thornton Street"],
    intro:
      "Kangaroo Point is a sought-after inner-Brisbane suburb on the bend of the Brisbane River, where high-rise residential development, the new Kangaroo Point Green Bridge and tourism infrastructure works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Kangaroo Point residential and infrastructure projects, with experience managing the suburb's constrained river-bend road network.",
    industries: [
      "High-density residential development",
      "Bridge and transport infrastructure",
      "Tourism and hospitality development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["South Brisbane", "Woolloongabba", "East Brisbane", "Coorparoo", "Stones Corner", "Norman Park", "Hawthorne", "Balmoral", "Bulimba", "New Farm"],
  },
  {
    slug: "milton",
    suburb: "Milton",
    state: "QLD",
    postcode: "4064",
    council: "Brisbane City Council",
    keyRoads: ["Milton Road", "Park Road", "Coronation Drive", "Baroona Road"],
    intro:
      "Milton is a vibrant inner-Brisbane suburb known for its dining and café precinct, where commercial construction, residential development and Coronation Drive corridor upgrades require traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Milton commercial and residential projects, with knowledge of the busy Coronation Drive and Milton Road corridors.",
    industries: [
      "Commercial and office development",
      "Residential construction",
      "Retail and hospitality fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Auchenflower", "Paddington", "Toowong", "Brisbane CBD", "Spring Hill", "Petrie Terrace", "Red Hill", "Rosalie", "Bardon", "Taringa"],
  },
  {
    slug: "new-farm",
    suburb: "New Farm",
    state: "QLD",
    postcode: "4005",
    council: "Brisbane City Council",
    keyRoads: ["Brunswick Street", "Merthyr Road", "New Farm Road", "Oxlade Drive"],
    intro:
      "New Farm is one of Brisbane's most sought-after inner suburbs, where boutique residential construction, heritage building renovation and riverfront development create demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for New Farm residential and commercial projects, managing the suburb's narrow streets and heritage-sensitive environment.",
    industries: [
      "Boutique residential construction",
      "Heritage building refurbishment",
      "Retail and hospitality fitouts",
      "Riverfront and foreshore works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Teneriffe", "Newstead", "Fortitude Valley", "Brisbane CBD", "Kangaroo Point", "East Brisbane", "Hawthorne", "Balmoral", "Bulimba", "Woolloongabba"],
  },
  {
    slug: "newstead",
    suburb: "Newstead",
    state: "QLD",
    postcode: "4006",
    council: "Brisbane City Council",
    keyRoads: ["Breakfast Creek Road", "Newstead Terrace", "Commercial Road", "Longland Street"],
    intro:
      "Newstead is Brisbane's fastest-growing urban renewal precinct, where high-rise residential towers, luxury hotels and the Gasworks retail and entertainment complex drive significant construction activity requiring traffic management documentation compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Brisbane City Council-compliant TMPs for Newstead residential, hotel and commercial projects, with specialist experience in the precinct's rapidly evolving construction environment.",
    industries: [
      "High-density residential development",
      "Hotel and hospitality construction",
      "Retail and entertainment precinct works",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Teneriffe", "New Farm", "Fortitude Valley", "Bowen Hills", "Herston", "Brisbane CBD", "Albion", "Wilston", "Windsor", "Hamilton"],
  },
  {
    slug: "spring-hill",
    suburb: "Spring Hill",
    state: "QLD",
    postcode: "4000",
    council: "Brisbane City Council",
    keyRoads: ["Leichhardt Street", "Wharf Street", "Boundary Street", "Upper Edward Street"],
    intro:
      "Spring Hill is Brisbane's closest inner suburb to the CBD, where high-density residential construction, commercial office development and heritage building refurbishment create constant demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Spring Hill residential and commercial projects, with experience managing the suburb's steep topography and dense street network.",
    industries: [
      "High-density residential development",
      "Commercial office construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Brisbane CBD", "Fortitude Valley", "Herston", "Kelvin Grove", "Red Hill", "Petrie Terrace", "Paddington", "Bowen Hills", "New Farm", "Milton"],
  },
  {
    slug: "west-end",
    suburb: "West End",
    state: "QLD",
    postcode: "4101",
    council: "Brisbane City Council",
    keyRoads: ["Boundary Street", "Melbourne Street", "Montague Road", "Jane Street"],
    intro:
      "West End is Brisbane's bohemian inner suburb and a rapidly densifying residential precinct, where high-rise apartment construction, retail development along Boundary Street and riverside infrastructure create demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for West End residential and commercial projects, managing the suburb's vibrant street environment and high pedestrian activity.",
    industries: [
      "High-density residential development",
      "Retail and hospitality fitouts",
      "Riverfront and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["South Brisbane", "Highgate Hill", "Dutton Park", "Woolloongabba", "Kangaroo Point", "Toowong", "Milton", "Auchenflower", "Paddington", "Brisbane CBD"],
  },
  {
    slug: "woolloongabba",
    suburb: "Woolloongabba",
    state: "QLD",
    postcode: "4102",
    council: "Brisbane City Council",
    keyRoads: ["Stanley Street", "Ipswich Road", "Logan Road", "Annerley Road"],
    intro:
      "Woolloongabba is one of Brisbane's most active construction precincts, home to The Gabba cricket ground and a major Brisbane Metro and Cross River Rail station, where Olympic 2032 infrastructure upgrades, stadium redevelopment and residential densification create strong demand for traffic management documentation compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Brisbane City Council-compliant TMPs for Woolloongabba stadium, transport and residential projects, with specialist knowledge of the precinct's complex construction environment.",
    industries: [
      "Stadium and sports infrastructure",
      "Metro and rail infrastructure",
      "High-density residential development",
      "Commercial and retail construction",
      "Utility and services upgrades",
    ],
    nearbySuburbs: ["South Brisbane", "Kangaroo Point", "East Brisbane", "Coorparoo", "Stones Corner", "Annerley", "Fairfield", "Dutton Park", "Highgate Hill", "Camp Hill"],
  },
  // Northern Brisbane
  {
    slug: "aspley",
    suburb: "Aspley",
    state: "QLD",
    postcode: "4034",
    council: "Brisbane City Council",
    keyRoads: ["Gympie Road", "Boundary Road", "Albany Creek Road", "Telegraph Road"],
    intro:
      "Aspley is a major northern Brisbane retail and residential suburb anchored by Aspley Hypermarket, where commercial construction and residential development create demand for traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Aspley commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chermside", "Zillmere", "Geebung", "Carseldine", "Bald Hills", "Albany Creek", "Bridgeman Downs", "Boondall", "Stafford Heights", "Kedron"],
  },
  {
    slug: "chermside",
    suburb: "Chermside",
    state: "QLD",
    postcode: "4032",
    council: "Brisbane City Council",
    keyRoads: ["Gympie Road", "Hamilton Road", "Rode Road", "Kittyhawk Drive"],
    intro:
      "Chermside is Brisbane's largest suburban retail precinct, anchored by Westfield Chermside and the Prince Charles Hospital, where retail construction, hospital expansion and high-density residential development create strong demand for traffic management documentation compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Chermside retail, health and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Health and hospital infrastructure",
      "High-density residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Aspley", "Kedron", "Stafford", "Stafford Heights", "Geebung", "Zillmere", "Nundah", "Wavell Heights", "Wooloowin", "Gordon Park"],
  },
  {
    slug: "clayfield",
    suburb: "Clayfield",
    state: "QLD",
    postcode: "4011",
    council: "Brisbane City Council",
    keyRoads: ["Sandgate Road", "Junction Road", "Bonney Avenue", "Seventh Avenue"],
    intro:
      "Clayfield is an affluent inner-northern Brisbane suburb where residential construction, boutique commercial development and heritage building refurbishment require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Clayfield residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wooloowin", "Nundah", "Hendra", "Ascot", "Hamilton", "Lutwyche", "Windsor", "Gordon Park", "Wavell Heights", "Banyo"],
  },
  {
    slug: "geebung",
    suburb: "Geebung",
    state: "QLD",
    postcode: "4034",
    council: "Brisbane City Council",
    keyRoads: ["Newman Road", "Zillmere Road", "Handford Road", "Gympie Road"],
    intro:
      "Geebung is a northern Brisbane suburb with a mix of residential and light industrial uses, where construction activity and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Geebung residential and industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Zillmere", "Aspley", "Chermside", "Stafford Heights", "Boondall", "Carseldine", "Taigum", "Bald Hills", "Kedron", "Nundah"],
  },
  {
    slug: "hamilton-qld",
    suburb: "Hamilton",
    state: "QLD",
    postcode: "4007",
    council: "Brisbane City Council",
    keyRoads: ["Racecourse Road", "Kingsford Smith Drive", "Heath Street", "Nudgee Road"],
    intro:
      "Hamilton is one of Brisbane's most prestigious riverside suburbs, home to Eagle Farm Racecourse and the Port of Brisbane corridor, where luxury residential construction and the Portside Wharf development create demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hamilton luxury residential and commercial projects, with knowledge of the Kingsford Smith Drive corridor.",
    industries: [
      "Luxury residential construction",
      "Commercial and marina development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Ascot", "Clayfield", "Hendra", "Albion", "Newstead", "Teneriffe", "New Farm", "Bowen Hills", "Nundah", "Banyo"],
  },
  {
    slug: "kedron",
    suburb: "Kedron",
    state: "QLD",
    postcode: "4031",
    council: "Brisbane City Council",
    keyRoads: ["Gympie Road", "Kedron Park Road", "Rode Road", "Webster Road"],
    intro:
      "Kedron is a residential suburb in inner-northern Brisbane where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Kedron residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chermside", "Stafford", "Stafford Heights", "Nundah", "Wooloowin", "Gordon Park", "Wavell Heights", "Windsor", "Lutwyche", "Aspley"],
  },
  {
    slug: "nundah",
    suburb: "Nundah",
    state: "QLD",
    postcode: "4012",
    council: "Brisbane City Council",
    keyRoads: ["Sandgate Road", "Buckland Road", "Bage Street", "Toombul Road"],
    intro:
      "Nundah is an inner-northern Brisbane suburb undergoing significant residential renewal, where apartment construction and commercial development along the Sandgate Road corridor require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nundah residential and commercial projects.",
    industries: [
      "Residential and mixed-use development",
      "Commercial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Wavell Heights", "Clayfield", "Wooloowin", "Chermside", "Kedron", "Hendra", "Banyo", "Northgate", "Boondall", "Toombul"],
  },
  {
    slug: "stafford",
    suburb: "Stafford",
    state: "QLD",
    postcode: "4053",
    council: "Brisbane City Council",
    keyRoads: ["Stafford Road", "Webster Road", "Rode Road", "Muller Road"],
    intro:
      "Stafford is a northern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Stafford residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chermside", "Kedron", "Stafford Heights", "Gordon Park", "Everton Park", "Mitchelton", "Alderley", "Grange", "Windsor", "Lutwyche"],
  },
  {
    slug: "windsor-qld",
    suburb: "Windsor",
    state: "QLD",
    postcode: "4030",
    council: "Brisbane City Council",
    keyRoads: ["Lutwyche Road", "Enoggera Road", "Newmarket Road", "Albion Road"],
    intro:
      "Windsor is an inner-northern Brisbane suburb where residential construction and commercial development along the Lutwyche Road corridor require traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Windsor residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Wilston", "Newmarket", "Lutwyche", "Gordon Park", "Herston", "Kelvin Grove", "Stafford", "Kedron", "Wooloowin", "Clayfield"],
  },
  {
    slug: "wooloowin",
    suburb: "Wooloowin",
    state: "QLD",
    postcode: "4030",
    council: "Brisbane City Council",
    keyRoads: ["Lutwyche Road", "Watson Street", "Cranbrook Street", "Garrick Terrace"],
    intro:
      "Wooloowin is a quiet inner-northern Brisbane suburb where residential construction and heritage building renovation require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Wooloowin residential projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
    ],
    nearbySuburbs: ["Windsor", "Lutwyche", "Gordon Park", "Wilston", "Kedron", "Clayfield", "Nundah", "Newmarket", "Stafford", "Wavell Heights"],
  },
  // Southern Brisbane
  {
    slug: "algester",
    suburb: "Algester",
    state: "QLD",
    postcode: "4115",
    council: "Brisbane City Council",
    keyRoads: ["Beaudesert Road", "Algester Road", "Draper Road", "Mortimer Road"],
    intro:
      "Algester is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Algester residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Calamvale", "Parkinson", "Drewvale", "Stretton", "Robertson", "Sunnybank Hills", "Runcorn", "Acacia Ridge", "Pallara", "Larapinta"],
  },
  {
    slug: "calamvale",
    suburb: "Calamvale",
    state: "QLD",
    postcode: "4116",
    council: "Brisbane City Council",
    keyRoads: ["Compton Road", "Beaudesert Road", "Calamvale Road", "Mortimer Road"],
    intro:
      "Calamvale is a southern Brisbane suburb where residential construction and commercial development create demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Calamvale residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Algester", "Parkinson", "Sunnybank Hills", "Robertson", "Runcorn", "Stretton", "Drewvale", "Macgregor", "Eight Mile Plains", "Pallara"],
  },
  {
    slug: "coopers-plains",
    suburb: "Coopers Plains",
    state: "QLD",
    postcode: "4108",
    council: "Brisbane City Council",
    keyRoads: ["Beaudesert Road", "Kessels Road", "Nursery Road", "Granard Road"],
    intro:
      "Coopers Plains is a southern Brisbane suburb with a mix of residential and light industrial uses, where construction activity and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Coopers Plains residential and light industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Sunnybank", "Macgregor", "Moorooka", "Salisbury", "Rocklea", "Nathan", "Mount Gravatt", "Runcorn", "Acacia Ridge", "Yeerongpilly"],
  },
  {
    slug: "eight-mile-plains",
    suburb: "Eight Mile Plains",
    state: "QLD",
    postcode: "4113",
    council: "Brisbane City Council",
    keyRoads: ["South East Freeway", "Beveridge Road", "Rochedale Road", "Miles Platting Road"],
    intro:
      "Eight Mile Plains is a major technology and business park precinct in southern Brisbane, where commercial office construction and the nearby Springwood industrial estate create demand for traffic management documentation compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Eight Mile Plains commercial and industrial projects.",
    industries: [
      "Commercial and technology park development",
      "Industrial and logistics construction",
      "Utility maintenance",
      "Road and access construction",
      "Residential development",
    ],
    nearbySuburbs: ["Rochedale South", "Sunnybank Hills", "Calamvale", "Macgregor", "Wishart", "Mount Gravatt East", "Underwood", "Springwood", "Slacks Creek", "Runcorn"],
  },
  {
    slug: "macgregor",
    suburb: "Macgregor",
    state: "QLD",
    postcode: "4109",
    council: "Brisbane City Council",
    keyRoads: ["Kessels Road", "Mains Road", "Wecker Road", "Granard Road"],
    intro:
      "Macgregor is a residential suburb in southern Brisbane where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Macgregor residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Sunnybank", "Coopers Plains", "Runcorn", "Mount Gravatt", "Wishart", "Eight Mile Plains", "Calamvale", "Robertson", "Sunnybank Hills", "Mansfield"],
  },
  {
    slug: "mount-gravatt",
    suburb: "Mount Gravatt",
    state: "QLD",
    postcode: "4122",
    council: "Brisbane City Council",
    keyRoads: ["Logan Road", "Kessels Road", "Mount Gravatt-Capalaba Road", "Mains Road"],
    intro:
      "Mount Gravatt is a major southern Brisbane commercial and educational hub, home to Griffith University and Garden City Shopping Centre, where retail construction, university development and residential projects create demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Mount Gravatt retail, education and residential projects.",
    industries: [
      "Retail and commercial construction",
      "University and education development",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Wishart", "Mansfield", "Carindale", "Rochedale South", "Macgregor", "Coopers Plains", "Sunnybank", "Mount Gravatt East", "Upper Mount Gravatt", "Holland Park"],
  },
  {
    slug: "runcorn",
    suburb: "Runcorn",
    state: "QLD",
    postcode: "4113",
    council: "Brisbane City Council",
    keyRoads: ["Warrigal Road", "Beaudesert Road", "Gowan Road", "Beenleigh Road"],
    intro:
      "Runcorn is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Runcorn residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Sunnybank Hills", "Calamvale", "Algester", "Macgregor", "Eight Mile Plains", "Stretton", "Coopers Plains", "Parkinson", "Drewvale", "Acacia Ridge"],
  },
  {
    slug: "slacks-creek",
    suburb: "Slacks Creek",
    state: "QLD",
    postcode: "4127",
    council: "Logan City Council",
    keyRoads: ["Kingston Road", "Wembley Road", "Loganlea Road", "Durack Street"],
    intro:
      "Slacks Creek is a major light industrial and commercial suburb in Logan City, where warehouse construction, industrial development and residential projects create demand for traffic management plans compliant with Logan City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Slacks Creek industrial, commercial and residential projects.",
    industries: [
      "Light industrial and warehouse development",
      "Commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Springwood", "Underwood", "Eight Mile Plains", "Kingston", "Loganlea", "Woodridge", "Logan Central", "Daisy Hill", "Rochedale South", "Shailer Park"],
  },
  {
    slug: "sunnybank",
    suburb: "Sunnybank",
    state: "QLD",
    postcode: "4109",
    council: "Brisbane City Council",
    keyRoads: ["Mains Road", "McCullough Street", "Beaudesert Road", "Pinelands Road"],
    intro:
      "Sunnybank is Brisbane's premier Asian dining and retail precinct, where commercial construction, residential development and the Sunnybank Hills Shoppingtown precinct generate demand for traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sunnybank commercial and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Macgregor", "Coopers Plains", "Sunnybank Hills", "Robertson", "Calamvale", "Runcorn", "Moorooka", "Salisbury", "Nathan", "Holland Park West"],
  },
  {
    slug: "wishart",
    suburb: "Wishart",
    state: "QLD",
    postcode: "4122",
    council: "Brisbane City Council",
    keyRoads: ["Wishart Road", "Wecker Road", "Mount Gravatt-Capalaba Road", "Warrigal Road"],
    intro:
      "Wishart is a residential suburb in southern Brisbane where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Wishart residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mount Gravatt", "Mansfield", "Rochedale South", "Carindale", "Mackenzie", "Eight Mile Plains", "Macgregor", "Upper Mount Gravatt", "Belmont", "Tingalpa"],
  },
  // Gold Coast (additional)
  {
    slug: "arundel",
    suburb: "Arundel",
    state: "QLD",
    postcode: "4214",
    council: "Gold Coast City Council",
    keyRoads: ["Olsen Avenue", "Gooding Drive", "Millaroo Drive", "Siganto Drive"],
    intro:
      "Arundel is a residential suburb in the northern Gold Coast, home to Griffith University's Gold Coast campus, where residential construction and university-related development require traffic management plans compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Arundel residential and education-related projects.",
    industries: [
      "Residential construction",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Parkwood", "Labrador", "Southport", "Molendinar", "Ashmore", "Biggera Waters", "Helensvale", "Oxenford", "Carrara", "Bundall"],
  },
  {
    slug: "biggera-waters",
    suburb: "Biggera Waters",
    state: "QLD",
    postcode: "4216",
    council: "Gold Coast City Council",
    keyRoads: ["Oxley Drive", "Marine Parade", "Hollinsworth Road", "Macarthur Parade"],
    intro:
      "Biggera Waters is a canal and waterway suburb on the northern Gold Coast where residential construction, marina development and coastal infrastructure works require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Biggera Waters residential and waterfront projects.",
    industries: [
      "Residential and waterfront construction",
      "Marina and marine infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Labrador", "Southport", "Arundel", "Coombabah", "Runaway Bay", "Paradise Point", "Hollywell", "Helensvale", "Parkwood", "Ashmore"],
  },
  {
    slug: "broadbeach",
    suburb: "Broadbeach",
    state: "QLD",
    postcode: "4218",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Surf Parade", "Victoria Avenue", "Albert Avenue"],
    intro:
      "Broadbeach is the Gold Coast's premier retail, dining and entertainment precinct, where the Pacific Fair shopping centre, Star Casino, G:link light rail and beachside residential construction create significant traffic management requirements compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Gold Coast City Council-compliant TMPs for Broadbeach retail, hospitality and residential projects, with experience in the precinct's high-volume tourism environment.",
    industries: [
      "Retail and entertainment precinct works",
      "High-density residential development",
      "Hotel and casino construction",
      "Light rail corridor works",
      "Utility and services upgrades",
    ],
    nearbySuburbs: ["Surfers Paradise", "Mermaid Beach", "Nobby Beach", "Miami", "Burleigh Heads", "Bundall", "Benowa", "Southport", "Nerang", "Carrara"],
  },
  {
    slug: "burleigh-heads",
    suburb: "Burleigh Heads",
    state: "QLD",
    postcode: "4220",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Tallebudgera Creek Road", "James Street", "Connor Street"],
    intro:
      "Burleigh Heads is one of the Gold Coast's most sought-after coastal villages, where boutique residential construction, hospitality fitouts and coastal infrastructure works create demand for traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Burleigh Heads residential and commercial projects, managing the suburb's popular beachside environment.",
    industries: [
      "Coastal residential construction",
      "Hospitality and retail fitouts",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Miami", "Mermaid Beach", "Palm Beach", "Tallebudgera", "Elanora", "Varsity Lakes", "Robina", "Mudgeeraba", "Currumbin", "Tugun"],
  },
  {
    slug: "coomera",
    suburb: "Coomera",
    state: "QLD",
    postcode: "4209",
    council: "Gold Coast City Council",
    keyRoads: ["Motorway", "Foxwell Road", "Coomera Connections Road", "Days Road"],
    intro:
      "Coomera is one of the fastest-growing residential areas in Australia, where large residential estate construction, the Westfield Coomera shopping centre and new schools create high demand for traffic management documentation compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Coomera residential, retail and education projects.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial development",
      "Education and community infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Pimpama", "Ormeau", "Oxenford", "Upper Coomera", "Hope Island", "Helensvale", "Parkwood", "Yatala", "Willow Vale", "Worongary"],
  },
  {
    slug: "coolangatta",
    suburb: "Coolangatta",
    state: "QLD",
    postcode: "4225",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Griffith Street", "Marine Parade", "Musgrave Street"],
    intro:
      "Coolangatta is the southern tip of the Gold Coast and gateway to the Tweed Coast, where beachside residential construction, tourism infrastructure and Gold Coast Airport expansion create demand for traffic management plans compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Gold Coast City Council-compliant TMPs for Coolangatta residential, tourism and airport-related projects.",
    industries: [
      "Coastal residential construction",
      "Tourism and hospitality development",
      "Airport and aviation infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Tweed Heads", "Kirra", "Bilinga", "Tugun", "Currumbin", "Palm Beach", "Elanora", "Varsity Lakes", "Robina", "Burleigh Heads"],
  },
  {
    slug: "hope-island",
    suburb: "Hope Island",
    state: "QLD",
    postcode: "4212",
    council: "Gold Coast City Council",
    keyRoads: ["Hope Island Road", "Santa Barbara Road", "Monterey Keys Drive", "Broadwater Avenue"],
    intro:
      "Hope Island is a prestigious canals and marina suburb on the northern Gold Coast, where luxury residential construction and marina development require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hope Island luxury residential and marina projects.",
    industries: [
      "Luxury residential construction",
      "Marina and marine infrastructure",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["Sanctuary Cove", "Coomera", "Oxenford", "Helensvale", "Biggera Waters", "Runaway Bay", "Paradise Point", "Hollywell", "Coombabah", "Labrador"],
  },
  {
    slug: "labrador",
    suburb: "Labrador",
    state: "QLD",
    postcode: "4215",
    council: "Gold Coast City Council",
    keyRoads: ["Marine Parade", "Olsen Avenue", "Frank Street", "Benowa Road"],
    intro:
      "Labrador is a waterfront suburb on the Gold Coast Broadwater where residential construction, waterfront development and utility works require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Labrador residential and waterfront projects.",
    industries: [
      "Residential and waterfront construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Southport", "Biggera Waters", "Arundel", "Ashmore", "Parkwood", "Molendinar", "Carrara", "Bundall", "Coombabah", "Runaway Bay"],
  },
  {
    slug: "nerang",
    suburb: "Nerang",
    state: "QLD",
    postcode: "4211",
    council: "Gold Coast City Council",
    keyRoads: ["Nerang-Broadbeach Road", "Price Street", "Nerang-Murwillumbah Road", "Gilston Road"],
    intro:
      "Nerang is the Gold Coast's major western service and industrial centre, where residential development, light industrial construction and the proximity to the M1 Pacific Motorway create demand for traffic management plans compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nerang industrial, commercial and residential projects.",
    industries: [
      "Light industrial and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Carrara", "Worongary", "Mudgeeraba", "Robina", "Upper Coomera", "Oxenford", "Molendinar", "Helensvale", "Gilston", "Highland Park"],
  },
  {
    slug: "robina",
    suburb: "Robina",
    state: "QLD",
    postcode: "4226",
    council: "Gold Coast City Council",
    keyRoads: ["Robina Parkway", "Scottsdale Drive", "Cheltenham Drive", "Ron Penhaligon Way"],
    intro:
      "Robina is the Gold Coast's major planned urban centre and home to Robina Town Centre, the Cbus Super Stadium and a major hospital, where retail construction, health infrastructure and high-density residential development create strong demand for traffic management documentation compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Robina retail, health and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Health and hospital infrastructure",
      "High-density residential development",
      "Sports and entertainment infrastructure",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Varsity Lakes", "Burleigh Waters", "Mudgeeraba", "Worongary", "Nerang", "Reedy Creek", "Tallai", "Merrimac", "Carrara", "Elanora"],
  },
  {
    slug: "southport",
    suburb: "Southport",
    state: "QLD",
    postcode: "4215",
    council: "Gold Coast City Council",
    keyRoads: ["Scarborough Street", "Nerang Street", "Olsen Avenue", "Ferry Road"],
    intro:
      "Southport is the Gold Coast's administrative and commercial capital and a Major Activty Centre, where high-rise residential towers, the Gold Coast University Hospital and a growing commercial core create strong demand for traffic management plans compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Gold Coast City Council-compliant TMPs for Southport residential, health and commercial projects, with experience in the city's central activity centre environment.",
    industries: [
      "High-density residential development",
      "Health and hospital infrastructure",
      "Commercial and retail construction",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Labrador", "Biggera Waters", "Ashmore", "Bundall", "Parkwood", "Arundel", "Molendinar", "Benowa", "Carrara", "Surfers Paradise"],
  },
  {
    slug: "surfers-paradise",
    suburb: "Surfers Paradise",
    state: "QLD",
    postcode: "4217",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Cavill Avenue", "Surfers Paradise Boulevard", "Ferny Avenue"],
    intro:
      "Surfers Paradise is one of Australia's most iconic tourist destinations and the Gold Coast's CBD, where high-rise residential towers, hotel construction, G:link light rail and major events create complex and constant traffic management requirements that must comply with Gold Coast City Council and Queensland TMR standards.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Surfers Paradise high-rise, hotel and infrastructure projects, with specialist experience managing works in Australia's busiest tourist precinct.",
    industries: [
      "High-rise residential development",
      "Hotel and resort construction",
      "Light rail and transport infrastructure",
      "Retail and entertainment precinct works",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["Broadbeach", "Southport", "Bundall", "Benowa", "Mermaid Beach", "Main Beach", "Ashmore", "Labrador", "Carrara", "Miami"],
  },
  // Sunshine Coast (additional)
  {
    slug: "buderim",
    suburb: "Buderim",
    state: "QLD",
    postcode: "4556",
    council: "Sunshine Coast Council",
    keyRoads: ["Mons Road", "Burnett Street", "Stringybark Road", "Mooloolaba Road"],
    intro:
      "Buderim is the Sunshine Coast's major residential hilltop suburb and commercial centre, where residential construction, retail development and infrastructure upgrades require traffic management plans compliant with Sunshine Coast Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Buderim residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Palmview", "Forest Glen", "Kunda Park", "Sippy Downs", "Mountain Creek", "Kuluin", "Mooloolaba", "Maroochydore", "Kawana", "Alexandra Headland"],
  },
  {
    slug: "caloundra",
    suburb: "Caloundra",
    state: "QLD",
    postcode: "4551",
    council: "Sunshine Coast Council",
    keyRoads: ["Nicklin Way", "Caloundra Road", "Ormonde Terrace", "Bulcock Street"],
    intro:
      "Caloundra is the southern gateway to the Sunshine Coast, where residential development, coastal tourism infrastructure and the Aura master-planned community drive demand for traffic management plans compliant with Sunshine Coast Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Caloundra and surrounding Aura development projects.",
    industries: [
      "Residential subdivision and housing",
      "Tourism and hospitality construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Pelican Waters", "Golden Beach", "Kings Beach", "Moffat Beach", "Currimundi", "Bokarina", "Wurtulla", "Little Mountain", "Sippy Downs", "Meridan Plains"],
  },
  {
    slug: "coolum",
    suburb: "Coolum",
    state: "QLD",
    postcode: "4573",
    council: "Sunshine Coast Council",
    keyRoads: ["David Low Way", "Coolum Road", "Tanawha Tourist Drive", "Beach Road"],
    intro:
      "Coolum is a popular Sunshine Coast beach town where coastal residential construction and tourism infrastructure works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Coolum coastal residential and tourism projects.",
    industries: [
      "Coastal residential construction",
      "Tourism and hospitality development",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Peregian Beach", "Yaroomba", "Point Arkwright", "Marcus Beach", "Marcoola", "Mount Coolum", "Mudjimba", "Twin Waters", "Noosa Heads", "Tewantin"],
  },
  {
    slug: "forest-glen",
    suburb: "Forest Glen",
    state: "QLD",
    postcode: "4556",
    council: "Sunshine Coast Council",
    keyRoads: ["Mons Road", "Sippy Downs Drive", "Mooloolaba Road", "Tanawha Tourist Drive"],
    intro:
      "Forest Glen is a semi-rural suburb in the Sunshine Coast hinterland, home to Australia Zoo, where rural residential development and tourism infrastructure require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Forest Glen residential and tourism projects.",
    industries: [
      "Rural residential development",
      "Tourism and attraction infrastructure",
      "Utility maintenance",
      "Road and access construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Buderim", "Sippy Downs", "Palmview", "Tanawha", "Kunda Park", "Mooloolah Valley", "Landsborough", "Beerwah", "Glass House Mountains", "Chevallum"],
  },
  {
    slug: "kawana",
    suburb: "Kawana",
    state: "QLD",
    postcode: "4575",
    council: "Sunshine Coast Council",
    keyRoads: ["Nicklin Way", "Kawana Way", "Lake Kawana Boulevard", "Bokarina Boulevard"],
    intro:
      "Kawana is a major residential and health precinct on the Sunshine Coast, home to the Sunshine Coast University Hospital, where hospital construction, residential development and the Kawana Town Centre create strong demand for traffic management documentation compliant with Sunshine Coast Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Kawana health, residential and commercial projects.",
    industries: [
      "Health and hospital infrastructure",
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Bokarina", "Wurtulla", "Birtinya", "Sippy Downs", "Mountain Creek", "Buddina", "Parrearra", "Warana", "Minyama", "Mooloolaba"],
  },
  {
    slug: "maleny",
    suburb: "Maleny",
    state: "QLD",
    postcode: "4552",
    council: "Sunshine Coast Council",
    keyRoads: ["Maleny-Montville Road", "Bunya Street", "Maple Street", "Maleny-Kenilworth Road"],
    intro:
      "Maleny is a picturesque hinterland town in the Sunshine Coast Hinterland where rural residential construction and tourism infrastructure require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Maleny rural residential and tourism projects.",
    industries: [
      "Rural residential construction",
      "Tourism and hospitality development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Montville", "Mapleton", "Flaxton", "Witta", "Conondale", "Kenilworth", "Landsborough", "Caloundra", "Beerwah", "Glass House Mountains"],
  },
  {
    slug: "nambour",
    suburb: "Nambour",
    state: "QLD",
    postcode: "4560",
    council: "Sunshine Coast Council",
    keyRoads: ["Nambour Connection Road", "Currie Street", "Howard Street", "Ann Street"],
    intro:
      "Nambour is the Sunshine Coast hinterland's major service centre, where residential development, commercial construction and infrastructure upgrades require traffic management plans compliant with Sunshine Coast Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Nambour residential and commercial projects.",
    industries: [
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Woombye", "Palmwoods", "Kulangoor", "Yandina", "Bli Bli", "Burnside", "Diddillibah", "Towen Mountain", "Maroochydore", "Buderim"],
  },
  {
    slug: "noosa-heads",
    suburb: "Noosa Heads",
    state: "QLD",
    postcode: "4567",
    council: "Noosa Shire Council",
    keyRoads: ["Noosa Drive", "Hastings Street", "Noosa Parade", "Weyba Road"],
    intro:
      "Noosa Heads is one of Australia's most prestigious coastal destinations, where strict development controls, high tourist volumes and luxury residential construction create complex traffic management requirements that must comply with Noosa Shire Council requirements.",
    bodyPara:
      "Focus Traffic Plans produces Noosa Shire Council-compliant TMPs for Noosa Heads residential and hospitality projects, with awareness of the shire's strict development and environmental controls.",
    industries: [
      "Luxury residential construction",
      "Tourism and hospitality development",
      "Heritage and environmental sensitive works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Noosaville", "Tewantin", "Sunshine Beach", "Peregian Beach", "Marcus Beach", "Castaways Beach", "Lake Weyba", "Doonan", "Cooroibah", "Cooroy"],
  },
  {
    slug: "palmview",
    suburb: "Palmview",
    state: "QLD",
    postcode: "4553",
    council: "Sunshine Coast Council",
    keyRoads: ["Sunshine Motorway", "Mons Road", "Innovation Parkway", "Sippy Downs Drive"],
    intro:
      "Palmview is one of the Sunshine Coast's largest greenfield development areas, with a major master-planned community, employment lands and associated infrastructure driving sustained high-volume construction traffic management requirements compliant with Sunshine Coast Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Palmview residential estate, employment land and infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Employment land and commercial development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
    ],
    nearbySuburbs: ["Sippy Downs", "Buderim", "Forest Glen", "Mountain Creek", "Kawana", "Bokarina", "Meridan Plains", "Caloundra", "Kunda Park", "Mooloolah Valley"],
  },
  // Townsville (additional)
  {
    slug: "aitkenvale",
    suburb: "Aitkenvale",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Ross River Road", "Nathan Street", "Bayswater Road", "Ingham Road"],
    intro:
      "Aitkenvale is a commercial and light industrial suburb in central Townsville, where retail construction, warehouse development and utility works require traffic management plans compliant with Townsville City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Aitkenvale commercial and industrial projects.",
    industries: [
      "Retail and commercial construction",
      "Light industrial and warehouse development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Mundingburra", "Kirwan", "Hermit Park", "Hyde Park", "Townsville CBD", "Garbutt", "Currajong", "Mount Louisa", "Vincent", "Annandale"],
  },
  {
    slug: "annandale",
    suburb: "Annandale",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Ross River Road", "Stuart Drive", "Annandale Drive", "Bamford Lane"],
    intro:
      "Annandale is a major residential and retail suburb in southern Townsville where residential construction and the Stockland Townsville shopping centre create demand for traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Annandale residential and retail projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Aitkenvale", "Kirwan", "Mundingburra", "Thuringowa Central", "Rasmussen", "Cranbrook", "Bohle Plains", "Douglas", "Mount Louisa", "Condon"],
  },
  {
    slug: "kirwan",
    suburb: "Kirwan",
    state: "QLD",
    postcode: "4817",
    council: "Townsville City Council",
    keyRoads: ["Thuringowa Drive", "Bayswater Road", "Greenbank Street", "Bamford Lane"],
    intro:
      "Kirwan is Townsville's largest residential suburb and a major commercial centre, where residential construction and retail development around Stockland Townsville create strong demand for traffic management documentation compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Kirwan residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Thuringowa Central", "Annandale", "Rasmussen", "Bohle Plains", "Mount Louisa", "Cranbrook", "Condon", "Aitkenvale", "Douglas", "Kelso"],
  },
  {
    slug: "mundingburra",
    suburb: "Mundingburra",
    state: "QLD",
    postcode: "4812",
    council: "Townsville City Council",
    keyRoads: ["Ross River Road", "Ingham Road", "Hugh Street", "Dalrymple Road"],
    intro:
      "Mundingburra is an established residential suburb close to Townsville CBD, where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mundingburra residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Aitkenvale", "Townsville CBD", "Hyde Park", "Hermit Park", "South Townsville", "Currajong", "Garbutt", "Cranbrook", "Vincent", "Mysterton"],
  },
  {
    slug: "pimlico",
    suburb: "Pimlico",
    state: "QLD",
    postcode: "4812",
    council: "Townsville City Council",
    keyRoads: ["Ross River Road", "Ingham Road", "Bamford Lane", "Abbot Street"],
    intro:
      "Pimlico is a residential suburb in inner Townsville where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Pimlico residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Townsville CBD", "Hyde Park", "Hermit Park", "Mundingburra", "Aitkenvale", "Garbutt", "Currajong", "South Townsville", "Vincent", "Mysterton"],
  },
  {
    slug: "rasmussen",
    suburb: "Rasmussen",
    state: "QLD",
    postcode: "4815",
    council: "Townsville City Council",
    keyRoads: ["Bamford Lane", "Hervey Range Road", "Rasmussen Avenue", "Stuart Drive"],
    intro:
      "Rasmussen is a growing residential suburb in the Thuringowa area of Townsville where residential estate construction requires traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Rasmussen residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kirwan", "Thuringowa Central", "Annandale", "Mount Louisa", "Cranbrook", "Bohle Plains", "Condon", "Douglas", "Kelso", "Aitkenvale"],
  },
  {
    slug: "thuringowa",
    suburb: "Thuringowa",
    state: "QLD",
    postcode: "4817",
    council: "Townsville City Council",
    keyRoads: ["Thuringowa Drive", "Deeragun Road", "Hervey Range Road", "Bayswater Road"],
    intro:
      "Thuringowa is the western residential growth area of Townsville, where ongoing residential estate development and associated infrastructure create demand for traffic management documentation compliant with Townsville City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Thuringowa residential and civil projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kirwan", "Rasmussen", "Bohle Plains", "Mount Louisa", "Deeragun", "Condon", "Kelso", "Cranbrook", "Annandale", "Douglas"],
  },
  {
    slug: "willows",
    suburb: "Willows",
    state: "QLD",
    postcode: "4815",
    council: "Townsville City Council",
    keyRoads: ["Bayswater Road", "Thuringowa Drive", "Saunders Street", "Hervey Range Road"],
    intro:
      "Willows is a residential suburb in western Townsville where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Willows residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Kirwan", "Thuringowa Central", "Bohle Plains", "Rasmussen", "Mount Louisa", "Deeragun", "Condon", "Kelso", "Cranbrook", "Annandale"],
  },
  // Cairns (additional)
  {
    slug: "brinsmead",
    suburb: "Brinsmead",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Kennedy Highway", "Brinsmead Road", "Barnwell Road", "Raintree Boulevard"],
    intro:
      "Brinsmead is a leafy residential suburb in Cairns' hinterland where residential construction and utility works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Brinsmead residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Whitfield", "Kamerunga", "Freshwater", "Caravonica", "Redlynch", "Smithfield", "Edge Hill", "Stratford", "Cairns North", "Manoora"],
  },
  {
    slug: "cairns-north",
    suburb: "Cairns North",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Sheridan Street", "Mcleod Street", "Abbott Street", "Grafton Street"],
    intro:
      "Cairns North is the residential area immediately north of Cairns CBD, where residential construction, commercial development and utility works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Cairns North residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cairns CBD", "Edge Hill", "Parramatta Park", "Manunda", "Manoora", "Westcourt", "Bungalow", "Portsmith", "Stratford", "Freshwater"],
  },
  {
    slug: "edge-hill",
    suburb: "Edge Hill",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Kamerunga Road", "Collins Avenue", "Walsh Street", "Hubinger Street"],
    intro:
      "Edge Hill is a sought-after residential suburb adjacent to the Cairns Botanic Gardens and rainforest, where residential construction and heritage building works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Edge Hill residential and heritage projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cairns North", "Brinsmead", "Whitfield", "Freshwater", "Kamerunga", "Smithfield", "Stratford", "Cairns CBD", "Manunda", "Parramatta Park"],
  },
  {
    slug: "gordonvale",
    suburb: "Gordonvale",
    state: "QLD",
    postcode: "4865",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "Gordon Street", "Eden Street", "Mill Road"],
    intro:
      "Gordonvale is a cane-growing town south of Cairns, where residential construction, agricultural infrastructure and sugar mill works require traffic management plans compliant with Cairns Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gordonvale residential and agricultural infrastructure projects.",
    industries: [
      "Residential construction",
      "Agricultural and sugar mill infrastructure",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Goldsborough", "Fishery Falls", "Aloomba", "Woree", "Bentley Park", "Mount Sheridan", "White Rock", "Cairns CBD", "Edmonton", "Babinda"],
  },
  {
    slug: "manunda",
    suburb: "Manunda",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Mulgrave Road", "Pease Street", "Severin Street", "McCoombe Street"],
    intro:
      "Manunda is a central Cairns suburb close to Cairns Base Hospital, where residential construction and health-related development require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Manunda residential and health precinct projects.",
    industries: [
      "Residential construction",
      "Health and hospital support works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Manoora", "Bungalow", "Westcourt", "Parramatta Park", "Cairns CBD", "Cairns North", "Whitfield", "Edge Hill", "Portsmith", "Stratford"],
  },
  {
    slug: "manoora",
    suburb: "Manoora",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Mulgrave Road", "McCoombe Street", "Bungalow Street", "Laver Street"],
    intro:
      "Manoora is a residential suburb in central Cairns where residential construction and utility works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Manoora residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Manunda", "Bungalow", "Westcourt", "Parramatta Park", "Cairns North", "Cairns CBD", "Mooroobool", "Edge Hill", "Portsmith", "Whitfield"],
  },
  {
    slug: "smithfield",
    suburb: "Smithfield",
    state: "QLD",
    postcode: "4878",
    council: "Cairns Regional Council",
    keyRoads: ["Captain Cook Highway", "Smithfield Bypass", "Kamerunga Road", "Sorbellos Road"],
    intro:
      "Smithfield is a major retail and residential suburb north of Cairns, home to Smithfield Shopping Centre, where commercial construction, residential development and the nearby James Cook University campus create demand for traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Smithfield retail, education and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Caravonica", "Kamerunga", "Brinsmead", "Freshwater", "Redlynch", "Yorkeys Knob", "Holloways Beach", "Trinity Beach", "Trinity Park", "Edge Hill"],
  },
  {
    slug: "westcourt",
    suburb: "Westcourt",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Mulgrave Road", "Pease Street", "D'Arcy Street", "Bentinck Street"],
    intro:
      "Westcourt is a light industrial and commercial suburb adjacent to Cairns CBD, where warehouse construction, commercial development and utility works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Westcourt light industrial and commercial projects.",
    industries: [
      "Light industrial and warehouse development",
      "Commercial construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Cairns CBD", "Bungalow", "Manunda", "Manoora", "Parramatta Park", "Portsmith", "Stratford", "Cairns North", "Woree", "Mooroobool"],
  },
  // Regional QLD
  {
    slug: "bundaberg",
    suburb: "Bundaberg",
    state: "QLD",
    postcode: "4670",
    council: "Bundaberg Regional Council",
    keyRoads: ["Bourbong Street", "Barolin Street", "Bundaberg Port Road", "Isis Highway"],
    intro:
      "Bundaberg is the major city of the Wide Bay-Burnett region, an important agricultural, sugar and rum industry hub, where residential development, commercial construction and agricultural infrastructure create demand for traffic management plans compliant with Bundaberg Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Bundaberg Regional Council-compliant TMPs for residential, agricultural and commercial projects in the Bundaberg region.",
    industries: [
      "Agricultural and sugar industry infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Avoca", "Kepnock", "Avenell Heights", "Svensson Heights", "Walkervale", "Millbank", "Bundaberg East", "Bargara", "Elliott Heads", "Gin Gin"],
  },
  {
    slug: "emerald",
    suburb: "Emerald",
    state: "QLD",
    postcode: "4720",
    council: "Central Highlands Regional Council",
    keyRoads: ["Clermont Street", "Egerton Street", "Borilla Street", "Hospital Road"],
    intro:
      "Emerald is the service centre of Queensland's Central Highlands coal and agricultural region, where mining infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Central Highlands Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Emerald mining support, residential and commercial projects in the Central Highlands.",
    industries: [
      "Mining and resources infrastructure",
      "Agricultural infrastructure",
      "Residential development",
      "Commercial construction",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Clermont", "Blackwater", "Capella", "Springsure", "Rolleston", "Tieri", "Moranbah", "Dysart", "Peak Downs", "Sapphire"],
  },
  {
    slug: "gladstone",
    suburb: "Gladstone",
    state: "QLD",
    postcode: "4680",
    council: "Gladstone Regional Council",
    keyRoads: ["Goondoon Street", "Glenlyon Road", "Philip Street", "Dawson Highway"],
    intro:
      "Gladstone is one of Australia's most significant industrial port cities, home to major LNG, aluminium and coal export facilities, where heavy industrial construction, port infrastructure and residential development create complex traffic management requirements compliant with Gladstone Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Gladstone Regional Council-compliant TMPs for industrial, port and residential projects, with experience in heavy industrial traffic environments.",
    industries: [
      "LNG and heavy industrial infrastructure",
      "Port and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Barney Point", "South Gladstone", "West Gladstone", "New Auckland", "Telina", "Calliope", "Boyne Island", "Tannum Sands", "Clinton", "Toolooa"],
  },
  {
    slug: "gympie",
    suburb: "Gympie",
    state: "QLD",
    postcode: "4570",
    council: "Gympie Regional Council",
    keyRoads: ["Mary Street", "Bruce Highway", "Channon Street", "Nash Street"],
    intro:
      "Gympie is a regional city in the Mary Valley and a major service centre for the Cooloola region, where residential development, commercial construction and infrastructure upgrades require traffic management plans compliant with Gympie Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gympie Regional Council-compliant TMPs for residential and commercial projects in the Gympie region.",
    industries: [
      "Residential development",
      "Commercial construction",
      "Agricultural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Southside", "Monkland", "Two Mile", "One Mile", "Mothar Mountain", "Widgee", "Gunalda", "Tin Can Bay", "Rainbow Beach", "Cooloola Cove"],
  },
  {
    slug: "hervey-bay",
    suburb: "Hervey Bay",
    state: "QLD",
    postcode: "4655",
    council: "Fraser Coast Regional Council",
    keyRoads: ["Maryborough-Hervey Bay Road", "Main Street", "Charlton Esplanade", "Boat Harbour Drive"],
    intro:
      "Hervey Bay is one of Queensland's fastest-growing coastal cities and the gateway to Fraser Island, where residential development, tourism infrastructure and the expanding Fraser Coast Regional Council service centre create strong demand for traffic management documentation compliant with Fraser Coast Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hervey Bay residential, tourism and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Tourism and hospitality construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Pialba", "Scarness", "Torquay", "Urangan", "Dundowran Beach", "Eli Waters", "Kawungan", "Point Vernon", "Toogoom", "Howard"],
  },
  {
    slug: "longreach",
    suburb: "Longreach",
    state: "QLD",
    postcode: "4730",
    council: "Longreach Regional Council",
    keyRoads: ["Eagle Street", "Duck Street", "Landsborough Highway", "Ilfracombe Road"],
    intro:
      "Longreach is the outback Queensland tourism capital, home to the Australian Stockman's Hall of Fame and Qantas Founders Museum, where tourism infrastructure, residential construction and remote area utility works require traffic management plans compliant with Longreach Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Longreach Regional Council-compliant TMPs for tourism, residential and infrastructure projects in outback Queensland.",
    industries: [
      "Tourism and attraction infrastructure",
      "Residential construction",
      "Remote area utility works",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ilfracombe", "Barcaldine", "Blackall", "Alpha", "Barcoo", "Isisford", "Muttaburra", "Stonehenge", "Tambo", "Morella"],
  },
  {
    slug: "mackay",
    suburb: "Mackay",
    state: "QLD",
    postcode: "4740",
    council: "Mackay Regional Council",
    keyRoads: ["Victoria Street", "Sydney Street", "Gordon Street", "Nebo Road"],
    intro:
      "Mackay is Queensland's sugar capital and a major service centre for the Bowen Basin coal mining industry, where mining support infrastructure, sugar industry construction and residential development create demand for traffic management plans compliant with Mackay Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans produces Mackay Regional Council-compliant TMPs for mining, agricultural and residential projects in the Mackay region.",
    industries: [
      "Mining and resources infrastructure",
      "Sugar and agricultural construction",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["North Mackay", "West Mackay", "South Mackay", "Ooralea", "Paget", "Glenella", "Beaconsfield", "Mount Pleasant", "Andergrove", "Blacks Beach"],
  },
  {
    slug: "mount-isa",
    suburb: "Mount Isa",
    state: "QLD",
    postcode: "4825",
    council: "Mount Isa City Council",
    keyRoads: ["Marian Street", "Miles Street", "Camooweal Street", "Barkly Highway"],
    intro:
      "Mount Isa is one of the world's largest single-mine cities and Queensland's outback mining capital, where major mining infrastructure, industrial construction and remote area utility works require traffic management plans compliant with Mount Isa City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mount Isa mining, industrial and residential projects in remote north-west Queensland.",
    industries: [
      "Mining and heavy industrial construction",
      "Remote area utility works",
      "Residential development",
      "Commercial construction",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Healy", "Sunset", "Pioneer", "Soldiers Hill", "Happy Valley", "Townview", "The Gap", "Breakaway", "Ryan", "Camooweal"],
  },
  {
    slug: "rockhampton",
    suburb: "Rockhampton",
    state: "QLD",
    postcode: "4700",
    council: "Rockhampton Regional Council",
    keyRoads: ["East Street", "Quay Street", "Fitzroy Street", "Rockhampton-Yeppoon Road"],
    intro:
      "Rockhampton is the beef capital of Australia and the major city of Central Queensland, where cattle industry infrastructure, residential development, commercial construction and the nearby Rockhampton Airport precinct create demand for traffic management plans compliant with Rockhampton Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Rockhampton Regional Council-compliant TMPs for residential, commercial and agricultural projects in Central Queensland.",
    industries: [
      "Agricultural and beef industry infrastructure",
      "Residential development",
      "Commercial and retail construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Gracemere", "North Rockhampton", "Berserker", "Park Avenue", "Frenchville", "Mount Morgan", "Yeppoon", "Emu Park", "Capricorn Coast", "Stanwell"],
  },

  // ─── QUEENSLAND (further additions) ───────────────────────────────────────

  // Greater Brisbane (inner additional)
  {
    slug: "auchenflower",
    suburb: "Auchenflower",
    state: "QLD",
    postcode: "4066",
    council: "Brisbane City Council",
    keyRoads: ["Milton Road", "Coronation Drive", "Baroona Road", "Fernberg Road"],
    intro:
      "Auchenflower is an inner Brisbane suburb on the Coronation Drive corridor, where residential construction and commercial development require traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Auchenflower residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Toowong", "Milton", "Paddington", "Taringa", "St Lucia", "Bardon", "Rosalie", "West End", "Chelmer", "Indooroopilly"],
  },
  {
    slug: "bowen-hills",
    suburb: "Bowen Hills",
    state: "QLD",
    postcode: "4006",
    council: "Brisbane City Council",
    keyRoads: ["Breakfast Creek Road", "Gregory Terrace", "Abbotsford Road", "Warner Street"],
    intro:
      "Bowen Hills is an inner Brisbane suburb undergoing significant urban renewal, where residential and commercial development adjacent to the RNA Showgrounds precinct require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bowen Hills residential and commercial projects.",
    industries: ["Residential and mixed-use development", "Commercial construction", "Events infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Newstead", "Fortitude Valley", "Herston", "Windsor", "Albion", "Hamilton", "Kelvin Grove", "Spring Hill", "Brisbane CBD", "Lutwyche"],
  },
  {
    slug: "east-brisbane",
    suburb: "East Brisbane",
    state: "QLD",
    postcode: "4169",
    council: "Brisbane City Council",
    keyRoads: ["Lytton Road", "Wellington Road", "Vulture Street", "Clarence Road"],
    intro:
      "East Brisbane is an inner southern Brisbane suburb adjacent to the Gabba, where residential construction and commercial development require traffic management plans compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for East Brisbane residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Woolloongabba", "Kangaroo Point", "South Brisbane", "Coorparoo", "Stones Corner", "Annerley", "Camp Hill", "Hawthorne", "Norman Park", "Balmoral"],
  },
  {
    slug: "highgate-hill",
    suburb: "Highgate Hill",
    state: "QLD",
    postcode: "4101",
    council: "Brisbane City Council",
    keyRoads: ["Dornoch Terrace", "Boundary Street", "Hampstead Road", "Gladstone Road"],
    intro:
      "Highgate Hill is a hilly inner-southern Brisbane suburb with sweeping river views, where residential construction and heritage building refurbishment require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Highgate Hill residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["West End", "South Brisbane", "Dutton Park", "Woolloongabba", "Annerley", "Fairfield", "Yeronga", "Moorooka", "Paddington", "Milton"],
  },
  {
    slug: "paddington-qld",
    suburb: "Paddington",
    state: "QLD",
    postcode: "4064",
    council: "Brisbane City Council",
    keyRoads: ["Given Terrace", "Latrobe Terrace", "Caxton Street", "Rosalie Street"],
    intro:
      "Paddington is one of Brisbane's most vibrant inner suburbs, known for its boutique shopping strips on Given Terrace and Caxton Street, where residential construction and retail fitouts require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Paddington residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Red Hill", "Bardon", "Milton", "Petrie Terrace", "Rosalie", "Kelvin Grove", "Auchenflower", "Toowong", "Spring Hill", "Brisbane CBD"],
  },
  {
    slug: "petrie-terrace",
    suburb: "Petrie Terrace",
    state: "QLD",
    postcode: "4000",
    council: "Brisbane City Council",
    keyRoads: ["Caxton Street", "Petrie Terrace", "Hale Street", "King Street"],
    intro:
      "Petrie Terrace is a compact inner suburb adjacent to Brisbane CBD, where residential construction and commercial fitouts require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Petrie Terrace residential and commercial projects.",
    industries: ["Residential construction", "Commercial and hospitality fitouts", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Spring Hill", "Brisbane CBD", "Paddington", "Milton", "Red Hill", "Kelvin Grove", "Bardon", "West End", "Auchenflower", "Rosalie"],
  },
  {
    slug: "red-hill-qld",
    suburb: "Red Hill",
    state: "QLD",
    postcode: "4059",
    council: "Brisbane City Council",
    keyRoads: ["Waterworks Road", "Musgrave Road", "Enoggera Road", "Musgrave Street"],
    intro:
      "Red Hill is a hilly inner Brisbane suburb with character homes and a lively café strip, where residential construction and boutique commercial development require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Red Hill residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Paddington", "Kelvin Grove", "Bardon", "Ashgrove", "Herston", "Windsor", "Spring Hill", "Petrie Terrace", "Newmarket", "Ithaca"],
  },
  {
    slug: "toowong",
    suburb: "Toowong",
    state: "QLD",
    postcode: "4066",
    council: "Brisbane City Council",
    keyRoads: ["Moggill Road", "Sherwood Road", "High Street", "Coronation Drive"],
    intro:
      "Toowong is a major western Brisbane activity centre and University of Queensland gateway suburb, where high-density residential development, retail construction and the Toowong Village precinct create demand for traffic management documentation compliant with Brisbane City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Toowong residential, retail and university precinct projects.",
    industries: ["High-density residential development", "Retail and commercial construction", "University support works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Auchenflower", "Milton", "St Lucia", "Taringa", "Indooroopilly", "Paddington", "Bardon", "Rosalie", "Chapel Hill", "Chelmer"],
  },
  // Southern Brisbane (additional)
  {
    slug: "annerley",
    suburb: "Annerley",
    state: "QLD",
    postcode: "4103",
    council: "Brisbane City Council",
    keyRoads: ["Ipswich Road", "Annerley Road", "Cornwall Street", "Paxton Street"],
    intro:
      "Annerley is an inner southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Annerley residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Woolloongabba", "Fairfield", "Yeronga", "Moorooka", "Greenslopes", "Stones Corner", "Holland Park", "East Brisbane", "Salisbury", "Yeerongpilly"],
  },
  {
    slug: "dutton-park",
    suburb: "Dutton Park",
    state: "QLD",
    postcode: "4102",
    council: "Brisbane City Council",
    keyRoads: ["Annerley Road", "Hampstead Road", "Gladstone Road", "Cornwall Street"],
    intro:
      "Dutton Park is an inner southern Brisbane suburb adjacent to the Princess Alexandra Hospital precinct, where health-related construction and residential development require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dutton Park health and residential projects.",
    industries: ["Health and hospital infrastructure", "Residential construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Woolloongabba", "South Brisbane", "Highgate Hill", "West End", "Annerley", "Fairfield", "Yeronga", "Stones Corner", "Greenslopes", "Moorooka"],
  },
  {
    slug: "fairfield-qld",
    suburb: "Fairfield",
    state: "QLD",
    postcode: "4103",
    council: "Brisbane City Council",
    keyRoads: ["Ipswich Road", "Fairfield Road", "Brisbane Terrace", "Augustus Street"],
    intro:
      "Fairfield is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Fairfield residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Annerley", "Yeronga", "Moorooka", "Yeerongpilly", "Salisbury", "Woolloongabba", "Dutton Park", "Greenslopes", "Rocklea", "Acacia Ridge"],
  },
  {
    slug: "greenslopes",
    suburb: "Greenslopes",
    state: "QLD",
    postcode: "4120",
    council: "Brisbane City Council",
    keyRoads: ["Logan Road", "Chatsworth Road", "Ipswich Road", "Annerley Road"],
    intro:
      "Greenslopes is a southern Brisbane suburb home to Greenslopes Private Hospital, where health infrastructure and residential construction require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Greenslopes health and residential projects.",
    industries: ["Health and hospital infrastructure", "Residential construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Holland Park", "Annerley", "Stones Corner", "Coorparoo", "Woolloongabba", "Camp Hill", "Moorooka", "Fairfield", "Kangaroo Point", "East Brisbane"],
  },
  {
    slug: "holland-park",
    suburb: "Holland Park",
    state: "QLD",
    postcode: "4121",
    council: "Brisbane City Council",
    keyRoads: ["Logan Road", "Cavendish Road", "Nursery Road", "Granard Road"],
    intro:
      "Holland Park is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Holland Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Greenslopes", "Stones Corner", "Mount Gravatt", "Coorparoo", "Camp Hill", "Wishart", "Mansfield", "Annerley", "Moorooka", "Tarragindi"],
  },
  {
    slug: "moorooka",
    suburb: "Moorooka",
    state: "QLD",
    postcode: "4105",
    council: "Brisbane City Council",
    keyRoads: ["Ipswich Road", "Beaudesert Road", "Moorooka Street", "Granard Road"],
    intro:
      "Moorooka is a southern Brisbane suburb and major automotive retail corridor, where commercial construction and residential development require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Moorooka commercial and residential projects.",
    industries: ["Commercial and automotive retail construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Annerley", "Yeerongpilly", "Fairfield", "Salisbury", "Yeronga", "Rocklea", "Acacia Ridge", "Woolloongabba", "Dutton Park", "Nathan"],
  },
  {
    slug: "salisbury-qld",
    suburb: "Salisbury",
    state: "QLD",
    postcode: "4107",
    council: "Brisbane City Council",
    keyRoads: ["Beaudesert Road", "Mains Road", "Sherwood Road", "Moorooka Street"],
    intro:
      "Salisbury is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Salisbury residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Moorooka", "Coopers Plains", "Yeerongpilly", "Fairfield", "Annerley", "Rocklea", "Acacia Ridge", "Nathan", "Sunnybank", "Macgregor"],
  },
  {
    slug: "stones-corner",
    suburb: "Stones Corner",
    state: "QLD",
    postcode: "4120",
    council: "Brisbane City Council",
    keyRoads: ["Logan Road", "Old Cleveland Road", "Cavendish Road", "Ipswich Road"],
    intro:
      "Stones Corner is an inner southern Brisbane suburb known for its antiques and design precinct on Logan Road, where residential construction and boutique commercial fitouts require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Stones Corner residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and commercial fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Greenslopes", "Holland Park", "Woolloongabba", "Coorparoo", "East Brisbane", "Annerley", "Camp Hill", "Kangaroo Point", "Moorooka", "Fairfield"],
  },
  {
    slug: "yeronga",
    suburb: "Yeronga",
    state: "QLD",
    postcode: "4104",
    council: "Brisbane City Council",
    keyRoads: ["Fairfield Road", "Kadumba Street", "Hyde Road", "Yeronga Street"],
    intro:
      "Yeronga is a riverside southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Yeronga residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Annerley", "Fairfield", "Moorooka", "Yeerongpilly", "Tennyson", "Corinda", "Graceville", "Chelmer", "Sherwood", "Indooroopilly"],
  },
  {
    slug: "yeerongpilly",
    suburb: "Yeerongpilly",
    state: "QLD",
    postcode: "4105",
    council: "Brisbane City Council",
    keyRoads: ["Ipswich Road", "Yeerongpilly Road", "Moorooka Street", "Fairfield Road"],
    intro:
      "Yeerongpilly is a southern Brisbane suburb where residential construction and utility works require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Yeerongpilly residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Moorooka", "Annerley", "Fairfield", "Yeronga", "Salisbury", "Tennyson", "Rocklea", "Acacia Ridge", "Nathan", "Coopers Plains"],
  },
  // Logan
  {
    slug: "beenleigh",
    suburb: "Beenleigh",
    state: "QLD",
    postcode: "4207",
    council: "Logan City Council",
    keyRoads: ["Pacific Highway", "George Street", "James Street", "Beenleigh-Redland Bay Road"],
    intro:
      "Beenleigh is Logan City's major commercial centre and the southern end of the Brisbane rail network, where residential development, retail construction and cross-river infrastructure works create demand for traffic management plans compliant with Logan City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Beenleigh commercial and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Eagleby", "Bethania", "Waterford", "Kingston", "Logan Central", "Woodridge", "Slacks Creek", "Loganlea", "Edens Landing", "Windaroo"],
  },
  {
    slug: "browns-plains",
    suburb: "Browns Plains",
    state: "QLD",
    postcode: "4118",
    council: "Logan City Council",
    keyRoads: ["Browns Plains Road", "Grand Plaza Drive", "Randall Road", "Boundary Road"],
    intro:
      "Browns Plains is a major southern corridor retail and residential hub anchored by Grand Plaza Shopping Centre, where retail construction and residential development create demand for traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Browns Plains retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Hillcrest", "Boronia Heights", "Park Ridge", "Heritage Park", "Forestdale", "Regents Park", "Marsden", "Drewvale", "Logan Reserve", "Waterford West"],
  },
  {
    slug: "kingston-qld",
    suburb: "Kingston",
    state: "QLD",
    postcode: "4114",
    council: "Logan City Council",
    keyRoads: ["Kingston Road", "Loganlea Road", "Wembley Road", "Freeway"],
    intro:
      "Kingston is a residential suburb in Logan City where residential construction and utility works require traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Kingston residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Logan Central", "Woodridge", "Slacks Creek", "Beenleigh", "Loganlea", "Waterford", "Bethania", "Springwood", "Underwood", "Rochedale South"],
  },
  {
    slug: "logan-central",
    suburb: "Logan Central",
    state: "QLD",
    postcode: "4114",
    council: "Logan City Council",
    keyRoads: ["Wembley Road", "Kingston Road", "Loganlea Road", "Logan Central Road"],
    intro:
      "Logan Central is the administrative heart of Logan City, where residential development, retail construction and infrastructure upgrades require traffic management plans compliant with Logan City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Logan Central residential and commercial projects.",
    industries: ["Residential development", "Retail and commercial construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Kingston", "Woodridge", "Slacks Creek", "Beenleigh", "Loganlea", "Marsden", "Waterford", "Underwood", "Springwood", "Meadowbrook"],
  },
  {
    slug: "loganholme",
    suburb: "Loganholme",
    state: "QLD",
    postcode: "4129",
    council: "Logan City Council",
    keyRoads: ["Pacific Motorway", "Loganholme Road", "Bryants Road", "Miles Platting Road"],
    intro:
      "Loganholme is a commercial and residential suburb on the Pacific Motorway corridor in Logan City, where retail construction and residential development require traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Loganholme commercial and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Slacks Creek", "Springwood", "Underwood", "Daisy Hill", "Kingston", "Tanah Merah", "Shailer Park", "Rochedale South", "Cornubia", "Carbrook"],
  },
  {
    slug: "marsden",
    suburb: "Marsden",
    state: "QLD",
    postcode: "4132",
    council: "Logan City Council",
    keyRoads: ["Chambers Flat Road", "Browns Plains Road", "Rosia Road", "Wahroonga Road"],
    intro:
      "Marsden is a residential suburb in Logan City where residential construction and utility works require traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Marsden residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Browns Plains", "Boronia Heights", "Park Ridge", "Regents Park", "Heritage Park", "Hillcrest", "Waterford West", "Logan Reserve", "Greenbank", "Forestdale"],
  },
  {
    slug: "meadowbrook",
    suburb: "Meadowbrook",
    state: "QLD",
    postcode: "4131",
    council: "Logan City Council",
    keyRoads: ["Loganlea Road", "Meadowbrook Drive", "Loganlea Drive", "Compton Road"],
    intro:
      "Meadowbrook is a health and education precinct in Logan City, home to Logan Hospital and Griffith University's Logan campus, where health infrastructure and residential development create demand for traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Meadowbrook health, university and residential projects.",
    industries: ["Health and hospital infrastructure", "University and education construction", "Residential development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Loganlea", "Logan Central", "Kingston", "Woodridge", "Slacks Creek", "Underwood", "Springwood", "Crestmead", "Marsden", "Waterford"],
  },
  {
    slug: "springwood-qld",
    suburb: "Springwood",
    state: "QLD",
    postcode: "4127",
    council: "Logan City Council",
    keyRoads: ["Pacific Motorway", "Springwood Road", "Bryants Road", "Logan Road"],
    intro:
      "Springwood is a major commercial and industrial hub in Logan City, where retail construction, warehouse development and residential projects create demand for traffic management plans compliant with Logan City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Springwood commercial, industrial and residential projects.",
    industries: ["Retail and commercial construction", "Light industrial and warehouse development", "Residential development", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Slacks Creek", "Underwood", "Loganholme", "Eight Mile Plains", "Kingston", "Rochedale South", "Shailer Park", "Daisy Hill", "Tanah Merah", "Cornubia"],
  },
  {
    slug: "underwood",
    suburb: "Underwood",
    state: "QLD",
    postcode: "4119",
    council: "Logan City Council",
    keyRoads: ["Underwood Road", "Moss Street", "Kurrajong Road", "Acanthus Street"],
    intro:
      "Underwood is a major light industrial and commercial suburb in south-east Brisbane, where warehouse construction, commercial development and residential projects require traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Logan City Council-compliant TMPs for Underwood industrial and commercial projects.",
    industries: ["Light industrial and warehouse development", "Commercial construction", "Residential development", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Springwood", "Slacks Creek", "Eight Mile Plains", "Loganholme", "Rochedale South", "Kingston", "Shailer Park", "Daisy Hill", "Cornubia", "Macgregor"],
  },
  {
    slug: "woodridge",
    suburb: "Woodridge",
    state: "QLD",
    postcode: "4114",
    council: "Logan City Council",
    keyRoads: ["Kingston Road", "Wembley Road", "Woodridge Road", "Station Road"],
    intro:
      "Woodridge is a residential suburb in Logan City where residential construction and utility works require traffic management plans compliant with Logan City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Woodridge residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Kingston", "Logan Central", "Slacks Creek", "Underwood", "Springwood", "Loganlea", "Meadowbrook", "Marsden", "Beenleigh", "Rochedale South"],
  },
  // Ipswich
  {
    slug: "booval",
    suburb: "Booval",
    state: "QLD",
    postcode: "4304",
    council: "Ipswich City Council",
    keyRoads: ["Brisbane Road", "South Station Road", "Limestone Street", "Blackall Street"],
    intro:
      "Booval is a residential suburb of Ipswich where residential construction and utility works require traffic management plans compliant with Ipswich City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ipswich City Council-compliant TMPs for Booval residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Ipswich CBD", "Bundamba", "North Ipswich", "One Mile", "Basin Pocket", "Silkstone", "Brassall", "Eastern Heights", "Newtown", "Leichhardt"],
  },
  {
    slug: "bundamba",
    suburb: "Bundamba",
    state: "QLD",
    postcode: "4304",
    council: "Ipswich City Council",
    keyRoads: ["Bundamba Road", "Brisbane Road", "Middle Street", "Jacaranda Avenue"],
    intro:
      "Bundamba is a residential and light industrial suburb of Ipswich where construction activity and utility works require traffic management plans compliant with Ipswich City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bundamba residential and light industrial projects.",
    industries: ["Residential construction", "Light industrial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Booval", "Ipswich CBD", "North Ipswich", "Silkstone", "Brassall", "Dinmore", "Riverview", "Redbank", "Goodna", "Collingwood Park"],
  },
  {
    slug: "goodna",
    suburb: "Goodna",
    state: "QLD",
    postcode: "4300",
    council: "Ipswich City Council",
    keyRoads: ["Ipswich Motorway", "Smiths Road", "Queen Street", "New Chum Road"],
    intro:
      "Goodna is a residential suburb at the eastern gateway of Ipswich, where residential construction and utility works require traffic management plans compliant with Ipswich City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ipswich City Council-compliant TMPs for Goodna residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Redbank", "Collingwood Park", "Springfield", "Redbank Plains", "Camira", "Carole Park", "Riverview", "Bundamba", "Dinmore", "Gailes"],
  },
  {
    slug: "ipswich-cbd",
    suburb: "Ipswich CBD",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Brisbane Street", "Nicholas Street", "Bell Street", "East Street"],
    intro:
      "Ipswich CBD is one of Queensland's oldest cities and is undergoing major urban renewal with the Ipswich City Heart project, where commercial construction, infrastructure upgrades and residential development require traffic management documentation compliant with Ipswich City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ipswich CBD urban renewal, commercial and infrastructure projects.",
    industries: ["Commercial and retail construction", "Urban renewal and mixed-use development", "Infrastructure upgrades", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["North Ipswich", "Booval", "One Mile", "Leichhardt", "Silkstone", "Brassall", "Eastern Heights", "Newtown", "Woodend", "Basin Pocket"],
  },
  {
    slug: "leichhardt-qld",
    suburb: "Leichhardt",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Warwick Road", "Limestone Street", "Chermside Road", "Taylor Street"],
    intro:
      "Leichhardt is a residential suburb of Ipswich where residential construction and utility works require traffic management plans compliant with Ipswich City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ipswich City Council-compliant TMPs for Leichhardt residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Ipswich CBD", "One Mile", "North Ipswich", "Booval", "Eastern Heights", "Newtown", "Woodend", "Silkstone", "Yamanto", "Raceview"],
  },
  {
    slug: "north-ipswich",
    suburb: "North Ipswich",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Limestone Street", "Brisbane Road", "Roderick Street", "Pine Mountain Road"],
    intro:
      "North Ipswich is a residential and heritage suburb across the Bremer River from Ipswich CBD, where residential construction and heritage building works require traffic management plans compliant with Ipswich City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for North Ipswich residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Ipswich CBD", "Booval", "One Mile", "Leichhardt", "Basin Pocket", "Silkstone", "Brassall", "Eastern Heights", "Newtown", "Woodend"],
  },
  {
    slug: "one-mile",
    suburb: "One Mile",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Brisbane Road", "Ipswich Road", "McLean Street", "Chelmsford Avenue"],
    intro:
      "One Mile is a residential suburb of Ipswich where residential construction and utility works require traffic management plans compliant with Ipswich City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ipswich City Council-compliant TMPs for One Mile residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Ipswich CBD", "North Ipswich", "Booval", "Leichhardt", "Eastern Heights", "Newtown", "Woodend", "Silkstone", "Brassall", "Basin Pocket"],
  },
  {
    slug: "redbank-plains",
    suburb: "Redbank Plains",
    state: "QLD",
    postcode: "4301",
    council: "Ipswich City Council",
    keyRoads: ["Redbank Plains Road", "Kruger Parade", "Ipswich Motorway", "Mount Juillerat Drive"],
    intro:
      "Redbank Plains is one of Ipswich's fastest-growing residential suburbs, where large residential estate construction and associated civil infrastructure create demand for traffic management documentation compliant with Ipswich City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Redbank Plains residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Collingwood Park", "Goodna", "Springfield", "Camira", "Gailes", "Riverview", "Bundamba", "Redbank", "Augustine Heights", "South Ripley"],
  },
  {
    slug: "springfield",
    suburb: "Springfield",
    state: "QLD",
    postcode: "4300",
    council: "Ipswich City Council",
    keyRoads: ["Springfield Parkway", "Centenary Highway", "Commercial Drive", "Sinnathamby Boulevard"],
    intro:
      "Springfield is Australia's largest master-planned city, a fast-growing western corridor hub with the University of Southern Queensland and Orion Springfield Central, where residential estate construction, university development and retail projects create strong demand for traffic management documentation compliant with Ipswich City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Ipswich City Council-compliant TMPs for Springfield residential, university and commercial projects.",
    industries: ["Residential subdivision and housing", "University and education construction", "Retail and commercial development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Springfield Lakes", "Augustine Heights", "Redbank Plains", "Camira", "Goodna", "Collingwood Park", "South Ripley", "Gailes", "Bellbird Park", "Brookwater"],
  },
  {
    slug: "yamanto",
    suburb: "Yamanto",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Warwick Road", "Ripley Road", "Spencers Road", "Boundary Road"],
    intro:
      "Yamanto is a residential suburb of Ipswich at the southern fringe of the urban area, where residential construction and utility works require traffic management plans compliant with Ipswich City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Yamanto residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Rural lifestyle development", "Council infrastructure works"],
    nearbySuburbs: ["Leichhardt", "Ripley", "South Ripley", "Raceview", "Silkstone", "Deebing Heights", "Ipswich CBD", "Camira", "Collingwood Park", "Ebenezer"],
  },
  // Eastern Brisbane & Bayside
  {
    slug: "alexandra-hills",
    suburb: "Alexandra Hills",
    state: "QLD",
    postcode: "4161",
    council: "Redland City Council",
    keyRoads: ["Finucane Road", "Vienna Road", "German Church Road", "Old Cleveland Road"],
    intro:
      "Alexandra Hills is a large residential suburb in Redland City where residential construction and utility works require traffic management plans compliant with Redland City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Redland City Council-compliant TMPs for Alexandra Hills residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Capalaba", "Thornlands", "Wellington Point", "Victoria Point", "Ormiston", "Cleveland", "Redland Bay", "Sheldon", "Chandler", "Belmont"],
  },
  {
    slug: "balmoral-qld",
    suburb: "Balmoral",
    state: "QLD",
    postcode: "4171",
    council: "Brisbane City Council",
    keyRoads: ["Wynnum Road", "Riding Road", "Lytton Road", "Green Parade"],
    intro:
      "Balmoral is a prestigious riverside Brisbane suburb on Moreton Bay, where luxury residential construction and boutique commercial development require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Balmoral residential and commercial projects.",
    industries: ["Luxury residential construction", "Boutique commercial development", "Foreshore works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Bulimba", "Hawthorne", "Wynnum", "Norman Park", "East Brisbane", "Coorparoo", "Tingalpa", "Murarrie", "Morningside", "Camp Hill"],
  },
  {
    slug: "capalaba",
    suburb: "Capalaba",
    state: "QLD",
    postcode: "4157",
    council: "Redland City Council",
    keyRoads: ["Old Cleveland Road", "Mount Cotton Road", "Moreton Bay Road", "Redland Bay Road"],
    intro:
      "Capalaba is the major commercial centre of Redland City, anchored by Capalaba Park Shopping Centre, where retail construction and residential development create demand for traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Redland City Council-compliant TMPs for Capalaba retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Alexandra Hills", "Thornlands", "Wellington Point", "Victoria Point", "Cleveland", "Redland Bay", "Chandler", "Ormiston", "Mount Cotton", "Sheldon"],
  },
  {
    slug: "cleveland",
    suburb: "Cleveland",
    state: "QLD",
    postcode: "4163",
    council: "Redland City Council",
    keyRoads: ["Shore Street", "Middle Street", "Bloomfield Street", "Passage Street"],
    intro:
      "Cleveland is the administrative centre of Redland City on Moreton Bay, where residential construction, waterfront development and tourism infrastructure require traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Cleveland residential and waterfront projects.",
    industries: ["Residential construction", "Waterfront and marina development", "Tourism infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Ormiston", "Thornlands", "Wellington Point", "Alexandra Hills", "Victoria Point", "Redland Bay", "Capalaba", "Mount Cotton", "Raby Bay", "Birkdale"],
  },
  {
    slug: "manly-qld",
    suburb: "Manly",
    state: "QLD",
    postcode: "4179",
    council: "Brisbane City Council",
    keyRoads: ["Cambridge Parade", "Manly Road", "Bay Terrace", "Wynnum Road"],
    intro:
      "Manly is a sought-after bayside Brisbane suburb with a picturesque harbour, where residential construction and marina development require traffic management plans compliant with Brisbane City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Brisbane City Council-compliant TMPs for Manly residential and marina projects.",
    industries: ["Residential construction", "Marina and waterfront development", "Boutique retail and hospitality fitouts", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Wynnum", "Lota", "Balmoral", "Tingalpa", "Murarrie", "Morningside", "Hawthorne", "Bulimba", "Wakerley", "Cannon Hill"],
  },
  {
    slug: "mount-cotton",
    suburb: "Mount Cotton",
    state: "QLD",
    postcode: "4165",
    council: "Redland City Council",
    keyRoads: ["Mount Cotton Road", "Redland Bay Road", "Quarry Road", "Valley Road"],
    intro:
      "Mount Cotton is a semi-rural suburb in Redland City where residential and rural lifestyle construction require traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mount Cotton residential and rural lifestyle projects.",
    industries: ["Residential construction", "Rural lifestyle development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Capalaba", "Alexandra Hills", "Redland Bay", "Victoria Point", "Sheldon", "Cornubia", "Carbrook", "Loganholme", "Shailer Park", "Tanah Merah"],
  },
  {
    slug: "redland-bay",
    suburb: "Redland Bay",
    state: "QLD",
    postcode: "4165",
    council: "Redland City Council",
    keyRoads: ["Redland Bay Road", "Shore Street", "Boundary Road", "Banana Street"],
    intro:
      "Redland Bay is a coastal suburb in Redland City and gateway to the Southern Moreton Bay Islands, where residential construction and coastal infrastructure works require traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Redland City Council-compliant TMPs for Redland Bay residential and coastal projects.",
    industries: ["Coastal residential construction", "Foreshore and coastal works", "Marina and marine infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Victoria Point", "Mount Cotton", "Capalaba", "Alexandra Hills", "Thornlands", "Cleveland", "Sheldon", "Cornubia", "Carbrook", "Woongoolba"],
  },
  {
    slug: "thornlands",
    suburb: "Thornlands",
    state: "QLD",
    postcode: "4164",
    council: "Redland City Council",
    keyRoads: ["Thornlands Road", "Taylor Road", "Boundary Road", "German Church Road"],
    intro:
      "Thornlands is a growing residential suburb in Redland City where residential estate construction and civil infrastructure require traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Thornlands residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Wellington Point", "Alexandra Hills", "Victoria Point", "Capalaba", "Cleveland", "Redland Bay", "Ormiston", "Mount Cotton", "Sheldon", "Birkdale"],
  },
  {
    slug: "victoria-point",
    suburb: "Victoria Point",
    state: "QLD",
    postcode: "4165",
    council: "Redland City Council",
    keyRoads: ["Colburn Avenue", "Redland Bay Road", "Lakeside Drive", "Victoria Point Road"],
    intro:
      "Victoria Point is a major bayside suburb in Redland City where residential construction and retail development around Victoria Point Lakeside create demand for traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Redland City Council-compliant TMPs for Victoria Point residential and retail projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Redland Bay", "Thornlands", "Mount Cotton", "Capalaba", "Alexandra Hills", "Cleveland", "Sheldon", "Cornubia", "Carbrook", "Woongoolba"],
  },
  {
    slug: "wellington-point",
    suburb: "Wellington Point",
    state: "QLD",
    postcode: "4160",
    council: "Redland City Council",
    keyRoads: ["Main Road", "Taylor Road", "Eagle Street", "Ormiston Road"],
    intro:
      "Wellington Point is a picturesque bayside suburb in Redland City where residential construction and coastal foreshore works require traffic management plans compliant with Redland City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wellington Point residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Thornlands", "Ormiston", "Cleveland", "Alexandra Hills", "Victoria Point", "Capalaba", "Birkdale", "Redland Bay", "Mount Cotton", "Sheldon"],
  },
  // Gold Coast (additional)
  {
    slug: "bundall",
    suburb: "Bundall",
    state: "QLD",
    postcode: "4217",
    council: "Gold Coast City Council",
    keyRoads: ["Bundall Road", "Ashmore Road", "Sorrento Road", "Bermuda Street"],
    intro:
      "Bundall is the Gold Coast's major business and corporate precinct, home to significant commercial office development and the Gold Coast Arts Centre, where commercial construction and utility works require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Bundall commercial and infrastructure projects.",
    industries: ["Commercial and office construction", "Arts and cultural infrastructure", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Surfers Paradise", "Southport", "Ashmore", "Benowa", "Carrara", "Nerang", "Molendinar", "Labrador", "Biggera Waters", "Broadbeach"],
  },
  {
    slug: "carrara",
    suburb: "Carrara",
    state: "QLD",
    postcode: "4211",
    council: "Gold Coast City Council",
    keyRoads: ["Nerang-Broadbeach Road", "Gooding Drive", "Beaudesert Road", "Carrara Road"],
    intro:
      "Carrara is a central Gold Coast suburb home to the Carrara Markets and Metricon Stadium, where residential construction, sporting venue works and commercial development require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Carrara residential, sporting and commercial projects.",
    industries: ["Residential construction", "Sports and events infrastructure", "Commercial development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Nerang", "Robina", "Merrimac", "Worongary", "Mudgeeraba", "Southport", "Ashmore", "Bundall", "Molendinar", "Benowa"],
  },
  {
    slug: "helensvale",
    suburb: "Helensvale",
    state: "QLD",
    postcode: "4212",
    council: "Gold Coast City Council",
    keyRoads: ["Helensvale Road", "Discovery Drive", "Siganto Drive", "Santa Barbara Road"],
    intro:
      "Helensvale is a major northern Gold Coast suburb with the G:link light rail, where residential development, the Westfield Helensvale retail centre and light rail corridor works create demand for traffic management documentation compliant with Gold Coast City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Helensvale residential, retail and light rail projects.",
    industries: ["Residential development", "Retail and commercial construction", "Light rail infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Hope Island", "Coomera", "Oxenford", "Arundel", "Parkwood", "Biggera Waters", "Southport", "Runaway Bay", "Coombabah", "Molendinar"],
  },
  {
    slug: "mermaid-beach",
    suburb: "Mermaid Beach",
    state: "QLD",
    postcode: "4218",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Hedges Avenue", "Frederick Street", "Mermaid Avenue"],
    intro:
      "Mermaid Beach is one of the Gold Coast's most exclusive beachside suburbs, where luxury residential construction and boutique hospitality development require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mermaid Beach luxury residential and hospitality projects.",
    industries: ["Luxury residential construction", "Boutique hospitality development", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Broadbeach", "Nobby Beach", "Burleigh Heads", "Miami", "Mermaid Waters", "Currumbin", "Surfers Paradise", "Bundall", "Benowa", "Carrara"],
  },
  {
    slug: "oxenford",
    suburb: "Oxenford",
    state: "QLD",
    postcode: "4210",
    council: "Gold Coast City Council",
    keyRoads: ["Motorway", "Days Road", "Oxenford Drive", "Old Pacific Highway"],
    intro:
      "Oxenford is a northern Gold Coast suburb home to Movie World and Sea World, where tourism attraction infrastructure, residential development and commercial construction require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Oxenford tourism, residential and commercial projects.",
    industries: ["Tourism and attraction infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Helensvale", "Coomera", "Hope Island", "Arundel", "Parkwood", "Molendinar", "Upper Coomera", "Maudsland", "Wongawallan", "Gaven"],
  },
  {
    slug: "palm-beach-qld",
    suburb: "Palm Beach",
    state: "QLD",
    postcode: "4221",
    council: "Gold Coast City Council",
    keyRoads: ["Gold Coast Highway", "Jefferson Lane", "Nineteenth Avenue", "Palm Beach Road"],
    intro:
      "Palm Beach is a popular southern Gold Coast beachside suburb where coastal residential construction and hospitality development require traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Palm Beach coastal residential and hospitality projects.",
    industries: ["Coastal residential construction", "Hospitality and retail development", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Tugun", "Currumbin", "Elanora", "Burleigh Heads", "Varsity Lakes", "Robina", "Coolangatta", "Bilinga", "Kirra", "Mermaid Beach"],
  },
  {
    slug: "varsity-lakes",
    suburb: "Varsity Lakes",
    state: "QLD",
    postcode: "4227",
    council: "Gold Coast City Council",
    keyRoads: ["Christine Avenue", "Varsity Parade", "Reedy Creek Road", "Guineas Creek Road"],
    intro:
      "Varsity Lakes is a master-planned residential and educational suburb on the southern Gold Coast, home to Bond University, where university development, residential construction and retail projects create demand for traffic management plans compliant with Gold Coast City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Gold Coast City Council-compliant TMPs for Varsity Lakes university, residential and retail projects.",
    industries: ["University and education construction", "Residential development", "Retail and commercial construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Burleigh Heads", "Robina", "Palm Beach", "Reedy Creek", "Elanora", "Mudgeeraba", "Tallebudgera", "Merrimac", "Worongary", "Burleigh Waters"],
  },
  // Sunshine Coast (additional)
  {
    slug: "alexandra-headland",
    suburb: "Alexandra Headland",
    state: "QLD",
    postcode: "4572",
    council: "Sunshine Coast Council",
    keyRoads: ["David Low Way", "Alexandra Parade", "Sunshine Boulevard", "Mooloolaba Esplanade"],
    intro:
      "Alexandra Headland is a beachside suburb between Maroochydore and Mooloolaba, where coastal residential construction and tourism infrastructure works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Alexandra Headland coastal residential and tourism projects.",
    industries: ["Coastal residential construction", "Tourism and hospitality development", "Foreshore works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Maroochydore", "Mooloolaba", "Buddina", "Kuluin", "Mountain Creek", "Buderim", "Kawana", "Bokarina", "Warana", "Cotton Tree"],
  },
  {
    slug: "bli-bli",
    suburb: "Bli Bli",
    state: "QLD",
    postcode: "4560",
    council: "Sunshine Coast Council",
    keyRoads: ["Bli Bli Road", "David Low Way", "Eumundi-Noosa Road", "Tanawha Road"],
    intro:
      "Bli Bli is a semi-rural residential suburb on the Maroochy River where residential construction and rural lifestyle development require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Bli Bli residential and rural lifestyle projects.",
    industries: ["Residential construction", "Rural lifestyle development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Maroochydore", "Nambour", "Yandina", "Dunethin Rock", "Maroochy River", "Eumundi", "Coolum", "Buderim", "Kuluin", "Diddillibah"],
  },
  {
    slug: "caloundra-west",
    suburb: "Caloundra West",
    state: "QLD",
    postcode: "4551",
    council: "Sunshine Coast Council",
    keyRoads: ["Caloundra Road", "Nicklin Way", "Sugarbag Road", "Meridan Way"],
    intro:
      "Caloundra West is a rapidly growing greenfield residential area in the Sunshine Coast's southern corridor, part of the Aura master-planned community, where large-scale estate construction and civil infrastructure create strong demand for traffic management documentation compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Caloundra West residential estate and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Caloundra", "Little Mountain", "Meridan Plains", "Bells Creek", "Bokarina", "Sippy Downs", "Palmview", "Baringa", "Nirimba", "Birtinya"],
  },
  {
    slug: "coolum-beach",
    suburb: "Coolum Beach",
    state: "QLD",
    postcode: "4573",
    council: "Sunshine Coast Council",
    keyRoads: ["David Low Way", "Coolum Road", "Beach Road", "Tanawha Tourist Drive"],
    intro:
      "Coolum Beach is a popular Sunshine Coast beach town where coastal residential construction and tourism infrastructure works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Coolum Beach coastal residential and tourism projects.",
    industries: ["Coastal residential construction", "Tourism and hospitality development", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Peregian Beach", "Yaroomba", "Point Arkwright", "Marcus Beach", "Mount Coolum", "Marcoola", "Mudjimba", "Twin Waters", "Noosa Heads", "Tewantin"],
  },
  {
    slug: "mountain-creek",
    suburb: "Mountain Creek",
    state: "QLD",
    postcode: "4557",
    council: "Sunshine Coast Council",
    keyRoads: ["Nicklin Way", "Mountain Creek Road", "Kawana Way", "Lake Kawana Boulevard"],
    intro:
      "Mountain Creek is a major residential and educational suburb on the Sunshine Coast, home to Mountain Creek State High School and adjacent to the Sunshine Coast University Hospital, where residential construction and education infrastructure works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mountain Creek residential and education projects.",
    industries: ["Residential construction", "Education and school infrastructure", "Health support works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Kawana", "Bokarina", "Birtinya", "Sippy Downs", "Buddina", "Minyama", "Buderim", "Alexandra Headland", "Mooloolaba", "Warana"],
  },
  {
    slug: "sippy-downs",
    suburb: "Sippy Downs",
    state: "QLD",
    postcode: "4556",
    council: "Sunshine Coast Council",
    keyRoads: ["Sippy Downs Drive", "Mons Road", "Innovation Parkway", "Stringybark Road"],
    intro:
      "Sippy Downs is the home of the University of the Sunshine Coast and a growing residential suburb, where university construction, residential development and innovation precinct works create demand for traffic management documentation compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Sippy Downs university, residential and commercial projects.",
    industries: ["University and education construction", "Residential development", "Commercial and technology park construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Buderim", "Palmview", "Forest Glen", "Mountain Creek", "Kawana", "Bokarina", "Kunda Park", "Mooloolah Valley", "Landsborough", "Meridan Plains"],
  },
  {
    slug: "twin-waters",
    suburb: "Twin Waters",
    state: "QLD",
    postcode: "4564",
    council: "Sunshine Coast Council",
    keyRoads: ["Twin Waters Drive", "David Low Way", "Mudjimba Beach Road", "Mudjimba Island Road"],
    intro:
      "Twin Waters is a master-planned canal and waterway suburb on the Sunshine Coast north of Maroochydore, where residential construction and marina development require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Twin Waters residential and marina projects.",
    industries: ["Residential and waterfront construction", "Marina and marine infrastructure", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Mudjimba", "Marcoola", "Coolum Beach", "Maroochydore", "Alexandra Headland", "Bli Bli", "Warana", "Bokarina", "Mountain Creek", "Minyama"],
  },
  {
    slug: "warana",
    suburb: "Warana",
    state: "QLD",
    postcode: "4575",
    council: "Sunshine Coast Council",
    keyRoads: ["Nicklin Way", "Kawana Way", "Warana Drive", "Bokarina Boulevard"],
    intro:
      "Warana is a residential suburb on the Sunshine Coast's Kawana corridor where residential construction and utility works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sunshine Coast Council-compliant TMPs for Warana residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Kawana", "Bokarina", "Birtinya", "Mountain Creek", "Buddina", "Minyama", "Parrearra", "Wurtulla", "Mooloolaba", "Alexandra Headland"],
  },
  {
    slug: "yandina",
    suburb: "Yandina",
    state: "QLD",
    postcode: "4561",
    council: "Sunshine Coast Council",
    keyRoads: ["Nambour Connection Road", "Stevens Street", "Yandina-Coolum Road", "Main Street"],
    intro:
      "Yandina is a historic hinterland town on the Sunshine Coast, known for The Ginger Factory, where rural residential construction and tourism infrastructure works require traffic management plans compliant with Sunshine Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Yandina rural residential and tourism projects.",
    industries: ["Rural residential construction", "Tourism and attraction infrastructure", "Agricultural and ginger industry works", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Nambour", "Bli Bli", "Eumundi", "Coolum", "Maroochy River", "Dunethin Rock", "Woombye", "Palmwoods", "Diddillibah", "Kulangoor"],
  },
  // Townsville (additional)
  {
    slug: "bohle-plains",
    suburb: "Bohle Plains",
    state: "QLD",
    postcode: "4817",
    council: "Townsville City Council",
    keyRoads: ["Bohle Plains Drive", "Deeragun Road", "Bayswater Road", "Thuringowa Drive"],
    intro:
      "Bohle Plains is a growing residential suburb in Townsville's western corridor where residential estate construction requires traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Bohle Plains residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Kirwan", "Thuringowa Central", "Deeragun", "Rasmussen", "Mount Louisa", "Condon", "Annandale", "Cranbrook", "Douglas", "Kelso"],
  },
  {
    slug: "condon",
    suburb: "Condon",
    state: "QLD",
    postcode: "4815",
    council: "Townsville City Council",
    keyRoads: ["Bayswater Road", "Deeragun Road", "Hervey Range Road", "Bohle Plains Drive"],
    intro:
      "Condon is a residential suburb in Townsville's western growth area where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Condon residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Kirwan", "Bohle Plains", "Thuringowa Central", "Rasmussen", "Mount Louisa", "Deeragun", "Annandale", "Douglas", "Kelso", "Cranbrook"],
  },
  {
    slug: "cranbrook",
    suburb: "Cranbrook",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Ross River Road", "Stuart Drive", "Cranbrook Drive", "Thuringowa Drive"],
    intro:
      "Cranbrook is a residential suburb in southern Townsville where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Cranbrook residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Annandale", "Kirwan", "Aitkenvale", "Rasmussen", "Thuringowa Central", "Bohle Plains", "Condon", "Douglas", "Mount Louisa", "Kelso"],
  },
  {
    slug: "douglas",
    suburb: "Douglas",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Douglas Street", "Deeragun Road", "Bayswater Road", "Bamford Lane"],
    intro:
      "Douglas is a residential suburb in north-west Townsville home to James Cook University and Townsville University Hospital, where health infrastructure and university construction require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Douglas health, university and residential projects.",
    industries: ["Health and hospital infrastructure", "University and education construction", "Residential development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Kirwan", "Thuringowa Central", "Bohle Plains", "Condon", "Rasmussen", "Mount Louisa", "Deeragun", "Annandale", "Kelso", "Cranbrook"],
  },
  {
    slug: "garbutt",
    suburb: "Garbutt",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Ingham Road", "Bayswater Road", "Bamford Lane", "Dalrymple Road"],
    intro:
      "Garbutt is a residential and commercial suburb of Townsville adjacent to Townsville Airport, where airport-related construction, commercial development and residential works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Garbutt airport, commercial and residential projects.",
    industries: ["Airport and aviation infrastructure", "Commercial and industrial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Townsville CBD", "Mundingburra", "Hyde Park", "Pimlico", "Aitkenvale", "Currajong", "Mysterton", "Mount Louisa", "Bohle", "Kirwan"],
  },
  {
    slug: "hyde-park",
    suburb: "Hyde Park",
    state: "QLD",
    postcode: "4812",
    council: "Townsville City Council",
    keyRoads: ["Ingham Road", "Bamford Lane", "Thuringowa Drive", "Abbot Street"],
    intro:
      "Hyde Park is a residential suburb of inner Townsville where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hyde Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Pimlico", "Townsville CBD", "Garbutt", "Mundingburra", "Aitkenvale", "Currajong", "Mysterton", "Hermit Park", "South Townsville", "Vincent"],
  },
  {
    slug: "mount-louisa",
    suburb: "Mount Louisa",
    state: "QLD",
    postcode: "4814",
    council: "Townsville City Council",
    keyRoads: ["Bayswater Road", "Thuringowa Drive", "Mount Louisa Drive", "Bohle Plains Drive"],
    intro:
      "Mount Louisa is a residential suburb in north-west Townsville where residential construction and utility works require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for Mount Louisa residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Kirwan", "Bohle Plains", "Rasmussen", "Deeragun", "Condon", "Douglas", "Thuringowa Central", "Annandale", "Cranbrook", "Kelso"],
  },
  {
    slug: "south-townsville",
    suburb: "South Townsville",
    state: "QLD",
    postcode: "4810",
    council: "Townsville City Council",
    keyRoads: ["The Strand", "Palmer Street", "Ross Creek Road", "Ernest Street"],
    intro:
      "South Townsville is an inner suburb adjacent to Townsville CBD's Palmer Street dining precinct, where residential construction and commercial fitouts require traffic management plans compliant with Townsville City Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for South Townsville residential and commercial projects.",
    industries: ["Residential construction", "Hospitality and retail fitouts", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Townsville CBD", "Hyde Park", "Pimlico", "Hermit Park", "Mundingburra", "North Ward", "Belgian Gardens", "Garbutt", "Currajong", "Castle Hill"],
  },
  {
    slug: "townsville-cbd",
    suburb: "Townsville CBD",
    state: "QLD",
    postcode: "4810",
    council: "Townsville City Council",
    keyRoads: ["Flinders Street", "Stanley Street", "Sturt Street", "Walker Street"],
    intro:
      "Townsville CBD is the commercial and civic heart of north Queensland, where commercial construction, infrastructure upgrades and the Strand foreshore precinct create demand for traffic management plans compliant with Townsville City Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Townsville City Council-compliant TMPs for CBD commercial and infrastructure projects.",
    industries: ["Commercial and office construction", "Government and civic infrastructure", "Retail and hospitality fitouts", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["South Townsville", "Hyde Park", "North Ward", "Belgian Gardens", "Hermit Park", "Pimlico", "Garbutt", "Mundingburra", "Aitkenvale", "Castle Hill"],
  },
  // Cairns (additional)
  {
    slug: "bentley-park",
    suburb: "Bentley Park",
    state: "QLD",
    postcode: "4869",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "Bentley Park Drive", "Buckley Road", "Sheridan Street"],
    intro:
      "Bentley Park is a growing southern Cairns suburb where residential construction and retail development require traffic management plans compliant with Cairns Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bentley Park residential and commercial projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Mount Sheridan", "Woree", "White Rock", "Edmonton", "Gordonvale", "Cairns CBD", "Manoora", "Mooroobool", "Bungalow", "Westcourt"],
  },
  {
    slug: "edmonton",
    suburb: "Edmonton",
    state: "QLD",
    postcode: "4869",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "Fleming Road", "Draper Street", "Gillies Highway"],
    intro:
      "Edmonton is a major southern Cairns suburb and service centre for the Atherton Tablelands, where residential construction, commercial development and cane industry infrastructure require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Edmonton residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Agricultural and cane industry infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Gordonvale", "Bentley Park", "Woree", "Mount Sheridan", "White Rock", "Cairns CBD", "Mooroobool", "Bungalow", "Westcourt", "Portsmith"],
  },
  {
    slug: "mount-sheridan",
    suburb: "Mount Sheridan",
    state: "QLD",
    postcode: "4868",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "Sheridan Street", "Kennedy Highway", "Greenslopes Street"],
    intro:
      "Mount Sheridan is a growing southern Cairns suburb where residential construction and retail development around Mount Sheridan Plaza create demand for traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mount Sheridan residential and retail projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Woree", "Bentley Park", "White Rock", "Edmonton", "Cairns CBD", "Bungalow", "Westcourt", "Mooroobool", "Portsmith", "Gordonvale"],
  },
  {
    slug: "redlynch",
    suburb: "Redlynch",
    state: "QLD",
    postcode: "4870",
    council: "Cairns Regional Council",
    keyRoads: ["Redlynch Intake Road", "Kamerunga Road", "Captain Cook Highway", "Millstream Road"],
    intro:
      "Redlynch is a growing northern Cairns suburb in the rainforest foothills, where residential estate construction requires traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Redlynch residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Smithfield", "Caravonica", "Kamerunga", "Freshwater", "Brinsmead", "Edge Hill", "Cairns North", "Stratford", "Trinity Beach", "Trinity Park"],
  },
  {
    slug: "white-rock",
    suburb: "White Rock",
    state: "QLD",
    postcode: "4868",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "White Rock Road", "Pease Street", "Kennedy Highway"],
    intro:
      "White Rock is a southern Cairns suburb where residential construction and utility works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for White Rock residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Woree", "Mount Sheridan", "Bentley Park", "Edmonton", "Cairns CBD", "Bungalow", "Mooroobool", "Westcourt", "Portsmith", "Gordonvale"],
  },
  {
    slug: "woree",
    suburb: "Woree",
    state: "QLD",
    postcode: "4868",
    council: "Cairns Regional Council",
    keyRoads: ["Bruce Highway", "Sheridan Street", "Pease Street", "Mulgrave Road"],
    intro:
      "Woree is a commercial and residential suburb in southern Cairns, home to major retail development and light industrial estates, where commercial construction and residential works require traffic management plans compliant with Cairns Regional Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Cairns Regional Council-compliant TMPs for Woree commercial and residential projects.",
    industries: ["Retail and commercial construction", "Light industrial development", "Residential construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Mount Sheridan", "Bentley Park", "White Rock", "Edmonton", "Bungalow", "Westcourt", "Cairns CBD", "Mooroobool", "Portsmith", "Gordonvale"],
  },
  // Regional QLD (additional)
  {
    slug: "bowen",
    suburb: "Bowen",
    state: "QLD",
    postcode: "4805",
    council: "Whitsunday Regional Council",
    keyRoads: ["Herbert Street", "Don Street", "Gregory Street", "Bruce Highway"],
    intro:
      "Bowen is a regional coastal town in the Whitsundays known for its mangoes and tomatoes, where agricultural infrastructure, port construction and residential development require traffic management plans compliant with Whitsunday Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bowen agricultural, port and residential projects.",
    industries: ["Agricultural and horticultural infrastructure", "Port and marine works", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Collinsville", "Airlie Beach", "Proserpine", "Merinda", "Guthalungra", "Mackay", "Home Hill", "Ayr", "Townsville", "Dingo Beach"],
  },
  {
    slug: "chinchilla",
    suburb: "Chinchilla",
    state: "QLD",
    postcode: "4413",
    council: "Western Downs Regional Council",
    keyRoads: ["Middle Street", "Heeney Street", "Warrego Highway", "Tara Road"],
    intro:
      "Chinchilla is the watermelon capital of Australia and a major service centre for the Western Downs gas fields, where CSG infrastructure, agricultural construction and residential development create demand for traffic management plans compliant with Western Downs Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Western Downs Regional Council-compliant TMPs for CSG, agricultural and residential projects in the Western Downs.",
    industries: ["CSG and resources infrastructure", "Agricultural construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Dalby", "Miles", "Roma", "Wandoan", "Tara", "Condamine", "Brigalow", "Warra", "Jandowae", "Meandarra"],
  },
  {
    slug: "dalby",
    suburb: "Dalby",
    state: "QLD",
    postcode: "4405",
    council: "Western Downs Regional Council",
    keyRoads: ["Cunningham Street", "Drayton Street", "Marble Street", "Warrego Highway"],
    intro:
      "Dalby is the major commercial centre of the Western Downs and an important agricultural hub for the Darling Downs grain belt, where agricultural infrastructure, CSG service industry construction and residential development create demand for traffic management plans compliant with Western Downs Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dalby agricultural, resources and residential projects.",
    industries: ["Agricultural and grain industry infrastructure", "CSG and resources services", "Residential development", "Commercial construction", "Road and civil construction"],
    nearbySuburbs: ["Chinchilla", "Toowoomba", "Jondaryan", "Jandowae", "Warra", "Brigalow", "Kaimkillenbun", "Macalister", "Miles", "Tara"],
  },
  {
    slug: "kingaroy",
    suburb: "Kingaroy",
    state: "QLD",
    postcode: "4610",
    council: "South Burnett Regional Council",
    keyRoads: ["Kingaroy Street", "Haly Street", "Youngman Street", "D'Aguilar Highway"],
    intro:
      "Kingaroy is the peanut capital of Australia and the major service centre of the South Burnett region, where agricultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with South Burnett Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares South Burnett Regional Council-compliant TMPs for agricultural, residential and commercial projects in the South Burnett.",
    industries: ["Peanut and agricultural infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Nanango", "Wondai", "Murgon", "Goomeri", "Proston", "Blackbutt", "Yarraman", "Kumbia", "Memerambi", "Tingoora"],
  },
  {
    slug: "maryborough",
    suburb: "Maryborough",
    state: "QLD",
    postcode: "4650",
    council: "Fraser Coast Regional Council",
    keyRoads: ["Bazaar Street", "Richmond Street", "Lennox Street", "Alice Street"],
    intro:
      "Maryborough is a heritage city on the Mary River and the birthplace of Mary Poppins author P.L. Travers, where heritage building refurbishment, residential development and manufacturing industry construction create demand for traffic management plans compliant with Fraser Coast Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Maryborough heritage, residential and industrial projects.",
    industries: ["Heritage building refurbishment", "Residential development", "Manufacturing and industrial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Hervey Bay", "Howard", "Tiaro", "Tinana", "Granville", "Walkers Point", "Glenwood", "Antigua", "Mungar", "Bauple"],
  },
  {
    slug: "proserpine",
    suburb: "Proserpine",
    state: "QLD",
    postcode: "4800",
    council: "Whitsunday Regional Council",
    keyRoads: ["Herbert Street", "Main Street", "Shute Harbour Road", "Bruce Highway"],
    intro:
      "Proserpine is the gateway to the Whitsundays and a major sugar cane town, where sugar industry infrastructure, tourism construction and residential development create demand for traffic management plans compliant with Whitsunday Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Whitsunday Regional Council-compliant TMPs for sugar industry, tourism and residential projects.",
    industries: ["Sugar and agricultural infrastructure", "Tourism and hospitality construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Airlie Beach", "Bowen", "Collinsville", "Cannonvale", "Mount Julian", "Kelsey Creek", "Homebush", "Dittmer", "Goorganga Plains", "Strathdickie"],
  },
  {
    slug: "roma",
    suburb: "Roma",
    state: "QLD",
    postcode: "4455",
    council: "Maranoa Regional Council",
    keyRoads: ["McDowall Street", "Arthur Street", "Charles Street", "Warrego Highway"],
    intro:
      "Roma is the beef cattle capital of Australia and the major oil and gas service centre of south-west Queensland, where petroleum infrastructure, agricultural construction and residential development create demand for traffic management plans compliant with Maranoa Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Roma petroleum, agricultural and residential projects in south-west Queensland.",
    industries: ["Petroleum and gas infrastructure", "Agricultural and cattle industry construction", "Residential development", "Commercial construction", "Road and civil construction"],
    nearbySuburbs: ["Mitchell", "Injune", "Surat", "Muckadilla", "Wallumbilla", "Yuleba", "Morven", "Charleville", "Augathella", "Mitchell"],
  },
  {
    slug: "stanthorpe",
    suburb: "Stanthorpe",
    state: "QLD",
    postcode: "4380",
    council: "Southern Downs Regional Council",
    keyRoads: ["Maryland Street", "Lock Street", "Connor Street", "New England Highway"],
    intro:
      "Stanthorpe is Queensland's coolest town and the heart of the Granite Belt wine and apple-growing region, where horticultural infrastructure, winery construction and tourism development require traffic management plans compliant with Southern Downs Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Southern Downs Regional Council-compliant TMPs for horticultural, winery and tourism projects in the Granite Belt.",
    industries: ["Horticultural and apple industry infrastructure", "Winery and tourism construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Warwick", "Ballandean", "Wallangarra", "Glen Aplin", "Girraween", "Tenterfield", "Toowoomba", "Dalveen", "Eukey", "Pikedale"],
  },
  {
    slug: "warwick",
    suburb: "Warwick",
    state: "QLD",
    postcode: "4370",
    council: "Southern Downs Regional Council",
    keyRoads: ["Palmerin Street", "Grafton Street", "Victoria Street", "New England Highway"],
    intro:
      "Warwick is the Rose and Rodeo City of Queensland and the major commercial centre of the Southern Downs, where agricultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Southern Downs Regional Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Warwick agricultural, residential and commercial projects in the Southern Downs.",
    industries: ["Agricultural construction", "Residential development", "Commercial and retail construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Stanthorpe", "Toowoomba", "Allora", "Clifton", "Killarney", "Pratten", "Leyburn", "Millmerran", "Texas", "Inglewood"],
  },
  {
    slug: "yeppoon",
    suburb: "Yeppoon",
    state: "QLD",
    postcode: "4703",
    council: "Livingstone Shire Council",
    keyRoads: ["Normanby Street", "James Street", "John Street", "Rockhampton-Yeppoon Road"],
    intro:
      "Yeppoon is the coastal city of the Capricorn Coast and the major tourism gateway to Great Keppel Island, where residential development, tourism infrastructure and coastal works require traffic management plans compliant with Livingstone Shire Council and Queensland TMR requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Livingstone Shire Council-compliant TMPs for Yeppoon residential, tourism and coastal projects on the Capricorn Coast.",
    industries: ["Residential development", "Tourism and hospitality construction", "Coastal and foreshore works", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Emu Park", "Rockhampton", "Byfield", "Keppel Sands", "Lammermoor", "Woorim", "Woodbury", "Bondoola", "Meikleville Hill", "Mount Chalmers"],
  },

  // ─── WESTERN AUSTRALIA ─────────────────────────────────────────────────────

  {
    slug: "perth-cbd",
    suburb: "Perth CBD",
    state: "WA",
    postcode: "6000",
    council: "City of Perth",
    keyRoads: ["St Georges Terrace", "Murray Street", "Hay Street", "Wellington Street"],
    intro:
      "Perth CBD is Western Australia's commercial core and the focus of significant construction activity, with new commercial towers, apartment conversions, Metronet rail infrastructure and public realm upgrades requiring detailed traffic management plan documentation compliant with City of Perth and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares TMP, TGS and road occupancy documentation for Perth CBD projects, with experience managing works in the Hay and Murray Street malls and surrounding commercial precincts.",
    industries: [
      "Commercial tower construction",
      "Rail and Metronet infrastructure",
      "Residential conversion",
      "Retail and hospitality fitouts",
      "Utility and services upgrades",
      "Government and council projects",
    ],
    nearbySuburbs: ["Northbridge", "East Perth", "West Perth", "South Perth", "Leederville", "Mount Hawthorn", "Subiaco", "Victoria Park", "Burswood", "Highgate"],
  },
  {
    slug: "fremantle",
    suburb: "Fremantle",
    state: "WA",
    postcode: "6160",
    council: "City of Fremantle",
    keyRoads: ["High Street", "Market Street", "South Terrace", "Marine Terrace"],
    intro:
      "Fremantle is a UNESCO World Heritage tentative-listed port city with a heritage streetscape, active working port and vibrant arts and tourism precinct. Traffic management plans for Fremantle must balance the needs of heritage conservation, heavy port vehicles and high pedestrian traffic under City of Fremantle requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Fremantle-compliant TMP and pedestrian management documentation for projects in the port city, with experience managing works in heritage conservation areas.",
    industries: [
      "Heritage building refurbishment",
      "Port and marine construction",
      "Hospitality and tourism fitouts",
      "Residential development",
      "Utility maintenance",
      "Events and festivals",
    ],
    nearbySuburbs: ["North Fremantle", "Beaconsfield", "White Gum Valley", "Hilton", "O'Connor", "Hamilton Hill", "Spearwood", "Coolbellup", "Cockburn Central", "Henderson"],
  },
  {
    slug: "joondalup",
    suburb: "Joondalup",
    state: "WA",
    postcode: "6027",
    council: "City of Joondalup",
    keyRoads: ["Joondalup Drive", "Grand Boulevard", "Wanneroo Road", "Mitchell Freeway"],
    intro:
      "Joondalup is Perth's major northern satellite city and a fast-growing centre for healthcare, education and residential development. The combination of major hospital expansion, new university precincts and residential growth creates consistent demand for traffic management plan documentation across the City of Joondalup.",
    bodyPara:
      "Focus Traffic Plans provides City of Joondalup-compliant TMP and council permit documentation for northern Perth projects, with fast turnaround to support the region's strong construction pipeline.",
    industries: [
      "Hospital and healthcare construction",
      "Educational facility development",
      "Residential construction",
      "Retail and commercial development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Edgewater", "Currambine", "Ocean Reef", "Iluka", "Burns Beach", "Kinross", "Connolly", "Beldon", "Heathridge", "Woodvale"],
  },
  {
    slug: "rockingham",
    suburb: "Rockingham",
    state: "WA",
    postcode: "6168",
    council: "City of Rockingham",
    keyRoads: ["Rockingham Road", "Dixon Road", "Read Street", "Patterson Road"],
    intro:
      "Rockingham is one of Perth's fastest-growing southern suburbs, combining a major naval base, industrial estates, significant residential development and a popular coastal tourism precinct that collectively generate consistent demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans supports Rockingham contractors and developers with City of Rockingham-compliant TMP documentation and permit submissions for all project types.",
    industries: [
      "Defence and naval infrastructure",
      "Industrial and logistics development",
      "Residential construction",
      "Commercial and retail projects",
      "Road and infrastructure upgrades",
      "Tourism and marine construction",
    ],
    nearbySuburbs: ["Baldivis", "Waikiki", "Secret Harbour", "Golden Bay", "Safety Bay", "Warnbro", "Port Kennedy", "Karnup", "Singleton", "Medina"],
  },
  {
    slug: "bunbury",
    suburb: "Bunbury",
    state: "WA",
    postcode: "6230",
    council: "City of Bunbury",
    keyRoads: ["Victoria Street", "Forrest Avenue", "Bussell Highway", "Blair Street"],
    intro:
      "Bunbury is the South West's major regional city and a key port hub for the state's agricultural and resources sectors. Active port development, residential growth and road upgrades create consistent demand for traffic management plan documentation under City of Bunbury and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans provides TMP and TGS documentation for Bunbury and the South West region, with the same 24-hour turnaround available to clients in Perth and across Australia.",
    industries: [
      "Port and industrial development",
      "Residential construction",
      "Commercial and retail projects",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and council works",
    ],
    nearbySuburbs: ["Australind", "Eaton", "Dalyellup", "Carey Park", "Usher", "College Grove", "Withers", "Vittoria", "Harvey", "Donnybrook"],
  },

  // ─── WESTERN AUSTRALIA (additional) ───────────────────────────────────────

  // Perth CBD & Inner (additional)
  {
    slug: "east-perth",
    suburb: "East Perth",
    state: "WA",
    postcode: "6004",
    council: "City of Perth",
    keyRoads: ["Adelaide Terrace", "Hay Street", "Plain Street", "Royal Street"],
    intro:
      "East Perth is a vibrant inner suburb and one of Perth's most significant urban renewal precincts, where high-density residential towers, commercial development, the Optus Stadium precinct and the new Burswood Bridge create complex and ongoing traffic management requirements compliant with City of Perth and Main Roads WA standards.",
    bodyPara:
      "Focus Traffic Plans prepares City of Perth-compliant TMPs for East Perth residential, commercial and stadium-precinct projects, with experience managing the unique major-event traffic environment.",
    industries: [
      "High-density residential development",
      "Commercial and mixed-use construction",
      "Stadium and events infrastructure",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Perth CBD", "Northbridge", "Highgate", "Mount Lawley", "Victoria Park", "Burswood", "Rivervale", "Carlisle", "Belmont", "South Perth"],
  },
  {
    slug: "leederville",
    suburb: "Leederville",
    state: "WA",
    postcode: "6007",
    council: "City of Vincent",
    keyRoads: ["Oxford Street", "Newcastle Street", "Loftus Street", "Lake Monger Drive"],
    intro:
      "Leederville is one of Perth's most vibrant inner suburbs, known for its Oxford Street café and entertainment strip, where residential construction, commercial fitouts and utility works require traffic management plans compliant with City of Vincent and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Leederville residential and commercial projects, with experience on the Oxford Street corridor.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["North Perth", "Mount Hawthorn", "West Perth", "Perth CBD", "Northbridge", "Wembley", "Floreat", "Joondanna", "Glendalough", "Osborne Park"],
  },
  {
    slug: "mount-hawthorn",
    suburb: "Mount Hawthorn",
    state: "WA",
    postcode: "6016",
    council: "City of Vincent",
    keyRoads: ["Scarborough Beach Road", "Oxford Street", "Buxton Street", "Egina Street"],
    intro:
      "Mount Hawthorn is a sought-after inner-northern Perth suburb with a lively café and restaurant precinct, where residential construction, boutique commercial development and utility works require traffic management plans compliant with City of Vincent and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Vincent-compliant TMPs for Mount Hawthorn residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Leederville", "North Perth", "Osborne Park", "Joondanna", "Wembley", "Floreat", "Glendalough", "Tuart Hill", "Scarborough", "Perth CBD"],
  },
  {
    slug: "northbridge",
    suburb: "Northbridge",
    state: "WA",
    postcode: "6003",
    council: "City of Perth",
    keyRoads: ["William Street", "Newcastle Street", "Francis Street", "Aberdeen Street"],
    intro:
      "Northbridge is Perth's premier entertainment and cultural precinct, where the Perth Cultural Centre, high-density residential development and a bustling nightlife and restaurant strip create ongoing demand for traffic management plans compliant with City of Perth and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Perth-compliant TMPs for Northbridge construction and utility projects, with specialist knowledge of the precinct's high-pedestrian evening environment.",
    industries: [
      "High-density residential development",
      "Hospitality and retail fitouts",
      "Cultural and arts infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Perth CBD", "East Perth", "Leederville", "North Perth", "Mount Hawthorn", "West Perth", "Highgate", "Mount Lawley", "Subiaco", "West Leederville"],
  },
  {
    slug: "south-perth",
    suburb: "South Perth",
    state: "WA",
    postcode: "6151",
    council: "City of South Perth",
    keyRoads: ["Canning Highway", "Mill Point Road", "South Terrace", "Angelo Street"],
    intro:
      "South Perth is a prestigious riverside suburb directly across from Perth CBD, where high-rise residential development, foreshore infrastructure and the Perth Zoo precinct create demand for traffic management plans compliant with City of South Perth and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for South Perth residential and foreshore projects, with knowledge of the Canning Highway corridor.",
    industries: [
      "High-density residential development",
      "Foreshore and parkland works",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Perth CBD", "East Perth", "Victoria Park", "Como", "Karawara", "Manning", "Kensington", "Waterford", "Bentley", "St James"],
  },
  {
    slug: "victoria-park",
    suburb: "Victoria Park",
    state: "WA",
    postcode: "6100",
    council: "Town of Victoria Park",
    keyRoads: ["Albany Highway", "Shepperton Road", "Rutland Avenue", "Haig Park Boulevard"],
    intro:
      "Victoria Park is a diverse inner-southern Perth suburb with a vibrant café and dining strip on Albany Highway, where residential construction, commercial fitouts and utility works require traffic management plans compliant with Town of Victoria Park and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Victoria Park-compliant TMPs for residential and commercial projects, with experience on the Albany Highway corridor.",
    industries: [
      "Residential construction",
      "Retail and hospitality fitouts",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["East Perth", "South Perth", "Carlisle", "St James", "Lathlain", "Bentley", "Rivervale", "Burswood", "Kensington", "Welshpool"],
  },
  {
    slug: "west-perth",
    suburb: "West Perth",
    state: "WA",
    postcode: "6005",
    council: "City of Perth",
    keyRoads: ["Hay Street", "Wellington Street", "Havelock Street", "Thomas Street"],
    intro:
      "West Perth is Perth's major professional and commercial office precinct, where office tower construction, commercial fitouts and utility upgrades require traffic management plans compliant with City of Perth and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for West Perth commercial and construction projects.",
    industries: [
      "Commercial office construction",
      "Retail and commercial fitouts",
      "Utility and services upgrades",
      "Road and footpath maintenance",
      "Heritage building refurbishment",
    ],
    nearbySuburbs: ["Perth CBD", "Northbridge", "Leederville", "Subiaco", "Kings Park", "Nedlands", "Shenton Park", "Wembley", "West Leederville", "Jolimont"],
  },
  // Northern Perth (additional)
  {
    slug: "ellenbrook",
    suburb: "Ellenbrook",
    state: "WA",
    postcode: "6069",
    council: "City of Swan",
    keyRoads: ["The Broadway", "Gnangara Road", "Ellenbrook Road", "Brockman Drive"],
    intro:
      "Ellenbrook is one of Perth's largest master-planned residential communities and one of Australia's fastest-growing suburbs, where ongoing residential estate construction, new schools and retail development create strong demand for traffic management documentation compliant with City of Swan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Swan-compliant TMPs for Ellenbrook residential, education and commercial projects.",
    industries: [
      "Residential subdivision and housing",
      "Education and community infrastructure",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["The Vines", "Upper Swan", "Aveley", "Henley Brook", "Bullsbrook", "Dayton", "Brabham", "Whiteman", "Ballajura", "Caversham"],
  },
  {
    slug: "midland",
    suburb: "Midland",
    state: "WA",
    postcode: "6056",
    council: "City of Swan",
    keyRoads: ["Great Eastern Highway", "Old Toodyay Road", "The Crescent", "Morrison Road"],
    intro:
      "Midland is Perth's eastern regional centre and gateway to the Wheatbelt, where the Midland Health Campus, significant residential development and the revitalised Midland Gate shopping precinct drive demand for traffic management plans compliant with City of Swan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Midland health, residential and commercial projects, with experience in the suburb's rapidly evolving urban environment.",
    industries: [
      "Health and hospital infrastructure",
      "Residential development",
      "Retail and commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Guildford", "Bellevue", "Helena Valley", "Stratton", "Jane Brook", "Swan View", "Greenmount", "Beechboro", "Ballajura", "Bennett Springs"],
  },
  {
    slug: "morley",
    suburb: "Morley",
    state: "WA",
    postcode: "6062",
    council: "City of Bayswater",
    keyRoads: ["Walter Road", "Whatley Crescent", "Camboon Road", "Benara Road"],
    intro:
      "Morley is a major northern Perth retail and residential centre, anchored by Galleria Shopping Centre, where retail construction, residential development and utility works require traffic management plans compliant with City of Bayswater and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Bayswater-compliant TMPs for Morley retail and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Noranda", "Beechboro", "Dianella", "Nollamara", "Balga", "Bassendean", "Eden Hill", "Bedford", "Bayswater", "Embleton"],
  },
  {
    slug: "mundaring",
    suburb: "Mundaring",
    state: "WA",
    postcode: "6073",
    council: "Shire of Mundaring",
    keyRoads: ["Great Eastern Highway", "Mundaring Weir Road", "Jacoby Street", "Stoneville Road"],
    intro:
      "Mundaring is a scenic Hills suburb and the gateway to the Perth Hills region, where rural residential construction, eco-tourism infrastructure and utility works in a bushfire-prone environment require traffic management plans compliant with Shire of Mundaring and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mundaring residential and rural infrastructure projects, with awareness of the Hills' unique road environment.",
    industries: [
      "Rural residential construction",
      "Tourism and recreation infrastructure",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chidlow", "Sawyers Valley", "Stoneville", "Parkerville", "Glen Forrest", "Darlington", "Mahogany Creek", "Bickley", "Midvale", "Midland"],
  },
  {
    slug: "nollamara",
    suburb: "Nollamara",
    state: "WA",
    postcode: "6061",
    council: "City of Stirling",
    keyRoads: ["Beach Road", "Mirrabooka Avenue", "Alexander Drive", "Flinders Street"],
    intro:
      "Nollamara is a residential suburb in Perth's northern corridor where residential construction and utility works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Nollamara residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Balga", "Morley", "Noranda", "Mirrabooka", "Westminster", "Dianella", "Koondoola", "Girrawheen", "Tuart Hill", "Yokine"],
  },
  {
    slug: "osborne-park",
    suburb: "Osborne Park",
    state: "WA",
    postcode: "6017",
    council: "City of Stirling",
    keyRoads: ["Scarborough Beach Road", "Main Street", "Hutton Street", "Stephenson Avenue"],
    intro:
      "Osborne Park is Perth's major car dealership and light industrial strip, where automotive retail construction, commercial development and utility works along the Scarborough Beach Road corridor require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Osborne Park commercial and industrial projects, with experience on the Scarborough Beach Road arterial.",
    industries: [
      "Commercial and automotive retail construction",
      "Light industrial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Innaloo", "Stirling", "Tuart Hill", "Nollamara", "Balcatta", "Glendalough", "North Beach", "Karrinyup", "Herdsman", "Yokine"],
  },
  {
    slug: "swan",
    suburb: "Swan",
    state: "WA",
    postcode: "6055",
    council: "City of Swan",
    keyRoads: ["West Swan Road", "Great Northern Highway", "Benara Road", "Reid Highway"],
    intro:
      "The City of Swan encompasses Perth's north-eastern growth corridor, including major residential suburbs, the Swan Valley wine region and significant industrial estates, where diverse construction activity requires traffic management plans compliant with City of Swan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Swan-compliant TMPs for residential, industrial and tourism projects across the Swan LGA.",
    industries: [
      "Residential subdivision and housing",
      "Tourism and wine industry infrastructure",
      "Industrial and logistics construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Ellenbrook", "Midland", "Guildford", "Caversham", "Henley Brook", "Upper Swan", "Baskerville", "Bullsbrook", "Dayton", "Brabham"],
  },
  {
    slug: "wanneroo",
    suburb: "Wanneroo",
    state: "WA",
    postcode: "6065",
    council: "City of Wanneroo",
    keyRoads: ["Wanneroo Road", "Joondalup Drive", "Pinjar Road", "Dundebar Road"],
    intro:
      "Wanneroo is the township centre of the City of Wanneroo, one of Perth's fastest-growing local government areas, where large residential estates, commercial development and infrastructure upgrades create strong demand for traffic management documentation compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wanneroo residential and commercial projects across the rapidly growing northern corridor.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Joondalup", "Clarkson", "Merriwa", "Quinns Rocks", "Sinagra", "Tapping", "Banksia Grove", "Carramar", "Landsdale", "Wangara"],
  },
  // Southern Perth (additional)
  {
    slug: "armadale",
    suburb: "Armadale",
    state: "WA",
    postcode: "6112",
    council: "City of Armadale",
    keyRoads: ["Armadale Road", "Albany Highway", "Orchard Avenue", "Lake Road"],
    intro:
      "Armadale is Perth's major south-eastern regional centre and one of WA's fastest-growing LGAs, where significant residential development, the Tonkin Highway corridor expansion and commercial growth create strong demand for traffic management documentation compliant with City of Armadale and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Armadale-compliant TMPs for residential, commercial and highway corridor projects in Perth's south-east.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Highway and road infrastructure",
      "Utility maintenance",
      "Civil and road construction",
    ],
    nearbySuburbs: ["Kelmscott", "Gosnells", "Byford", "Harrisdale", "Piara Waters", "Forrestdale", "Hilbert", "Brookdale", "Wungong", "Bedfordale"],
  },
  {
    slug: "canning",
    suburb: "Canning",
    state: "WA",
    postcode: "6107",
    council: "City of Canning",
    keyRoads: ["Albany Highway", "Canning Highway", "Leach Highway", "Welshpool Road"],
    intro:
      "The City of Canning encompasses a diverse mix of residential, commercial and industrial suburbs in Perth's inner south-east, where construction activity along major arterial corridors requires traffic management plans compliant with City of Canning and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Canning LGA residential and commercial projects across the suburb's major road corridors.",
    industries: [
      "Residential development",
      "Commercial and industrial construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bentley", "St James", "Cannington", "Beckenham", "Queens Park", "Welshpool", "East Cannington", "Wilson", "Southern River", "Parkwood"],
  },
  {
    slug: "cockburn",
    suburb: "Cockburn",
    state: "WA",
    postcode: "6164",
    council: "City of Cockburn",
    keyRoads: ["Kwinana Freeway", "Cockburn Road", "Beeliar Drive", "Rowley Road"],
    intro:
      "The City of Cockburn is one of Perth's most significant industrial and residential growth corridors, encompassing major port-related industry at Latitude 32, large residential estates and the Cockburn Central activity centre, creating strong demand for traffic management documentation compliant with City of Cockburn and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Cockburn-compliant TMPs for industrial, residential and commercial projects across the LGA's diverse development environments.",
    industries: [
      "Industrial and port-related construction",
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Jandakot", "Success", "Bibra Lake", "Munster", "Henderson", "Spearwood", "Hamilton Hill", "Coogee", "Banjup", "Atwell"],
  },
  {
    slug: "gosnells",
    suburb: "Gosnells",
    state: "WA",
    postcode: "6110",
    council: "City of Gosnells",
    keyRoads: ["Albany Highway", "Corfield Street", "Fremantle Road", "Warton Road"],
    intro:
      "Gosnells is a major south-eastern Perth suburb and the administrative centre of the City of Gosnells LGA, where residential development, the Gosnells town centre and utility works require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gosnells residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Maddington", "Kenwick", "Orange Grove", "Martin", "Huntingdale", "Southern River", "Canning Vale", "Thornlie", "Beckenham", "Armadale"],
  },
  {
    slug: "kelmscott",
    suburb: "Kelmscott",
    state: "WA",
    postcode: "6111",
    council: "City of Armadale",
    keyRoads: ["Albany Highway", "Gillam Drive", "Clifton Street", "Seville Drive"],
    intro:
      "Kelmscott is an established suburb in the City of Armadale where residential construction and utility works require traffic management plans compliant with City of Armadale and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Armadale-compliant TMPs for Kelmscott residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Armadale", "Roleystone", "Karragullen", "Bedfordale", "Wungong", "Camillo", "Champion Lakes", "Brookdale", "Gosnells", "Maddington"],
  },
  {
    slug: "mandurah",
    suburb: "Mandurah",
    state: "WA",
    postcode: "6210",
    council: "City of Mandurah",
    keyRoads: ["Pinjarra Road", "Mandurah Terrace", "Gordon Road", "Ormsby Terrace"],
    intro:
      "Mandurah is the Peel region's major city and one of WA's fastest-growing urban areas, where significant residential estate construction, the Mandurah Forum shopping precinct and coastal tourism infrastructure create strong demand for traffic management documentation compliant with City of Mandurah and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Mandurah-compliant TMPs for residential, commercial and tourism projects across the Peel region.",
    industries: [
      "Residential subdivision and housing",
      "Retail and commercial construction",
      "Tourism and marina development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Halls Head", "Meadow Springs", "Falcon", "Wannanup", "Dawesville", "Erskine", "Dudley Park", "Greenfields", "Coodanup", "Pinjarra"],
  },
  {
    slug: "melville",
    suburb: "Melville",
    state: "WA",
    postcode: "6156",
    council: "City of Melville",
    keyRoads: ["Canning Highway", "Leach Highway", "Kwinana Freeway", "Stock Road"],
    intro:
      "The City of Melville encompasses sought-after riverside and coastal suburbs in Perth's inner south, where residential construction, the Westfield Booragoon shopping precinct and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Melville LGA residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Booragoon", "Applecross", "Myaree", "Attadale", "Palmyra", "Bicton", "Willagee", "Murdoch", "Kardinya", "Mount Pleasant"],
  },
  {
    slug: "murdoch",
    suburb: "Murdoch",
    state: "WA",
    postcode: "6150",
    council: "City of Melville",
    keyRoads: ["Kwinana Freeway", "Murdoch Drive", "South Street", "Barry Marshall Parade"],
    intro:
      "Murdoch is Perth's major health and education precinct south of the river, home to Fiona Stanley Hospital, St John of God Murdoch and Murdoch University, where hospital expansion, university construction and the Fiona Stanley precinct development create complex traffic management requirements compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melville-compliant TMPs for Murdoch health, university and residential projects, with specialist experience in major health precinct traffic management.",
    industries: [
      "Health and hospital infrastructure",
      "University and education construction",
      "Residential development",
      "Utility and services upgrades",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Kardinya", "Winthrop", "Booragoon", "Willagee", "Myaree", "Bull Creek", "Bibra Lake", "South Lake", "Leeming", "Melville"],
  },
  // Western Suburbs
  {
    slug: "claremont",
    suburb: "Claremont",
    state: "WA",
    postcode: "6010",
    council: "Town of Claremont",
    keyRoads: ["Stirling Highway", "Bay View Terrace", "Claremont Crescent", "Princess Road"],
    intro:
      "Claremont is an affluent western suburbs town with a vibrant retail strip on Bay View Terrace, where residential construction, boutique commercial development and the Claremont Showgrounds precinct create demand for traffic management plans compliant with Town of Claremont and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Claremont residential and commercial projects, with experience on the Stirling Highway western corridor.",
    industries: [
      "Residential construction",
      "Boutique retail and commercial development",
      "Events and showground infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Cottesloe", "Swanbourne", "Nedlands", "Peppermint Grove", "Dalkeith", "Karrakatta", "Mount Claremont", "Floreat", "City Beach", "Shenton Park"],
  },
  {
    slug: "cottesloe",
    suburb: "Cottesloe",
    state: "WA",
    postcode: "6011",
    council: "Town of Cottesloe",
    keyRoads: ["Marine Parade", "Stirling Highway", "Napoleon Street", "Eric Street"],
    intro:
      "Cottesloe is Perth's most iconic beach suburb, where luxury residential construction, the Cottesloe Beach Hotel and coastal infrastructure works require traffic management plans compliant with Town of Cottesloe and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Cottesloe-compliant TMPs for residential and coastal infrastructure projects, managing the suburb's popular beachfront environment.",
    industries: [
      "Luxury residential construction",
      "Coastal and foreshore works",
      "Hospitality and retail development",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Swanbourne", "North Cottesloe", "Peppermint Grove", "Claremont", "Nedlands", "Mosman Park", "Floreat", "City Beach", "Hollywood", "Mount Claremont"],
  },
  {
    slug: "floreat",
    suburb: "Floreat",
    state: "WA",
    postcode: "6014",
    council: "Town of Cambridge",
    keyRoads: ["Floreat Avenue", "Winthrop Avenue", "Oceanic Drive", "Howtree Place"],
    intro:
      "Floreat is a leafy western suburb known for its generous residential lots and proximity to City Beach, where residential construction and utility works require traffic management plans compliant with Town of Cambridge and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Floreat residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["City Beach", "Wembley", "Mount Claremont", "Claremont", "Swanbourne", "Cottesloe", "Shenton Park", "West Leederville", "Jolimont", "Churchlands"],
  },
  {
    slug: "mosman-park",
    suburb: "Mosman Park",
    state: "WA",
    postcode: "6012",
    council: "Town of Mosman Park",
    keyRoads: ["Stirling Highway", "Glyde Street", "Victoria Street", "Bay View Terrace"],
    intro:
      "Mosman Park is a prestigious riverside suburb in Perth's western corridor where luxury residential construction and coastal infrastructure works require traffic management plans compliant with Town of Mosman Park and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Mosman Park-compliant TMPs for luxury residential and coastal infrastructure projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Cottesloe", "Peppermint Grove", "Claremont", "North Fremantle", "Fremantle", "Bicton", "Attadale", "Palmyra", "East Fremantle", "Swanbourne"],
  },
  {
    slug: "nedlands",
    suburb: "Nedlands",
    state: "WA",
    postcode: "6009",
    council: "City of Nedlands",
    keyRoads: ["Stirling Highway", "Broadway", "Mounts Bay Road", "Hampden Road"],
    intro:
      "Nedlands is one of Perth's most prestigious western suburbs, home to the Sir Charles Gairdner Hospital and University of Western Australia, where hospital expansion, university construction and luxury residential development create demand for traffic management plans compliant with City of Nedlands and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nedlands health, university and residential projects, with experience in the Queen Elizabeth II Medical Centre precinct.",
    industries: [
      "Health and hospital infrastructure",
      "University and education construction",
      "Luxury residential development",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Crawley", "Claremont", "Dalkeith", "Floreat", "Mount Claremont", "Hollywood", "Subiaco", "West Perth", "Shenton Park", "Matilda Bay"],
  },
  {
    slug: "peppermint-grove",
    suburb: "Peppermint Grove",
    state: "WA",
    postcode: "6011",
    council: "Shire of Peppermint Grove",
    keyRoads: ["Stirling Highway", "Leake Street", "View Street", "Forrest Street"],
    intro:
      "Peppermint Grove is Australia's smallest local government area and one of Perth's most exclusive riverside suburbs, where luxury residential construction and heritage building refurbishment require traffic management plans compliant with Shire of Peppermint Grove and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Peppermint Grove-compliant TMPs for luxury residential and heritage projects in this prestigious suburb.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Landscaping and civil works",
    ],
    nearbySuburbs: ["Cottesloe", "Mosman Park", "Claremont", "Swanbourne", "North Cottesloe", "Dalkeith", "Nedlands", "East Fremantle", "Mount Claremont", "Hollywood"],
  },
  {
    slug: "shenton-park",
    suburb: "Shenton Park",
    state: "WA",
    postcode: "6008",
    council: "City of Nedlands",
    keyRoads: ["Stubbs Terrace", "Thomas Street", "Selby Street", "Onslow Road"],
    intro:
      "Shenton Park is a leafy western suburb adjacent to Lake Jualbup and the QE II Medical Centre precinct, where residential construction and utility works require traffic management plans compliant with City of Nedlands and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Shenton Park residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Dual occupancy development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Subiaco", "West Perth", "Nedlands", "Floreat", "Jolimont", "Mount Claremont", "Claremont", "Wembley", "West Leederville", "Hollywood"],
  },
  {
    slug: "subiaco",
    suburb: "Subiaco",
    state: "WA",
    postcode: "6008",
    council: "City of Subiaco",
    keyRoads: ["Rokeby Road", "Hay Street", "Roberts Road", "Bagot Road"],
    intro:
      "Subiaco is one of Perth's most vibrant inner-western suburbs, where the Subiaco Oval redevelopment into Jualbup Parkland, high-density residential construction, the Subi Centro transit-oriented development and a bustling retail strip create ongoing demand for traffic management plans compliant with City of Subiaco and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Subiaco-compliant TMPs for residential, commercial and urban renewal projects, with specialist knowledge of the Rokeby Road and Hay Street corridors.",
    industries: [
      "High-density residential development",
      "Retail and hospitality fitouts",
      "Urban renewal and mixed-use construction",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["West Perth", "Shenton Park", "Nedlands", "Leederville", "West Leederville", "Jolimont", "Wembley", "Floreat", "Daglish", "Crawley"],
  },
  {
    slug: "swanbourne",
    suburb: "Swanbourne",
    state: "WA",
    postcode: "6010",
    council: "Town of Claremont",
    keyRoads: ["Stirling Highway", "Claremont Crescent", "Marine Parade", "Swanbourne Street"],
    intro:
      "Swanbourne is a beachside suburb in Perth's western corridor, home to a significant defence facility, where residential construction and coastal infrastructure works require traffic management plans compliant with Town of Claremont and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Swanbourne residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Defence-related construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Cottesloe", "Claremont", "Floreat", "City Beach", "North Cottesloe", "Mount Claremont", "Nedlands", "Peppermint Grove", "Mosman Park", "Hollywood"],
  },
  // Bunbury & South West (additional)
  {
    slug: "australind",
    suburb: "Australind",
    state: "WA",
    postcode: "6233",
    council: "Shire of Harvey",
    keyRoads: ["Old Coast Road", "Australind Bypass", "Sunridge Road", "Paris Road"],
    intro:
      "Australind is a fast-growing residential suburb north of Bunbury, where residential estate construction and associated civil infrastructure create demand for traffic management plans compliant with Shire of Harvey and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Harvey-compliant TMPs for Australind residential and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Bunbury", "Eaton", "Carey Park", "Dalyellup", "Leschenault", "Burekup", "Harvey", "Wollaston", "Treendale", "Usher"],
  },
  {
    slug: "busselton",
    suburb: "Busselton",
    state: "WA",
    postcode: "6280",
    council: "City of Busselton",
    keyRoads: ["Bussell Highway", "Queen Street", "Albert Street", "Causeway Road"],
    intro:
      "Busselton is the major city of the Capes region and gateway to the Margaret River wine country, where residential development, tourism infrastructure and the Busselton Margaret River Airport create demand for traffic management plans compliant with City of Busselton and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Busselton residential, tourism and airport-related projects.",
    industries: [
      "Residential development",
      "Tourism and hospitality construction",
      "Airport and aviation infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Dunsborough", "Quindalup", "Vasse", "West Busselton", "Siesta Park", "Eagle Bay", "Yallingup", "Cowaramup", "Margaret River", "Naturaliste"],
  },
  {
    slug: "collie",
    suburb: "Collie",
    state: "WA",
    postcode: "6225",
    council: "Shire of Collie",
    keyRoads: ["Throssell Street", "Steere Street", "Wittenoom Street", "Prince Street"],
    intro:
      "Collie is WA's coal mining capital and a community undergoing significant economic transition, where mining infrastructure, energy projects and residential construction require traffic management plans compliant with Shire of Collie and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Collie-compliant TMPs for mining, energy and residential projects in the Collie region.",
    industries: [
      "Mining and energy infrastructure",
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Bunbury", "Australind", "Harvey", "Darkan", "Boyup Brook", "Bridgetown", "Donnybrook", "Balingup", "Preston Settlement", "Muja"],
  },
  {
    slug: "dunsborough",
    suburb: "Dunsborough",
    state: "WA",
    postcode: "6281",
    council: "City of Busselton",
    keyRoads: ["Naturaliste Terrace", "Dunn Bay Road", "Cape Naturaliste Road", "Geographe Bay Road"],
    intro:
      "Dunsborough is a premium coastal tourist and residential destination in WA's Capes region, where luxury residential construction and tourism infrastructure works require traffic management plans compliant with City of Busselton and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dunsborough residential and tourism projects, with awareness of the area's high seasonal visitor volumes.",
    industries: [
      "Luxury residential construction",
      "Tourism and hospitality development",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Busselton", "Yallingup", "Eagle Bay", "Quindalup", "Cape Naturaliste", "Vasse", "Smiths Beach", "Meelup", "Cowaramup", "Margaret River"],
  },
  {
    slug: "harvey",
    suburb: "Harvey",
    state: "WA",
    postcode: "6220",
    council: "Shire of Harvey",
    keyRoads: ["South Western Highway", "Uduc Road", "Young Street", "Hayward Street"],
    intro:
      "Harvey is a major agricultural town in the South West, known for its dairy industry and irrigation infrastructure, where agricultural construction, residential development and utility works require traffic management plans compliant with Shire of Harvey and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Harvey-compliant TMPs for agricultural, residential and infrastructure projects in the Harvey region.",
    industries: [
      "Agricultural and dairy infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Australind", "Bunbury", "Waroona", "Yarloop", "Myalup", "Cookernup", "Binningup", "Wokalup", "Leschenault", "Mornington"],
  },
  {
    slug: "margaret-river",
    suburb: "Margaret River",
    state: "WA",
    postcode: "6285",
    council: "Shire of Augusta-Margaret River",
    keyRoads: ["Bussell Highway", "Tunbridge Street", "Wallcliffe Road", "Farrelly Street"],
    intro:
      "Margaret River is the heart of WA's world-famous wine and surf region, where tourism infrastructure, boutique hospitality construction and rural residential development create demand for traffic management plans compliant with Shire of Augusta-Margaret River and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Margaret River tourism, hospitality and residential projects.",
    industries: [
      "Tourism and hospitality construction",
      "Winery and agricultural infrastructure",
      "Residential development",
      "Heritage and boutique commercial development",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Cowaramup", "Witchcliffe", "Rosa Brook", "Prevelly", "Gracetown", "Karridale", "Augusta", "Busselton", "Dunsborough", "Yallingup"],
  },
  {
    slug: "manjimup",
    suburb: "Manjimup",
    state: "WA",
    postcode: "6258",
    council: "Shire of Manjimup",
    keyRoads: ["South Western Highway", "Rose Street", "Giblett Street", "Mottram Street"],
    intro:
      "Manjimup is the major service centre of WA's southern timber and horticultural region, where timber industry infrastructure, agricultural construction and residential development require traffic management plans compliant with Shire of Manjimup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Manjimup-compliant TMPs for timber, agricultural and residential projects in the South West.",
    industries: [
      "Timber and forestry infrastructure",
      "Agricultural and horticultural construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Pemberton", "Northcliffe", "Bridgetown", "Nannup", "Walpole", "Shannon", "Quinninup", "Jardee", "Graphite", "Palgarup"],
  },
  // Goldfields
  {
    slug: "boulder",
    suburb: "Boulder",
    state: "WA",
    postcode: "6432",
    council: "City of Kalgoorlie-Boulder",
    keyRoads: ["Burt Street", "Lane Street", "Hamilton Street", "Lionel Street"],
    intro:
      "Boulder is the historic mining twin of Kalgoorlie and home to the Super Pit open-cut gold mine, where mining infrastructure, heritage building refurbishment and residential construction require traffic management plans compliant with City of Kalgoorlie-Boulder and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Kalgoorlie-Boulder-compliant TMPs for mining, heritage and residential projects in the Golden Mile region.",
    industries: [
      "Mining and gold industry infrastructure",
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Kalgoorlie", "Hannans", "Lamington", "Karlkurla", "Piccadilly", "West Kalgoorlie", "Somerville", "South Kalgoorlie", "Williamstown", "Broadwood"],
  },
  {
    slug: "coolgardie",
    suburb: "Coolgardie",
    state: "WA",
    postcode: "6429",
    council: "Shire of Coolgardie",
    keyRoads: ["Bayley Street", "Hunt Street", "Great Eastern Highway", "Woodward Street"],
    intro:
      "Coolgardie is a historic gold rush town and the birthplace of WA's Golden Mile, where mining support infrastructure, heritage building maintenance and utility works require traffic management plans compliant with Shire of Coolgardie and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Coolgardie mining support and heritage projects.",
    industries: [
      "Mining support infrastructure",
      "Heritage building maintenance",
      "Utility maintenance",
      "Road maintenance",
      "Tourism infrastructure",
    ],
    nearbySuburbs: ["Kalgoorlie", "Boulder", "Kambalda", "Norseman", "Menzies", "Broad Arrow", "Ora Banda", "Kanowna", "Binduli", "Eyre"],
  },
  {
    slug: "esperance",
    suburb: "Esperance",
    state: "WA",
    postcode: "6450",
    council: "Shire of Esperance",
    keyRoads: ["Dempster Street", "Andrew Street", "Forrest Street", "Pink Lake Road"],
    intro:
      "Esperance is a remote coastal city on WA's south coast, a major grain export port and tourism destination, where port infrastructure, agricultural logistics and residential development create demand for traffic management plans compliant with Shire of Esperance and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Esperance-compliant TMPs for port, agricultural and residential projects in the Esperance region.",
    industries: [
      "Port and grain export infrastructure",
      "Agricultural and logistics construction",
      "Residential development",
      "Tourism infrastructure",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Castletown", "Nulsen", "Pink Lake", "Myrup", "Gibson", "Grass Patch", "Scaddan", "Condingup", "Cape Le Grand", "Israelite Bay"],
  },
  {
    slug: "kalgoorlie",
    suburb: "Kalgoorlie",
    state: "WA",
    postcode: "6430",
    council: "City of Kalgoorlie-Boulder",
    keyRoads: ["Hannan Street", "Boulder Road", "Egan Street", "Maritana Street"],
    intro:
      "Kalgoorlie is Australia's gold capital and the hub of WA's Goldfields-Esperance region, where major gold mining operations, a booming resources sector and associated residential and commercial growth create strong demand for traffic management documentation compliant with City of Kalgoorlie-Boulder and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Kalgoorlie-Boulder-compliant TMPs for mining, commercial and residential projects in the Goldfields.",
    industries: [
      "Mining and gold industry infrastructure",
      "Commercial and retail construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Boulder", "Hannans", "Lamington", "Karlkurla", "Piccadilly", "West Kalgoorlie", "Somerville", "South Kalgoorlie", "Coolgardie", "Kambalda"],
  },
  {
    slug: "norseman",
    suburb: "Norseman",
    state: "WA",
    postcode: "6443",
    council: "Shire of Dundas",
    keyRoads: ["Roberts Street", "Ramsay Street", "Park Street", "Eyre Highway"],
    intro:
      "Norseman is the gateway to the Nullarbor Plain and a significant gold mining town, where mining infrastructure, highway maintenance and residential construction require traffic management plans compliant with Shire of Dundas and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Norseman mining and highway infrastructure projects in remote WA.",
    industries: [
      "Mining infrastructure",
      "Highway and road maintenance",
      "Residential construction",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Grass Patch", "Salmon Gums", "Esperance", "Balladonia", "Caiguna", "Cocklebiddy", "Coolgardie", "Kambalda", "Marvel Loch", "Southern Cross"],
  },
  // Pilbara
  {
    slug: "dampier",
    suburb: "Dampier",
    state: "WA",
    postcode: "6713",
    council: "City of Karratha",
    keyRoads: ["Dampier Highway", "The Esplanade", "Maitland Road", "Winch Place"],
    intro:
      "Dampier is WA's major iron ore and LNG export port town on the Burrup Peninsula, where port infrastructure, processing plant maintenance and residential construction in a remote industrial environment require traffic management plans compliant with City of Karratha and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Karratha-compliant TMPs for Dampier port, industrial and residential projects.",
    industries: [
      "Port and iron ore export infrastructure",
      "LNG and processing plant maintenance",
      "Residential construction",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["Karratha", "Point Samson", "Roebourne", "Wickham", "Cossack", "Mardie", "Burrup Peninsula", "Millstream", "Tom Price", "Pannawonica"],
  },
  {
    slug: "karratha",
    suburb: "Karratha",
    state: "WA",
    postcode: "6714",
    council: "City of Karratha",
    keyRoads: ["Karratha Road", "Welcome Road", "Sharpe Avenue", "Balmoral Road"],
    intro:
      "Karratha is the Pilbara's fastest-growing city and the regional hub for WA's resources sector, where major LNG and iron ore infrastructure, rapid residential growth and commercial development create strong demand for traffic management documentation compliant with City of Karratha and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Karratha-compliant TMPs for resources, residential and commercial projects across the Pilbara's major city.",
    industries: [
      "LNG and resources infrastructure",
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Dampier", "Roebourne", "Wickham", "Point Samson", "Millstream", "Pannawonica", "Tom Price", "Baynton", "Nickol", "Bulgarra"],
  },
  {
    slug: "newman",
    suburb: "Newman",
    state: "WA",
    postcode: "6753",
    council: "Shire of East Pilbara",
    keyRoads: ["Fortescue Road", "Newman Drive", "Kalgan Road", "Great Northern Highway"],
    intro:
      "Newman is one of Australia's largest and most remote mining towns, built around BHP's Mount Whaleback iron ore operation, where mine expansion, residential construction and essential services infrastructure require traffic management plans compliant with Shire of East Pilbara and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of East Pilbara-compliant TMPs for Newman mining, residential and infrastructure projects in the remote Pilbara.",
    industries: [
      "Iron ore and mining infrastructure",
      "Residential construction",
      "Essential services and utility works",
      "Road and civil construction",
      "Remote area infrastructure",
    ],
    nearbySuburbs: ["Ophthalmia", "Capricorn", "Mulga Downs", "Nullagine", "Marble Bar", "Paraburdoo", "Tom Price", "Meekatharra", "Mount Newman", "Jigalong"],
  },
  {
    slug: "paraburdoo",
    suburb: "Paraburdoo",
    state: "WA",
    postcode: "6754",
    council: "Shire of Ashburton",
    keyRoads: ["Rocklea Road", "Paraburdoo Road", "Tom Price Road", "Rio Tinto Drive"],
    intro:
      "Paraburdoo is a remote Pilbara mining town built to service Rio Tinto's iron ore operations, where mine infrastructure, residential maintenance and essential services works require traffic management plans compliant with Shire of Ashburton and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Paraburdoo mining and residential projects in the remote Pilbara.",
    industries: [
      "Iron ore and mining infrastructure",
      "Residential maintenance and construction",
      "Essential services works",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Tom Price", "Newman", "Onslow", "Pannawonica", "Karratha", "Dampier", "Nanutarra", "Meekatharra", "Carnarvon", "Gascoyne Junction"],
  },
  {
    slug: "port-hedland",
    suburb: "Port Hedland",
    state: "WA",
    postcode: "6721",
    council: "Town of Port Hedland",
    keyRoads: ["McGregor Street", "Richardson Street", "Wedge Street", "Anderson Street"],
    intro:
      "Port Hedland is the world's largest bulk export port by tonnage and WA's major iron ore shipping hub, where port expansion, mining support infrastructure and residential construction in an extreme industrial environment create complex traffic management requirements compliant with Town of Port Hedland and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans produces Town of Port Hedland-compliant TMPs for port, mining and residential projects, with specialist knowledge of the extreme heavy vehicle traffic environment.",
    industries: [
      "Port and iron ore export infrastructure",
      "Mining support and processing construction",
      "Residential construction",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["South Hedland", "Wedgefield", "Pippingarra", "Boodarie", "De Grey", "Marble Bar", "Newman", "Karratha", "Broome", "Pardoo"],
  },
  {
    slug: "tom-price",
    suburb: "Tom Price",
    state: "WA",
    postcode: "6751",
    council: "Shire of Ashburton",
    keyRoads: ["Central Road", "Tom Price Road", "Paraburdoo Road", "Nameless Valley Drive"],
    intro:
      "Tom Price is a remote Pilbara mining town nestled in the Hamersley Range, built to service Rio Tinto's iron ore operations, where mine infrastructure, residential construction and remote area utility works require traffic management plans compliant with Shire of Ashburton and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Tom Price mining and residential projects in the remote Pilbara interior.",
    industries: [
      "Iron ore and mining infrastructure",
      "Residential construction",
      "Essential services works",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Paraburdoo", "Newman", "Pannawonica", "Karratha", "Dampier", "Onslow", "Nanutarra", "Carnarvon", "Meekatharra", "Gascoyne Junction"],
  },
  // Kimberley
  {
    slug: "broome",
    suburb: "Broome",
    state: "WA",
    postcode: "6725",
    council: "Shire of Broome",
    keyRoads: ["Louis Samson Highway", "Broome Road", "Cable Beach Road", "Frederick Street"],
    intro:
      "Broome is WA's iconic pearling and tourism capital in the Kimberley, where luxury resort construction, tourism infrastructure, the Broome Port and residential development in a remote tropical environment create demand for traffic management plans compliant with Shire of Broome and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Broome-compliant TMPs for tourism, port, residential and infrastructure projects in this iconic Kimberley destination.",
    industries: [
      "Tourism and resort construction",
      "Port and pearling infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Cable Beach", "Roebuck", "Djugun", "Coconut Wells", "Dampier Peninsula", "Port Hedland", "Derby", "Fitzroy Crossing", "Halls Creek", "Kununurra"],
  },
  {
    slug: "derby",
    suburb: "Derby",
    state: "WA",
    postcode: "6728",
    council: "Shire of Derby-West Kimberley",
    keyRoads: ["Loch Street", "Derby Highway", "Elder Street", "Clarendon Street"],
    intro:
      "Derby is the administrative centre of the West Kimberley and gateway to the Gibb River Road, where pastoral and mining infrastructure, health services construction and essential services works require traffic management plans compliant with Shire of Derby-West Kimberley and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Derby health, infrastructure and essential services projects in the remote Kimberley.",
    industries: [
      "Health and hospital infrastructure",
      "Essential services construction",
      "Pastoral and agricultural works",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Broome", "Fitzroy Crossing", "Halls Creek", "Kununurra", "Wyndham", "Camballin", "Looma", "Noonkanbah", "Mowanjum", "Gibb River"],
  },
  {
    slug: "halls-creek",
    suburb: "Halls Creek",
    state: "WA",
    postcode: "6770",
    council: "Shire of Halls Creek",
    keyRoads: ["Great Northern Highway", "Thomas Street", "Hall Street", "Roberta Avenue"],
    intro:
      "Halls Creek is a remote Kimberley town on the edge of the Tanami Desert, where mining infrastructure, essential services construction and remote area road works require traffic management plans compliant with Shire of Halls Creek and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Halls Creek-compliant TMPs for mining, essential services and road infrastructure projects in the remote Kimberley.",
    industries: [
      "Mining infrastructure",
      "Essential services construction",
      "Remote area road works",
      "Utility maintenance",
      "Health and community infrastructure",
    ],
    nearbySuburbs: ["Fitzroy Crossing", "Derby", "Broome", "Kununurra", "Wyndham", "Warmun", "Purnululu", "Ringer Soak", "Carranya", "Balgo"],
  },
  {
    slug: "kununurra",
    suburb: "Kununurra",
    state: "WA",
    postcode: "6743",
    council: "Shire of Wyndham-East Kimberley",
    keyRoads: ["Victoria Highway", "Konkerberry Drive", "Coolibah Drive", "Messmate Way"],
    intro:
      "Kununurra is the East Kimberley's major town and a significant agricultural and tourism hub near the Argyle diamond mine, where irrigation infrastructure, residential construction and tourism development require traffic management plans compliant with Shire of Wyndham-East Kimberley and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kununurra agricultural, tourism and residential projects in the remote East Kimberley.",
    industries: [
      "Agricultural and irrigation infrastructure",
      "Tourism and hospitality development",
      "Mining support infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Wyndham", "Halls Creek", "Derby", "Broome", "Katherine", "Darwin", "Kalumburu", "Lake Argyle", "El Questro", "Warmun"],
  },
  {
    slug: "wyndham",
    suburb: "Wyndham",
    state: "WA",
    postcode: "6740",
    council: "Shire of Wyndham-East Kimberley",
    keyRoads: ["Great Northern Highway", "O'Donnell Street", "Kimberley Street", "Barker Street"],
    intro:
      "Wyndham is one of Australia's most remote port towns, the northernmost port in WA and gateway to the East Kimberley, where port infrastructure, pastoral support and essential services works require traffic management plans compliant with Shire of Wyndham-East Kimberley and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Wyndham-East Kimberley-compliant TMPs for port, pastoral and essential services projects in the remote Kimberley.",
    industries: [
      "Port and pastoral infrastructure",
      "Essential services construction",
      "Remote area road works",
      "Utility maintenance",
      "Health and community infrastructure",
    ],
    nearbySuburbs: ["Kununurra", "Halls Creek", "Derby", "Broome", "Katherine", "Darwin", "Kalumburu", "Lake Argyle", "El Questro", "Durack"],
  },

  // ─── WESTERN AUSTRALIA (further additions) ────────────────────────────────

  // Perth CBD & Inner (additional)
  {
    slug: "burswood",
    suburb: "Burswood",
    state: "WA",
    postcode: "6100",
    council: "City of Belmont",
    keyRoads: ["Great Eastern Highway", "Graham Farmer Freeway", "Victoria Park Drive", "Burswood Road"],
    intro:
      "Burswood is home to Crown Perth casino resort and is adjacent to Optus Stadium, where major hotel construction, entertainment venue works and residential development require traffic management plans compliant with City of Belmont and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Belmont-compliant TMPs for Burswood resort, stadium and residential projects.",
    industries: ["Hotel and resort construction", "Stadium and entertainment infrastructure", "Residential development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Victoria Park", "East Perth", "Rivervale", "Belmont", "Carlisle", "South Perth", "Lathlain", "Perth CBD", "St James", "Welshpool"],
  },
  {
    slug: "crawley",
    suburb: "Crawley",
    state: "WA",
    postcode: "6009",
    council: "City of Nedlands",
    keyRoads: ["Hackett Drive", "Fairway", "Mounts Bay Road", "Stirling Highway"],
    intro:
      "Crawley is home to the University of Western Australia's main campus on the Swan River foreshore, where university construction, research facility development and residential works require traffic management plans compliant with City of Nedlands and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Crawley university and residential projects.",
    industries: ["University and education construction", "Research facility development", "Residential construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Nedlands", "Subiaco", "Shenton Park", "West Perth", "Matilda Bay", "Claremont", "Hollywood", "Floreat", "Jolimont", "Kings Park"],
  },
  {
    slug: "highgate",
    suburb: "Highgate",
    state: "WA",
    postcode: "6003",
    council: "City of Vincent",
    keyRoads: ["Lord Street", "Walcott Street", "Beaufort Street", "Fitzgerald Street"],
    intro:
      "Highgate is an inner Perth suburb adjacent to the CBD where high-density residential development and commercial construction require traffic management plans compliant with City of Vincent and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Vincent-compliant TMPs for Highgate residential and commercial projects.",
    industries: ["High-density residential development", "Commercial construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Northbridge", "Mount Lawley", "North Perth", "East Perth", "Perth CBD", "Inglewood", "Maylands", "Leederville", "West Leederville", "Jolimont"],
  },
  {
    slug: "inglewood",
    suburb: "Inglewood",
    state: "WA",
    postcode: "6052",
    council: "City of Stirling",
    keyRoads: ["Beaufort Street", "Walter Road", "Ninth Avenue", "Tenth Avenue"],
    intro:
      "Inglewood is a popular inner-northern Perth suburb with a vibrant Beaufort Street café and retail strip, where residential construction and commercial fitouts require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Inglewood residential and commercial projects on the Beaufort Street corridor.",
    industries: ["Residential construction", "Retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Mount Lawley", "Maylands", "Dianella", "Morley", "Joondanna", "Nollamara", "Bedford", "Noranda", "Yokine", "North Perth"],
  },
  {
    slug: "jolimont",
    suburb: "Jolimont",
    state: "WA",
    postcode: "6014",
    council: "Town of Cambridge",
    keyRoads: ["Havelock Street", "Loftus Street", "Cambridge Street", "Ruislip Street"],
    intro:
      "Jolimont is a small inner Perth suburb where residential construction and utility works require traffic management plans compliant with Town of Cambridge and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Cambridge-compliant TMPs for Jolimont residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Wembley", "Subiaco", "West Leederville", "Shenton Park", "West Perth", "Floreat", "Leederville", "City Beach", "Churchlands", "North Perth"],
  },
  {
    slug: "maylands",
    suburb: "Maylands",
    state: "WA",
    postcode: "6051",
    council: "City of Bayswater",
    keyRoads: ["Guildford Road", "Eighth Avenue", "Whatley Crescent", "Peninsula Road"],
    intro:
      "Maylands is a vibrant inner-northern suburb on the Swan River, known for its Eighth Avenue café strip, where residential construction and boutique commercial fitouts require traffic management plans compliant with City of Bayswater and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Maylands residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Mount Lawley", "Inglewood", "Bayswater", "Morley", "Ascot", "Bedford", "Noranda", "Highgate", "Joondanna", "Dianella"],
  },
  {
    slug: "mount-lawley",
    suburb: "Mount Lawley",
    state: "WA",
    postcode: "6050",
    council: "City of Stirling",
    keyRoads: ["Beaufort Street", "Walcott Street", "Lord Street", "Guildford Road"],
    intro:
      "Mount Lawley is one of Perth's most prestigious inner suburbs, with a vibrant Beaufort Street strip, where residential construction and boutique commercial development require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Mount Lawley residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Inglewood", "Maylands", "North Perth", "Highgate", "Northbridge", "Morley", "Dianella", "Bedford", "Joondanna", "Yokine"],
  },
  {
    slug: "north-perth",
    suburb: "North Perth",
    state: "WA",
    postcode: "6006",
    council: "City of Vincent",
    keyRoads: ["Charles Street", "Fitzgerald Street", "Angove Street", "Buxton Street"],
    intro:
      "North Perth is an inner suburb with a lively café and arts precinct on Angove Street, where residential construction and boutique commercial development require traffic management plans compliant with City of Vincent and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for North Perth residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Leederville", "Mount Hawthorn", "Northbridge", "Mount Lawley", "Highgate", "Inglewood", "Joondanna", "Nollamara", "Yokine", "Perth CBD"],
  },
  {
    slug: "south-fremantle",
    suburb: "South Fremantle",
    state: "WA",
    postcode: "6162",
    council: "City of Fremantle",
    keyRoads: ["South Terrace", "Hampton Road", "Carrington Street", "Cockburn Road"],
    intro:
      "South Fremantle is a vibrant beachside suburb south of Fremantle, where residential construction, foreshore development and boutique commercial works require traffic management plans compliant with City of Fremantle and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Fremantle-compliant TMPs for South Fremantle residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Boutique retail and hospitality fitouts", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Fremantle", "Hamilton Hill", "Spearwood", "Beaconsfield", "White Gum Valley", "Hilton", "O'Connor", "Munster", "Coolbellup", "North Coogee"],
  },
  {
    slug: "west-leederville",
    suburb: "West Leederville",
    state: "WA",
    postcode: "6007",
    council: "Town of Cambridge",
    keyRoads: ["Cambridge Street", "Southport Street", "Railway Parade", "Harbourne Street"],
    intro:
      "West Leederville is an inner Perth suburb where residential construction and boutique commercial development require traffic management plans compliant with Town of Cambridge and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for West Leederville residential and commercial projects.",
    industries: ["Residential construction", "Boutique commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Leederville", "Jolimont", "Wembley", "Subiaco", "Shenton Park", "North Perth", "Mount Hawthorn", "Floreat", "West Perth", "Churchlands"],
  },
  // Northern Perth (additional)
  {
    slug: "alkimos",
    suburb: "Alkimos",
    state: "WA",
    postcode: "6038",
    council: "City of Wanneroo",
    keyRoads: ["Marmion Avenue", "Lukin Drive", "Shorehaven Boulevard", "Connolly Drive"],
    intro:
      "Alkimos is a rapidly growing coastal suburb north of Perth where large residential estate construction and associated civil infrastructure create demand for traffic management documentation compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Wanneroo-compliant TMPs for Alkimos residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Eglinton", "Yanchep", "Merriwa", "Clarkson", "Butler", "Mindarie", "Quinns Rocks", "Two Rocks", "Neerabup", "Nowergup"],
  },
  {
    slug: "balcatta",
    suburb: "Balcatta",
    state: "WA",
    postcode: "6021",
    council: "City of Stirling",
    keyRoads: ["Balcatta Road", "Scarborough Beach Road", "Wanneroo Road", "Main Street"],
    intro:
      "Balcatta is a major light industrial and commercial suburb in northern Perth where industrial construction, warehouse development and commercial works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Balcatta light industrial and commercial projects.",
    industries: ["Light industrial and warehouse development", "Commercial construction", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Osborne Park", "Nollamara", "Mirrabooka", "Tuart Hill", "Innaloo", "Stirling", "Herdsman", "Gwelup", "Dianella", "Yokine"],
  },
  {
    slug: "balga",
    suburb: "Balga",
    state: "WA",
    postcode: "6061",
    council: "City of Stirling",
    keyRoads: ["Mirrabooka Avenue", "Balga Avenue", "Marangaroo Drive", "Beach Road"],
    intro:
      "Balga is a northern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Balga residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Mirrabooka", "Nollamara", "Koondoola", "Girrawheen", "Westminster", "Dianella", "Morley", "Noranda", "Beechboro", "Yokine"],
  },
  {
    slug: "ballajura",
    suburb: "Ballajura",
    state: "WA",
    postcode: "6066",
    council: "City of Swan",
    keyRoads: ["West Swan Road", "Reid Highway", "Gnangara Road", "Benara Road"],
    intro:
      "Ballajura is a northern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Swan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ballajura residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Beechboro", "Morley", "Noranda", "Dianella", "Ellenbrook", "Caversham", "Dayton", "Brabham", "Bennett Springs", "Malaga"],
  },
  {
    slug: "beechboro",
    suburb: "Beechboro",
    state: "WA",
    postcode: "6063",
    council: "City of Swan",
    keyRoads: ["Beechboro Road", "Benara Road", "Reid Highway", "Walter Road"],
    intro:
      "Beechboro is a northern Perth suburb where residential construction and light industrial development require traffic management plans compliant with City of Swan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Swan-compliant TMPs for Beechboro residential and industrial projects.",
    industries: ["Residential construction", "Light industrial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Morley", "Noranda", "Ballajura", "Dianella", "Embleton", "Eden Hill", "Bassendean", "Bayswater", "Midland", "Bennett Springs"],
  },
  {
    slug: "beldon",
    suburb: "Beldon",
    state: "WA",
    postcode: "6027",
    council: "City of Joondalup",
    keyRoads: ["Shenton Avenue", "Canham Way", "Beldon Drive", "Lakelands Drive"],
    intro:
      "Beldon is a residential suburb in Joondalup City where residential construction and utility works require traffic management plans compliant with City of Joondalup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Beldon residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Heathridge", "Ocean Reef", "Kingsley", "Greenwood", "Padbury", "Craigie", "Woodvale", "Edgewater", "Hillarys", "Kallaroo"],
  },
  {
    slug: "butler",
    suburb: "Butler",
    state: "WA",
    postcode: "6036",
    council: "City of Wanneroo",
    keyRoads: ["Marmion Avenue", "Lukin Drive", "Connolly Drive", "Butler Boulevard"],
    intro:
      "Butler is a fast-growing northern coastal suburb in Perth where residential estate construction and retail development create demand for traffic management plans compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Wanneroo-compliant TMPs for Butler residential and commercial projects.",
    industries: ["Residential subdivision and housing", "Retail and commercial development", "Utility maintenance", "Road and civil construction", "Community infrastructure"],
    nearbySuburbs: ["Alkimos", "Clarkson", "Merriwa", "Ridgewood", "Mindarie", "Quinns Rocks", "Eglinton", "Two Rocks", "Neerabup", "Banksia Grove"],
  },
  {
    slug: "clarkson",
    suburb: "Clarkson",
    state: "WA",
    postcode: "6030",
    council: "City of Wanneroo",
    keyRoads: ["Marmion Avenue", "Ocean Keys Boulevard", "Connolly Drive", "Neerabup Road"],
    intro:
      "Clarkson is a major northern Perth activity centre anchored by Ocean Keys Shopping Centre, where retail construction and residential development create demand for traffic management plans compliant with City of Wanneroo requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Clarkson retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Butler", "Merriwa", "Mindarie", "Quinns Rocks", "Ridgewood", "Banksia Grove", "Neerabup", "Alkimos", "Eglinton", "Wanneroo"],
  },
  {
    slug: "dianella",
    suburb: "Dianella",
    state: "WA",
    postcode: "6059",
    council: "City of Stirling",
    keyRoads: ["Morley Drive", "Walter Road", "Grand Promenade", "Eddystone Avenue"],
    intro:
      "Dianella is a large northern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Dianella residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Morley", "Noranda", "Inglewood", "Bedford", "Yokine", "Nollamara", "Balga", "Mirrabooka", "Beechboro", "Bayswater"],
  },
  {
    slug: "greenwood",
    suburb: "Greenwood",
    state: "WA",
    postcode: "6024",
    council: "City of Joondalup",
    keyRoads: ["Warwick Road", "Beach Road", "Erindale Road", "Greenwood Drive"],
    intro:
      "Greenwood is a residential suburb in the northern suburbs where residential construction and utility works require traffic management plans compliant with City of Joondalup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Greenwood residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Warwick", "Kingsley", "Craigie", "Woodvale", "Padbury", "Beldon", "Heathridge", "Duncraig", "Carine", "Karrinyup"],
  },
  {
    slug: "heathridge",
    suburb: "Heathridge",
    state: "WA",
    postcode: "6027",
    council: "City of Joondalup",
    keyRoads: ["Ocean Reef Road", "Shenton Avenue", "Canham Way", "Mullaloo Drive"],
    intro:
      "Heathridge is a residential suburb in northern Perth where residential construction and utility works require traffic management plans compliant with City of Joondalup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Joondalup-compliant TMPs for Heathridge residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Beldon", "Ocean Reef", "Mullaloo", "Kingsley", "Greenwood", "Padbury", "Craigie", "Woodvale", "Connolly", "Edgewater"],
  },
  {
    slug: "hillarys",
    suburb: "Hillarys",
    state: "WA",
    postcode: "6025",
    council: "City of Joondalup",
    keyRoads: ["West Coast Drive", "Whitfords Avenue", "Hillarys Beach Road", "Hodges Drive"],
    intro:
      "Hillarys is a popular coastal suburb home to Hillarys Boat Harbour, where residential construction, marina development and coastal works require traffic management plans compliant with City of Joondalup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hillarys residential and marina projects.",
    industries: ["Residential construction", "Marina and coastal works", "Tourism and hospitality development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Sorrento", "Padbury", "Craigie", "Woodvale", "Beldon", "Ocean Reef", "Connolly", "Kallaroo", "Whitfords", "Joondalup"],
  },
  {
    slug: "innaloo",
    suburb: "Innaloo",
    state: "WA",
    postcode: "6018",
    council: "City of Stirling",
    keyRoads: ["Scarborough Beach Road", "Karrinyup Road", "Ellen Stirling Boulevard", "Oswald Street"],
    intro:
      "Innaloo is a major retail hub in northern Perth, anchored by Westfield Innaloo, where retail construction and residential development require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Innaloo retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Osborne Park", "Balcatta", "Stirling", "Karrinyup", "Gwelup", "Hamersley", "Woodlands", "Churchlands", "Scarborough", "Doubleview"],
  },
  {
    slug: "karrinyup",
    suburb: "Karrinyup",
    state: "WA",
    postcode: "6018",
    council: "City of Stirling",
    keyRoads: ["Karrinyup Road", "Scarborough Beach Road", "West Coast Drive", "Cape Peron Drive"],
    intro:
      "Karrinyup is home to the recently expanded Karrinyup Shopping Centre and a sought-after coastal residential suburb, where retail construction and residential development require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Karrinyup retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Innaloo", "Scarborough", "Trigg", "North Beach", "Doubleview", "Carine", "Hamersley", "Gwelup", "Duncraig", "Stirling"],
  },
  {
    slug: "kingsley",
    suburb: "Kingsley",
    state: "WA",
    postcode: "6026",
    council: "City of Joondalup",
    keyRoads: ["Wanneroo Road", "Kingsley Drive", "Erindale Road", "Trappers Drive"],
    intro:
      "Kingsley is a residential suburb in northern Perth where residential construction and utility works require traffic management plans compliant with City of Joondalup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Joondalup-compliant TMPs for Kingsley residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Greenwood", "Warwick", "Woodvale", "Craigie", "Padbury", "Beldon", "Heathridge", "Duncraig", "Carine", "Karrinyup"],
  },
  {
    slug: "landsdale",
    suburb: "Landsdale",
    state: "WA",
    postcode: "6065",
    council: "City of Wanneroo",
    keyRoads: ["Gnangara Road", "Landsdale Road", "Hartman Drive", "Mirrabooka Avenue"],
    intro:
      "Landsdale is a growing northern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Landsdale residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Wangara", "Tapping", "Sinagra", "Nollamara", "Balga", "Mirrabooka", "Westminster", "Girrawheen", "Koondoola", "Alexander Heights"],
  },
  {
    slug: "mirrabooka",
    suburb: "Mirrabooka",
    state: "WA",
    postcode: "6061",
    council: "City of Stirling",
    keyRoads: ["Mirrabooka Avenue", "Alexander Drive", "Yirrigan Drive", "Marangaroo Drive"],
    intro:
      "Mirrabooka is a diverse northern Perth suburb anchored by Mirrabooka Square, where retail construction and residential development require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Mirrabooka retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Balga", "Nollamara", "Koondoola", "Girrawheen", "Westminster", "Alexander Heights", "Landsdale", "Dianella", "Tuart Hill", "Yokine"],
  },
  {
    slug: "scarborough",
    suburb: "Scarborough",
    state: "WA",
    postcode: "6019",
    council: "City of Stirling",
    keyRoads: ["West Coast Highway", "Scarborough Beach Road", "Vickery Street", "Manning Street"],
    intro:
      "Scarborough is Perth's major beachside entertainment and residential precinct, recently transformed by the Scarborough Beach Redevelopment, where coastal residential construction, hotel development and foreshore works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Scarborough coastal residential, hotel and foreshore projects.",
    industries: ["Coastal residential development", "Hotel and hospitality construction", "Foreshore and coastal works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Doubleview", "Innaloo", "Karrinyup", "Trigg", "North Beach", "Wembley Downs", "Churchlands", "Floreat", "City Beach", "Gwelup"],
  },
  {
    slug: "stirling-wa",
    suburb: "Stirling",
    state: "WA",
    postcode: "6021",
    council: "City of Stirling",
    keyRoads: ["Scarborough Beach Road", "Balcatta Road", "Beach Road", "Stephenson Avenue"],
    intro:
      "Stirling is a northern Perth suburb and the administrative centre of the City of Stirling, where residential construction and commercial development require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Stirling residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Balcatta", "Osborne Park", "Innaloo", "Nollamara", "Tuart Hill", "Hamersley", "Karrinyup", "Gwelup", "Yokine", "Dianella"],
  },
  {
    slug: "thornlie",
    suburb: "Thornlie",
    state: "WA",
    postcode: "6108",
    council: "City of Gosnells",
    keyRoads: ["Spencer Road", "Warton Road", "Carousel Road", "Nicholson Road"],
    intro:
      "Thornlie is a major southern Perth suburb home to Westfield Carousel, where retail construction and residential development require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Thornlie retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Gosnells", "Maddington", "Kenwick", "Orange Grove", "Huntingdale", "Canning Vale", "Southern River", "Parkwood", "Beckenham", "Queens Park"],
  },
  {
    slug: "two-rocks",
    suburb: "Two Rocks",
    state: "WA",
    postcode: "6037",
    council: "City of Wanneroo",
    keyRoads: ["Marmion Avenue", "Yanchep Beach Road", "Two Rocks Road", "Breakwater Drive"],
    intro:
      "Two Rocks is a coastal township at the northern edge of Perth's urban area where residential construction and marina development require traffic management plans compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Wanneroo-compliant TMPs for Two Rocks residential and marina projects.",
    industries: ["Residential construction", "Marina and coastal works", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Yanchep", "Alkimos", "Eglinton", "Butler", "Clarkson", "Quinns Rocks", "Mindarie", "Merriwa", "Neerabup", "Nowergup"],
  },
  {
    slug: "wangara",
    suburb: "Wangara",
    state: "WA",
    postcode: "6065",
    council: "City of Wanneroo",
    keyRoads: ["Gnangara Road", "Prindiville Drive", "Enterprise Avenue", "Dellamarta Road"],
    intro:
      "Wangara is Perth's major northern industrial and logistics estate, where warehouse construction, industrial development and commercial works require traffic management plans compliant with City of Wanneroo and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wangara industrial and logistics projects.",
    industries: ["Industrial and logistics construction", "Warehouse development", "Commercial construction", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Landsdale", "Sinagra", "Tapping", "Wanneroo", "Neerabup", "Carramar", "Banksia Grove", "Alexander Heights", "Gnangara", "Mirrabooka"],
  },
  {
    slug: "yokine",
    suburb: "Yokine",
    state: "WA",
    postcode: "6060",
    council: "City of Stirling",
    keyRoads: ["Wanneroo Road", "Flinders Street", "Yokine Avenue", "Tuart Road"],
    intro:
      "Yokine is an established northern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Stirling and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Stirling-compliant TMPs for Yokine residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Dianella", "Morley", "Nollamara", "Inglewood", "Tuart Hill", "Balga", "Mount Lawley", "Mirrabooka", "Joondanna", "Bedford"],
  },
  // Southern Perth (additional)
  {
    slug: "atwell",
    suburb: "Atwell",
    state: "WA",
    postcode: "6164",
    council: "City of Cockburn",
    keyRoads: ["Beeliar Drive", "Spearwood Avenue", "Hammond Road", "Packard Avenue"],
    intro:
      "Atwell is a residential suburb in the City of Cockburn where residential construction and utility works require traffic management plans compliant with City of Cockburn and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Atwell residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Success", "Jandakot", "Cockburn Central", "Yangebup", "Bibra Lake", "Hamilton Hill", "Coolbellup", "Munster", "Spearwood", "South Lake"],
  },
  {
    slug: "baldivis",
    suburb: "Baldivis",
    state: "WA",
    postcode: "6171",
    council: "City of Rockingham",
    keyRoads: ["Baldivis Road", "Nairn Drive", "Safety Bay Road", "Sixty Eight Road"],
    intro:
      "Baldivis is one of Perth's fastest-growing outer southern suburbs where large residential estate construction and associated civil infrastructure create strong demand for traffic management documentation compliant with City of Rockingham and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Rockingham-compliant TMPs for Baldivis residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Rockingham", "Secret Harbour", "Golden Bay", "Singleton", "Port Kennedy", "Safety Bay", "Warnbro", "Wellard", "Kwinana", "Bertram"],
  },
  {
    slug: "brentwood",
    suburb: "Brentwood",
    state: "WA",
    postcode: "6153",
    council: "City of Melville",
    keyRoads: ["Leach Highway", "Murdoch Drive", "South Street", "Bull Creek Drive"],
    intro:
      "Brentwood is a residential suburb in the City of Melville where residential construction and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Brentwood residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Bull Creek", "Murdoch", "Kardinya", "Winthrop", "Leeming", "Booragoon", "Myaree", "Willagee", "Palmyra", "Applecross"],
  },
  {
    slug: "bull-creek",
    suburb: "Bull Creek",
    state: "WA",
    postcode: "6149",
    council: "City of Melville",
    keyRoads: ["South Street", "Leach Highway", "Bull Creek Drive", "Farrington Road"],
    intro:
      "Bull Creek is a southern Perth suburb where residential construction and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melville-compliant TMPs for Bull Creek residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Murdoch", "Brentwood", "Winthrop", "Kardinya", "Leeming", "Willagee", "Booragoon", "Myaree", "South Lake", "Bibra Lake"],
  },
  {
    slug: "byford",
    suburb: "Byford",
    state: "WA",
    postcode: "6122",
    council: "Shire of Serpentine-Jarrahdale",
    keyRoads: ["South Western Highway", "Abernethy Road", "Thomas Road", "Orton Road"],
    intro:
      "Byford is a rapidly growing outer southern suburb where large residential estate construction creates demand for traffic management plans compliant with Shire of Serpentine-Jarrahdale and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Byford residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Armadale", "Mundijong", "Oakford", "Cardup", "Karrakup", "Darling Downs", "Kelmscott", "Bedfordale", "Roleystone", "Serpentine"],
  },
  {
    slug: "canning-vale",
    suburb: "Canning Vale",
    state: "WA",
    postcode: "6155",
    council: "City of Gosnells",
    keyRoads: ["Ranford Road", "Nicholson Road", "Warton Road", "Livingstone Road"],
    intro:
      "Canning Vale is a major southern Perth residential suburb and industrial area, where residential construction, warehouse development and commercial works require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Gosnells-compliant TMPs for Canning Vale residential and industrial projects.",
    industries: ["Residential construction", "Industrial and logistics development", "Commercial construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Thornlie", "Southern River", "Parkwood", "Jandakot", "Atwell", "Success", "Harrisdale", "Piara Waters", "Gosnells", "Huntingdale"],
  },
  {
    slug: "harrisdale",
    suburb: "Harrisdale",
    state: "WA",
    postcode: "6112",
    council: "City of Armadale",
    keyRoads: ["Armadale Road", "Ranford Road", "Harrisdale Drive", "Nicholson Road"],
    intro:
      "Harrisdale is a growing outer southern suburb where residential estate construction requires traffic management plans compliant with City of Armadale and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Harrisdale residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Piara Waters", "Southern River", "Canning Vale", "Haynes", "Brookdale", "Forrestdale", "Armadale", "Hilbert", "Wungong", "Kelmscott"],
  },
  {
    slug: "jandakot",
    suburb: "Jandakot",
    state: "WA",
    postcode: "6164",
    council: "City of Cockburn",
    keyRoads: ["Jandakot Road", "Beeliar Drive", "Karel Avenue", "Patterson Road"],
    intro:
      "Jandakot is home to Jandakot Airport and a significant industrial estate, where aviation-related construction, industrial development and residential works require traffic management plans compliant with City of Cockburn and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Cockburn-compliant TMPs for Jandakot aviation, industrial and residential projects.",
    industries: ["Aviation and airport infrastructure", "Industrial and logistics development", "Residential construction", "Utility maintenance", "Road and access construction"],
    nearbySuburbs: ["Atwell", "Success", "Cockburn Central", "Yangebup", "Bibra Lake", "Banjup", "South Lake", "Hammond Park", "Wattleup", "Munster"],
  },
  {
    slug: "kenwick",
    suburb: "Kenwick",
    state: "WA",
    postcode: "6107",
    council: "City of Gosnells",
    keyRoads: ["Albany Highway", "Roe Highway", "Kenwick Road", "Stanton Road"],
    intro:
      "Kenwick is a light industrial and residential suburb in southern Perth where industrial construction and residential development require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kenwick industrial and residential projects.",
    industries: ["Light industrial and commercial construction", "Residential development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Maddington", "Gosnells", "Orange Grove", "Thornlie", "Canning Vale", "Beckenham", "Queens Park", "Welshpool", "East Cannington", "Huntingdale"],
  },
  {
    slug: "maddington",
    suburb: "Maddington",
    state: "WA",
    postcode: "6109",
    council: "City of Gosnells",
    keyRoads: ["Burslem Drive", "Kelvin Road", "Spencer Road", "Albany Highway"],
    intro:
      "Maddington is a major light industrial suburb in southern Perth where industrial construction, commercial development and residential works require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Gosnells-compliant TMPs for Maddington industrial and residential projects.",
    industries: ["Light industrial and commercial construction", "Residential development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Kenwick", "Gosnells", "Orange Grove", "Thornlie", "Martin", "Canning Vale", "Huntingdale", "Southern River", "Beckenham", "Queens Park"],
  },
  {
    slug: "piara-waters",
    suburb: "Piara Waters",
    state: "WA",
    postcode: "6112",
    council: "City of Armadale",
    keyRoads: ["Armadale Road", "Ranford Road", "Piara Waters Drive", "Haynes Road"],
    intro:
      "Piara Waters is one of Perth's fastest-growing outer southern suburbs where large residential estate construction creates strong demand for traffic management documentation compliant with City of Armadale and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Piara Waters residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Harrisdale", "Southern River", "Canning Vale", "Haynes", "Forrestdale", "Armadale", "Hilbert", "Brookdale", "Wungong", "Kelmscott"],
  },
  {
    slug: "secret-harbour",
    suburb: "Secret Harbour",
    state: "WA",
    postcode: "6173",
    council: "City of Rockingham",
    keyRoads: ["Secret Harbour Boulevard", "Ocean Drive", "Nautical Way", "Stately Drive"],
    intro:
      "Secret Harbour is a coastal master-planned suburb in the City of Rockingham where residential construction and coastal infrastructure works require traffic management plans compliant with City of Rockingham and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Rockingham-compliant TMPs for Secret Harbour residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Golden Bay", "Singleton", "Baldivis", "Port Kennedy", "Safety Bay", "Warnbro", "Rockingham", "Kwinana", "Wellard", "Bertram"],
  },
  {
    slug: "southern-river",
    suburb: "Southern River",
    state: "WA",
    postcode: "6110",
    council: "City of Gosnells",
    keyRoads: ["Ranford Road", "Southern River Road", "Nicholson Road", "Warton Road"],
    intro:
      "Southern River is a growing outer southern suburb where residential estate construction and commercial development require traffic management plans compliant with City of Gosnells and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Southern River residential and commercial projects.",
    industries: ["Residential subdivision and housing", "Commercial development", "Utility maintenance", "Road and civil construction", "Council infrastructure works"],
    nearbySuburbs: ["Canning Vale", "Thornlie", "Harrisdale", "Piara Waters", "Gosnells", "Maddington", "Huntingdale", "Parkwood", "Kenwick", "Orange Grove"],
  },
  {
    slug: "success",
    suburb: "Success",
    state: "WA",
    postcode: "6164",
    council: "City of Cockburn",
    keyRoads: ["Beeliar Drive", "Armadale Road", "Wentworth Parade", "Success Drive"],
    intro:
      "Success is a residential suburb in the City of Cockburn where residential construction and utility works require traffic management plans compliant with City of Cockburn and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Cockburn-compliant TMPs for Success residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Atwell", "Jandakot", "Cockburn Central", "Yangebup", "Hammond Park", "Bibra Lake", "South Lake", "Banjup", "Munster", "Spearwood"],
  },
  {
    slug: "wellard",
    suburb: "Wellard",
    state: "WA",
    postcode: "6170",
    council: "City of Kwinana",
    keyRoads: ["Thomas Road", "Anstey Road", "Bertram Road", "Mortimer Road"],
    intro:
      "Wellard is a fast-growing residential suburb in the City of Kwinana where residential estate construction creates demand for traffic management plans compliant with City of Kwinana and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wellard residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Baldivis", "Kwinana", "Bertram", "Hope Valley", "Parmelia", "Leda", "Casuarina", "Wandi", "Anketell", "Rockingham"],
  },
  // Western Suburbs (additional)
  {
    slug: "applecross",
    suburb: "Applecross",
    state: "WA",
    postcode: "6153",
    council: "City of Melville",
    keyRoads: ["Canning Highway", "Ardross Street", "Riseley Street", "Kearns Crescent"],
    intro:
      "Applecross is a prestigious riverside suburb in the City of Melville where luxury residential construction and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melville-compliant TMPs for Applecross luxury residential and infrastructure projects.",
    industries: ["Luxury residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Ardross", "Mount Pleasant", "Booragoon", "Myaree", "Attadale", "Brentwood", "Melville", "Palmyra", "Bicton", "South Perth"],
  },
  {
    slug: "attadale",
    suburb: "Attadale",
    state: "WA",
    postcode: "6156",
    council: "City of Melville",
    keyRoads: ["Canning Highway", "Stock Road", "Attadale Road", "San Souci Road"],
    intro:
      "Attadale is an established riverside suburb in the City of Melville where residential construction and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Attadale residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Applecross", "Palmyra", "Melville", "Bicton", "Myaree", "Booragoon", "Riverton", "Willagee", "Mount Pleasant", "South Perth"],
  },
  {
    slug: "bicton",
    suburb: "Bicton",
    state: "WA",
    postcode: "6157",
    council: "City of Melville",
    keyRoads: ["Canning Highway", "Point Walter Road", "Dell Road", "Clive Street"],
    intro:
      "Bicton is a leafy riverside suburb in the City of Melville where residential construction and utility works require traffic management plans compliant with City of Melville and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Melville-compliant TMPs for Bicton residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Attadale", "Palmyra", "East Fremantle", "Fremantle", "Hilton", "Beaconsfield", "Willagee", "Melville", "Applecross", "Booragoon"],
  },
  {
    slug: "city-beach",
    suburb: "City Beach",
    state: "WA",
    postcode: "6015",
    council: "Town of Cambridge",
    keyRoads: ["Oceanic Drive", "Challenger Parade", "Kirkdale Drive", "Floreat Avenue"],
    intro:
      "City Beach is a prestigious coastal suburb in the Town of Cambridge where luxury residential construction and coastal works require traffic management plans compliant with Town of Cambridge and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for City Beach luxury residential and coastal projects.",
    industries: ["Luxury residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Floreat", "Wembley", "Churchlands", "Scarborough", "Swanbourne", "Claremont", "Jolimont", "West Leederville", "Doubleview", "Innaloo"],
  },
  {
    slug: "dalkeith",
    suburb: "Dalkeith",
    state: "WA",
    postcode: "6009",
    council: "City of Nedlands",
    keyRoads: ["Dalkeith Road", "Waratah Avenue", "Victoria Avenue", "Stirling Highway"],
    intro:
      "Dalkeith is one of Perth's most exclusive residential suburbs on the Swan River, where luxury residential construction and heritage building works require traffic management plans compliant with City of Nedlands and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Nedlands-compliant TMPs for Dalkeith luxury residential and heritage projects.",
    industries: ["Luxury residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Nedlands", "Claremont", "Swanbourne", "Crawley", "Floreat", "Matilda Bay", "Hollywood", "Peppermint Grove", "Karrakatta", "Mount Claremont"],
  },
  {
    slug: "karrakatta",
    suburb: "Karrakatta",
    state: "WA",
    postcode: "6010",
    council: "Town of Claremont",
    keyRoads: ["Railway Road", "Stubbs Terrace", "Stirling Highway", "Dodd Street"],
    intro:
      "Karrakatta is a small residential suburb in the western suburbs where residential construction and utility works require traffic management plans compliant with Town of Claremont and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Karrakatta residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Claremont", "Swanbourne", "Shenton Park", "Nedlands", "Dalkeith", "Mount Claremont", "Floreat", "Hollywood", "West Leederville", "Jolimont"],
  },
  {
    slug: "wembley",
    suburb: "Wembley",
    state: "WA",
    postcode: "6014",
    council: "Town of Cambridge",
    keyRoads: ["Cambridge Street", "Harborne Street", "Salvado Road", "Grantham Street"],
    intro:
      "Wembley is a popular inner western suburb adjacent to Wembley Golf Course where residential construction and utility works require traffic management plans compliant with Town of Cambridge and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Cambridge-compliant TMPs for Wembley residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Jolimont", "Floreat", "Subiaco", "Churchlands", "City Beach", "West Leederville", "Leederville", "Shenton Park", "Mount Hawthorn", "West Perth"],
  },
  // Bunbury & South West (additional)
  {
    slug: "capel",
    suburb: "Capel",
    state: "WA",
    postcode: "6271",
    council: "Shire of Capel",
    keyRoads: ["Forrest Highway", "Capel Drive", "Carpenters Road", "Burekup Road"],
    intro:
      "Capel is a mineral sands mining town and growing residential community south of Bunbury, where mining infrastructure, residential construction and utility works require traffic management plans compliant with Shire of Capel and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Capel mining and residential projects.",
    industries: ["Mining and mineral sands infrastructure", "Residential construction", "Utility maintenance", "Road and civil construction", "Council infrastructure works"],
    nearbySuburbs: ["Bunbury", "Australind", "Eaton", "Dalyellup", "Gelorup", "Boyanup", "Donnybrook", "Harvey", "Busselton", "Collie"],
  },
  {
    slug: "eaton",
    suburb: "Eaton",
    state: "WA",
    postcode: "6232",
    council: "Shire of Dardanup",
    keyRoads: ["South Western Highway", "Eaton Drive", "Recreation Drive", "Old Coast Road"],
    intro:
      "Eaton is a growing residential suburb north of Bunbury where residential estate construction and retail development create demand for traffic management plans compliant with Shire of Dardanup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Dardanup-compliant TMPs for Eaton residential and commercial projects.",
    industries: ["Residential subdivision and housing", "Retail and commercial development", "Utility maintenance", "Road and civil construction", "Council infrastructure works"],
    nearbySuburbs: ["Bunbury", "Australind", "Treendale", "Dalyellup", "Leschenault", "Australind", "Picton", "Usher", "Glen Iris", "Wollaston"],
  },
  {
    slug: "pemberton",
    suburb: "Pemberton",
    state: "WA",
    postcode: "6260",
    council: "Shire of Manjimup",
    keyRoads: ["Brockman Street", "Vasse Highway", "Karri Gully Road", "Kennedy Street"],
    intro:
      "Pemberton is a timber and eco-tourism town in the heart of WA's karri forest, where timber industry infrastructure, tourism development and residential construction require traffic management plans compliant with Shire of Manjimup and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Pemberton timber, tourism and residential projects.",
    industries: ["Timber and forestry infrastructure", "Tourism and eco-tourism development", "Residential construction", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Manjimup", "Northcliffe", "Walpole", "Quinninup", "Jardee", "Channybearup", "Donnelly River", "Beedelup", "Lake Muir", "Shannon"],
  },
  // Mid West
  {
    slug: "carnarvon",
    suburb: "Carnarvon",
    state: "WA",
    postcode: "6701",
    council: "Shire of Carnarvon",
    keyRoads: ["Robinson Street", "Olivia Terrace", "North West Coastal Highway", "Babbage Island Road"],
    intro:
      "Carnarvon is a major horticultural centre on the Gascoyne River and the gateway to the Coral Coast, where horticultural infrastructure, tourism construction and residential development require traffic management plans compliant with Shire of Carnarvon and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Carnarvon-compliant TMPs for horticultural, tourism and residential projects in the Gascoyne.",
    industries: ["Horticultural and agricultural infrastructure", "Tourism and hospitality construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Exmouth", "Denham", "Shark Bay", "Gascoyne Junction", "Minilya", "Coral Bay", "Meekatharra", "Mount Magnet", "Geraldton", "Karratha"],
  },
  {
    slug: "dongara",
    suburb: "Dongara",
    state: "WA",
    postcode: "6525",
    council: "Shire of Irwin",
    keyRoads: ["Moreton Terrace", "Point Leander Drive", "Waldeck Street", "Brand Highway"],
    intro:
      "Dongara is a heritage town and crayfish fishing centre south of Geraldton, where tourism infrastructure, fishing industry construction and residential development require traffic management plans compliant with Shire of Irwin and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dongara fishing industry, tourism and residential projects.",
    industries: ["Fishing and aquaculture infrastructure", "Tourism and hospitality construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Geraldton", "Mingenew", "Three Springs", "Northampton", "Eneabba", "Carnamah", "Jurien Bay", "Cervantes", "Leeman", "Green Head"],
  },
  {
    slug: "exmouth",
    suburb: "Exmouth",
    state: "WA",
    postcode: "6707",
    council: "Shire of Exmouth",
    keyRoads: ["Murat Road", "Learmonth Road", "Lefroy Street", "Madstone Street"],
    intro:
      "Exmouth is a remote coastal town on the North West Cape and gateway to the Ningaloo Reef, where tourism infrastructure, defence facility works and residential development require traffic management plans compliant with Shire of Exmouth and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Exmouth-compliant TMPs for tourism, defence and residential projects at Ningaloo.",
    industries: ["Tourism and resort construction", "Defence and naval infrastructure", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Coral Bay", "Carnarvon", "Karratha", "Dampier", "Onslow", "Tom Price", "Paraburdoo", "Learmonth", "Minilya", "Gascoyne Junction"],
  },
  {
    slug: "geraldton",
    suburb: "Geraldton",
    state: "WA",
    postcode: "6530",
    council: "City of Greater Geraldton",
    keyRoads: ["Marine Terrace", "Cathedral Avenue", "Durlacher Street", "North West Coastal Highway"],
    intro:
      "Geraldton is the major city of WA's Mid West and a significant port and lobster fishing hub, where port infrastructure, residential development, commercial construction and wind energy development create demand for traffic management plans compliant with City of Greater Geraldton and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Geraldton port, energy, residential and commercial projects in the Mid West.",
    industries: ["Port and fishing industry infrastructure", "Wind energy construction", "Residential development", "Commercial construction", "Road and civil construction"],
    nearbySuburbs: ["Beresford", "Spalding", "Wandina", "Strathalbyn", "Waggrakine", "Rangeway", "Mahomets Flats", "Drummond Cove", "Cape Burney", "Dongara"],
  },
  {
    slug: "jurien-bay",
    suburb: "Jurien Bay",
    state: "WA",
    postcode: "6516",
    council: "Shire of Dandaragan",
    keyRoads: ["Bashford Street", "Waramboo Street", "Roberts Street", "Brand Highway"],
    intro:
      "Jurien Bay is a coastal town in WA's Turquoise Coast, a growing tourist and residential destination, where coastal residential construction and tourism infrastructure require traffic management plans compliant with Shire of Dandaragan and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Dandaragan-compliant TMPs for Jurien Bay residential and tourism projects.",
    industries: ["Coastal residential construction", "Tourism and hospitality development", "Fishing industry infrastructure", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Cervantes", "Dongara", "Lancelin", "Leeman", "Green Head", "Eneabba", "Three Springs", "Badgingarra", "Brand", "Coorow"],
  },
  // Great Southern
  {
    slug: "albany",
    suburb: "Albany",
    state: "WA",
    postcode: "6330",
    council: "City of Albany",
    keyRoads: ["York Street", "Albany Highway", "Middleton Road", "Chester Pass Road"],
    intro:
      "Albany is the major city of WA's Great Southern region, a significant port city and one of Australia's most beautiful coastal destinations, where port infrastructure, residential development, tourism construction and commercial works create demand for traffic management plans compliant with City of Albany and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Albany port, residential and tourism projects in the Great Southern.",
    industries: ["Port and shipping infrastructure", "Residential development", "Tourism and hospitality construction", "Commercial construction", "Road and civil construction"],
    nearbySuburbs: ["Middleton Beach", "Emu Point", "Bayonet Head", "Mount Melville", "Centennial Park", "Yakamia", "Lockyer", "Kalgan", "Denmark", "Mount Barker"],
  },
  {
    slug: "denmark",
    suburb: "Denmark",
    state: "WA",
    postcode: "6333",
    council: "Shire of Denmark",
    keyRoads: ["South Coast Highway", "Strickland Street", "North Street", "Scotsdale Road"],
    intro:
      "Denmark is a beautiful coastal and forest town on the South Coast Highway, a popular tourist destination and lifestyle destination, where tourism infrastructure, residential construction and winery development require traffic management plans compliant with Shire of Denmark and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Denmark-compliant TMPs for tourism, residential and winery projects.",
    industries: ["Tourism and hospitality construction", "Winery and agricultural development", "Residential construction", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Albany", "Walpole", "Pemberton", "Mount Barker", "Manjimup", "Nornalup", "Peaceful Bay", "Ocean Beach", "Bow Bridge", "Parryville"],
  },
  {
    slug: "katanning",
    suburb: "Katanning",
    state: "WA",
    postcode: "6317",
    council: "Shire of Katanning",
    keyRoads: ["Clive Street", "Austral Terrace", "Amherst Street", "Great Southern Highway"],
    intro:
      "Katanning is the major service centre of the southern Wheatbelt and an important multicultural agricultural hub, where agricultural infrastructure, residential development and commercial construction require traffic management plans compliant with Shire of Katanning and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Katanning agricultural, residential and commercial projects.",
    industries: ["Agricultural and livestock infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Broomehill", "Woodanilling", "Kojonup", "Wagin", "Dumbleyung", "Nyabing", "Cranbrook", "Tambellup", "Gnowangerup", "Lake Grace"],
  },
  {
    slug: "mount-barker-wa",
    suburb: "Mount Barker",
    state: "WA",
    postcode: "6324",
    council: "Shire of Plantagenet",
    keyRoads: ["Albany Highway", "Lowood Road", "Langton Road", "Duke Street"],
    intro:
      "Mount Barker is a growing Great Southern township in the heart of the Porongurup wine region, where residential development, winery construction and infrastructure upgrades require traffic management plans compliant with Shire of Plantagenet and Main Roads WA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Shire of Plantagenet-compliant TMPs for Mount Barker residential, winery and infrastructure projects.",
    industries: ["Residential development", "Winery and vineyard construction", "Agricultural infrastructure", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Albany", "Denmark", "Katanning", "Cranbrook", "Kojonup", "Tambellup", "Gnowangerup", "Broomehill", "Porongurup", "Kendenup"],
  },

  // ─── SOUTH AUSTRALIA ───────────────────────────────────────────────────────

  {
    slug: "adelaide-cbd",
    suburb: "Adelaide CBD",
    state: "SA",
    postcode: "5000",
    council: "Adelaide City Council",
    keyRoads: ["King William Street", "North Terrace", "Rundle Mall", "Grenfell Street"],
    intro:
      "Adelaide CBD is the compact, grid-planned heart of South Australia's capital, where light rail operations, major hospital and university precincts, commercial development and government infrastructure works create consistent demand for traffic management plan documentation under Adelaide City Council and DPTI requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Adelaide City Council-compliant TMP and TGS documentation for CBD projects, with experience navigating Adelaide's unique grid street layout and tram corridor requirements.",
    industries: [
      "Commercial and government construction",
      "Hospital and healthcare development",
      "University and educational projects",
      "Light rail infrastructure",
      "Retail and hospitality fitouts",
      "Events and public gatherings",
    ],
    nearbySuburbs: ["North Adelaide", "Parkside", "Norwood", "Unley", "Prospect", "Hindmarsh", "Bowden", "Brompton", "Kensington", "College Park"],
  },
  {
    slug: "port-adelaide",
    suburb: "Port Adelaide",
    state: "SA",
    postcode: "5015",
    council: "City of Port Adelaide Enfield",
    keyRoads: ["Port Road", "Commercial Road", "St Vincent Street", "Lipson Street"],
    intro:
      "Port Adelaide is undergoing a significant urban transformation, with heritage wharves converted to residential and cultural uses, new apartment developments and active industrial port operations creating a complex traffic management environment that requires carefully prepared TMP documentation.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Adelaide Enfield-compliant TMPs and heritage streetscape traffic management documentation for projects in the Port Adelaide precinct.",
    industries: [
      "Heritage waterfront redevelopment",
      "Port and industrial construction",
      "Residential development",
      "Cultural and tourism fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Semaphore", "Exeter", "New Port", "Alberton", "Pennington", "Mansfield Park", "Cheltenham", "Ottoway", "Ethelton", "Birkenhead"],
  },
  {
    slug: "glenelg",
    suburb: "Glenelg",
    state: "SA",
    postcode: "5045",
    council: "City of Holdfast Bay",
    keyRoads: ["Jetty Road", "Moseley Street", "Brighton Road", "Anzac Highway"],
    intro:
      "Glenelg is Adelaide's iconic beachside suburb and a year-round tourism destination, where tram operations, high pedestrian volumes on Jetty Road and ongoing residential and hospitality construction require detailed traffic management plans that comply with City of Holdfast Bay requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Holdfast Bay-compliant TMP and pedestrian control plan documentation for Glenelg projects, with experience managing works on the busy Jetty Road retail strip.",
    industries: [
      "Residential and hospitality construction",
      "Retail and tourism fitouts",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Events and festivals",
      "Tram corridor works",
    ],
    nearbySuburbs: ["Brighton", "Somerton Park", "Novar Gardens", "Glengowrie", "Hove", "North Brighton", "West Beach", "Plympton", "South Plympton", "Oaklands Park"],
  },
  {
    slug: "mount-gambier",
    suburb: "Mount Gambier",
    state: "SA",
    postcode: "5290",
    council: "City of Mount Gambier",
    keyRoads: ["Commercial Street", "Penola Road", "Bay Road", "Jubilee Highway"],
    intro:
      "Mount Gambier is South Australia's second-largest city and the key service centre for the South East, where timber industry infrastructure, residential development and road maintenance on the Dukes Highway corridor create consistent demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans provides City of Mount Gambier-compliant TMP documentation for the South East region, with the same 24-hour turnaround available across all of Australia.",
    industries: [
      "Timber and industrial construction",
      "Residential development",
      "Commercial and retail projects",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and council works",
    ],
    nearbySuburbs: ["Millicent", "Naracoorte", "Penola", "Bordertown", "Beachport", "Robe", "Keith", "Casterton", "Penola", "Lucindale"],
  },

  // ─── SOUTH AUSTRALIA (additional) ─────────────────────────────────────────

  // Adelaide CBD & Inner (additional)
  {
    slug: "burnside",
    suburb: "Burnside",
    state: "SA",
    postcode: "5066",
    council: "City of Burnside",
    keyRoads: ["Greenhill Road", "Portrush Road", "Kensington Road", "Glynburn Road"],
    intro:
      "Burnside is one of Adelaide's most prestigious eastern suburbs, where luxury residential construction, boutique commercial development and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for residential and commercial projects in this sought-after eastern Adelaide suburb.",
    industries: [
      "Luxury residential construction",
      "Boutique commercial development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Glenside", "Hazelwood Park", "Kensington Gardens", "Linden Park", "Magill", "Rose Park", "Toorak Gardens", "Tusmore", "Dulwich", "Frewville"],
  },
  {
    slug: "henley-beach",
    suburb: "Henley Beach",
    state: "SA",
    postcode: "5022",
    council: "City of Charles Sturt",
    keyRoads: ["Henley Beach Road", "Military Road", "Seaview Road", "Cudmore Terrace"],
    intro:
      "Henley Beach is Adelaide's premier beachside suburb, where coastal residential construction, the Henley Square restaurant precinct and foreshore infrastructure works require traffic management plans compliant with City of Charles Sturt and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Henley Beach residential and coastal infrastructure projects.",
    industries: [
      "Coastal residential construction",
      "Hospitality and retail fitouts",
      "Foreshore and coastal works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Grange", "Fulham", "West Beach", "Tennyson", "Semaphore", "Largs Bay", "Henley Beach South", "Fulham Gardens", "Lockleys", "Flinders Park"],
  },
  {
    slug: "hindmarsh",
    suburb: "Hindmarsh",
    state: "SA",
    postcode: "5007",
    council: "City of Charles Sturt",
    keyRoads: ["Port Road", "Torrens Road", "Gibson Street", "Hawker Street"],
    intro:
      "Hindmarsh is an inner-western Adelaide suburb on the Port Road corridor, where residential construction, commercial development and the proximity to the Adelaide Entertainment Centre create demand for traffic management plans compliant with City of Charles Sturt and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Charles Sturt-compliant TMPs for Hindmarsh residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Events and entertainment infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Bowden", "Brompton", "Croydon", "Ridleyton", "West Hindmarsh", "Thebarton", "Torrensville", "Welland", "Woodville", "Adelaide CBD"],
  },
  {
    slug: "norwood",
    suburb: "Norwood",
    state: "SA",
    postcode: "5067",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["The Parade", "Osmond Terrace", "Magill Road", "William Street"],
    intro:
      "Norwood is Adelaide's premier eastern dining and boutique retail destination, where commercial fitouts along The Parade, residential construction and utility works require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Norwood commercial and residential projects, with experience on The Parade corridor.",
    industries: [
      "Retail and hospitality fitouts",
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Kensington", "Rose Park", "Marryatville", "Evandale", "Payneham", "St Peters", "Kent Town", "Hackney", "College Park", "Dulwich"],
  },
  {
    slug: "prospect",
    suburb: "Prospect",
    state: "SA",
    postcode: "5082",
    council: "City of Prospect",
    keyRoads: ["Prospect Road", "Churchill Road", "Main North Road", "Regency Road"],
    intro:
      "Prospect is a vibrant inner-northern Adelaide suburb with a popular café and arts precinct on Prospect Road, where residential construction, boutique commercial development and utility works require traffic management plans compliant with City of Prospect and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Prospect-compliant TMPs for residential and commercial projects on the Prospect Road corridor.",
    industries: [
      "Residential construction",
      "Boutique retail and commercial development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Nailsworth", "Medindie", "Fitzroy", "Blair Athol", "Kilburn", "Broadview", "Thorngate", "Sefton Park", "Collinswood", "Enfield"],
  },
  {
    slug: "semaphore",
    suburb: "Semaphore",
    state: "SA",
    postcode: "5019",
    council: "City of Port Adelaide Enfield",
    keyRoads: ["Semaphore Road", "Military Road", "Esplanade", "Fletcher Road"],
    intro:
      "Semaphore is a charming heritage beachside suburb in Adelaide's north-west, where residential construction, the Semaphore Road retail strip and coastal foreshore works require traffic management plans compliant with City of Port Adelaide Enfield and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Semaphore residential and coastal projects, managing the suburb's heritage streetscape environment.",
    industries: [
      "Coastal residential construction",
      "Heritage building refurbishment",
      "Retail and hospitality fitouts",
      "Foreshore and coastal works",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Exeter", "Largs Bay", "Largs North", "Port Adelaide", "Pennington", "Mansfield Park", "Taperoo", "North Haven", "Outer Harbor", "Grange"],
  },
  {
    slug: "unley",
    suburb: "Unley",
    state: "SA",
    postcode: "5061",
    council: "City of Unley",
    keyRoads: ["Unley Road", "King William Road", "Goodwood Road", "Cross Road"],
    intro:
      "Unley is one of Adelaide's most desirable inner-southern suburbs, home to the King William Road boutique shopping strip, where residential construction, commercial fitouts and heritage building works require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Unley-compliant TMPs for residential and commercial projects, with experience on the King William Road and Unley Road corridors.",
    industries: [
      "Residential construction",
      "Boutique retail and commercial fitouts",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Malvern", "Parkside", "Hyde Park", "Goodwood", "Millswood", "Clarence Park", "Black Forest", "Fullarton", "Dulwich", "Wayville"],
  },
  // Northern Adelaide
  {
    slug: "elizabeth",
    suburb: "Elizabeth",
    state: "SA",
    postcode: "5112",
    council: "City of Playford",
    keyRoads: ["John Street", "Philip Highway", "Elizabeth Way", "Davoren Road"],
    intro:
      "Elizabeth is the major centre of Adelaide's northern urban corridor and the heart of the City of Playford, where urban renewal, residential development and social infrastructure construction create demand for traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Elizabeth residential and infrastructure projects across the northern growth corridor.",
    industries: [
      "Residential development",
      "Urban renewal and mixed-use construction",
      "Community and social infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Davoren Park", "Andrews Farm", "Blakeview", "Smithfield", "Craigmore", "Munno Para", "Paralowie", "Salisbury", "Parafield Gardens", "Evanston"],
  },
  {
    slug: "gawler",
    suburb: "Gawler",
    state: "SA",
    postcode: "5118",
    council: "Town of Gawler",
    keyRoads: ["Main North Road", "Murray Street", "Adelaide Road", "Lyndoch Road"],
    intro:
      "Gawler is one of South Australia's oldest towns and the northern gateway of the Adelaide metropolitan area, where residential development, heritage building refurbishment and infrastructure upgrades create demand for traffic management plans compliant with Town of Gawler and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Town of Gawler-compliant TMPs for residential, heritage and infrastructure projects in the northern Adelaide corridor.",
    industries: [
      "Residential subdivision and housing",
      "Heritage building refurbishment",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Evanston", "Evanston Park", "Hewett", "Reid", "Willaston", "Kudla", "Hillier", "Bibaringa", "Roseworthy", "Lyndoch"],
  },
  {
    slug: "parafield",
    suburb: "Parafield",
    state: "SA",
    postcode: "5106",
    council: "City of Salisbury",
    keyRoads: ["Main North Road", "Parafield Road", "Salisbury Highway", "Kings Road"],
    intro:
      "Parafield is a northern Adelaide suburb home to Parafield Airport and significant light industrial estates, where aviation-related construction, warehouse development and residential works require traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Parafield aviation, industrial and residential projects.",
    industries: [
      "Aviation and airport infrastructure",
      "Light industrial and warehouse development",
      "Residential construction",
      "Utility maintenance",
      "Road and access construction",
    ],
    nearbySuburbs: ["Salisbury", "Para Hills", "Pooraka", "Mawson Lakes", "Globe Derby Park", "Brahma Lodge", "Parafield Gardens", "Gepps Cross", "Cavan", "Dry Creek"],
  },
  {
    slug: "para-hills",
    suburb: "Para Hills",
    state: "SA",
    postcode: "5096",
    council: "City of Salisbury",
    keyRoads: ["Salisbury Highway", "Ingle Farm Road", "Montague Road", "Bridge Road"],
    intro:
      "Para Hills is a residential suburb in northern Adelaide where residential construction and utility works require traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Salisbury-compliant TMPs for Para Hills residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Salisbury", "Ingle Farm", "Parafield Gardens", "Modbury", "Tea Tree Gully", "Pooraka", "Mawson Lakes", "Walkley Heights", "Hillbank", "Salisbury Heights"],
  },
  {
    slug: "playford",
    suburb: "Playford",
    state: "SA",
    postcode: "5120",
    council: "City of Playford",
    keyRoads: ["Andrews Farm Boulevard", "Angle Vale Road", "Curtis Road", "Uley Road"],
    intro:
      "The City of Playford encompasses Adelaide's fastest-growing northern residential corridor, including major greenfield estates at Andrews Farm and Buckland Park, where residential subdivision construction and associated civil infrastructure create strong demand for traffic management documentation compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Playford LGA residential estate and civil infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Andrews Farm", "Angle Vale", "Buckland Park", "Virginia", "Hillier", "Smithfield", "Blakeview", "Munno Para", "Elizabeth", "Craigmore"],
  },
  {
    slug: "salisbury",
    suburb: "Salisbury",
    state: "SA",
    postcode: "5108",
    council: "City of Salisbury",
    keyRoads: ["John Street", "Salisbury Highway", "Park Terrace", "Commercial Road"],
    intro:
      "Salisbury is the administrative and commercial centre of Adelaide's northern suburbs, where residential development, light industrial construction and infrastructure upgrades create demand for traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Salisbury-compliant TMPs for residential, commercial and infrastructure projects across the Salisbury LGA.",
    industries: [
      "Residential development",
      "Light industrial and commercial construction",
      "Council infrastructure works",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Parafield", "Para Hills", "Brahma Lodge", "Pooraka", "Mawson Lakes", "Paralowie", "Parafield Gardens", "Globe Derby Park", "Cavan", "Elizabeth"],
  },
  {
    slug: "tea-tree-gully",
    suburb: "Tea Tree Gully",
    state: "SA",
    postcode: "5091",
    council: "City of Tea Tree Gully",
    keyRoads: ["Reservoir Road", "North East Road", "Montacute Road", "Tea Tree Gully Road"],
    intro:
      "Tea Tree Gully is a major north-eastern Adelaide suburb and the administrative hub of the City of Tea Tree Gully, where residential development, retail construction and utility works create demand for traffic management plans compliant with City of Tea Tree Gully and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Tea Tree Gully residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Modbury", "Modbury Heights", "Ridgehaven", "Fairview Park", "Highbury", "Surrey Downs", "Banksia Park", "Greenwith", "Redwood Park", "Para Hills"],
  },
  {
    slug: "waterloo-corner",
    suburb: "Waterloo Corner",
    state: "SA",
    postcode: "5110",
    council: "City of Playford",
    keyRoads: ["Main North Road", "Waterloo Corner Road", "Old Port Wakefield Road", "Angle Vale Road"],
    intro:
      "Waterloo Corner is a semi-rural suburb in Adelaide's far north, where rural residential construction and proximity to the northern growth corridor create demand for traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Playford-compliant TMPs for Waterloo Corner rural residential and infrastructure projects.",
    industries: [
      "Rural residential construction",
      "Agricultural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Angle Vale", "Virginia", "Bolivar", "Globe Derby Park", "Parafield Gardens", "Edinburgh", "Penfield", "Gawler", "Hillier", "Evanston"],
  },
  // Southern Adelaide
  {
    slug: "christie-downs",
    suburb: "Christie Downs",
    state: "SA",
    postcode: "5164",
    council: "City of Onkaparinga",
    keyRoads: ["Ramsay Crescent", "Christies Beach Road", "Aldershot Road", "Loch Road"],
    intro:
      "Christie Downs is a residential suburb in Adelaide's southern urban corridor where residential construction and utility works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Christie Downs residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Noarlunga", "Morphett Vale", "Hackham", "Christies Beach", "Seaford", "Onkaparinga Hills", "Woodcroft", "Reynella", "Old Reynella", "Happy Valley"],
  },
  {
    slug: "hackham",
    suburb: "Hackham",
    state: "SA",
    postcode: "5163",
    council: "City of Onkaparinga",
    keyRoads: ["Main South Road", "Hackham Road", "Sherriffs Road", "Kokoda Road"],
    intro:
      "Hackham is a southern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Hackham residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Morphett Vale", "Noarlunga", "Christie Downs", "Huntfield Heights", "Hackham West", "Onkaparinga Hills", "Reynella East", "Old Noarlunga", "Christies Beach", "Seaford"],
  },
  {
    slug: "hallett-cove",
    suburb: "Hallett Cove",
    state: "SA",
    postcode: "5158",
    council: "City of Marion",
    keyRoads: ["Hallett Cove Road", "Galloway Road", "Higgins Road", "Sherriffs Road"],
    intro:
      "Hallett Cove is a coastal suburb in Adelaide's south with significant natural heritage along the Hallett Cove Conservation Park coastline, where residential construction and coastal infrastructure works require traffic management plans compliant with City of Marion and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hallett Cove residential and coastal infrastructure projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Sheidow Park", "Trott Park", "Lonsdale", "O'Halloran Hill", "Mitchell Park", "Morphett Vale", "Seacliff Park", "Marino", "Christie Downs", "Reynella"],
  },
  {
    slug: "morphett-vale",
    suburb: "Morphett Vale",
    state: "SA",
    postcode: "5162",
    council: "City of Onkaparinga",
    keyRoads: ["Main South Road", "Pimpala Road", "Bains Road", "Sherriffs Road"],
    intro:
      "Morphett Vale is one of Adelaide's largest southern suburbs, where residential construction, retail development and utility works along the Main South Road corridor require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Morphett Vale residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Reynella", "Old Reynella", "Noarlunga", "Hackham", "Christie Downs", "Woodcroft", "Seaford", "Christies Beach", "Happy Valley", "Hallett Cove"],
  },
  {
    slug: "noarlunga",
    suburb: "Noarlunga",
    state: "SA",
    postcode: "5168",
    council: "City of Onkaparinga",
    keyRoads: ["Dyson Road", "Pimpala Road", "Beach Road", "Main South Road"],
    intro:
      "Noarlunga is the major activity centre of Adelaide's southern suburbs, where the Colonnades shopping centre, Noarlunga Hospital and residential development create demand for traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Noarlunga retail, health and residential projects.",
    industries: [
      "Retail and commercial construction",
      "Health and hospital infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Christies Beach", "Morphett Vale", "Old Noarlunga", "Hackham", "Christie Downs", "Seaford", "Woodcroft", "Reynella", "Port Noarlunga", "Onkaparinga Hills"],
  },
  {
    slug: "old-noarlunga",
    suburb: "Old Noarlunga",
    state: "SA",
    postcode: "5168",
    council: "City of Onkaparinga",
    keyRoads: ["Main South Road", "Beach Road", "Onkaparinga Valley Road", "Grundy Terrace"],
    intro:
      "Old Noarlunga is a heritage township on the Onkaparinga River, where residential construction and heritage building refurbishment require traffic management plans compliant with City of Onkaparinga requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Old Noarlunga residential and heritage projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Noarlunga", "Christies Beach", "Port Noarlunga", "Hackham", "Morphett Vale", "McLaren Vale", "Seaford", "Christie Downs", "Onkaparinga Hills", "Woodcroft"],
  },
  {
    slug: "seaford",
    suburb: "Seaford",
    state: "SA",
    postcode: "5169",
    council: "City of Onkaparinga",
    keyRoads: ["Seaford Road", "Koster Street", "Commercial Road", "Sheriffs Road"],
    intro:
      "Seaford is a growing coastal suburb in Adelaide's south, where residential development and coastal infrastructure works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Seaford residential and coastal infrastructure projects.",
    industries: [
      "Residential subdivision and housing",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Seaford Rise", "Morphett Vale", "Noarlunga", "Christies Beach", "Port Noarlunga", "Hackham", "Christie Downs", "Aldinga Beach", "Moana", "Maslin Beach"],
  },
  // Eastern Adelaide
  {
    slug: "campbelltown-sa",
    suburb: "Campbelltown",
    state: "SA",
    postcode: "5074",
    council: "City of Campbelltown",
    keyRoads: ["Montacute Road", "Lower North East Road", "Gorge Road", "North East Road"],
    intro:
      "Campbelltown is a major eastern Adelaide suburb and the administrative centre of the City of Campbelltown, where residential construction and commercial development require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Campbelltown-compliant TMPs for residential and commercial projects in this established eastern suburb.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Magill", "Newton", "Tranmere", "Rostrevor", "Hectorville", "Athelstone", "Auldana", "Marryatville", "Burnside", "St Morris"],
  },
  {
    slug: "kensington-sa",
    suburb: "Kensington",
    state: "SA",
    postcode: "5068",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Kensington Road", "The Parade", "Magill Road", "Edmund Avenue"],
    intro:
      "Kensington is an affluent inner-eastern Adelaide suburb where residential construction, boutique commercial development and heritage building works require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kensington residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Norwood", "Rose Park", "Dulwich", "Marryatville", "Burnside", "Toorak Gardens", "Evandale", "Kent Town", "Hackney", "Payneham"],
  },
  {
    slug: "marden",
    suburb: "Marden",
    state: "SA",
    postcode: "5070",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Payneham Road", "Marden Road", "River Road", "Grand Junction Road"],
    intro:
      "Marden is a northern inner suburb on the River Torrens where residential construction and commercial development require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Norwood Payneham & St Peters-compliant TMPs for Marden residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Payneham", "Felixstow", "Evandale", "Joslin", "Hackney", "Royston Park", "St Morris", "Maylands", "Glynde", "Firle"],
  },
  {
    slug: "newton",
    suburb: "Newton",
    state: "SA",
    postcode: "5074",
    council: "City of Campbelltown",
    keyRoads: ["North East Road", "Montacute Road", "Newton Road", "Gorge Road"],
    intro:
      "Newton is a residential suburb in eastern Adelaide where residential construction and utility works require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Newton residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Campbelltown", "Magill", "Tranmere", "Rostrevor", "Hectorville", "Athelstone", "St Morris", "Auldana", "Burnside", "Kensington Gardens"],
  },
  {
    slug: "rostrevor",
    suburb: "Rostrevor",
    state: "SA",
    postcode: "5073",
    council: "City of Campbelltown",
    keyRoads: ["Gorge Road", "Rostrevor Parade", "Montacute Road", "Woodforde Road"],
    intro:
      "Rostrevor is a leafy foothills suburb in eastern Adelaide where residential construction in a heritage-sensitive, bushland setting requires traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Campbelltown-compliant TMPs for Rostrevor residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Campbelltown", "Newton", "Tranmere", "Magill", "Hectorville", "Athelstone", "Auldana", "Woodforde", "Norton Summit", "Burnside"],
  },
  {
    slug: "tranmere",
    suburb: "Tranmere",
    state: "SA",
    postcode: "5073",
    council: "City of Campbelltown",
    keyRoads: ["Montacute Road", "Lower North East Road", "Tranmere Avenue", "Pevensey Road"],
    intro:
      "Tranmere is an established eastern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Tranmere residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Campbelltown", "Newton", "Rostrevor", "Magill", "Hectorville", "Athelstone", "St Morris", "Burnside", "Kensington Gardens", "Marryatville"],
  },
  {
    slug: "wattle-park",
    suburb: "Wattle Park",
    state: "SA",
    postcode: "5066",
    council: "City of Burnside",
    keyRoads: ["Glynburn Road", "Wattle Street", "Springfield Road", "Beaumont Road"],
    intro:
      "Wattle Park is a quiet residential suburb in Adelaide's eastern foothills where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Wattle Park residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Burnside", "Magill", "Kensington Gardens", "Hazelwood Park", "Beaumont", "Linden Park", "Frewville", "Glen Osmond", "Skye", "Glenunga"],
  },
  // Barossa Valley
  {
    slug: "angaston",
    suburb: "Angaston",
    state: "SA",
    postcode: "5353",
    council: "Barossa Council",
    keyRoads: ["Murray Street", "Angaston Road", "Eden Valley Road", "Washington Street"],
    intro:
      "Angaston is a historic Barossa Valley town renowned for its wineries and heritage buildings, where tourism infrastructure, winery construction and residential works require traffic management plans compliant with Barossa Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Angaston tourism, winery and residential projects in the Barossa Valley.",
    industries: [
      "Winery and tourism infrastructure",
      "Heritage building refurbishment",
      "Residential construction",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Nuriootpa", "Tanunda", "Williamstown", "Eden Valley", "Keyneton", "Moculta", "Sandergrove", "Stockwell", "Greenock", "Truro"],
  },
  {
    slug: "lyndoch",
    suburb: "Lyndoch",
    state: "SA",
    postcode: "5351",
    council: "Barossa Council",
    keyRoads: ["Barossa Valley Way", "Lyndoch Valley Road", "Para Road", "Rowan Road"],
    intro:
      "Lyndoch is the southern gateway to the Barossa Valley, where winery construction, tourism infrastructure and rural residential development require traffic management plans compliant with Barossa Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Barossa Council-compliant TMPs for Lyndoch winery, tourism and residential projects.",
    industries: [
      "Winery and tourism infrastructure",
      "Rural residential construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Williamstown", "Tanunda", "Rosedale", "Rowland Flat", "Gawler", "Sandy Creek", "Bethany", "Barossa Goldfields", "Cockatoo Valley", "Seppeltsfield"],
  },
  {
    slug: "nuriootpa",
    suburb: "Nuriootpa",
    state: "SA",
    postcode: "5355",
    council: "Barossa Council",
    keyRoads: ["Murray Street", "Light Pass Road", "Moppa Road", "Barossa Valley Way"],
    intro:
      "Nuriootpa is the commercial centre of the Barossa Valley and home to major wine processing facilities, where winery construction, commercial development and residential works require traffic management plans compliant with Barossa Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nuriootpa winery, commercial and residential projects at the heart of the Barossa Valley.",
    industries: [
      "Winery and wine processing construction",
      "Commercial and retail development",
      "Residential construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Tanunda", "Angaston", "Light Pass", "Greenock", "Seppeltsfield", "Marananga", "Moppa", "Vine Vale", "Stockwell", "Williamstown"],
  },
  {
    slug: "tanunda",
    suburb: "Tanunda",
    state: "SA",
    postcode: "5352",
    council: "Barossa Council",
    keyRoads: ["Murray Street", "Barossa Valley Way", "Tanunda Road", "Elizabeth Street"],
    intro:
      "Tanunda is the cultural heart of the Barossa Valley, a heritage-rich township with a strong German heritage, where winery and tourism construction, heritage building refurbishment and residential works require traffic management plans compliant with Barossa Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Barossa Council-compliant TMPs for Tanunda winery, heritage and residential projects.",
    industries: [
      "Winery and tourism infrastructure",
      "Heritage building refurbishment",
      "Residential construction",
      "Hospitality and retail fitouts",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Nuriootpa", "Angaston", "Lyndoch", "Bethany", "Seppeltsfield", "Marananga", "Vine Vale", "Rowland Flat", "Greenock", "Stockwell"],
  },
  {
    slug: "two-wells",
    suburb: "Two Wells",
    state: "SA",
    postcode: "5501",
    council: "District Council of Mallala",
    keyRoads: ["Port Wakefield Road", "Two Wells Road", "Old Port Wakefield Road", "Main Road"],
    intro:
      "Two Wells is a rural township north of Adelaide on the Port Wakefield Road corridor, where residential development and agricultural infrastructure create demand for traffic management plans compliant with District Council of Mallala and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Two Wells residential and agricultural infrastructure projects.",
    industries: [
      "Rural residential construction",
      "Agricultural and horticultural infrastructure",
      "Utility maintenance",
      "Road and civil construction",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Lewiston", "Angle Vale", "Virginia", "Gawler", "Roseworthy", "Mallala", "Grace Plains", "Parham", "Webb Beach", "Dublin"],
  },
  // Fleurieu Peninsula
  {
    slug: "mclaren-vale",
    suburb: "McLaren Vale",
    state: "SA",
    postcode: "5171",
    council: "City of Onkaparinga",
    keyRoads: ["Main Road", "Chalk Hill Road", "Olivers Road", "Caffrey Street"],
    intro:
      "McLaren Vale is South Australia's premier boutique wine region just south of Adelaide, where winery and cellar door construction, tourism infrastructure and rural residential development require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for McLaren Vale winery, tourism and residential projects.",
    industries: [
      "Winery and cellar door construction",
      "Tourism and hospitality development",
      "Rural residential construction",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["McLaren Flat", "Willunga", "Aldinga Beach", "Old Noarlunga", "Morphett Vale", "Seaford", "Noarlunga", "Christies Beach", "Kangarilla", "Clarendon"],
  },
  {
    slug: "mclaren-flat",
    suburb: "McLaren Flat",
    state: "SA",
    postcode: "5171",
    council: "City of Onkaparinga",
    keyRoads: ["Kangarilla Road", "Chalk Hill Road", "Kays Road", "McLaren Flat Road"],
    intro:
      "McLaren Flat is a rural township in the McLaren Vale wine region where winery construction and rural residential development require traffic management plans compliant with City of Onkaparinga requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for McLaren Flat winery and rural residential projects.",
    industries: [
      "Winery and vineyard infrastructure",
      "Rural residential construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["McLaren Vale", "Willunga", "Kangarilla", "Clarendon", "Hackham", "Blewitt Springs", "Whites Valley", "Cherry Gardens", "Aldinga", "Sellicks Beach"],
  },
  {
    slug: "port-elliot",
    suburb: "Port Elliot",
    state: "SA",
    postcode: "5212",
    council: "Alexandrina Council",
    keyRoads: ["The Strand", "North Terrace", "Horseshoe Bay Road", "Goolwa Road"],
    intro:
      "Port Elliot is a charming historic beach town on the Fleurieu Peninsula, where coastal residential construction and tourism infrastructure works require traffic management plans compliant with Alexandrina Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alexandrina Council-compliant TMPs for Port Elliot residential and tourism projects.",
    industries: [
      "Coastal residential construction",
      "Tourism and hospitality development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Goolwa", "Victor Harbor", "Middleton", "Encounter Bay", "Hayborough", "Currency Creek", "Hindmarsh Island", "Newland", "Waitpinga", "Inman Valley"],
  },
  {
    slug: "strathalbyn",
    suburb: "Strathalbyn",
    state: "SA",
    postcode: "5255",
    council: "Alexandrina Council",
    keyRoads: ["South Terrace", "Goolwa Road", "Milang Road", "Dawson Street"],
    intro:
      "Strathalbyn is a charming heritage town on the Angas River, a popular destination for antiques and tourism, where residential construction and heritage building works require traffic management plans compliant with Alexandrina Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Strathalbyn heritage and residential projects.",
    industries: [
      "Heritage building refurbishment",
      "Residential construction",
      "Tourism infrastructure",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Langhorne Creek", "Milang", "Currency Creek", "Goolwa", "Clayton Bay", "Ashbourne", "Macclesfield", "Meadows", "Murray Bridge", "Sandergrove"],
  },
  {
    slug: "victor-harbor",
    suburb: "Victor Harbor",
    state: "SA",
    postcode: "5211",
    council: "City of Victor Harbor",
    keyRoads: ["Ocean Street", "Victoria Street", "Hindmarsh Road", "Adelaide Road"],
    intro:
      "Victor Harbor is the Fleurieu Peninsula's major coastal city and a popular tourist destination, where residential development, tourism infrastructure and whale-watching facilities create demand for traffic management plans compliant with City of Victor Harbor and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Victor Harbor-compliant TMPs for residential and tourism projects on the Fleurieu Peninsula.",
    industries: [
      "Tourism and hospitality construction",
      "Residential development",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Encounter Bay", "Hayborough", "Port Elliot", "Middleton", "Goolwa", "Inman Valley", "Waitpinga", "Currency Creek", "Hindmarsh Island", "Hindmarsh Valley"],
  },
  // Regional SA
  {
    slug: "murray-bridge",
    suburb: "Murray Bridge",
    state: "SA",
    postcode: "5253",
    council: "Rural City of Murray Bridge",
    keyRoads: ["Adelaide Road", "Swanport Road", "Bridge Street", "Standen Street"],
    intro:
      "Murray Bridge is South Australia's largest inland city and the gateway to the Murraylands, where residential development, food processing industry construction and infrastructure upgrades create demand for traffic management plans compliant with Rural City of Murray Bridge and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Murray Bridge residential, industrial and infrastructure projects.",
    industries: [
      "Residential development",
      "Food processing and industrial construction",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Brinkley", "Monarto", "White Hill", "Gifford Hill", "Mobilong", "Mypolonga", "Riverview", "Toora", "Jervois", "Callington"],
  },
  {
    slug: "port-augusta",
    suburb: "Port Augusta",
    state: "SA",
    postcode: "5700",
    council: "City of Port Augusta",
    keyRoads: ["Augusta Highway", "Commercial Road", "Transcontinental Drive", "Mitchell Crescent"],
    intro:
      "Port Augusta is the crossroads of Australia and the gateway to the Outback, where renewable energy infrastructure, rail operations and residential development create demand for traffic management plans compliant with City of Port Augusta and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Port Augusta-compliant TMPs for renewable energy, industrial and residential projects in SA's crossroads city.",
    industries: [
      "Renewable energy and infrastructure",
      "Rail and transport infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Stirling North", "Davenport", "Commissariat Point", "Whyalla", "Port Pirie", "Quorn", "Hawker", "Pichi Richi", "Wilmington", "Booleroo Centre"],
  },
  {
    slug: "port-lincoln",
    suburb: "Port Lincoln",
    state: "SA",
    postcode: "5606",
    council: "City of Port Lincoln",
    keyRoads: ["Tasman Terrace", "Liverpool Street", "London Street", "Washington Street"],
    intro:
      "Port Lincoln is Australia's tuna capital and the Eyre Peninsula's major city, where seafood processing infrastructure, port construction and residential development create demand for traffic management plans compliant with City of Port Lincoln and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Port Lincoln port, seafood processing and residential projects on the Eyre Peninsula.",
    industries: [
      "Seafood and aquaculture infrastructure",
      "Port and marine construction",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Proper Bay", "Boston", "Kirton Point", "Louth Bay", "Coffin Bay", "Tumby Bay", "Cummins", "Wangary", "Uley", "Sleaford"],
  },
  {
    slug: "port-pirie",
    suburb: "Port Pirie",
    state: "SA",
    postcode: "5540",
    council: "Port Pirie Regional Council",
    keyRoads: ["Main Road", "Ellen Street", "Florence Street", "Mary Elie Street"],
    intro:
      "Port Pirie is home to the world's largest lead smelter and a major industrial port city, where heavy industrial construction, port infrastructure and residential development create demand for traffic management plans compliant with Port Pirie Regional Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Port Pirie Regional Council-compliant TMPs for industrial, port and residential projects in this major regional city.",
    industries: [
      "Heavy industrial and smelter infrastructure",
      "Port and logistics construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Solomontown", "Port Pirie West", "Risdon Park", "Napperby", "Wandearah", "Crystal Brook", "Gladstone", "Broughton", "Koolunga", "Baroota"],
  },
  {
    slug: "renmark",
    suburb: "Renmark",
    state: "SA",
    postcode: "5341",
    council: "Renmark Paringa Council",
    keyRoads: ["Renmark Avenue", "Murray Avenue", "Eighteenth Street", "Ral Ral Avenue"],
    intro:
      "Renmark is the major city of the Riverland region and an important horticultural and wine production hub on the Murray River, where irrigation infrastructure, winery construction and residential development create demand for traffic management plans compliant with Renmark Paringa Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Renmark horticultural, winery and residential projects in the Riverland.",
    industries: [
      "Horticultural and irrigation infrastructure",
      "Winery and wine processing construction",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Paringa", "Berri", "Barmera", "Loxton", "Waikerie", "Cobdogla", "Loveday", "Lyrup", "Chaffey", "Murtho"],
  },
  {
    slug: "whyalla",
    suburb: "Whyalla",
    state: "SA",
    postcode: "5600",
    council: "City of Whyalla",
    keyRoads: ["McBryde Terrace", "Forsyth Street", "Patterson Street", "Stuart Highway"],
    intro:
      "Whyalla is South Australia's third-largest city and a major steelmaking and port hub on the Eyre Peninsula, where steel industry construction, port infrastructure and residential development create demand for traffic management plans compliant with City of Whyalla and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Whyalla-compliant TMPs for steel industry, port and residential projects on the Eyre Peninsula.",
    industries: [
      "Steel industry and heavy industrial construction",
      "Port and marine infrastructure",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Hummocks", "Cultana", "Mullaquana", "Port Bonython", "Port Augusta", "Iron Knob", "Kimba", "Cowell", "Cleve", "Arno Bay"],
  },

  // ─── SOUTH AUSTRALIA (further additions) ──────────────────────────────────

  // Adelaide CBD & Inner (additional)
  {
    slug: "bowden",
    suburb: "Bowden",
    state: "SA",
    postcode: "5007",
    council: "City of Charles Sturt",
    keyRoads: ["Port Road", "First Street", "Gibson Street", "Phillips Street"],
    intro:
      "Bowden is Adelaide's most exciting urban renewal precinct, where the Renewal SA Urban Village project has transformed a former industrial site into a vibrant high-density residential and creative hub, creating ongoing demand for traffic management plans compliant with City of Charles Sturt and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Charles Sturt-compliant TMPs for Bowden urban renewal and residential projects.",
    industries: ["High-density residential development", "Creative industry fitouts", "Urban renewal and mixed-use construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Brompton", "Hindmarsh", "Ridleyton", "West Hindmarsh", "Croydon", "Thebarton", "Adelaide CBD", "North Adelaide", "Prospect", "Ovingham"],
  },
  {
    slug: "brompton",
    suburb: "Brompton",
    state: "SA",
    postcode: "5007",
    council: "City of Charles Sturt",
    keyRoads: ["Port Road", "Torrens Road", "Bowden Street", "Matheson Road"],
    intro:
      "Brompton is an inner western suburb adjacent to the Bowden urban renewal precinct, where residential construction and commercial development require traffic management plans compliant with City of Charles Sturt and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Brompton residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Bowden", "Hindmarsh", "Ridleyton", "West Hindmarsh", "Croydon", "Thebarton", "Prospect", "Ovingham", "Adelaide CBD", "Pennington"],
  },
  {
    slug: "college-park",
    suburb: "College Park",
    state: "SA",
    postcode: "5069",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Payneham Road", "Porter Street", "Kensington Road", "Magill Road"],
    intro:
      "College Park is an inner eastern suburb where residential construction and utility works require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Norwood Payneham & St Peters-compliant TMPs for College Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Norwood", "Kensington", "Rose Park", "Evandale", "Payneham", "St Peters", "Hackney", "Royston Park", "Kent Town", "Marryatville"],
  },
  {
    slug: "gilberton",
    suburb: "Gilberton",
    state: "SA",
    postcode: "5081",
    council: "City of Prospect",
    keyRoads: ["North East Road", "Walkerville Terrace", "Stephens Terrace", "Gilberton Road"],
    intro:
      "Gilberton is an affluent inner northern suburb where residential construction and heritage building works require traffic management plans compliant with City of Prospect and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gilberton residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Walkerville", "Collinswood", "Medindie", "Prospect", "Nailsworth", "Fitzroy", "St Peters", "Payneham", "Vale Park", "Thorngate"],
  },
  {
    slug: "glenside",
    suburb: "Glenside",
    state: "SA",
    postcode: "5065",
    council: "City of Burnside",
    keyRoads: ["Fullarton Road", "Greenhill Road", "Portrush Road", "Conyngham Street"],
    intro:
      "Glenside is an eastern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Glenside residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Glen Osmond", "Frewville", "Dulwich", "Wattle Park", "Rose Park", "Linden Park", "Hazelwood Park", "Skye", "Urrbrae"],
  },
  {
    slug: "goodwood",
    suburb: "Goodwood",
    state: "SA",
    postcode: "5034",
    council: "City of Unley",
    keyRoads: ["Goodwood Road", "Cross Road", "Young Street", "Millswood Road"],
    intro:
      "Goodwood is an inner southern suburb with a charming village character on Goodwood Road, where residential construction and boutique commercial development require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Goodwood residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and commercial development", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Millswood", "Clarence Park", "Unley", "Hyde Park", "Parkside", "Black Forest", "Wayville", "Edwardstown", "Malvern", "Cumberland Park"],
  },
  {
    slug: "hackney",
    suburb: "Hackney",
    state: "SA",
    postcode: "5069",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Hackney Road", "Melbourne Street", "Payneham Road", "Kermode Street"],
    intro:
      "Hackney is an inner suburb on the River Torrens where residential construction and utility works require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Norwood Payneham & St Peters-compliant TMPs for Hackney residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["College Park", "Norwood", "Kent Town", "St Peters", "Rose Park", "Payneham", "Fitzroy", "Evandale", "Royston Park", "Joslin"],
  },
  {
    slug: "hazelwood-park",
    suburb: "Hazelwood Park",
    state: "SA",
    postcode: "5066",
    council: "City of Burnside",
    keyRoads: ["Greenhill Road", "Glynburn Road", "Hazelwood Avenue", "Fenn Road"],
    intro:
      "Hazelwood Park is a quiet eastern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hazelwood Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Glenside", "Wattle Park", "Kensington Gardens", "Linden Park", "Rose Park", "Frewville", "Tusmore", "Glen Osmond", "Beaumont"],
  },
  {
    slug: "kent-town",
    suburb: "Kent Town",
    state: "SA",
    postcode: "5067",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Rundle Street", "Payneham Road", "Barnard Street", "Dequetteville Terrace"],
    intro:
      "Kent Town is a vibrant inner suburb just east of the Adelaide CBD, known for its creative industries and proximity to the East End entertainment precinct, where commercial construction and residential development require traffic management plans compliant with City of Norwood Payneham & St Peters requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Norwood Payneham & St Peters-compliant TMPs for Kent Town commercial and residential projects.",
    industries: ["Commercial and creative industry fitouts", "Residential construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Norwood", "College Park", "Hackney", "Rose Park", "St Peters", "Evandale", "Adelaide CBD", "Payneham", "Kensington", "Royston Park"],
  },
  {
    slug: "kensington-gardens",
    suburb: "Kensington Gardens",
    state: "SA",
    postcode: "5068",
    council: "City of Burnside",
    keyRoads: ["Kensington Road", "Magill Road", "Portrush Road", "Glynburn Road"],
    intro:
      "Kensington Gardens is a prestigious eastern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kensington Gardens residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Kensington", "Rose Park", "Hazelwood Park", "Wattle Park", "Linden Park", "Tusmore", "Toorak Gardens", "Marryatville", "Frewville"],
  },
  {
    slug: "linden-park",
    suburb: "Linden Park",
    state: "SA",
    postcode: "5065",
    council: "City of Burnside",
    keyRoads: ["Portrush Road", "Greenhill Road", "Devereux Road", "Linden Avenue"],
    intro:
      "Linden Park is an eastern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Linden Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Hazelwood Park", "Kensington Gardens", "Wattle Park", "Glenside", "Rose Park", "Frewville", "Glenunga", "Tusmore", "Urrbrae"],
  },
  {
    slug: "malvern-sa",
    suburb: "Malvern",
    state: "SA",
    postcode: "5061",
    council: "City of Unley",
    keyRoads: ["Unley Road", "Cross Road", "Clarke Street", "Marlborough Street"],
    intro:
      "Malvern is an inner southern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Malvern residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Unley", "Parkside", "Hyde Park", "Goodwood", "Millswood", "Clarence Park", "Black Forest", "Wayville", "Fullarton", "Dulwich"],
  },
  {
    slug: "marryatville",
    suburb: "Marryatville",
    state: "SA",
    postcode: "5068",
    council: "City of Burnside",
    keyRoads: ["Kensington Road", "Portrush Road", "Marryatville Avenue", "Alexandra Avenue"],
    intro:
      "Marryatville is a prestigious eastern suburb where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Marryatville residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Kensington", "Kensington Gardens", "Rose Park", "Toorak Gardens", "Hazelwood Park", "Linden Park", "Wattle Park", "Glenunga", "Frewville"],
  },
  {
    slug: "millswood",
    suburb: "Millswood",
    state: "SA",
    postcode: "5034",
    council: "City of Unley",
    keyRoads: ["Millswood Road", "Cross Road", "Goodwood Road", "Kenilworth Road"],
    intro:
      "Millswood is a quiet inner southern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Millswood residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Goodwood", "Clarence Park", "Unley", "Hyde Park", "Malvern", "Wayville", "Parkside", "Black Forest", "Cumberland Park", "Edwardstown"],
  },
  {
    slug: "mitcham-sa",
    suburb: "Mitcham",
    state: "SA",
    postcode: "5062",
    council: "City of Mitcham",
    keyRoads: ["Belair Road", "Main Road", "Daws Road", "Scotch College Drive"],
    intro:
      "Mitcham is the administrative centre of the City of Mitcham and a leafy inner southern suburb, where residential construction and utility works require traffic management plans compliant with City of Mitcham and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Mitcham-compliant TMPs for Mitcham residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Blackwood", "Hawthorndene", "Torrens Park", "Lynton", "Colonel Light Gardens", "Clapham", "Pasadena", "Panorama", "Edwardstown", "Eden Hills"],
  },
  {
    slug: "parkside",
    suburb: "Parkside",
    state: "SA",
    postcode: "5063",
    council: "City of Unley",
    keyRoads: ["Unley Road", "Greenhill Road", "Cross Road", "Glen Osmond Road"],
    intro:
      "Parkside is a sought-after inner southern suburb adjacent to the Adelaide Parklands, where residential construction and utility works require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Parkside residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Hyde Park", "Malvern", "Wayville", "Unley", "Goodwood", "Millswood", "Adelaide CBD", "Rose Park", "Fullarton", "Clarence Park"],
  },
  {
    slug: "payneham",
    suburb: "Payneham",
    state: "SA",
    postcode: "5070",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Payneham Road", "St Johns Road", "Glynburn Road", "Portrush Road"],
    intro:
      "Payneham is an established north-eastern suburb where residential construction and commercial development require traffic management plans compliant with City of Norwood Payneham & St Peters and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Norwood Payneham & St Peters-compliant TMPs for Payneham residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Marden", "College Park", "Felixstow", "Evandale", "Joslin", "Royston Park", "St Morris", "Hackney", "Norwood", "Glynde"],
  },
  {
    slug: "plympton",
    suburb: "Plympton",
    state: "SA",
    postcode: "5038",
    council: "City of West Torrens",
    keyRoads: ["Marion Road", "Anzac Highway", "South Road", "Daws Road"],
    intro:
      "Plympton is a western suburb where residential construction and commercial development require traffic management plans compliant with City of West Torrens and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Plympton residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Glandore", "Camden Park", "Edwardstown", "Clarence Park", "Netherby", "Kurralta Park", "Torrensville", "Cowandilla", "Richmond", "Marleston"],
  },
  {
    slug: "rose-park",
    suburb: "Rose Park",
    state: "SA",
    postcode: "5067",
    council: "City of Burnside",
    keyRoads: ["Kensington Road", "Portrush Road", "Fullarton Road", "Glen Osmond Road"],
    intro:
      "Rose Park is a prestigious inner eastern suburb adjacent to Norwood, where residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Rose Park residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Norwood", "Kensington", "Marryatville", "Dulwich", "Toorak Gardens", "Hazelwood Park", "Linden Park", "Kensington Gardens", "Glenunga", "Frewville"],
  },
  {
    slug: "thebarton",
    suburb: "Thebarton",
    state: "SA",
    postcode: "5031",
    council: "City of West Torrens",
    keyRoads: ["Port Road", "Henley Beach Road", "Sir Donald Bradman Drive", "Railway Terrace"],
    intro:
      "Thebarton is an inner western suburb undergoing significant residential transformation, where high-density residential development and commercial construction require traffic management plans compliant with City of West Torrens and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Thebarton residential and commercial projects.",
    industries: ["Residential and mixed-use development", "Commercial construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Torrensville", "Hindmarsh", "Bowden", "Brompton", "Mile End", "Cowandilla", "Hilton", "Richmond", "West Hindmarsh", "Adelaide CBD"],
  },
  {
    slug: "toorak-gardens",
    suburb: "Toorak Gardens",
    state: "SA",
    postcode: "5065",
    council: "City of Burnside",
    keyRoads: ["Kensington Road", "Portrush Road", "Fullarton Road", "Glynburn Road"],
    intro:
      "Toorak Gardens is one of Adelaide's most prestigious eastern suburbs where luxury residential construction and utility works require traffic management plans compliant with City of Burnside and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Burnside-compliant TMPs for Toorak Gardens luxury residential and infrastructure projects.",
    industries: ["Luxury residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Burnside", "Rose Park", "Marryatville", "Kensington", "Kensington Gardens", "Hazelwood Park", "Linden Park", "Glenunga", "Dulwich", "Tusmore"],
  },
  {
    slug: "torrensville",
    suburb: "Torrensville",
    state: "SA",
    postcode: "5031",
    council: "City of West Torrens",
    keyRoads: ["Sir Donald Bradman Drive", "Henley Beach Road", "Morphett Road", "Port Road"],
    intro:
      "Torrensville is an inner western suburb where residential construction and commercial development require traffic management plans compliant with City of West Torrens and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Torrensville residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Thebarton", "Hindmarsh", "Mile End", "Cowandilla", "Hilton", "Richmond", "Bowden", "West Hindmarsh", "Lockleys", "Underdale"],
  },
  {
    slug: "wayville",
    suburb: "Wayville",
    state: "SA",
    postcode: "5034",
    council: "City of Unley",
    keyRoads: ["Goodwood Road", "Greenhill Road", "Unley Road", "Cross Road"],
    intro:
      "Wayville is an inner southern suburb adjacent to the Adelaide Showground, where residential construction and commercial development around the showground precinct require traffic management plans compliant with City of Unley and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Unley-compliant TMPs for Wayville residential and commercial projects.",
    industries: ["Residential construction", "Events and showground infrastructure", "Commercial development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Goodwood", "Hyde Park", "Parkside", "Unley", "Malvern", "Millswood", "Clarence Park", "Fullarton", "Black Forest", "Edwardstown"],
  },
  // Northern Adelaide (additional)
  {
    slug: "andrews-farm",
    suburb: "Andrews Farm",
    state: "SA",
    postcode: "5114",
    council: "City of Playford",
    keyRoads: ["Andrews Farm Boulevard", "Heaslip Road", "Curtis Road", "Stebonheath Road"],
    intro:
      "Andrews Farm is one of Adelaide's fastest-growing northern residential estate areas, where large-scale subdivision construction and civil infrastructure create demand for traffic management documentation compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Andrews Farm residential estate and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Angle Vale", "Blakeview", "Munno Para", "Craigmore", "Smithfield", "Elizabeth", "Davoren Park", "Buckland Park", "Virginia", "Hillier"],
  },
  {
    slug: "angle-vale",
    suburb: "Angle Vale",
    state: "SA",
    postcode: "5117",
    council: "City of Playford",
    keyRoads: ["Angle Vale Road", "Curtis Road", "Old Port Wakefield Road", "Stebonheath Road"],
    intro:
      "Angle Vale is a semi-rural suburb in Adelaide's northern growth corridor where rural residential construction and horticultural infrastructure require traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Playford-compliant TMPs for Angle Vale rural residential and horticultural projects.",
    industries: ["Rural residential construction", "Horticultural infrastructure", "Utility maintenance", "Road and civil construction", "Council infrastructure works"],
    nearbySuburbs: ["Andrews Farm", "Virginia", "Buckland Park", "Hillier", "Gawler", "Two Wells", "Waterloo Corner", "Penfield", "Globe Derby Park", "Evanston"],
  },
  {
    slug: "blakeview",
    suburb: "Blakeview",
    state: "SA",
    postcode: "5114",
    council: "City of Playford",
    keyRoads: ["Coventry Road", "Andrews Farm Boulevard", "Curtis Road", "Craigmore Road"],
    intro:
      "Blakeview is a growing northern Adelaide suburb where residential construction and civil infrastructure require traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Blakeview residential and civil infrastructure projects.",
    industries: ["Residential construction", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Andrews Farm", "Craigmore", "Munno Para", "Smithfield", "Elizabeth", "Davoren Park", "Uleybury", "One Tree Hill", "Gulfview Heights", "Hillbank"],
  },
  {
    slug: "craigmore",
    suburb: "Craigmore",
    state: "SA",
    postcode: "5114",
    council: "City of Playford",
    keyRoads: ["Craigmore Road", "Coventry Road", "Montague Road", "Yorktown Road"],
    intro:
      "Craigmore is an established northern suburb in the City of Playford where residential construction and utility works require traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Playford-compliant TMPs for Craigmore residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Blakeview", "Andrews Farm", "Munno Para", "Smithfield", "Elizabeth", "Davoren Park", "Gulfview Heights", "Hillbank", "Uleybury", "One Tree Hill"],
  },
  {
    slug: "golden-grove",
    suburb: "Golden Grove",
    state: "SA",
    postcode: "5125",
    council: "City of Tea Tree Gully",
    keyRoads: ["The Golden Way", "Sunridge Road", "Auldana Road", "Grove Way"],
    intro:
      "Golden Grove is a large master-planned residential suburb in Adelaide's north-east, where residential construction and commercial development around The Grove Shopping Centre create demand for traffic management plans compliant with City of Tea Tree Gully and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Golden Grove residential and commercial projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Greenwith", "Surrey Downs", "Fairview Park", "Redwood Park", "Modbury Heights", "Ridgehaven", "St Agnes", "Banksia Park", "Wynn Vale", "Tea Tree Gully"],
  },
  {
    slug: "modbury",
    suburb: "Modbury",
    state: "SA",
    postcode: "5092",
    council: "City of Tea Tree Gully",
    keyRoads: ["North East Road", "Smart Road", "Modbury Road", "Reservoir Road"],
    intro:
      "Modbury is a major north-eastern Adelaide retail centre, anchored by Tea Tree Plaza, where retail construction and residential development create demand for traffic management plans compliant with City of Tea Tree Gully and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Tea Tree Gully-compliant TMPs for Modbury retail and residential projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Tea Tree Gully", "Para Hills", "Modbury Heights", "Ridgehaven", "Fairview Park", "Surrey Downs", "Golden Grove", "Ingle Farm", "Gulfview Heights", "Walkley Heights"],
  },
  {
    slug: "munno-para",
    suburb: "Munno Para",
    state: "SA",
    postcode: "5115",
    council: "City of Playford",
    keyRoads: ["Main North Road", "Davoren Road", "Andrews Farm Boulevard", "Munno Para Road"],
    intro:
      "Munno Para is a northern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Munno Para residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Davoren Park", "Andrews Farm", "Blakeview", "Craigmore", "Smithfield", "Elizabeth", "Paralowie", "Parafield Gardens", "Salisbury", "Salisbury North"],
  },
  {
    slug: "paralowie",
    suburb: "Paralowie",
    state: "SA",
    postcode: "5108",
    council: "City of Salisbury",
    keyRoads: ["Main North Road", "Salisbury Highway", "Paralowie Road", "Bridge Road"],
    intro:
      "Paralowie is a northern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Salisbury-compliant TMPs for Paralowie residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Salisbury", "Munno Para", "Parafield Gardens", "Para Hills", "Brahma Lodge", "Mawson Lakes", "Globe Derby Park", "Pooraka", "Elizabeth", "Davoren Park"],
  },
  {
    slug: "parafield-gardens",
    suburb: "Parafield Gardens",
    state: "SA",
    postcode: "5107",
    council: "City of Salisbury",
    keyRoads: ["Salisbury Highway", "Whites Road", "Bridge Road", "Kings Road"],
    intro:
      "Parafield Gardens is a northern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Parafield Gardens residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Parafield", "Para Hills", "Salisbury", "Paralowie", "Mawson Lakes", "Globe Derby Park", "Brahma Lodge", "Pooraka", "Ingle Farm", "Salisbury Heights"],
  },
  {
    slug: "pooraka",
    suburb: "Pooraka",
    state: "SA",
    postcode: "5095",
    council: "City of Salisbury",
    keyRoads: ["Main North Road", "Womma Road", "Haydown Road", "Martins Road"],
    intro:
      "Pooraka is a northern Adelaide light industrial and residential suburb where industrial construction and residential development require traffic management plans compliant with City of Salisbury and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Salisbury-compliant TMPs for Pooraka industrial and residential projects.",
    industries: ["Light industrial and commercial construction", "Residential development", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Mawson Lakes", "Salisbury", "Para Hills", "Parafield", "Dry Creek", "Cavan", "Brahma Lodge", "Globe Derby Park", "Parafield Gardens", "Walkley Heights"],
  },
  {
    slug: "smithfield-sa",
    suburb: "Smithfield",
    state: "SA",
    postcode: "5114",
    council: "City of Playford",
    keyRoads: ["Main North Road", "Andrews Farm Boulevard", "Craigmore Road", "Heaslip Road"],
    intro:
      "Smithfield is a northern Adelaide suburb where residential construction and commercial development at Munno Para Shopping City create demand for traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Smithfield residential and commercial projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Munno Para", "Andrews Farm", "Blakeview", "Craigmore", "Davoren Park", "Elizabeth", "Paralowie", "Salisbury", "Parafield Gardens", "Gulfview Heights"],
  },
  {
    slug: "virginia",
    suburb: "Virginia",
    state: "SA",
    postcode: "5120",
    council: "City of Playford",
    keyRoads: ["Port Wakefield Road", "Virginia Road", "Angle Vale Road", "Old Port Wakefield Road"],
    intro:
      "Virginia is a horticultural and rural township north of Adelaide, where greenhouse vegetable production, rural residential construction and associated infrastructure require traffic management plans compliant with City of Playford and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Playford-compliant TMPs for Virginia horticultural and rural infrastructure projects.",
    industries: ["Horticultural and greenhouse infrastructure", "Rural residential construction", "Agricultural infrastructure", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Angle Vale", "Waterloo Corner", "Two Wells", "Andrews Farm", "Hillier", "Buckland Park", "Bolivar", "Globe Derby Park", "Parafield Gardens", "Gawler"],
  },
  // Southern Adelaide (additional)
  {
    slug: "aldinga-beach",
    suburb: "Aldinga Beach",
    state: "SA",
    postcode: "5173",
    council: "City of Onkaparinga",
    keyRoads: ["Port Willunga Road", "Aldinga Beach Road", "Reef Road", "Commercial Road"],
    intro:
      "Aldinga Beach is a growing coastal suburb at the southern end of Metropolitan Adelaide, where residential construction and coastal infrastructure works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Aldinga Beach residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Seaford", "Port Willunga", "Willunga", "McLaren Vale", "Sellicks Beach", "Moana", "Maslin Beach", "Morphett Vale", "Old Noarlunga", "Noarlunga"],
  },
  {
    slug: "christies-beach",
    suburb: "Christies Beach",
    state: "SA",
    postcode: "5165",
    council: "City of Onkaparinga",
    keyRoads: ["Beach Road", "Dyson Road", "Commercial Road", "Bowman Road"],
    intro:
      "Christies Beach is a coastal suburb in southern Adelaide's Onkaparinga region, where residential construction and foreshore infrastructure works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Christies Beach residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Noarlunga", "Port Noarlunga", "Morphett Vale", "Old Noarlunga", "Hackham", "Seaford", "Christie Downs", "Woodcroft", "Reynella", "Onkaparinga Hills"],
  },
  {
    slug: "happy-valley",
    suburb: "Happy Valley",
    state: "SA",
    postcode: "5159",
    council: "City of Marion",
    keyRoads: ["Main South Road", "Happy Valley Drive", "Majors Road", "Galloway Road"],
    intro:
      "Happy Valley is a southern Adelaide suburb where residential construction and utility works require traffic management plans compliant with City of Marion and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Happy Valley residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Hallett Cove", "Sheidow Park", "Trott Park", "O'Halloran Hill", "Morphett Vale", "Reynella", "Woodcroft", "Christie Downs", "Lonsdale", "Mitchell Park"],
  },
  {
    slug: "moana",
    suburb: "Moana",
    state: "SA",
    postcode: "5169",
    council: "City of Onkaparinga",
    keyRoads: ["Seaford Road", "Tatachilla Road", "Patterson Road", "Celeste Road"],
    intro:
      "Moana is a coastal suburb in Adelaide's southern corridor where residential construction and coastal infrastructure works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Moana residential and coastal projects.",
    industries: ["Coastal residential construction", "Foreshore and coastal works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Seaford", "Maslin Beach", "Aldinga Beach", "Morphett Vale", "Noarlunga", "Christies Beach", "Port Noarlunga", "Hackham", "Christie Downs", "Seaford Rise"],
  },
  {
    slug: "morphettville",
    suburb: "Morphettville",
    state: "SA",
    postcode: "5043",
    council: "City of Marion",
    keyRoads: ["Marion Road", "Morphett Road", "Anzac Highway", "Diagonal Road"],
    intro:
      "Morphettville is a western suburb home to the Adelaide Racecourse, where residential construction, racing precinct infrastructure and commercial development require traffic management plans compliant with City of Marion and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Morphettville residential and commercial projects.",
    industries: ["Residential construction", "Racecourse and events infrastructure", "Commercial development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Park Holme", "Mitchell Park", "Oaklands Park", "Glengowrie", "South Plympton", "Edwardstown", "Plympton", "Sturt", "Marion", "Warradale"],
  },
  {
    slug: "old-reynella",
    suburb: "Old Reynella",
    state: "SA",
    postcode: "5161",
    council: "City of Onkaparinga",
    keyRoads: ["Main South Road", "Panalatinga Road", "Bains Road", "Sherriffs Road"],
    intro:
      "Old Reynella is an established southern suburb where residential construction and utility works require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Old Reynella residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Reynella", "Morphett Vale", "Hackham", "Woodcroft", "Christie Downs", "Noarlunga", "Seaford", "Christies Beach", "Happy Valley", "Hallett Cove"],
  },
  {
    slug: "reynella",
    suburb: "Reynella",
    state: "SA",
    postcode: "5161",
    council: "City of Onkaparinga",
    keyRoads: ["Main South Road", "Panalatinga Road", "Bains Road", "Tatachilla Road"],
    intro:
      "Reynella is a southern Adelaide suburb where residential construction and retail development require traffic management plans compliant with City of Onkaparinga and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Reynella residential and commercial projects.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Old Reynella", "Morphett Vale", "Hackham", "Woodcroft", "Christie Downs", "Noarlunga", "Seaford", "Christies Beach", "Happy Valley", "Hallett Cove"],
  },
  // Eastern Adelaide (additional)
  {
    slug: "athelstone",
    suburb: "Athelstone",
    state: "SA",
    postcode: "5076",
    council: "City of Campbelltown",
    keyRoads: ["Gorge Road", "Darley Road", "Newton Road", "Athelstone Road"],
    intro:
      "Athelstone is a foothills suburb in eastern Adelaide adjacent to the Morialta Conservation Park, where residential construction and utility works require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Campbelltown-compliant TMPs for Athelstone residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Newton", "Campbelltown", "Rostrevor", "Magill", "Hectorville", "Tranmere", "St Morris", "Auldana", "Burnside", "Kensington Gardens"],
  },
  {
    slug: "auldana",
    suburb: "Auldana",
    state: "SA",
    postcode: "5072",
    council: "City of Campbelltown",
    keyRoads: ["Auldana Road", "Rostrevor Parade", "Montacute Road", "Norton Summit Road"],
    intro:
      "Auldana is a small foothills suburb in eastern Adelaide where residential construction and utility works require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Auldana residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Rostrevor", "Magill", "Newton", "Campbelltown", "Athelstone", "Hectorville", "Norton Summit", "Burnside", "Kensington Gardens", "Wattle Park"],
  },
  {
    slug: "hectorville",
    suburb: "Hectorville",
    state: "SA",
    postcode: "5073",
    council: "City of Campbelltown",
    keyRoads: ["Lower North East Road", "Athelstone Road", "Hectorville Road", "Gorge Road"],
    intro:
      "Hectorville is a residential suburb in eastern Adelaide where residential construction and utility works require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Campbelltown-compliant TMPs for Hectorville residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Campbelltown", "Newton", "Tranmere", "Athelstone", "Rostrevor", "Magill", "St Morris", "Auldana", "Burnside", "Kensington Gardens"],
  },
  {
    slug: "magill",
    suburb: "Magill",
    state: "SA",
    postcode: "5072",
    council: "City of Campbelltown",
    keyRoads: ["Magill Road", "Montacute Road", "Gorge Road", "Lower North East Road"],
    intro:
      "Magill is an eastern Adelaide suburb known for its wine heritage and the University of South Australia's Magill campus, where university-related construction and residential development require traffic management plans compliant with City of Campbelltown and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Magill university, residential and heritage projects.",
    industries: ["University and education support works", "Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Campbelltown", "Newton", "Rostrevor", "Athelstone", "Hectorville", "Auldana", "St Morris", "Tranmere", "Burnside", "Kensington Gardens"],
  },
  // Fleurieu Peninsula (additional)
  {
    slug: "goolwa",
    suburb: "Goolwa",
    state: "SA",
    postcode: "5214",
    council: "Alexandrina Council",
    keyRoads: ["Goolwa Road", "Cadell Street", "Barrage Road", "Hindmarsh Island Road"],
    intro:
      "Goolwa is a historic river town at the mouth of the Murray River, a popular tourist destination and the gateway to Hindmarsh Island, where residential construction, marina development and tourism infrastructure require traffic management plans compliant with Alexandrina Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alexandrina Council-compliant TMPs for Goolwa residential, marina and tourism projects.",
    industries: ["Residential construction", "Marina and waterfront development", "Tourism infrastructure", "Heritage building refurbishment", "Utility maintenance"],
    nearbySuburbs: ["Port Elliot", "Victor Harbor", "Middleton", "Hindmarsh Island", "Currency Creek", "Sandergrove", "Finniss", "Milang", "Strathalbyn", "Clayton Bay"],
  },
  {
    slug: "middleton-sa",
    suburb: "Middleton",
    state: "SA",
    postcode: "5213",
    council: "Alexandrina Council",
    keyRoads: ["Goolwa Road", "Fielder Street", "Victor Harbor Road", "Surfers Avenue"],
    intro:
      "Middleton is a small coastal township between Goolwa and Port Elliot, famous for its surf breaks, where coastal residential construction and tourism infrastructure works require traffic management plans compliant with Alexandrina Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Middleton coastal residential and tourism projects.",
    industries: ["Coastal residential construction", "Tourism and hospitality development", "Coastal and foreshore works", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Port Elliot", "Goolwa", "Victor Harbor", "Encounter Bay", "Hayborough", "Currency Creek", "Hindmarsh Island", "Waitpinga", "Newland", "Inman Valley"],
  },
  {
    slug: "willunga",
    suburb: "Willunga",
    state: "SA",
    postcode: "5172",
    council: "City of Onkaparinga",
    keyRoads: ["Main Road", "Aldinga Road", "St Judes Street", "Old Willunga Hill Road"],
    intro:
      "Willunga is a heritage township in the McLaren Vale wine region, known for its almonds, heritage buildings and Saturday market, where rural residential construction and winery development require traffic management plans compliant with City of Onkaparinga requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Onkaparinga-compliant TMPs for Willunga heritage, residential and winery projects.",
    industries: ["Rural residential construction", "Winery and vineyard infrastructure", "Heritage building refurbishment", "Tourism development", "Utility maintenance"],
    nearbySuburbs: ["McLaren Vale", "McLaren Flat", "Aldinga Beach", "Seaford", "Old Noarlunga", "Morphett Vale", "Noarlunga", "Christies Beach", "Kangarilla", "Clarendon"],
  },
  // Regional SA (additional)
  {
    slug: "bordertown",
    suburb: "Bordertown",
    state: "SA",
    postcode: "5268",
    council: "Tatiara District Council",
    keyRoads: ["Woolshed Street", "Dukes Highway", "Farquhar Street", "Nathan Terrace"],
    intro:
      "Bordertown is the birthplace of former Prime Minister Bob Hawke and the major service centre of the Tatiara district, where agricultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Tatiara District Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bordertown agricultural, residential and commercial projects.",
    industries: ["Agricultural construction", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Wolseley", "Keith", "Naracoorte", "Padthaway", "Mundulla", "Tintinara", "Kaniva", "Nhill", "Frances", "Serviceton"],
  },
  {
    slug: "ceduna",
    suburb: "Ceduna",
    state: "SA",
    postcode: "5690",
    council: "District Council of Ceduna",
    keyRoads: ["McKenzie Street", "Highway One", "Kuhlmann Street", "Poynton Street"],
    intro:
      "Ceduna is the gateway to the Nullarbor Plain and a major service centre for the far west Eyre Peninsula, where oyster aquaculture industry construction, remote area infrastructure and residential development create demand for traffic management plans compliant with District Council of Ceduna and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares District Council of Ceduna-compliant TMPs for aquaculture, remote infrastructure and residential projects.",
    industries: ["Aquaculture and oyster industry infrastructure", "Remote area infrastructure", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Smoky Bay", "Streaky Bay", "Penong", "Cactus Beach", "Nunjikompita", "Denial Bay", "Thevenard", "Nullarbor", "Fowlers Bay", "Coorabie"],
  },
  {
    slug: "loxton",
    suburb: "Loxton",
    state: "SA",
    postcode: "5333",
    council: "Loxton Waikerie District Council",
    keyRoads: ["East Terrace", "Bookpurnong Road", "Loxton Road", "Riverfront Road"],
    intro:
      "Loxton is a Riverland town known for its irrigation horticulture and the Loxton Historical Village, where horticultural infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Loxton Waikerie District Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Loxton horticultural, residential and commercial projects in the Riverland.",
    industries: ["Horticultural and irrigation infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Waikerie", "Berri", "Barmera", "Renmark", "Paringa", "Ramco", "Moorook", "Kingston on Murray", "Cobdogla", "Loveday"],
  },
  {
    slug: "millicent",
    suburb: "Millicent",
    state: "SA",
    postcode: "5280",
    council: "Wattle Range Council",
    keyRoads: ["George Street", "Penola Road", "Mount Gambier Road", "McLean Street"],
    intro:
      "Millicent is the major service centre of the Wattle Range district, where timber industry infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Wattle Range Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wattle Range Council-compliant TMPs for timber industry, residential and commercial projects.",
    industries: ["Timber and forestry infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Penola", "Beachport", "Robe", "Mount Gambier", "Bordertown", "Lucindale", "Tantanoola", "Kalangadoo", "Glencoe", "Southend"],
  },
  {
    slug: "naracoorte",
    suburb: "Naracoorte",
    state: "SA",
    postcode: "5271",
    council: "Naracoorte Lucindale Council",
    keyRoads: ["Smith Street", "Ormerod Street", "Jenkins Terrace", "Frances Road"],
    intro:
      "Naracoorte is the major service centre of the South East and gateway to the Naracoorte Caves World Heritage Area, where livestock industry infrastructure, residential development and commercial construction create demand for traffic management plans compliant with Naracoorte Lucindale Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Naracoorte agricultural, residential and commercial projects in the South East.",
    industries: ["Livestock and agricultural infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Lucindale", "Keith", "Bordertown", "Penola", "Millicent", "Coonawarra", "Bool Lagoon", "Frances", "Keppoch", "Padthaway"],
  },
  {
    slug: "penola",
    suburb: "Penola",
    state: "SA",
    postcode: "5277",
    council: "Wattle Range Council",
    keyRoads: ["Church Street", "Arthur Street", "Portland Road", "Riddoch Highway"],
    intro:
      "Penola is the heart of the Coonawarra wine region and the birthplace of Mary MacKillop, where winery construction, tourism infrastructure and residential development require traffic management plans compliant with Wattle Range Council and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Wattle Range Council-compliant TMPs for Penola winery, tourism and residential projects.",
    industries: ["Winery and vineyard construction", "Tourism infrastructure", "Residential development", "Heritage building refurbishment", "Utility maintenance"],
    nearbySuburbs: ["Coonawarra", "Mount Gambier", "Millicent", "Naracoorte", "Lucindale", "Padthaway", "Bordertown", "Kalangadoo", "Glencoe", "Wrattonbully"],
  },
  {
    slug: "streaky-bay",
    suburb: "Streaky Bay",
    state: "SA",
    postcode: "5680",
    council: "District Council of Streaky Bay",
    keyRoads: ["Alfred Terrace", "Bay Road", "Wells Street", "Flinders Highway"],
    intro:
      "Streaky Bay is a remote coastal town on the Eyre Peninsula, a growing tourism destination, where aquaculture infrastructure, tourism construction and residential development require traffic management plans compliant with District Council of Streaky Bay and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Streaky Bay aquaculture, tourism and residential projects.",
    industries: ["Aquaculture infrastructure", "Tourism and hospitality construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Ceduna", "Smoky Bay", "Poochera", "Wirrulla", "Wudinna", "Minnipa", "Kimba", "Cowell", "Elliston", "Lock"],
  },
  {
    slug: "woomera",
    suburb: "Woomera",
    state: "SA",
    postcode: "5720",
    council: "Roxby Downs Municipality",
    keyRoads: ["Dewrang Avenue", "Eureka Avenue", "Stuart Highway", "Island Lagoon Road"],
    intro:
      "Woomera is Australia's most significant rocket testing and defence research town, where defence infrastructure, residential maintenance and essential services works require traffic management plans compliant with Commonwealth and Department for Infrastructure and Transport SA requirements.",
    bodyPara:
      "Focus Traffic Plans prepares compliant TMPs for Woomera defence infrastructure and essential services projects in remote South Australia.",
    industries: ["Defence and aerospace infrastructure", "Essential services works", "Residential maintenance", "Utility maintenance", "Remote area civil works"],
    nearbySuburbs: ["Port Augusta", "Roxby Downs", "Olympic Dam", "Andamooka", "Pimba", "Glendambo", "Coober Pedy", "Leigh Creek", "Marree", "Hawker"],
  },

  // ─── TASMANIA ──────────────────────────────────────────────────────────────

  {
    slug: "hobart",
    suburb: "Hobart CBD",
    state: "TAS",
    postcode: "7000",
    council: "Hobart City Council",
    keyRoads: ["Elizabeth Street", "Macquarie Street", "Murray Street", "Davey Street"],
    intro:
      "Hobart CBD is Tasmania's capital and one of Australia's fastest-growing cities, with major waterfront redevelopment, significant residential construction, heritage building upgrades and increasing tourism infrastructure creating a strong and growing demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans prepares Hobart City Council-compliant TMP and heritage streetscape documentation for Hobart projects, with an understanding of the compact CBD grid and waterfront precinct requirements.",
    industries: [
      "Waterfront and tourism development",
      "Heritage building refurbishment",
      "Residential construction",
      "Commercial and hospitality fitouts",
      "Utility maintenance",
      "Events and festivals",
    ],
    nearbySuburbs: ["Battery Point", "Sandy Bay", "South Hobart", "West Hobart", "North Hobart", "New Town", "Glenorchy", "Moonah", "Lutana", "Lindisfarne"],
  },
  {
    slug: "launceston",
    suburb: "Launceston",
    state: "TAS",
    postcode: "7250",
    council: "Launceston City Council",
    keyRoads: ["Brisbane Street", "Charles Street", "Cameron Street", "Westbury Road"],
    intro:
      "Launceston is Tasmania's second city and the gateway to Northern Tasmania, with active residential construction, heritage CBD maintenance, university development and Tamar Valley infrastructure works creating consistent demand for traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans provides Launceston City Council-compliant TMP documentation for Northern Tasmania projects, offering fast turnaround to match the pace of the region's growing construction sector.",
    industries: [
      "Residential and commercial construction",
      "Heritage building refurbishment",
      "University and educational projects",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Agribusiness and rural infrastructure",
    ],
    nearbySuburbs: ["Devonport", "Burnie", "Ulverstone", "Westbury", "Longford", "Perth", "Invermay", "Mowbray", "Ravenswood", "Prospect"],
  },
  {
    slug: "devonport",
    suburb: "Devonport",
    state: "TAS",
    postcode: "7310",
    council: "Devonport City Council",
    keyRoads: ["Fenton Street", "Rooke Street", "Formby Road", "Don Road"],
    intro:
      "Devonport is Tasmania's ferry gateway and North West Coast's major commercial hub, where port operations, residential development and road upgrades on key North West arterials require traffic management plan documentation under Devonport City Council and Infrastructure Tasmania standards.",
    bodyPara:
      "Focus Traffic Plans provides TMP and TGS documentation for Devonport and the North West Coast region, supporting projects from residential builds to major port and road infrastructure.",
    industries: [
      "Port and marine construction",
      "Residential construction",
      "Commercial and retail development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Agribusiness and food processing",
    ],
    nearbySuburbs: ["Ulverstone", "Burnie", "Penguin", "Spreyton", "Latrobe", "Port Sorell", "Sheffield", "Wynyard", "Forth", "Turners Beach"],
  },

  // ─── TASMANIA (additional) ─────────────────────────────────────────────────

  // Greater Hobart (additional)
  {
    slug: "battery-point",
    suburb: "Battery Point",
    state: "TAS",
    postcode: "7004",
    council: "City of Hobart",
    keyRoads: ["Hampden Road", "McGregor Street", "Sandy Bay Road", "Napoleon Street"],
    intro:
      "Battery Point is Hobart's historic maritime village and one of Australia's most intact Georgian and Victorian heritage precincts, where heritage building refurbishment, boutique hospitality development and residential construction require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Hobart-compliant TMPs for Battery Point heritage and residential projects, with sensitivity to the suburb's narrow heritage streetscape.",
    industries: [
      "Heritage building refurbishment",
      "Boutique hospitality and retail fitouts",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Hobart CBD", "Sandy Bay", "South Hobart", "West Hobart", "Glebe", "Dynnyrne", "Taroona", "Mount Stuart", "Lenah Valley", "New Town"],
  },
  {
    slug: "glenorchy",
    suburb: "Glenorchy",
    state: "TAS",
    postcode: "7010",
    council: "City of Glenorchy",
    keyRoads: ["Main Road", "Brooker Highway", "Tolosa Street", "Derwent Park Road"],
    intro:
      "Glenorchy is Hobart's major northern industrial and commercial suburb, home to the Moonah Arts Centre and significant residential and light industrial development, where construction activity requires traffic management plans compliant with City of Glenorchy and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Glenorchy residential, commercial and light industrial projects, with experience on the Brooker Highway corridor.",
    industries: [
      "Light industrial and commercial construction",
      "Residential development",
      "Arts and cultural infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Moonah", "Derwent Park", "Claremont", "Berriedale", "Rosetta", "Montrose", "Austins Ferry", "Granton", "Hobart CBD", "New Town"],
  },
  {
    slug: "howrah",
    suburb: "Howrah",
    state: "TAS",
    postcode: "7018",
    council: "City of Clarence",
    keyRoads: ["Howrah Road", "South Arm Highway", "Rokeby Road", "Richmond Road"],
    intro:
      "Howrah is a major eastern shore suburb in Hobart's City of Clarence, where residential construction and utility works require traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Howrah residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Rokeby", "Lauderdale", "Mornington", "Tranmere", "Warrane", "Montagu Bay", "Rosny Park", "Bellerive", "Clarence Plains", "Risdon Vale"],
  },
  {
    slug: "huonville",
    suburb: "Huonville",
    state: "TAS",
    postcode: "7109",
    council: "Huon Valley Council",
    keyRoads: ["Main Road", "Huon Highway", "High Street", "James Street"],
    intro:
      "Huonville is the service centre of the Huon Valley, Tasmania's premier apple-growing and aquaculture region, where agricultural infrastructure, residential development and salmon farming support construction create demand for traffic management plans compliant with Huon Valley Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Huonville agricultural, residential and infrastructure projects in the Huon Valley.",
    industries: [
      "Agricultural and aquaculture infrastructure",
      "Residential construction",
      "Commercial development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Grove", "Cygnet", "Geeveston", "Franklin", "Ranelagh", "Birchs Bay", "Lymington", "Port Huon", "Judbury", "Brookfield"],
  },
  {
    slug: "kingston",
    suburb: "Kingston",
    state: "TAS",
    postcode: "7050",
    council: "Kingborough Council",
    keyRoads: ["Channel Highway", "Kingston Bypass", "Beach Road", "Hutchins Street"],
    intro:
      "Kingston is the commercial centre of Hobart's rapidly growing southern corridor, home to Kingborough Council, the Antarctic Division and major retail development, where construction activity creates demand for traffic management plans compliant with Kingborough Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Kingborough Council-compliant TMPs for Kingston retail, residential and infrastructure projects in Hobart's southern growth corridor.",
    industries: [
      "Retail and commercial construction",
      "Residential subdivision and housing",
      "Government and research infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Blackmans Bay", "Huntingfield", "Oyster Cove", "Margate", "Woodbridge", "Taroona", "Bonnet Hill", "Coningham", "Lower Longley", "Howden"],
  },
  {
    slug: "moonah",
    suburb: "Moonah",
    state: "TAS",
    postcode: "7009",
    council: "City of Glenorchy",
    keyRoads: ["Main Road", "Hopkins Street", "Moonah Place", "Derwent Park Road"],
    intro:
      "Moonah is a diverse inner-northern Hobart suburb with a growing arts and multicultural identity, where residential construction, commercial development and utility works require traffic management plans compliant with City of Glenorchy and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Moonah residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Glenorchy", "New Town", "Derwent Park", "Lutana", "Hobart CBD", "North Hobart", "West Moonah", "Claremont", "Berriedale", "Rosetta"],
  },
  {
    slug: "sandy-bay",
    suburb: "Sandy Bay",
    state: "TAS",
    postcode: "7005",
    council: "City of Hobart",
    keyRoads: ["Sandy Bay Road", "Churchill Avenue", "Nelson Road", "Quayle Street"],
    intro:
      "Sandy Bay is Hobart's premier residential suburb, home to the Wrest Point Casino and University of Tasmania's Sandy Bay campus, where luxury residential construction, university-related development and boutique retail works require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Hobart-compliant TMPs for Sandy Bay residential, university and commercial projects.",
    industries: [
      "Luxury residential construction",
      "University and education development",
      "Casino and hospitality construction",
      "Boutique retail fitouts",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Battery Point", "Hobart CBD", "South Hobart", "Dynnyrne", "Taroona", "Lower Sandy Bay", "Glebe", "Mount Nelson", "Tolmans Hill", "West Hobart"],
  },
  {
    slug: "sorell",
    suburb: "Sorell",
    state: "TAS",
    postcode: "7172",
    council: "Sorell Council",
    keyRoads: ["Cole Street", "Sorell Street", "Forcett Street", "Arthur Highway"],
    intro:
      "Sorell is the fastest-growing municipality in Tasmania, a heritage township and gateway to the Tasman Peninsula, where major residential subdivision, commercial development and infrastructure upgrades create strong demand for traffic management documentation compliant with Sorell Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sorell residential, commercial and infrastructure projects in Tasmania's fastest-growing corridor.",
    industries: [
      "Residential subdivision and housing",
      "Commercial and retail development",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Midway Point", "Dodges Ferry", "Lewisham", "Penna", "Rokeby", "Lauderdale", "Pittwater", "Orielton", "Forcett", "Carlton River"],
  },
  // Northern Tasmania (additional)
  {
    slug: "burnie",
    suburb: "Burnie",
    state: "TAS",
    postcode: "7320",
    council: "Burnie City Council",
    keyRoads: ["Wilson Street", "Bass Highway", "Mount Street", "Marine Terrace"],
    intro:
      "Burnie is north-west Tasmania's major industrial port city and regional hub, where port infrastructure, industrial construction and residential development create demand for traffic management plans compliant with Burnie City Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Burnie City Council-compliant TMPs for port, industrial and residential projects in north-west Tasmania.",
    industries: [
      "Port and industrial infrastructure",
      "Residential development",
      "Commercial construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Wynyard", "Somerset", "Penguin", "Ulverstone", "Cooee", "Parklands", "Havenview", "Romaine", "Shorewell Park", "Wivenhoe"],
  },
  {
    slug: "longford",
    suburb: "Longford",
    state: "TAS",
    postcode: "7301",
    council: "Northern Midlands Council",
    keyRoads: ["Wellington Street", "Marlborough Street", "Archer Street", "Perth Road"],
    intro:
      "Longford is a heritage township in Tasmania's Northern Midlands and the gateway to the Ben Lomond ski resort, where residential construction, agricultural infrastructure and heritage building works require traffic management plans compliant with Northern Midlands Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Longford residential and heritage projects in the Northern Midlands.",
    industries: [
      "Residential construction",
      "Agricultural infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Perth", "Launceston", "Carrick", "Hadspen", "Westbury", "Evandale", "Cressy", "Bishopsbourne", "Bracknell", "Hagley"],
  },
  {
    slug: "perth-tas",
    suburb: "Perth",
    state: "TAS",
    postcode: "7300",
    council: "Northern Midlands Council",
    keyRoads: ["Midland Highway", "High Street", "Bass Highway", "Esk Highway"],
    intro:
      "Perth is a heritage township just south of Launceston and a significant rural service centre, where residential construction and agricultural infrastructure require traffic management plans compliant with Northern Midlands Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Northern Midlands Council-compliant TMPs for Perth residential and rural infrastructure projects.",
    industries: [
      "Residential construction",
      "Agricultural infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Longford", "Launceston", "Hadspen", "Carrick", "Westbury", "Evandale", "Bishopsbourne", "Hagley", "Breadalbane", "Cressy"],
  },
  {
    slug: "ulverstone",
    suburb: "Ulverstone",
    state: "TAS",
    postcode: "7315",
    council: "Central Coast Council",
    keyRoads: ["Reibey Street", "King Edward Street", "Water Street", "Bass Highway"],
    intro:
      "Ulverstone is a coastal town on the north-west Tasmanian coast and the commercial centre of Central Coast Council, where residential development, commercial construction and coastal infrastructure works require traffic management plans compliant with Central Coast Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ulverstone residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial development",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Devonport", "Penguin", "Burnie", "Turners Beach", "Forth", "Heybridge", "Nietta", "Preservation Bay", "Sulphur Creek", "Leith"],
  },
  {
    slug: "westbury",
    suburb: "Westbury",
    state: "TAS",
    postcode: "7303",
    council: "Meander Valley Council",
    keyRoads: ["William Street", "Bass Highway", "Deloraine Road", "Perth Road"],
    intro:
      "Westbury is a charming heritage township in the Meander Valley, where residential construction and agricultural infrastructure require traffic management plans compliant with Meander Valley Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Meander Valley Council-compliant TMPs for Westbury residential and rural infrastructure projects.",
    industries: [
      "Residential construction",
      "Agricultural infrastructure",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Longford", "Perth", "Deloraine", "Launceston", "Hagley", "Carrick", "Hadspen", "Bracknell", "Meander", "Chudleigh"],
  },
  {
    slug: "wynyard",
    suburb: "Wynyard",
    state: "TAS",
    postcode: "7325",
    council: "Waratah-Wynyard Council",
    keyRoads: ["Goldie Street", "Dodgin Street", "Inglis Street", "Bass Highway"],
    intro:
      "Wynyard is a coastal town in north-west Tasmania adjacent to Burnie Airport, where residential construction, tourism infrastructure and utility works require traffic management plans compliant with Waratah-Wynyard Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wynyard residential and tourism projects in north-west Tasmania.",
    industries: [
      "Residential construction",
      "Tourism and hospitality development",
      "Airport-related construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Burnie", "Somerset", "Boat Harbour Beach", "Sisters Beach", "Table Cape", "Fossil Bluff", "Cam", "Wiltshire", "Flowerdale", "Doctors Rocks"],
  },
  // East Coast
  {
    slug: "bicheno",
    suburb: "Bicheno",
    state: "TAS",
    postcode: "7215",
    council: "Break O'Day Council",
    keyRoads: ["Burgess Street", "Foster Street", "Tasman Highway", "Banksia Street"],
    intro:
      "Bicheno is a popular east coast Tasmanian tourist town, a gateway to Freycinet National Park, where tourism infrastructure, residential construction and coastal works require traffic management plans compliant with Break O'Day Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Break O'Day Council-compliant TMPs for Bicheno tourism and residential projects on Tasmania's east coast.",
    industries: [
      "Tourism and hospitality construction",
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Swansea", "Coles Bay", "Freycinet", "Friendly Beaches", "Cranbrook", "Apslawn", "St Helens", "Scamander", "Douglas-Apsley", "Four Mile Creek"],
  },
  {
    slug: "campbell-town",
    suburb: "Campbell Town",
    state: "TAS",
    postcode: "7210",
    council: "Northern Midlands Council",
    keyRoads: ["High Street", "Midland Highway", "Bridge Street", "Queen Street"],
    intro:
      "Campbell Town is a historic convict-era township on the Midland Highway, where heritage building refurbishment, agricultural infrastructure and road works require traffic management plans compliant with Northern Midlands Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Campbell Town heritage and rural infrastructure projects.",
    industries: [
      "Heritage building refurbishment",
      "Agricultural infrastructure",
      "Road and highway maintenance",
      "Utility maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Ross", "Conara", "Longford", "Tunbridge", "Cressy", "Avoca", "Lake Leake", "Epping Forest", "Hermitage", "Tooms Lake"],
  },
  {
    slug: "orford",
    suburb: "Orford",
    state: "TAS",
    postcode: "7190",
    council: "Glamorgan Spring Bay Council",
    keyRoads: ["Tasman Highway", "Charles Street", "Raspins Beach Road", "Spring Beach Road"],
    intro:
      "Orford is a coastal township on the Prosser River estuary and gateway to Maria Island, where tourism infrastructure, residential construction and coastal works require traffic management plans compliant with Glamorgan Spring Bay Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Glamorgan Spring Bay Council-compliant TMPs for Orford tourism and residential projects.",
    industries: [
      "Tourism and hospitality construction",
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Triabunna", "Swansea", "Buckland", "Wielangta", "Spring Beach", "Raspins Beach", "Rheban", "Runnymede", "Sorell", "Dodges Ferry"],
  },
  {
    slug: "st-helens",
    suburb: "St Helens",
    state: "TAS",
    postcode: "7216",
    council: "Break O'Day Council",
    keyRoads: ["Cecilia Street", "Georges Bay Road", "Quail Street", "Tasman Highway"],
    intro:
      "St Helens is the largest town on Tasmania's east coast and a major fishing and tourism hub on Georges Bay, where residential development, tourism infrastructure and port works require traffic management plans compliant with Break O'Day Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for St Helens residential and tourism projects on the east coast.",
    industries: [
      "Residential construction",
      "Tourism and hospitality development",
      "Port and fishing infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Bicheno", "Scamander", "Beaumaris", "St Marys", "Fingal", "Pyengana", "Ansons Bay", "Four Mile Creek", "Falmouth", "Stieglitz"],
  },
  {
    slug: "swansea",
    suburb: "Swansea",
    state: "TAS",
    postcode: "7190",
    council: "Glamorgan Spring Bay Council",
    keyRoads: ["Franklin Street", "Tasman Highway", "Maria Street", "Victoria Street"],
    intro:
      "Swansea is a heritage town on Great Oyster Bay and the gateway to Freycinet Peninsula, where tourism infrastructure, residential construction and heritage building works require traffic management plans compliant with Glamorgan Spring Bay Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Glamorgan Spring Bay Council-compliant TMPs for Swansea tourism and residential projects.",
    industries: [
      "Tourism and hospitality construction",
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Bicheno", "Orford", "Coles Bay", "Freycinet", "Triabunna", "Cranbrook", "Little Swanport", "Dolphin Sands", "Apslawn", "Friendly Beaches"],
  },
  // West Coast
  {
    slug: "queenstown",
    suburb: "Queenstown",
    state: "TAS",
    postcode: "7467",
    council: "West Coast Council",
    keyRoads: ["Orr Street", "Driffield Street", "Sticht Street", "Lyell Highway"],
    intro:
      "Queenstown is one of Australia's most distinctive mining towns, famous for its stark, colourful landscape and copper mining heritage, where mine operations, tourism infrastructure and essential services construction require traffic management plans compliant with West Coast Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Queenstown mining, tourism and essential services projects on Tasmania's remote west coast.",
    industries: [
      "Mining and copper industry infrastructure",
      "Tourism and heritage development",
      "Essential services construction",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Gormanston", "Linda", "Strahan", "Rosebery", "Zeehan", "Tullah", "Granville Harbour", "Macquarie Heads", "Teepookana", "Crotty"],
  },
  {
    slug: "rosebery",
    suburb: "Rosebery",
    state: "TAS",
    postcode: "7470",
    council: "West Coast Council",
    keyRoads: ["Agnes Street", "Park Street", "Murchison Highway", "Drake Street"],
    intro:
      "Rosebery is a remote west coast mining town where zinc and lead mining operations, residential maintenance and essential services works require traffic management plans compliant with West Coast Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares West Coast Council-compliant TMPs for Rosebery mining and essential services projects.",
    industries: [
      "Mining and base metals infrastructure",
      "Residential maintenance",
      "Essential services construction",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Zeehan", "Tullah", "Queenstown", "Renison Bell", "Granville Harbour", "Strahan", "Savage River", "Waratah", "Burnie", "Ulverstone"],
  },
  {
    slug: "strahan",
    suburb: "Strahan",
    state: "TAS",
    postcode: "7468",
    council: "West Coast Council",
    keyRoads: ["The Esplanade", "Harold Street", "Innes Street", "Lyell Highway"],
    intro:
      "Strahan is Tasmania's gateway to Macquarie Harbour and the wild west coast, a major tourism destination, where tourism infrastructure, port works and essential services construction require traffic management plans compliant with West Coast Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Strahan tourism and port infrastructure projects on the remote west coast.",
    industries: [
      "Tourism and hospitality construction",
      "Port and marine infrastructure",
      "Essential services construction",
      "Utility maintenance",
      "Road and access maintenance",
    ],
    nearbySuburbs: ["Queenstown", "Zeehan", "Rosebery", "Granville Harbour", "Macquarie Heads", "Teepookana", "Crotty", "Kelly Basin", "Gormanston", "Tullah"],
  },
  {
    slug: "zeehan",
    suburb: "Zeehan",
    state: "TAS",
    postcode: "7469",
    council: "West Coast Council",
    keyRoads: ["Main Street", "Fowler Street", "Murchison Highway", "Oceana Road"],
    intro:
      "Zeehan is a historic silver-mining town on Tasmania's west coast, where mining heritage infrastructure, residential maintenance and essential services works require traffic management plans compliant with West Coast Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares West Coast Council-compliant TMPs for Zeehan mining heritage and essential services projects.",
    industries: [
      "Mining heritage infrastructure",
      "Residential maintenance",
      "Essential services construction",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Rosebery", "Queenstown", "Tullah", "Renison Bell", "Granville Harbour", "Strahan", "Savage River", "Waratah", "Burnie", "Wynyard"],
  },

  // ─── TASMANIA (further additions) ─────────────────────────────────────────

  // Greater Hobart (additional)
  {
    slug: "bellerive",
    suburb: "Bellerive",
    state: "TAS",
    postcode: "7018",
    council: "City of Clarence",
    keyRoads: ["Cambridge Road", "Bellerive Road", "Rokeby Road", "Derwent Parade"],
    intro:
      "Bellerive is an eastern shore suburb of Hobart on the Derwent River, home to Bellerive Oval and a popular waterfront, where residential construction and coastal infrastructure works require traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Bellerive residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Sports infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Rosny Park", "Montagu Bay", "Howrah", "Mornington", "Rokeby", "Warrane", "Tranmere", "Lindisfarne", "Risdon Vale", "Clarence Plains"],
  },
  {
    slug: "clarence",
    suburb: "Clarence",
    state: "TAS",
    postcode: "7018",
    council: "City of Clarence",
    keyRoads: ["East Derwent Highway", "Cambridge Road", "Rokeby Road", "South Arm Highway"],
    intro:
      "The City of Clarence encompasses Hobart's major eastern shore suburbs, where diverse residential construction, retail development and the Eastlands shopping precinct create demand for traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Clarence LGA residential and commercial projects across the eastern shore.",
    industries: ["Residential construction", "Retail and commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Bellerive", "Rosny Park", "Howrah", "Rokeby", "Mornington", "Tranmere", "Warrane", "Montagu Bay", "Lindisfarne", "Risdon Vale"],
  },
  {
    slug: "claremont-tas",
    suburb: "Claremont",
    state: "TAS",
    postcode: "7011",
    council: "City of Glenorchy",
    keyRoads: ["Main Road", "Claremont Street", "Derwent Valley Road", "Claremont Avenue"],
    intro:
      "Claremont is a northern Hobart suburb on the Derwent River where residential construction and utility works require traffic management plans compliant with City of Glenorchy and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Glenorchy-compliant TMPs for Claremont residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Glenorchy", "Berriedale", "Rosetta", "Montrose", "Chigwell", "Granton", "Austins Ferry", "New Town", "Moonah", "Derwent Park"],
  },
  {
    slug: "lindisfarne",
    suburb: "Lindisfarne",
    state: "TAS",
    postcode: "7015",
    council: "City of Clarence",
    keyRoads: ["East Derwent Highway", "Lindisfarne Road", "Sandown Road", "Channel Court"],
    intro:
      "Lindisfarne is a sought-after eastern shore suburb of Hobart with sweeping Derwent River views, where residential construction and utility works require traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Lindisfarne residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Rosny Park", "Montagu Bay", "Bellerive", "Warrane", "Mornington", "Howrah", "Geilston Bay", "Rose Bay", "Rokeby", "Clarence Plains"],
  },
  {
    slug: "montagu-bay",
    suburb: "Montagu Bay",
    state: "TAS",
    postcode: "7018",
    council: "City of Clarence",
    keyRoads: ["Montagu Bay Road", "East Derwent Highway", "Rokeby Road", "Proctors Road"],
    intro:
      "Montagu Bay is a residential suburb on the eastern shore of Hobart where residential construction and utility works require traffic management plans compliant with City of Clarence requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Montagu Bay residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Bellerive", "Rosny Park", "Lindisfarne", "Warrane", "Howrah", "Mornington", "Rokeby", "Tranmere", "Risdon Vale", "Clarence Plains"],
  },
  {
    slug: "new-town",
    suburb: "New Town",
    state: "TAS",
    postcode: "7008",
    council: "City of Hobart",
    keyRoads: ["New Town Road", "Main Road", "Augusta Road", "Risdon Road"],
    intro:
      "New Town is an inner northern Hobart suburb where residential construction and utility works require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for New Town residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Moonah", "Glenorchy", "North Hobart", "West Hobart", "Lutana", "Derwent Park", "Claremont", "Lenah Valley", "Mount Stuart", "Glebe"],
  },
  {
    slug: "north-hobart",
    suburb: "North Hobart",
    state: "TAS",
    postcode: "7000",
    council: "City of Hobart",
    keyRoads: ["Elizabeth Street", "Argyle Street", "Brisbane Street", "Wellington Street"],
    intro:
      "North Hobart is a vibrant inner suburb known for its lively Elizabeth Street café and restaurant strip, where residential construction and boutique commercial fitouts require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Hobart-compliant TMPs for North Hobart residential and commercial projects.",
    industries: ["Residential construction", "Boutique retail and hospitality fitouts", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["New Town", "West Hobart", "Hobart CBD", "Glebe", "Spring Hill", "Moonah", "Lenah Valley", "Mount Stuart", "Battery Point", "South Hobart"],
  },
  {
    slug: "risdon-vale",
    suburb: "Risdon Vale",
    state: "TAS",
    postcode: "7016",
    council: "City of Clarence",
    keyRoads: ["Risdon Vale Road", "East Derwent Highway", "Risdon Road", "Bonney Street"],
    intro:
      "Risdon Vale is an eastern shore suburb of Hobart where residential construction and utility works require traffic management plans compliant with City of Clarence requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Risdon Vale residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Montagu Bay", "Warrane", "Lindisfarne", "Rosny Park", "Geilston Bay", "Clarendon Vale", "Risdon", "Rokeby", "Hobart CBD", "Glenorchy"],
  },
  {
    slug: "rokeby",
    suburb: "Rokeby",
    state: "TAS",
    postcode: "7019",
    council: "City of Clarence",
    keyRoads: ["Rokeby Road", "South Arm Highway", "Rokeby Highway", "Prossers Road"],
    intro:
      "Rokeby is a southern eastern shore suburb of Hobart where residential construction, retail development and utility works require traffic management plans compliant with City of Clarence requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Rokeby residential and commercial projects.",
    industries: ["Residential construction", "Commercial and retail development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Howrah", "Bellerive", "Mornington", "Tranmere", "Clarence Plains", "Warrane", "Sorell", "Dodges Ferry", "Midway Point", "Lauderdale"],
  },
  {
    slug: "rosny-park",
    suburb: "Rosny Park",
    state: "TAS",
    postcode: "7018",
    council: "City of Clarence",
    keyRoads: ["Cambridge Road", "Rosny Hill Road", "Bayfield Street", "East Derwent Highway"],
    intro:
      "Rosny Park is the major commercial centre of Hobart's eastern shore, anchored by Eastlands Shopping Centre, where retail construction and commercial development create demand for traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Rosny Park retail and commercial projects.",
    industries: ["Retail and commercial construction", "Residential development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Bellerive", "Montagu Bay", "Lindisfarne", "Howrah", "Warrane", "Mornington", "Rokeby", "Tranmere", "Clarence", "Geilston Bay"],
  },
  {
    slug: "south-hobart",
    suburb: "South Hobart",
    state: "TAS",
    postcode: "7004",
    council: "City of Hobart",
    keyRoads: ["Sandy Bay Road", "Macquarie Street", "Wellesley Street", "Molle Street"],
    intro:
      "South Hobart is an inner southern suburb where residential construction and heritage building refurbishment require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Hobart-compliant TMPs for South Hobart residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Hobart CBD", "Battery Point", "Sandy Bay", "West Hobart", "North Hobart", "Mount Nelson", "Dynnyrne", "Glebe", "Tolmans Hill", "Lower Sandy Bay"],
  },
  {
    slug: "west-hobart",
    suburb: "West Hobart",
    state: "TAS",
    postcode: "7000",
    council: "City of Hobart",
    keyRoads: ["Cascade Road", "Hill Street", "Argyle Street", "Davey Street"],
    intro:
      "West Hobart is a hilly inner suburb with panoramic Derwent River views, where residential construction and heritage building works require traffic management plans compliant with City of Hobart and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for West Hobart residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Hobart CBD", "North Hobart", "South Hobart", "New Town", "Battery Point", "Glebe", "Spring Hill", "Mount Stuart", "Lenah Valley", "Dynnyrne"],
  },
  // Hobart Surrounds
  {
    slug: "cambridge-tas",
    suburb: "Cambridge",
    state: "TAS",
    postcode: "7170",
    council: "City of Clarence",
    keyRoads: ["Cambridge Road", "Richmond Road", "East Derwent Highway", "Rookwood Road"],
    intro:
      "Cambridge is a growing eastern suburb of Hobart adjacent to Hobart Airport, where residential development, aviation-related construction and the Cambridge Park commercial precinct create demand for traffic management plans compliant with City of Clarence and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Cambridge residential, commercial and aviation-related projects.",
    industries: ["Residential development", "Airport and aviation infrastructure", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Rokeby", "Rosny Park", "Howrah", "Mornington", "Sorell", "Midway Point", "Dodges Ferry", "Richmond", "Orielton", "Penna"],
  },
  {
    slug: "dodges-ferry",
    suburb: "Dodges Ferry",
    state: "TAS",
    postcode: "7173",
    council: "Sorell Council",
    keyRoads: ["Carlton River Road", "Penna Road", "Dodges Ferry Road", "Shark Point Road"],
    intro:
      "Dodges Ferry is a coastal township in the Sorell municipality where coastal residential construction and foreshore works require traffic management plans compliant with Sorell Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dodges Ferry residential and coastal projects.",
    industries: ["Coastal residential construction", "Foreshore and coastal works", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Sorell", "Midway Point", "Lewisham", "Cambridge", "Rokeby", "Carlton River", "Pittwater", "Orielton", "Forcett", "Marion Bay"],
  },
  {
    slug: "kingston-beach",
    suburb: "Kingston Beach",
    state: "TAS",
    postcode: "7050",
    council: "Kingborough Council",
    keyRoads: ["Beach Road", "Osborne Esplanade", "Channel Highway", "Spring Farm Road"],
    intro:
      "Kingston Beach is a popular coastal suburb in Kingborough where residential construction and foreshore infrastructure works require traffic management plans compliant with Kingborough Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Kingborough Council-compliant TMPs for Kingston Beach residential and coastal projects.",
    industries: ["Coastal residential construction", "Foreshore and coastal works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Kingston", "Blackmans Bay", "Bonnet Hill", "Taroona", "Huntingfield", "Oyster Cove", "Margate", "Howden", "Coningham", "Woodbridge"],
  },
  {
    slug: "margate",
    suburb: "Margate",
    state: "TAS",
    postcode: "7054",
    council: "Kingborough Council",
    keyRoads: ["Channel Highway", "Margate Road", "Whitings Road", "Wilmot Road"],
    intro:
      "Margate is a coastal township on Hobart's channel, where residential construction and rural lifestyle development require traffic management plans compliant with Kingborough Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Margate residential and rural lifestyle projects.",
    industries: ["Residential construction", "Rural lifestyle development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Kingston", "Kingston Beach", "Snug", "Kettering", "Oyster Cove", "Woodbridge", "Howden", "Coningham", "Electrona", "Huntingfield"],
  },
  {
    slug: "midway-point",
    suburb: "Midway Point",
    state: "TAS",
    postcode: "7171",
    council: "Sorell Council",
    keyRoads: ["Midway Point Road", "Arthur Highway", "Orielton Road", "Penna Road"],
    intro:
      "Midway Point is a growing residential peninsula suburb between Hobart and Sorell, where residential construction and civil infrastructure create demand for traffic management plans compliant with Sorell Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Sorell Council-compliant TMPs for Midway Point residential and civil infrastructure projects.",
    industries: ["Residential construction", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Sorell", "Dodges Ferry", "Cambridge", "Rokeby", "Lewisham", "Orielton", "Pittwater", "Clarence Plains", "Carlton River", "Penna"],
  },
  {
    slug: "new-norfolk",
    suburb: "New Norfolk",
    state: "TAS",
    postcode: "7140",
    council: "Derwent Valley Council",
    keyRoads: ["High Street", "Circle Street", "Lyell Highway", "Burnett Street"],
    intro:
      "New Norfolk is a historic hop-growing and tourism town on the Derwent River, where residential construction, hop industry infrastructure and heritage building works require traffic management plans compliant with Derwent Valley Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for New Norfolk hop industry, residential and heritage projects.",
    industries: ["Hop and agricultural infrastructure", "Residential construction", "Heritage building refurbishment", "Tourism infrastructure", "Utility maintenance"],
    nearbySuburbs: ["Hobart CBD", "Glenorchy", "Bridgewater", "Boyer", "Bushy Park", "Westerway", "National Park", "Ouse", "Hamilton", "Ellendale"],
  },
  {
    slug: "richmond-tas",
    suburb: "Richmond",
    state: "TAS",
    postcode: "7025",
    council: "City of Clarence",
    keyRoads: ["Bridge Street", "Wellington Street", "Richmond Road", "Coal River Road"],
    intro:
      "Richmond is one of Australia's best-preserved colonial towns, a UNESCO-listed heritage destination and popular day trip from Hobart, where heritage building works, boutique hospitality construction and residential development require traffic management plans compliant with City of Clarence requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Clarence-compliant TMPs for Richmond heritage and residential projects.",
    industries: ["Heritage building refurbishment", "Tourism and hospitality construction", "Residential construction", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Cambridge", "Sorell", "Coal River Valley", "Campania", "Colebrook", "Tea Tree", "Buckland", "Rokeby", "Mornington", "Orielton"],
  },
  // Launceston & North (additional)
  {
    slug: "beaconsfield",
    suburb: "Beaconsfield",
    state: "TAS",
    postcode: "7270",
    council: "West Tamar Council",
    keyRoads: ["West Tamar Highway", "Grubb Street", "Weld Street", "Main Street"],
    intro:
      "Beaconsfield is a historic gold mining town on the West Tamar renowned for the 2006 mine rescue, where residential construction, heritage tourism and utility works require traffic management plans compliant with West Tamar Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Beaconsfield residential and heritage tourism projects.",
    industries: ["Heritage and mining tourism infrastructure", "Residential construction", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Beauty Point", "George Town", "Exeter", "Gravelly Beach", "Rowella", "Notley Hills", "Legana", "Riverside", "Launceston CBD", "Westbury"],
  },
  {
    slug: "beauty-point",
    suburb: "Beauty Point",
    state: "TAS",
    postcode: "7270",
    council: "West Tamar Council",
    keyRoads: ["West Tamar Highway", "Flinders Street", "Saville Street", "Faulkner Street"],
    intro:
      "Beauty Point is a small riverside town on the Tamar River, home to Seahorse World and the Australian Maritime College, where residential construction and marine infrastructure works require traffic management plans compliant with West Tamar Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares West Tamar Council-compliant TMPs for Beauty Point residential and marine projects.",
    industries: ["Residential construction", "Marine and maritime infrastructure", "Tourism and aquaculture development", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Beaconsfield", "George Town", "Exeter", "Gravelly Beach", "Rowella", "Kayena", "Kelso", "Low Head", "Notley Hills", "Greens Beach"],
  },
  {
    slug: "deloraine",
    suburb: "Deloraine",
    state: "TAS",
    postcode: "7304",
    council: "Meander Valley Council",
    keyRoads: ["Emu Bay Road", "Bass Highway", "West Parade", "Lake Highway"],
    intro:
      "Deloraine is a picturesque heritage town in the Meander Valley, a gateway to the Great Western Tiers, where residential construction, tourism infrastructure and agricultural works require traffic management plans compliant with Meander Valley Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Deloraine residential, tourism and agricultural projects.",
    industries: ["Residential construction", "Tourism and heritage development", "Agricultural infrastructure", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Westbury", "Longford", "Launceston CBD", "Mole Creek", "Meander", "Chudleigh", "Bracknell", "Elizabeth Town", "Hagley", "Carrick"],
  },
  {
    slug: "east-launceston",
    suburb: "East Launceston",
    state: "TAS",
    postcode: "7250",
    council: "City of Launceston",
    keyRoads: ["Talbot Road", "Brisbane Street", "Wellington Street", "Invermay Road"],
    intro:
      "East Launceston is a residential suburb of Launceston where residential construction and utility works require traffic management plans compliant with City of Launceston and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Launceston-compliant TMPs for East Launceston residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Launceston CBD", "South Launceston", "Prospect", "Ravenswood", "Newnham", "Mayfield", "Kings Meadows", "Youngtown", "Invermay", "Mowbray"],
  },
  {
    slug: "george-town",
    suburb: "George Town",
    state: "TAS",
    postcode: "7253",
    council: "George Town Council",
    keyRoads: ["Main Road", "Anne Street", "Elizabeth Street", "Low Head Road"],
    intro:
      "George Town is a historic town at the mouth of the Tamar River and home to Bell Bay industrial precinct, where heavy industrial construction, port infrastructure and residential development require traffic management plans compliant with George Town Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for George Town industrial, port and residential projects.",
    industries: ["Heavy industrial and aluminium infrastructure", "Port and logistics construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Beaconsfield", "Beauty Point", "Low Head", "Kelso", "Greens Beach", "Exeter", "Gravelly Beach", "Launceston CBD", "Legana", "Riverside"],
  },
  {
    slug: "launceston-cbd",
    suburb: "Launceston CBD",
    state: "TAS",
    postcode: "7250",
    council: "City of Launceston",
    keyRoads: ["Brisbane Street", "Charles Street", "Wellington Street", "Cameron Street"],
    intro:
      "Launceston CBD is the commercial and cultural heart of northern Tasmania, undergoing significant urban renewal with high-density residential development, commercial construction and Cataract Gorge precinct improvements creating demand for traffic management plans compliant with City of Launceston and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Launceston-compliant TMPs for CBD commercial and residential projects.",
    industries: ["Commercial and retail construction", "High-density residential development", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["East Launceston", "South Launceston", "Prospect", "Invermay", "Newnham", "Ravenswood", "Mowbray", "Kings Meadows", "Mayfield", "Youngtown"],
  },
  {
    slug: "prospect-tas",
    suburb: "Prospect",
    state: "TAS",
    postcode: "7250",
    council: "City of Launceston",
    keyRoads: ["Westbury Road", "Talbot Road", "High Street", "Hobart Road"],
    intro:
      "Prospect is a residential suburb of Launceston where residential construction and utility works require traffic management plans compliant with City of Launceston and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Prospect residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Launceston CBD", "East Launceston", "South Launceston", "Ravenswood", "Kings Meadows", "Mowbray", "Newnham", "Youngtown", "Mayfield", "Rocherlea"],
  },
  {
    slug: "ravenswood-tas",
    suburb: "Ravenswood",
    state: "TAS",
    postcode: "7250",
    council: "City of Launceston",
    keyRoads: ["Hobart Road", "Tyne Street", "Mowbray Heights Road", "North Plympton Road"],
    intro:
      "Ravenswood is a residential suburb in Launceston where residential construction and utility works require traffic management plans compliant with City of Launceston requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Launceston-compliant TMPs for Ravenswood residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Prospect", "East Launceston", "South Launceston", "Launceston CBD", "Kings Meadows", "Youngtown", "Newnham", "Mowbray", "Mayfield", "Waverley"],
  },
  {
    slug: "scottsdale",
    suburb: "Scottsdale",
    state: "TAS",
    postcode: "7260",
    council: "Break O'Day Council",
    keyRoads: ["King Street", "George Street", "Victoria Street", "Bridport Road"],
    intro:
      "Scottsdale is the major service centre of Tasmania's north-east, a hub for the timber industry and berry farming, where agricultural infrastructure, residential construction and commercial development require traffic management plans compliant with Break O'Day Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Scottsdale agricultural, residential and commercial projects in north-east Tasmania.",
    industries: ["Timber and agricultural infrastructure", "Residential development", "Commercial construction", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Derby", "Bridport", "Ringarooma", "Branxholm", "Winnaleah", "Pyengana", "St Helens", "Launceston CBD", "George Town", "Longford"],
  },
  {
    slug: "sheffield",
    suburb: "Sheffield",
    state: "TAS",
    postcode: "7306",
    council: "Central Coast Council",
    keyRoads: ["High Street", "Spring Street", "West Road", "Claude Road"],
    intro:
      "Sheffield is a heritage mural town at the foot of Mount Roland, a popular tourist destination and the gateway to Cradle Mountain, where tourism infrastructure and residential construction require traffic management plans compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Sheffield tourism and residential projects.",
    industries: ["Tourism and heritage development", "Residential construction", "Agricultural infrastructure", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Devonport", "Ulverstone", "Railton", "Latrobe", "Barrington", "Gowrie Park", "Kimberley", "Dunorlan", "Lake Barrington", "Mole Creek"],
  },
  {
    slug: "south-launceston",
    suburb: "South Launceston",
    state: "TAS",
    postcode: "7249",
    council: "City of Launceston",
    keyRoads: ["Wellington Street", "Charles Street", "Margaret Street", "Canning Street"],
    intro:
      "South Launceston is a residential suburb close to Launceston CBD where residential construction and utility works require traffic management plans compliant with City of Launceston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for South Launceston residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Launceston CBD", "East Launceston", "Prospect", "Kings Meadows", "Youngtown", "Mayfield", "Newnham", "Ravenswood", "Mowbray", "Invermay"],
  },
  // North West Tasmania (additional)
  {
    slug: "penguin",
    suburb: "Penguin",
    state: "TAS",
    postcode: "7316",
    council: "Central Coast Council",
    keyRoads: ["Main Road", "Bass Highway", "Ironcliffe Road", "Crescent Street"],
    intro:
      "Penguin is a charming coastal town on north-west Tasmania's Penguin Coast, known for its giant penguin and beachside lifestyle, where residential construction and coastal infrastructure works require traffic management plans compliant with Central Coast Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Central Coast Council-compliant TMPs for Penguin residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Tourism infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Ulverstone", "Burnie", "Sulphur Creek", "Heybridge", "Leith", "Preservation Bay", "Forth", "Turners Beach", "Castra", "Nietta"],
  },
  {
    slug: "smithton",
    suburb: "Smithton",
    state: "TAS",
    postcode: "7330",
    council: "Circular Head Council",
    keyRoads: ["Emmett Street", "Goldie Street", "Nelson Street", "Bass Highway"],
    intro:
      "Smithton is the major service centre of Tasmania's far north-west, a hub for beef and dairy farming and the timber industry, where agricultural infrastructure, residential development and timber industry construction create demand for traffic management plans compliant with Circular Head Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Smithton agricultural, timber and residential projects in the Circular Head region.",
    industries: ["Agricultural and dairy infrastructure", "Timber industry construction", "Residential development", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Stanley", "Marrawah", "Temma", "Trowutta", "Montagu", "Irishtown", "Burnie", "Wynyard", "Waratah", "Savage River"],
  },
  // East Coast (additional)
  {
    slug: "st-marys-tas",
    suburb: "St Marys",
    state: "TAS",
    postcode: "7215",
    council: "Break O'Day Council",
    keyRoads: ["Main Road", "Story Street", "Gray Street", "Fingal Valley Highway"],
    intro:
      "St Marys is a small inland township on the east coast of Tasmania, where residential construction and agricultural infrastructure require traffic management plans compliant with Break O'Day Council and Department of State Growth Tasmania requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Break O'Day Council-compliant TMPs for St Marys residential and agricultural projects.",
    industries: ["Residential construction", "Agricultural infrastructure", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["St Helens", "Fingal", "Avoca", "Scamander", "Bicheno", "Beaumaris", "Four Mile Creek", "Falmouth", "Stieglitz", "German Town"],
  },

  // ─── NORTHERN TERRITORY ────────────────────────────────────────────────────

  {
    slug: "darwin",
    suburb: "Darwin",
    state: "NT",
    postcode: "0800",
    council: "Darwin City Council",
    keyRoads: ["Stuart Highway", "Bagot Road", "McMillans Road", "Tiger Brennan Drive"],
    intro:
      "Darwin is the Northern Territory's capital and a strategic hub for defence, resources, and tropical construction. The wet season, complex road permissions from the NT Department of Infrastructure and significant defence and government project pipeline make well-prepared traffic management plan documentation essential for every project.",
    bodyPara:
      "Focus Traffic Plans prepares Darwin City Council and NT Government-compliant TMP documentation for projects across Darwin and the Top End, with an understanding of the seasonal constraints that affect construction scheduling.",
    industries: [
      "Defence and government infrastructure",
      "Resources and energy construction",
      "Residential and commercial development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Tourism and hospitality development",
    ],
    nearbySuburbs: ["Casuarina", "Nightcliff", "Parap", "Stuart Park", "Fannie Bay", "Coconut Grove", "Rapid Creek", "Moil", "Palmerston", "Howard Springs"],
  },
  {
    slug: "alice-springs",
    suburb: "Alice Springs",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Stuart Highway", "Gap Road", "Todd Street", "Larapinta Drive"],
    intro:
      "Alice Springs is the NT's second-largest town and the service centre for Central Australia, where remote location, desert climate and a significant community infrastructure pipeline create a unique set of requirements for traffic management plan documentation under Alice Springs Town Council and NT Government standards.",
    bodyPara:
      "Focus Traffic Plans provides TMP and TGS documentation for Alice Springs and remote Central Australian projects, with documentation prepared to NT Government requirements and delivered within our standard 24-hour turnaround.",
    industries: [
      "Government and community infrastructure",
      "Resources and pastoral construction",
      "Residential development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Tourism and hospitality development",
    ],
    nearbySuburbs: ["Gillen", "Larapinta", "Sadadeen", "Desert Springs", "Braitling", "Eastside", "The Gap", "Heavitree", "Mount Johns", "Ross"],
  },

  // ─── NORTHERN TERRITORY (additional) ──────────────────────────────────────

  // Darwin (additional)
  {
    slug: "casuarina",
    suburb: "Casuarina",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Casuarina Drive", "Trower Road", "Vanderlin Drive", "Lee Point Road"],
    intro:
      "Casuarina is Darwin's major northern suburb and retail hub, home to Casuarina Square and Charles Darwin University, where retail construction, university development and residential works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Casuarina retail, education and residential projects.",
    industries: [
      "Retail and commercial construction",
      "University and education development",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Nightcliff", "Rapid Creek", "Tiwi", "Wanguri", "Leanyer", "Brinkin", "Nakara", "Wagaman", "Millner", "Coconut Grove"],
  },
  {
    slug: "darwin-cbd",
    suburb: "Darwin CBD",
    state: "NT",
    postcode: "0800",
    council: "City of Darwin",
    keyRoads: ["Mitchell Street", "Smith Street", "Knuckey Street", "McMinn Street"],
    intro:
      "Darwin CBD is the commercial and administrative heart of Australia's Top End, where tropical cyclone-resilient construction standards, defence precinct proximity and ongoing urban development create demand for traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Darwin CBD commercial, hospitality and infrastructure projects, with experience in the city's tropical construction environment.",
    industries: [
      "Commercial and hotel construction",
      "Government and defence infrastructure",
      "Retail and hospitality fitouts",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Darwin", "Larrakeyah", "Stuart Park", "Parap", "Fannie Bay", "Nightcliff", "Casuarina", "Winnellie", "Woolner", "Bayview"],
  },
  {
    slug: "howard-springs",
    suburb: "Howard Springs",
    state: "NT",
    postcode: "0835",
    council: "Litchfield Council",
    keyRoads: ["Howard Springs Road", "Whitewood Road", "Dwyer Circuit", "Burrendah Road"],
    intro:
      "Howard Springs is a semi-rural lifestyle suburb south of Darwin in Litchfield Council, where rural residential construction and utility works in a tropical environment require traffic management plans compliant with Litchfield Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Litchfield Council-compliant TMPs for Howard Springs rural residential and infrastructure projects.",
    industries: [
      "Rural residential construction",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
      "Agricultural and lifestyle development",
    ],
    nearbySuburbs: ["Humpty Doo", "Palmerston", "Coolalinga", "Virginia", "Noonamah", "Lambells Lagoon", "Acacia Hills", "Berry Springs", "Darwin", "Girraween"],
  },
  {
    slug: "humpty-doo",
    suburb: "Humpty Doo",
    state: "NT",
    postcode: "0836",
    council: "Litchfield Council",
    keyRoads: ["Arnhem Highway", "Coolalinga Road", "Freds Pass Road", "Strauss Road"],
    intro:
      "Humpty Doo is a rural township east of Darwin on the Arnhem Highway corridor and the gateway to Kakadu National Park, where rural residential construction, tourism infrastructure and utility works require traffic management plans compliant with Litchfield Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Humpty Doo rural residential and tourism projects.",
    industries: [
      "Rural residential construction",
      "Tourism and recreation infrastructure",
      "Agricultural development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Howard Springs", "Palmerston", "Virginia", "Noonamah", "Lambells Lagoon", "Berry Springs", "Girraween", "Coolalinga", "Acacia Hills", "Darwin"],
  },
  {
    slug: "nightcliff",
    suburb: "Nightcliff",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Dick Ward Drive", "Nightcliff Road", "Progress Drive", "Casuarina Drive"],
    intro:
      "Nightcliff is a popular coastal suburb in Darwin's northern suburbs, known for its weekend market and beachside lifestyle, where residential construction and coastal infrastructure works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Nightcliff residential and coastal projects.",
    industries: [
      "Residential construction",
      "Coastal and foreshore works",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Casuarina", "Rapid Creek", "Coconut Grove", "Millner", "Nakara", "Tiwi", "Wanguri", "Brinkin", "Wagaman", "Darwin CBD"],
  },
  {
    slug: "palmerston",
    suburb: "Palmerston",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Temple Terrace", "Roystonea Avenue", "Chung Wah Terrace", "Elrundie Avenue"],
    intro:
      "Palmerston is Darwin's satellite city and the NT's fastest-growing urban centre, where large residential estates, a new hospital, retail development and defence-related infrastructure create strong demand for traffic management documentation compliant with City of Palmerston and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans produces City of Palmerston-compliant TMPs for residential, health and commercial projects across Darwin's growing satellite city.",
    industries: [
      "Residential subdivision and housing",
      "Health and hospital infrastructure",
      "Retail and commercial development",
      "Defence-related construction",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Howard Springs", "Humpty Doo", "Virginia", "Coolalinga", "Noonamah", "Darwin", "Girraween", "Archer", "Gunn", "Durack"],
  },
  {
    slug: "parap",
    suburb: "Parap",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Parap Road", "Gilruth Avenue", "Gregory Street", "Ross Smith Avenue"],
    intro:
      "Parap is an inner Darwin suburb known for its popular Saturday market, heritage bungalows and proximity to the Darwin CBD, where residential construction and boutique commercial development require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Parap residential and commercial projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Darwin CBD", "Stuart Park", "Fannie Bay", "Larrakeyah", "Woolner", "Ludmilla", "Bayview", "Nightcliff", "Coconut Grove", "Millner"],
  },
  {
    slug: "stuart-park",
    suburb: "Stuart Park",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Tiger Brennan Drive", "Gilruth Avenue", "Shepherd Street", "Stuart Highway"],
    intro:
      "Stuart Park is an inner Darwin suburb adjacent to the CBD, where residential construction, commercial development and the proximity to the Darwin Waterfront precinct create demand for traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Stuart Park residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and office development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Darwin CBD", "Parap", "Larrakeyah", "Fannie Bay", "Woolner", "Bayview", "Ludmilla", "Nightcliff", "Coconut Grove", "Winnellie"],
  },
  // Alice Springs (additional)
  {
    slug: "braitling",
    suburb: "Braitling",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Undoolya Road", "Chewings Street", "Schwarz Crescent", "Stott Terrace"],
    intro:
      "Braitling is a residential suburb in Alice Springs where residential construction and utility works in a remote desert environment require traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Braitling residential and infrastructure projects in Alice Springs.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alice Springs CBD", "Gillen", "Larapinta", "Desert Springs", "Sadadeen", "Eastside", "The Gap", "Heavitree", "Mount Johns", "Ross"],
  },
  {
    slug: "desert-springs",
    suburb: "Desert Springs",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Ross Highway", "Cromwell Drive", "Warburton Street", "Palm Circuit"],
    intro:
      "Desert Springs is an eastern Alice Springs suburb where residential construction and utility works require traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alice Springs Town Council-compliant TMPs for Desert Springs residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alice Springs CBD", "Sadadeen", "Gillen", "Larapinta", "Braitling", "Eastside", "The Gap", "Heavitree", "Mount Johns", "Ross"],
  },
  {
    slug: "gillen",
    suburb: "Gillen",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Gap Road", "Chewings Street", "Priest Street", "Traeger Avenue"],
    intro:
      "Gillen is a residential suburb in south-west Alice Springs where residential construction and utility works require traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gillen residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Alice Springs CBD", "Larapinta", "Braitling", "Desert Springs", "Sadadeen", "The Gap", "Heavitree", "Mount Johns", "White Gums", "Araluen"],
  },
  {
    slug: "larapinta",
    suburb: "Larapinta",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Larapinta Drive", "Ragonesi Road", "Undoolya Road", "Ilparpa Road"],
    intro:
      "Larapinta is a growing western suburb of Alice Springs where residential construction and proximity to the Western Desert Drive and Larapinta Trail tourism corridor create demand for traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alice Springs Town Council-compliant TMPs for Larapinta residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Tourism support infrastructure",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gillen", "Alice Springs CBD", "Braitling", "Desert Springs", "Sadadeen", "The Gap", "White Gums", "Araluen", "Ilparpa", "Mount Johns"],
  },
  {
    slug: "sadadeen",
    suburb: "Sadadeen",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["South Terrace", "Sadadeen Road", "Gap Road", "Ross Highway"],
    intro:
      "Sadadeen is a southern Alice Springs suburb where residential construction and utility works in a remote desert environment require traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sadadeen residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
      "Essential services works",
    ],
    nearbySuburbs: ["Alice Springs CBD", "Desert Springs", "Gillen", "The Gap", "Heavitree", "Mount Johns", "Larapinta", "Braitling", "Eastside", "Ross"],
  },
  // Katherine
  {
    slug: "katherine",
    suburb: "Katherine",
    state: "NT",
    postcode: "0850",
    council: "Victoria Daly Regional Council",
    keyRoads: ["Katherine Terrace", "Stuart Highway", "Giles Street", "First Street"],
    intro:
      "Katherine is the NT's fourth-largest town and the major service centre of the Top End's south, home to RAAF Base Tindal and Nitmiluk (Katherine Gorge) National Park, where defence infrastructure, tourism construction and residential development create demand for traffic management plans compliant with Victoria Daly Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares council-compliant TMPs for Katherine defence, tourism and residential projects in the NT's southern Top End.",
    industries: [
      "Defence and RAAF infrastructure",
      "Tourism and hospitality construction",
      "Residential development",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Tindal", "Katherine East", "Mataranka", "Larrimah", "Daly Waters", "Pine Creek", "Kakadu", "Nitmiluk", "Batchelor", "Darwin"],
  },
  {
    slug: "katherine-east",
    suburb: "Katherine East",
    state: "NT",
    postcode: "0850",
    council: "Victoria Daly Regional Council",
    keyRoads: ["Stuart Highway", "Florina Road", "Railway Terrace", "Pearce Street"],
    intro:
      "Katherine East is a residential and light industrial suburb of Katherine where residential construction and utility works require traffic management plans compliant with Victoria Daly Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Katherine East residential and light industrial projects.",
    industries: [
      "Residential construction",
      "Light industrial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Katherine", "Tindal", "Mataranka", "Darwin", "Pine Creek", "Larrimah", "Daly Waters", "Batchelor", "Adelaide River", "Kakadu"],
  },
  {
    slug: "mataranka",
    suburb: "Mataranka",
    state: "NT",
    postcode: "0852",
    council: "Roper Gulf Regional Council",
    keyRoads: ["Stuart Highway", "Martin Road", "Roper Terrace", "Gorrie Road"],
    intro:
      "Mataranka is a remote outback township on the Stuart Highway south of Katherine, famous for its thermal pools and proximity to Elsey National Park, where tourism infrastructure and essential services works require traffic management plans compliant with Roper Gulf Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares council-compliant TMPs for Mataranka tourism and essential services projects in remote NT.",
    industries: [
      "Tourism and hospitality construction",
      "Essential services works",
      "Remote area infrastructure",
      "Utility maintenance",
      "Road and highway maintenance",
    ],
    nearbySuburbs: ["Katherine", "Larrimah", "Daly Waters", "Roper Bar", "Elsey", "Birdum", "Barkly Homestead", "Tennant Creek", "Darwin", "Pine Creek"],
  },
  {
    slug: "tindal",
    suburb: "Tindal",
    state: "NT",
    postcode: "0852",
    council: "Victoria Daly Regional Council",
    keyRoads: ["Stuart Highway", "Tindal Road", "RAAF Base Road", "Katherine Gorge Road"],
    intro:
      "Tindal is home to RAAF Base Tindal, one of Australia's largest air combat bases and a critical piece of national defence infrastructure, where base expansion, residential construction and utility works require traffic management plans compliant with NT Department of Infrastructure and Defence requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Tindal defence and residential projects near Katherine.",
    industries: [
      "Defence and RAAF base infrastructure",
      "Residential construction",
      "Utility maintenance",
      "Road and access construction",
      "Essential services works",
    ],
    nearbySuburbs: ["Katherine", "Katherine East", "Mataranka", "Pine Creek", "Darwin", "Larrimah", "Kakadu", "Nitmiluk", "Batchelor", "Adelaide River"],
  },
  // Regional NT
  {
    slug: "elliott",
    suburb: "Elliott",
    state: "NT",
    postcode: "0862",
    council: "Barkly Regional Council",
    keyRoads: ["Stuart Highway", "Railway Road", "Tablelands Highway", "Elliott Street"],
    intro:
      "Elliott is a remote outback township on the Stuart Highway in the Barkly region, where highway infrastructure maintenance, essential services works and pastoral support construction require traffic management plans compliant with Barkly Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares council-compliant TMPs for Elliott highway infrastructure and essential services projects in remote central NT.",
    industries: [
      "Highway and road maintenance",
      "Essential services construction",
      "Pastoral and agricultural infrastructure",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Tennant Creek", "Renner Springs", "Banka Banka", "Newcastle Waters", "Daly Waters", "Mataranka", "Ali Curung", "Barkly Homestead", "Darwin", "Katherine"],
  },
  {
    slug: "nhulunbuy",
    suburb: "Nhulunbuy",
    state: "NT",
    postcode: "0880",
    council: "East Arnhem Regional Council",
    keyRoads: ["Westal Street", "Endeavour Square", "Arnhem Road", "Matthew Flinders Way"],
    intro:
      "Nhulunbuy is a remote mining town on the Gove Peninsula in Arnhem Land, home to a major bauxite mining and alumina refining operation, where mining infrastructure, residential construction and essential services works require traffic management plans compliant with East Arnhem Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nhulunbuy mining, residential and essential services projects in remote north-east Arnhem Land.",
    industries: [
      "Bauxite mining and alumina infrastructure",
      "Residential construction",
      "Essential services works",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Yirrkala", "Gunyangara", "Bapunu", "Gove", "Birritjimi", "Darwin", "Katherine", "Groote Eylandt", "Alyangula", "Jabiru"],
  },
  {
    slug: "tennant-creek",
    suburb: "Tennant Creek",
    state: "NT",
    postcode: "0860",
    council: "Barkly Regional Council",
    keyRoads: ["Stuart Highway", "Paterson Street", "Davidson Street", "Venn Street"],
    intro:
      "Tennant Creek is the Barkly region's major service centre and a significant gold mining town at the geographic centre of the Northern Territory, where mining infrastructure, residential development and essential services construction create demand for traffic management plans compliant with Barkly Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares council-compliant TMPs for Tennant Creek mining, residential and infrastructure projects in remote central NT.",
    industries: [
      "Gold mining and resources infrastructure",
      "Residential development",
      "Essential services construction",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Elliott", "Ali Curung", "Renner Springs", "Banka Banka", "Barkly Homestead", "Alice Springs", "Katherine", "Darwin", "Wauchope", "Wycliffe Well"],
  },
  {
    slug: "yulara",
    suburb: "Yulara",
    state: "NT",
    postcode: "0872",
    council: "MacDonnell Regional Council",
    keyRoads: ["Yulara Drive", "Connellan Airport Road", "Lasseter Highway", "Resort Circle"],
    intro:
      "Yulara is the resort village and service hub for Uluru-Kata Tjuta National Park, one of Australia's most visited tourist destinations, where tourism resort construction, airport upgrades and essential services works require traffic management plans compliant with MacDonnell Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Yulara resort construction and essential services projects near Uluru.",
    industries: [
      "Tourism resort construction",
      "Airport and aviation infrastructure",
      "Essential services works",
      "Utility maintenance",
      "Remote area civil works",
    ],
    nearbySuburbs: ["Mutitjulu", "Docker River", "Kata Tjuta", "Alice Springs", "Kings Canyon", "Curtin Springs", "Erldunda", "Mount Ebenezer", "Finke", "Kulgera"],
  },

  // ─── NORTHERN TERRITORY (further additions) ────────────────────────────────

  // Darwin Inner (additional)
  {
    slug: "bagot",
    suburb: "Bagot",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Bagot Road", "Progress Drive", "McMillans Road", "Beaton Road"],
    intro:
      "Bagot is an inner Darwin suburb where residential construction and utility works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Bagot residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works", "Essential services works"],
    nearbySuburbs: ["Casuarina", "Nightcliff", "Millner", "Nakara", "Tiwi", "Rapid Creek", "Coconut Grove", "Wagaman", "Jingili", "Moil"],
  },
  {
    slug: "bayview",
    suburb: "Bayview",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Bayview Boulevard", "Gilruth Avenue", "Beaufort Street", "Cavenagh Street"],
    intro:
      "Bayview is a residential suburb of inner Darwin overlooking Fannie Bay, where residential construction and utility works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bayview residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Fannie Bay", "Parap", "Stuart Park", "Darwin CBD", "Larrakeyah", "Ludmilla", "Woolner", "Nightcliff", "Coconut Grove", "Millner"],
  },
  {
    slug: "coconut-grove",
    suburb: "Coconut Grove",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Trower Road", "Coconut Grove Road", "Dick Ward Drive", "Progress Drive"],
    intro:
      "Coconut Grove is a northern Darwin suburb where residential construction and coastal infrastructure works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Coconut Grove residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Nightcliff", "Rapid Creek", "Casuarina", "Millner", "Nakara", "Tiwi", "Wanguri", "Brinkin", "Wagaman", "Darwin CBD"],
  },
  {
    slug: "fannie-bay",
    suburb: "Fannie Bay",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["East Point Road", "Gilruth Avenue", "Ross Smith Avenue", "Fannie Bay Crescent"],
    intro:
      "Fannie Bay is a prestigious Darwin suburb on the Timor Sea foreshore, home to the Museum and Art Gallery of the Northern Territory, where residential construction and coastal infrastructure works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fannie Bay residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Cultural infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Darwin CBD", "Bayview", "Parap", "Stuart Park", "Larrakeyah", "Ludmilla", "Nightcliff", "Coconut Grove", "Woolner", "Millner"],
  },
  {
    slug: "jingili",
    suburb: "Jingili",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["McMillans Road", "Vanderlin Drive", "Jingili Terrace", "Trower Road"],
    intro:
      "Jingili is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Jingili residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Nakara", "Millner", "Tiwi", "Wagaman", "Casuarina", "Coconut Grove", "Rapid Creek", "Wanguri", "Leanyer", "Nightcliff"],
  },
  {
    slug: "larrakeyah",
    suburb: "Larrakeyah",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["The Esplanade", "Woods Street", "McMinn Street", "Daly Street"],
    intro:
      "Larrakeyah is an inner Darwin suburb adjacent to the CBD and HMAS Coonawarra naval base, where residential construction and defence infrastructure works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Larrakeyah residential and defence-adjacent projects.",
    industries: ["Residential construction", "Defence-adjacent infrastructure", "Heritage building works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Darwin CBD", "Stuart Park", "Fannie Bay", "Bayview", "Parap", "Woolner", "Ludmilla", "Nightcliff", "Coconut Grove", "West Darwin"],
  },
  {
    slug: "leanyer",
    suburb: "Leanyer",
    state: "NT",
    postcode: "0812",
    council: "City of Darwin",
    keyRoads: ["Vanderlin Drive", "Leanyer Drive", "Lee Point Road", "Trower Road"],
    intro:
      "Leanyer is a northern Darwin suburb home to the Leanyer Recreation Park, where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Leanyer residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Recreation infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Casuarina", "Wanguri", "Tiwi", "Nakara", "Jingili", "Wagaman", "Brinkin", "Coconut Grove", "Nightcliff", "Millner"],
  },
  {
    slug: "ludmilla",
    suburb: "Ludmilla",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Bagot Road", "Progress Drive", "Stuart Highway", "Woolner Road"],
    intro:
      "Ludmilla is an inner Darwin suburb where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ludmilla residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Parap", "Fannie Bay", "Stuart Park", "Bayview", "Darwin CBD", "Larrakeyah", "Woolner", "Millner", "Nightcliff", "Coconut Grove"],
  },
  {
    slug: "malak",
    suburb: "Malak",
    state: "NT",
    postcode: "0812",
    council: "City of Darwin",
    keyRoads: ["Vanderlin Drive", "Malak Crescent", "Leanyer Drive", "Trower Road"],
    intro:
      "Malak is a northern Darwin suburb where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Malak residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Leanyer", "Casuarina", "Wanguri", "Tiwi", "Nakara", "Jingili", "Wagaman", "Brinkin", "Coconut Grove", "Nightcliff"],
  },
  {
    slug: "millner",
    suburb: "Millner",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Dick Ward Drive", "Trower Road", "Millner Street", "Casuarina Drive"],
    intro:
      "Millner is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Millner residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Nightcliff", "Rapid Creek", "Coconut Grove", "Nakara", "Tiwi", "Jingili", "Wagaman", "Casuarina", "Wanguri", "Fannie Bay"],
  },
  {
    slug: "moil",
    suburb: "Moil",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["McMillans Road", "Trower Road", "Moil Avenue", "Vanderlin Drive"],
    intro:
      "Moil is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Moil residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Nakara", "Jingili", "Millner", "Tiwi", "Wagaman", "Casuarina", "Coconut Grove", "Rapid Creek", "Wanguri", "Leanyer"],
  },
  {
    slug: "nakara",
    suburb: "Nakara",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["McMillans Road", "Nakara Avenue", "Trower Road", "Vanderlin Drive"],
    intro:
      "Nakara is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Nakara residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Jingili", "Moil", "Millner", "Tiwi", "Wagaman", "Casuarina", "Coconut Grove", "Rapid Creek", "Wanguri", "Leanyer"],
  },
  {
    slug: "rapid-creek",
    suburb: "Rapid Creek",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Dick Ward Drive", "Rapid Creek Road", "Trower Road", "Progress Drive"],
    intro:
      "Rapid Creek is a northern Darwin suburb known for its Sunday market and Asian food culture, where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Rapid Creek residential and infrastructure projects.",
    industries: ["Residential construction", "Retail and market infrastructure", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Nightcliff", "Casuarina", "Millner", "Coconut Grove", "Nakara", "Tiwi", "Jingili", "Wagaman", "Wanguri", "Moil"],
  },
  {
    slug: "sanderson",
    suburb: "Sanderson",
    state: "NT",
    postcode: "0812",
    council: "City of Darwin",
    keyRoads: ["Vanderlin Drive", "Sanderson Road", "Leanyer Drive", "McMillans Road"],
    intro:
      "Sanderson is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Sanderson residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Leanyer", "Malak", "Casuarina", "Wanguri", "Tiwi", "Nakara", "Jingili", "Wagaman", "Brinkin", "Nightcliff"],
  },
  {
    slug: "tiwi",
    suburb: "Tiwi",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Casuarina Drive", "Tiwi Place", "McMillans Road", "Vanderlin Drive"],
    intro:
      "Tiwi is a residential suburb adjacent to Charles Darwin University in northern Darwin, where residential construction and university-related works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Tiwi residential and education support projects.",
    industries: ["Residential construction", "University and education support works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Casuarina", "Nakara", "Jingili", "Millner", "Wagaman", "Wanguri", "Rapid Creek", "Coconut Grove", "Nightcliff", "Leanyer"],
  },
  {
    slug: "wagaman",
    suburb: "Wagaman",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Trower Road", "Wagaman Crescent", "McMillans Road", "Vanderlin Drive"],
    intro:
      "Wagaman is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Wagaman residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Nakara", "Jingili", "Moil", "Millner", "Tiwi", "Casuarina", "Rapid Creek", "Coconut Grove", "Wanguri", "Leanyer"],
  },
  {
    slug: "wanguri",
    suburb: "Wanguri",
    state: "NT",
    postcode: "0810",
    council: "City of Darwin",
    keyRoads: ["Vanderlin Drive", "Wanguri Terrace", "Leanyer Drive", "McMillans Road"],
    intro:
      "Wanguri is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Wanguri residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Leanyer", "Casuarina", "Tiwi", "Nakara", "Jingili", "Wagaman", "Malak", "Sanderson", "Brinkin", "Coconut Grove"],
  },
  {
    slug: "winnellie",
    suburb: "Winnellie",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Stuart Highway", "Winnellie Road", "McMillans Road", "Tiger Brennan Drive"],
    intro:
      "Winnellie is Darwin's major light industrial and logistics suburb, where industrial construction, warehouse development and commercial works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Winnellie industrial and commercial projects.",
    industries: ["Light industrial and warehouse development", "Commercial construction", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Darwin CBD", "Stuart Park", "Parap", "Berrimah", "Ludmilla", "Woolner", "Larrakeyah", "Fannie Bay", "Gray", "Marrara"],
  },
  {
    slug: "woolner",
    suburb: "Woolner",
    state: "NT",
    postcode: "0820",
    council: "City of Darwin",
    keyRoads: ["Tiger Brennan Drive", "Woolner Road", "Gilruth Avenue", "Stuart Highway"],
    intro:
      "Woolner is an inner Darwin suburb where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Woolner residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Commercial development", "Council infrastructure works"],
    nearbySuburbs: ["Darwin CBD", "Stuart Park", "Parap", "Larrakeyah", "Fannie Bay", "Bayview", "Ludmilla", "Winnellie", "Nightcliff", "Coconut Grove"],
  },
  // Darwin Industrial & Outer (additional)
  {
    slug: "berrimah",
    suburb: "Berrimah",
    state: "NT",
    postcode: "0828",
    council: "City of Darwin",
    keyRoads: ["Tiger Brennan Drive", "Berrimah Road", "Stuart Highway", "Wishart Road"],
    intro:
      "Berrimah is Darwin's major industrial estate and home to the Darwin Correctional Centre, where industrial construction, warehouse development and essential services works require traffic management plans compliant with City of Darwin and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Berrimah industrial and infrastructure projects.",
    industries: ["Industrial and logistics construction", "Warehouse development", "Essential services works", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Winnellie", "Darwin CBD", "Gray", "Marrara", "Stuart Park", "Palmerston", "Holtze", "Knuckey Lagoon", "Virginia NT", "Howard Springs"],
  },
  {
    slug: "buffalo-creek",
    suburb: "Buffalo Creek",
    state: "NT",
    postcode: "0812",
    council: "City of Darwin",
    keyRoads: ["Lee Point Road", "Buffalo Creek Road", "Casuarina Drive", "Vanderlin Drive"],
    intro:
      "Buffalo Creek is a northern Darwin coastal suburb where residential construction and foreshore works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Buffalo Creek residential and coastal projects.",
    industries: ["Residential construction", "Coastal and foreshore works", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Casuarina", "Leanyer", "Sanderson", "Nightcliff", "Rapid Creek", "Wanguri", "Coconut Grove", "Malak", "Tiwi", "Nakara"],
  },
  {
    slug: "gray",
    suburb: "Gray",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Stuart Highway", "Roystonea Avenue", "Temple Terrace", "Gray Road"],
    intro:
      "Gray is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Gray residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Bakewell", "Durack", "Woodroffe", "Johnston", "Archer", "Rosebery", "Zuccoli"],
  },
  {
    slug: "karama",
    suburb: "Karama",
    state: "NT",
    postcode: "0812",
    council: "City of Darwin",
    keyRoads: ["Vanderlin Drive", "Karama Drive", "McMillans Road", "Leanyer Drive"],
    intro:
      "Karama is a residential suburb in northern Darwin where residential construction and utility works require traffic management plans compliant with City of Darwin requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Darwin-compliant TMPs for Karama residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Malak", "Leanyer", "Sanderson", "Casuarina", "Wanguri", "Tiwi", "Nakara", "Jingili", "Wagaman", "Nightcliff"],
  },
  // Palmerston suburbs
  {
    slug: "archer",
    suburb: "Archer",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Roystonea Avenue", "Archer Road", "Temple Terrace", "Elrundie Avenue"],
    intro:
      "Archer is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Archer residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Bakewell", "Durack", "Woodroffe", "Johnston", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "bakewell",
    suburb: "Bakewell",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Bakewell Road", "Goyder Road", "Elrundie Avenue", "Chung Wah Terrace"],
    intro:
      "Bakewell is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Palmerston-compliant TMPs for Bakewell residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Durack", "Woodroffe", "Johnston", "Archer", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "bellamack",
    suburb: "Bellamack",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Elrundie Avenue", "Bellamack Road", "Chung Wah Terrace", "Makagon Road"],
    intro:
      "Bellamack is a growing residential suburb of Palmerston where residential estate construction creates demand for traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bellamack residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Zuccoli", "Johnston", "Archer", "Gunn", "Driver", "Durack", "Woodroffe", "Bakewell", "Rosebery"],
  },
  {
    slug: "driver",
    suburb: "Driver",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Driver Road", "Roystonea Avenue", "Temple Terrace", "Elrundie Avenue"],
    intro:
      "Driver is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Palmerston-compliant TMPs for Driver residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Archer", "Bakewell", "Durack", "Woodroffe", "Johnston", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "durack",
    suburb: "Durack",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Roystonea Avenue", "Durack Drive", "Temple Terrace", "Elrundie Avenue"],
    intro:
      "Durack is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Durack residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Archer", "Bakewell", "Woodroffe", "Johnston", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "gunn",
    suburb: "Gunn",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Elrundie Avenue", "Gunn Road", "Chung Wah Terrace", "Roystonea Avenue"],
    intro:
      "Gunn is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Palmerston-compliant TMPs for Gunn residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Driver", "Archer", "Bakewell", "Durack", "Woodroffe", "Johnston", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "johnston",
    suburb: "Johnston",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Elrundie Avenue", "Johnston Road", "Chung Wah Terrace", "Bellamack Road"],
    intro:
      "Johnston is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Johnston residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Bellamack", "Zuccoli", "Archer", "Gunn", "Driver", "Durack", "Woodroffe", "Bakewell", "Rosebery"],
  },
  {
    slug: "rosebery-nt",
    suburb: "Rosebery",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Roystonea Avenue", "Rosebery Road", "Elrundie Avenue", "Chung Wah Terrace"],
    intro:
      "Rosebery is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Palmerston-compliant TMPs for Rosebery residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Archer", "Bakewell", "Durack", "Woodroffe", "Johnston", "Gray", "Zuccoli"],
  },
  {
    slug: "woodroffe",
    suburb: "Woodroffe",
    state: "NT",
    postcode: "0830",
    council: "City of Palmerston",
    keyRoads: ["Woodroffe Avenue", "Roystonea Avenue", "Temple Terrace", "Elrundie Avenue"],
    intro:
      "Woodroffe is a residential suburb of Palmerston where residential construction and utility works require traffic management plans compliant with City of Palmerston requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Woodroffe residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Gunn", "Driver", "Archer", "Bakewell", "Durack", "Johnston", "Gray", "Rosebery", "Zuccoli"],
  },
  {
    slug: "zuccoli",
    suburb: "Zuccoli",
    state: "NT",
    postcode: "0832",
    council: "City of Palmerston",
    keyRoads: ["Makagon Road", "Zuccoli Parade", "Elrundie Avenue", "Chung Wah Terrace"],
    intro:
      "Zuccoli is a newly developed master-planned suburb on the outer edge of Palmerston, where large residential estate construction creates demand for traffic management plans compliant with City of Palmerston and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares City of Palmerston-compliant TMPs for Zuccoli residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Palmerston", "Bellamack", "Johnston", "Archer", "Gunn", "Driver", "Durack", "Woodroffe", "Bakewell", "Rosebery"],
  },
  // Alice Springs (additional)
  {
    slug: "alice-springs-cbd",
    suburb: "Alice Springs CBD",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Todd Mall", "Hartley Street", "Bath Street", "Stott Terrace"],
    intro:
      "Alice Springs CBD is the commercial heart of Central Australia, where commercial construction, infrastructure upgrades and tourism development create demand for traffic management plans compliant with Alice Springs Town Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Alice Springs CBD commercial and infrastructure projects.",
    industries: ["Commercial and retail construction", "Tourism infrastructure", "Government and civic works", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Braitling", "Gillen", "Larapinta", "Desert Springs", "Sadadeen", "The Gap", "Heavitree", "Mount Johns", "White Gums", "Araluen"],
  },
  {
    slug: "mount-johns",
    suburb: "Mount Johns",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Palm Circuit", "Cromwell Drive", "Warburton Street", "Ross Highway"],
    intro:
      "Mount Johns is a residential suburb of Alice Springs where residential construction and utility works require traffic management plans compliant with Alice Springs Town Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alice Springs Town Council-compliant TMPs for Mount Johns residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Alice Springs CBD", "Desert Springs", "Sadadeen", "Gillen", "Larapinta", "Braitling", "The Gap", "Heavitree", "White Gums", "Araluen"],
  },
  {
    slug: "the-gap",
    suburb: "The Gap",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Gap Road", "Stuart Highway", "Undoolya Road", "Ross Highway"],
    intro:
      "The Gap is a southern Alice Springs suburb where residential construction and utility works require traffic management plans compliant with Alice Springs Town Council requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for The Gap residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Alice Springs CBD", "Gillen", "Sadadeen", "Heavitree", "Desert Springs", "Mount Johns", "Larapinta", "Braitling", "White Gums", "Araluen"],
  },
  {
    slug: "white-gums",
    suburb: "White Gums",
    state: "NT",
    postcode: "0870",
    council: "Alice Springs Town Council",
    keyRoads: ["Gap Road", "White Gums Road", "Larapinta Drive", "Undoolya Road"],
    intro:
      "White Gums is a residential suburb of Alice Springs where residential construction and utility works require traffic management plans compliant with Alice Springs Town Council requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Alice Springs Town Council-compliant TMPs for White Gums residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Gillen", "Larapinta", "The Gap", "Alice Springs CBD", "Desert Springs", "Sadadeen", "Braitling", "Mount Johns", "Heavitree", "Araluen"],
  },
  // Katherine & Top End (additional)
  {
    slug: "jabiru",
    suburb: "Jabiru",
    state: "NT",
    postcode: "0886",
    council: "Kakadu",
    keyRoads: ["Flinders Street", "Lakeside Drive", "Jabiru Drive", "Arnhem Highway"],
    intro:
      "Jabiru is a purpose-built uranium mining town within Kakadu National Park, where mining infrastructure, national park service construction and essential services works require traffic management plans compliant with NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Jabiru mining, national park and essential services projects.",
    industries: ["Uranium mining infrastructure", "National park service construction", "Essential services works", "Tourism infrastructure", "Remote area civil works"],
    nearbySuburbs: ["Darwin", "Katherine", "Pine Creek", "Adelaide River", "Batchelor", "Coolalinga", "Noonamah", "Kakadu", "Arnhem Land", "Oenpelli"],
  },
  {
    slug: "pine-creek",
    suburb: "Pine Creek",
    state: "NT",
    postcode: "0847",
    council: "Coomalie Community Government Council",
    keyRoads: ["Stuart Highway", "Moule Street", "Frew Street", "Pine Creek Road"],
    intro:
      "Pine Creek is a historic gold mining town on the Stuart Highway between Darwin and Katherine, where highway maintenance, mining heritage infrastructure and essential services works require traffic management plans compliant with Coomalie Community Government Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans prepares compliant TMPs for Pine Creek highway infrastructure and essential services projects.",
    industries: ["Highway and road maintenance", "Mining heritage infrastructure", "Essential services works", "Tourism infrastructure", "Remote area civil works"],
    nearbySuburbs: ["Katherine", "Darwin", "Jabiru", "Adelaide River", "Batchelor", "Coolalinga", "Howard Springs", "Noonamah", "Mataranka", "Tindal"],
  },
  // Regional NT (additional)
  {
    slug: "borroloola",
    suburb: "Borroloola",
    state: "NT",
    postcode: "0854",
    council: "Roper Gulf Regional Council",
    keyRoads: ["McArthur River Road", "Robinson Road", "Borroloola Road", "Carpentaria Highway"],
    intro:
      "Borroloola is a remote Gulf Country township near the McArthur River zinc mine, where mining infrastructure, essential services works and remote area construction require traffic management plans compliant with Roper Gulf Regional Council and NT Department of Infrastructure requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Borroloola mining and essential services projects in remote Gulf Country.",
    industries: ["Mining and zinc industry infrastructure", "Essential services works", "Remote area construction", "Utility maintenance", "Road and civil works"],
    nearbySuburbs: ["Tennant Creek", "Katherine", "Darwin", "Nhulunbuy", "Mount Isa", "Daly Waters", "Elliott", "Mataranka", "Roper Bar", "Manangoora"],
  },

  // ─── AUSTRALIAN CAPITAL TERRITORY ─────────────────────────────────────────

  {
    slug: "canberra",
    suburb: "Canberra CBD",
    state: "ACT",
    postcode: "2601",
    council: "ACT Government (City Services)",
    keyRoads: ["Northbourne Avenue", "Flemington Road", "Constitution Avenue", "Parkes Way"],
    intro:
      "Canberra CBD is the nation's capital and a growing city centre, with major light rail expansion, significant government and commercial construction and ongoing road upgrades creating consistent demand for traffic management plan documentation compliant with ACT Government City Services and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMP and TGS documentation for Canberra CBD projects, with experience managing works around the light rail corridor and key parliamentary and government precincts.",
    industries: [
      "Government and parliamentary construction",
      "Light rail and transport infrastructure",
      "Commercial and office development",
      "Residential construction",
      "Utility maintenance",
      "Road and infrastructure upgrades",
    ],
    nearbySuburbs: ["Civic", "Braddon", "New Acton", "Reid", "Barton", "Deakin", "Forrest", "Kingston", "Manuka", "Yarralumla"],
  },
  {
    slug: "belconnen",
    suburb: "Belconnen",
    state: "ACT",
    postcode: "2617",
    council: "ACT Government (City Services)",
    keyRoads: ["Benjamin Way", "Belconnen Way", "Coulter Drive", "Ginninderra Drive"],
    intro:
      "Belconnen is Canberra's largest district and a major town centre, home to the University of Canberra, major retail and a significant residential population experiencing ongoing densification. Road upgrades, university expansion and residential construction create consistent demand for TMP documentation across the district.",
    bodyPara:
      "Focus Traffic Plans supports Belconnen construction projects with ACT Government-compliant TMP documentation and council permit submissions for all project types.",
    industries: [
      "University and educational construction",
      "Residential densification",
      "Retail and commercial development",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and community projects",
    ],
    nearbySuburbs: ["Bruce", "Charnwood", "Florey", "Hawker", "Latham", "Macquarie", "Page", "Scullin", "Evatt", "Spence"],
  },
  {
    slug: "tuggeranong",
    suburb: "Tuggeranong",
    state: "ACT",
    postcode: "2900",
    council: "ACT Government (City Services)",
    keyRoads: ["Drakeford Drive", "Tuggeranong Parkway", "Isabella Drive", "Athllon Drive"],
    intro:
      "Tuggeranong is Canberra's southernmost district and largest population centre, where ongoing residential development, town centre upgrades and road maintenance create regular demand for traffic management plan documentation under ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans provides TMP and TGS documentation for Tuggeranong projects, with the same fast-turnaround service available across the ACT and nationally.",
    industries: [
      "Residential construction and renovation",
      "Commercial and retail projects",
      "Road and infrastructure upgrades",
      "Utility maintenance",
      "Government and community projects",
      "Educational facility development",
    ],
    nearbySuburbs: ["Calwell", "Erindale", "Gordon", "Greenway", "Kambah", "Theodore", "Chisholm", "Macarthur", "Gilmore", "Isabella Plains"],
  },

  // ─── AUSTRALIAN CAPITAL TERRITORY (additional) ─────────────────────────────

  // Canberra CBD & Inner (additional)
  {
    slug: "barton",
    suburb: "Barton",
    state: "ACT",
    postcode: "2600",
    council: "ACT Government",
    keyRoads: ["Kings Avenue", "National Circuit", "Macquarie Street", "Canberra Avenue"],
    intro:
      "Barton is Canberra's parliamentary and diplomatic precinct, home to foreign embassies and major government departments, where government building construction, embassy works and infrastructure upgrades require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Barton government, diplomatic and infrastructure projects.",
    industries: [
      "Government and embassy construction",
      "Commercial office development",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Canberra CBD", "Forrest", "Deakin", "Kingston", "Griffith", "Yarralumla", "Red Hill", "Manuka", "Fyshwick", "Russell"],
  },
  {
    slug: "civic",
    suburb: "Civic",
    state: "ACT",
    postcode: "2601",
    council: "ACT Government",
    keyRoads: ["City Walk", "London Circuit", "Northbourne Avenue", "Alinga Street"],
    intro:
      "Civic is Canberra's commercial and retail CBD, home to Canberra Centre, major government offices and the light rail terminus, where high-density development, light rail infrastructure and commercial construction create demand for traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Civic commercial, retail and light rail corridor projects in Canberra's city centre.",
    industries: [
      "Commercial and retail construction",
      "Light rail and transport infrastructure",
      "High-density residential development",
      "Utility and services upgrades",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Canberra CBD", "Braddon", "Turner", "Reid", "Acton", "Lyneham", "O'Connor", "Watson", "Downer", "Ainslie"],
  },
  {
    slug: "deakin",
    suburb: "Deakin",
    state: "ACT",
    postcode: "2600",
    council: "ACT Government",
    keyRoads: ["Hopetoun Circuit", "Empire Circuit", "Adelaide Avenue", "Strickland Crescent"],
    intro:
      "Deakin is a prestigious inner Canberra suburb of embassies, government offices and established residences, where construction and utility works in a heritage-sensitive diplomatic environment require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Deakin residential, embassy and government office projects.",
    industries: [
      "Government and embassy construction",
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Forrest", "Barton", "Yarralumla", "Red Hill", "Canberra CBD", "Manuka", "Griffith", "Curtin", "Hughes", "Woden"],
  },
  {
    slug: "forrest",
    suburb: "Forrest",
    state: "ACT",
    postcode: "2603",
    council: "ACT Government",
    keyRoads: ["Melbourne Avenue", "National Circuit", "Mugga Way", "Endeavour Street"],
    intro:
      "Forrest is one of Canberra's most prestigious residential and diplomatic suburbs, where luxury residential construction, embassy works and heritage building refurbishment require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Forrest residential and diplomatic construction projects.",
    industries: [
      "Luxury residential construction",
      "Embassy and government construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Deakin", "Barton", "Griffith", "Red Hill", "Manuka", "Yarralumla", "Kingston", "Canberra CBD", "Hughes", "Curtin"],
  },
  {
    slug: "griffith",
    suburb: "Griffith",
    state: "ACT",
    postcode: "2603",
    council: "ACT Government",
    keyRoads: ["Canberra Avenue", "Mugga Way", "Boolimba Crescent", "Dominion Circuit"],
    intro:
      "Griffith is an established inner south Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Griffith residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Manuka", "Forrest", "Red Hill", "Deakin", "Barton", "Kingston", "Narrabundah", "Fyshwick", "Canberra CBD", "Yarralumla"],
  },
  {
    slug: "kingston-act",
    suburb: "Kingston",
    state: "ACT",
    postcode: "2604",
    council: "ACT Government",
    keyRoads: ["Eyre Street", "Wentworth Avenue", "Kennedy Street", "Jardine Street"],
    intro:
      "Kingston is Canberra's inner south village and one of the ACT's most vibrant dining and arts precincts, where residential construction, boutique commercial fitouts and the Kingston Foreshore urban renewal development create demand for traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Kingston residential, commercial and foreshore redevelopment projects.",
    industries: [
      "Residential and mixed-use development",
      "Retail and hospitality fitouts",
      "Foreshore urban renewal",
      "Heritage building refurbishment",
      "Utility maintenance",
    ],
    nearbySuburbs: ["Manuka", "Griffith", "Barton", "Forrest", "Fyshwick", "Canberra CBD", "Narrabundah", "Red Hill", "Deakin", "Yarralumla"],
  },
  {
    slug: "manuka",
    suburb: "Manuka",
    state: "ACT",
    postcode: "2603",
    council: "ACT Government",
    keyRoads: ["Franklin Street", "Flinders Way", "Furneaux Street", "Manuka Circle"],
    intro:
      "Manuka is Canberra's premier boutique shopping and dining precinct, where commercial fitouts, residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Manuka commercial and residential projects.",
    industries: [
      "Retail and hospitality fitouts",
      "Residential construction",
      "Boutique commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Griffith", "Forrest", "Kingston", "Red Hill", "Deakin", "Barton", "Yarralumla", "Canberra CBD", "Narrabundah", "Fyshwick"],
  },
  {
    slug: "red-hill",
    suburb: "Red Hill",
    state: "ACT",
    postcode: "2603",
    council: "ACT Government",
    keyRoads: ["La Perouse Street", "Mugga Way", "Empire Circuit", "Novar Street"],
    intro:
      "Red Hill is a prestigious inner south Canberra suburb with sweeping views of the city, where luxury residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Red Hill luxury residential and infrastructure projects.",
    industries: [
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Forrest", "Griffith", "Deakin", "Manuka", "Barton", "Hughes", "Curtin", "Yarralumla", "Canberra CBD", "Narrabundah"],
  },
  {
    slug: "yarralumla",
    suburb: "Yarralumla",
    state: "ACT",
    postcode: "2600",
    council: "ACT Government",
    keyRoads: ["Adelaide Avenue", "Dunrossil Drive", "Mugga Way", "Hopetoun Circuit"],
    intro:
      "Yarralumla is Canberra's most exclusive suburb, home to Government House, foreign embassies and the Royal Canberra Golf Club, where diplomatic construction, luxury residential works and heritage infrastructure projects require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Yarralumla diplomatic, residential and heritage projects.",
    industries: [
      "Diplomatic and government construction",
      "Luxury residential construction",
      "Heritage building refurbishment",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Deakin", "Forrest", "Barton", "Red Hill", "Manuka", "Griffith", "Canberra CBD", "Hughes", "Curtin", "Weston"],
  },
  // Gungahlin
  {
    slug: "casey",
    suburb: "Casey",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government",
    keyRoads: ["Gungahlin Drive", "Horse Park Drive", "Mirrabei Drive", "Kingsford Smith Drive"],
    intro:
      "Casey is a new and rapidly growing suburb in Canberra's Gungahlin district, where residential estate construction and associated civil infrastructure create demand for traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Casey residential and civil infrastructure projects in the Gungahlin growth corridor.",
    industries: [
      "Residential subdivision and housing",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community and education infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Forde", "Moncrieff", "Ngunnawal", "Gungahlin", "Mitchell", "Franklin", "Harrison", "Bonner", "Amaroo", "Taylor"],
  },
  {
    slug: "forde",
    suburb: "Forde",
    state: "ACT",
    postcode: "2914",
    council: "ACT Government",
    keyRoads: ["Horse Park Drive", "Hibberson Street", "Gungahlin Drive", "Well Station Drive"],
    intro:
      "Forde is a growing residential suburb in the Gungahlin district where residential construction and civil infrastructure works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Forde residential and civil infrastructure projects.",
    industries: [
      "Residential construction",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Casey", "Moncrieff", "Ngunnawal", "Gungahlin", "Mitchell", "Franklin", "Harrison", "Bonner", "Amaroo", "Taylor"],
  },
  {
    slug: "franklin",
    suburb: "Franklin",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government",
    keyRoads: ["Gungahlin Drive", "Hibberson Street", "Anthony Rolfe Avenue", "Clarrie Hermes Drive"],
    intro:
      "Franklin is an established Gungahlin suburb with a mix of residential and retail uses, where construction and utility works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Franklin residential and commercial projects.",
    industries: [
      "Residential construction",
      "Commercial and retail development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gungahlin", "Mitchell", "Ngunnawal", "Harrison", "Forde", "Casey", "Moncrieff", "Amaroo", "Bonner", "Nicholls"],
  },
  {
    slug: "gungahlin",
    suburb: "Gungahlin",
    state: "ACT",
    postcode: "2912",
    council: "ACT Government",
    keyRoads: ["Hibberson Street", "Gungahlin Drive", "Gundaroo Drive", "Horse Park Drive"],
    intro:
      "Gungahlin is Canberra's major northern activity centre and the ACT's fastest-growing district, where retail construction, high-density residential development and the light rail corridor create demand for traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Gungahlin retail, residential and light rail corridor projects.",
    industries: [
      "Retail and commercial construction",
      "High-density residential development",
      "Light rail and transport infrastructure",
      "Utility maintenance",
      "Road and civil construction",
    ],
    nearbySuburbs: ["Mitchell", "Franklin", "Harrison", "Ngunnawal", "Forde", "Casey", "Moncrieff", "Amaroo", "Nicholls", "Bonner"],
  },
  {
    slug: "mitchell",
    suburb: "Mitchell",
    state: "ACT",
    postcode: "2911",
    council: "ACT Government",
    keyRoads: ["Flemington Road", "Sandford Street", "Vicars Street", "Hoskins Street"],
    intro:
      "Mitchell is Canberra's major light industrial and trade precinct, where warehouse construction, automotive retail development and light industrial works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Mitchell light industrial and commercial projects.",
    industries: [
      "Light industrial and warehouse development",
      "Automotive and commercial retail",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gungahlin", "Franklin", "Harrison", "Watson", "Downer", "Lyneham", "O'Connor", "Hackett", "Civic", "Dickson"],
  },
  {
    slug: "moncrieff",
    suburb: "Moncrieff",
    state: "ACT",
    postcode: "2914",
    council: "ACT Government",
    keyRoads: ["Horse Park Drive", "Gungahlin Drive", "Clarrie Hermes Drive", "Hibberson Street"],
    intro:
      "Moncrieff is a modern Gungahlin suburb where residential construction and civil infrastructure works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Moncrieff residential and civil infrastructure projects.",
    industries: [
      "Residential construction",
      "Civil and road infrastructure",
      "Utility maintenance",
      "Community infrastructure",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Forde", "Casey", "Ngunnawal", "Gungahlin", "Harrison", "Franklin", "Mitchell", "Bonner", "Amaroo", "Taylor"],
  },
  {
    slug: "ngunnawal",
    suburb: "Ngunnawal",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government",
    keyRoads: ["Gundaroo Drive", "Gungahlin Drive", "Baldwin Drive", "Flemington Road"],
    intro:
      "Ngunnawal is an established northern Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ngunnawal residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Gungahlin", "Mitchell", "Franklin", "Harrison", "Forde", "Casey", "Moncrieff", "Amaroo", "Nicholls", "Bonner"],
  },
  // Woden Valley
  {
    slug: "chifley",
    suburb: "Chifley",
    state: "ACT",
    postcode: "2606",
    council: "ACT Government",
    keyRoads: ["Athlon Drive", "Chifley Drive", "Sulwood Drive", "Drakeford Drive"],
    intro:
      "Chifley is a residential suburb in Canberra's Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Chifley residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Curtin", "Garran", "Hughes", "Mawson", "Philip", "Woden", "Farrer", "Isaacs", "Torrens", "Pearce"],
  },
  {
    slug: "curtin",
    suburb: "Curtin",
    state: "ACT",
    postcode: "2605",
    council: "ACT Government",
    keyRoads: ["Melrose Drive", "Curtin Place", "La Perouse Street", "Catchpole Street"],
    intro:
      "Curtin is a well-established Woden Valley suburb adjacent to Stromlo Forest Park, where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Curtin residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Hughes", "Garran", "Deakin", "Red Hill", "Forrest", "Yarralumla", "Phillip", "Woden", "Chifley", "Mawson"],
  },
  {
    slug: "garran",
    suburb: "Garran",
    state: "ACT",
    postcode: "2605",
    council: "ACT Government",
    keyRoads: ["Yamba Drive", "Garran Place", "Wiseman Street", "Novar Street"],
    intro:
      "Garran is home to the Canberra Hospital campus, one of the ACT's major health precincts, where hospital expansion, medical facility construction and residential works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Garran health and residential projects, with experience in hospital precinct traffic management.",
    industries: [
      "Health and hospital infrastructure",
      "Residential construction",
      "University and education support works",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Hughes", "Curtin", "Woden", "Philip", "Chifley", "Mawson", "Farrer", "Pearce", "Torrens", "Isaacs"],
  },
  {
    slug: "hughes",
    suburb: "Hughes",
    state: "ACT",
    postcode: "2605",
    council: "ACT Government",
    keyRoads: ["Melrose Drive", "Novar Street", "Pearce Drive", "Hughes Place"],
    intro:
      "Hughes is a quiet residential suburb in Canberra's Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hughes residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Garran", "Curtin", "Deakin", "Forrest", "Red Hill", "Woden", "Philip", "Chifley", "Mawson", "Pearce"],
  },
  {
    slug: "mawson",
    suburb: "Mawson",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government",
    keyRoads: ["Mawson Drive", "Athllon Drive", "Beasley Street", "Clare Dennis Avenue"],
    intro:
      "Mawson is a residential and retail suburb in Canberra's Woden Valley where residential construction and commercial development around the Mawson shops require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Mawson residential and commercial projects.",
    industries: [
      "Residential construction",
      "Retail and commercial development",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chifley", "Garran", "Hughes", "Philip", "Woden", "Curtin", "Farrer", "Isaacs", "Torrens", "Pearce"],
  },
  {
    slug: "philip",
    suburb: "Philip",
    state: "ACT",
    postcode: "2606",
    council: "ACT Government",
    keyRoads: ["Athllon Drive", "Botany Street", "Wollongong Street", "Melrose Drive"],
    intro:
      "Philip is Woden's major commercial and light industrial precinct, where commercial construction, automotive retail and light industrial works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Philip commercial and light industrial projects in the Woden Valley.",
    industries: [
      "Light industrial and commercial construction",
      "Automotive and retail development",
      "Utility maintenance",
      "Road and access maintenance",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Woden", "Chifley", "Garran", "Hughes", "Mawson", "Curtin", "Pearce", "Torrens", "Farrer", "Isaacs"],
  },
  {
    slug: "woden",
    suburb: "Woden",
    state: "ACT",
    postcode: "2606",
    council: "ACT Government",
    keyRoads: ["Melrose Drive", "Athllon Drive", "Hindmarsh Drive", "Callam Street"],
    intro:
      "Woden is Canberra's second major activity centre, anchored by the Westfield Woden shopping centre and significant government office accommodation, where commercial construction, government office development and residential projects create demand for traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Woden commercial, government and residential projects.",
    industries: [
      "Commercial and retail construction",
      "Government office development",
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
    ],
    nearbySuburbs: ["Philip", "Garran", "Hughes", "Chifley", "Mawson", "Curtin", "Pearce", "Torrens", "Farrer", "Isaacs"],
  },
  // Weston Creek
  {
    slug: "chapman",
    suburb: "Chapman",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Chapman Drive", "Kathner Street", "Woodcock Drive", "Streeton Drive"],
    intro:
      "Chapman is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Chapman residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Duffy", "Fisher", "Holder", "Rivett", "Stirling", "Waramanga", "Weston", "Yarralumla", "Curtin", "Deakin"],
  },
  {
    slug: "duffy",
    suburb: "Duffy",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Streeton Drive", "Eucumbene Drive", "Duffy Place", "Woodcock Drive"],
    intro:
      "Duffy is a residential suburb in Canberra's Weston Creek district adjacent to Stromlo Forest Park, where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Duffy residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chapman", "Fisher", "Holder", "Rivett", "Stirling", "Waramanga", "Weston", "Curtin", "Yarralumla", "Deakin"],
  },
  {
    slug: "fisher",
    suburb: "Fisher",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Athllon Drive", "Sulwood Drive", "Kootara Crescent", "Fisher Place"],
    intro:
      "Fisher is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fisher residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Chifley", "Mawson", "Holder", "Waramanga", "Stirling", "Chapman", "Duffy", "Rivett", "Weston", "Torrens"],
  },
  {
    slug: "holder",
    suburb: "Holder",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Eucumbene Drive", "Streeton Drive", "Holder Place", "Woodcock Drive"],
    intro:
      "Holder is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Holder residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Duffy", "Chapman", "Fisher", "Rivett", "Stirling", "Waramanga", "Weston", "Curtin", "Yarralumla", "Deakin"],
  },
  {
    slug: "rivett",
    suburb: "Rivett",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Streeton Drive", "Eucumbene Drive", "Rivett Place", "Woodcock Drive"],
    intro:
      "Rivett is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Rivett residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Holder", "Duffy", "Chapman", "Fisher", "Stirling", "Waramanga", "Weston", "Curtin", "Yarralumla", "Deakin"],
  },
  {
    slug: "stirling-act",
    suburb: "Stirling",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Eucumbene Drive", "Streeton Drive", "Stirling Place", "Woodcock Drive"],
    intro:
      "Stirling is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Stirling residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Holder", "Rivett", "Chapman", "Duffy", "Fisher", "Waramanga", "Weston", "Curtin", "Yarralumla", "Deakin"],
  },
  {
    slug: "waramanga",
    suburb: "Waramanga",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Waramanga Place", "Eucumbene Drive", "Athllon Drive", "Streeton Drive"],
    intro:
      "Waramanga is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Waramanga residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Fisher", "Holder", "Stirling", "Rivett", "Chapman", "Duffy", "Weston", "Chifley", "Mawson", "Torrens"],
  },
  {
    slug: "weston",
    suburb: "Weston",
    state: "ACT",
    postcode: "2611",
    council: "ACT Government",
    keyRoads: ["Yamba Drive", "Eucumbene Drive", "Streeton Drive", "Hindmarsh Drive"],
    intro:
      "Weston is a residential suburb in Canberra's Weston Creek district where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Weston residential and infrastructure projects.",
    industries: [
      "Residential construction",
      "Utility maintenance",
      "Road and footpath maintenance",
      "Dual occupancy development",
      "Council infrastructure works",
    ],
    nearbySuburbs: ["Waramanga", "Stirling", "Holder", "Rivett", "Chapman", "Duffy", "Fisher", "Yarralumla", "Curtin", "Deakin"],
  },

  // ─── ACT (further additions) ───────────────────────────────────────────────

  // Canberra CBD & Inner (additional)
  {
    slug: "acton",
    suburb: "Acton",
    state: "ACT",
    postcode: "2601",
    council: "ACT Government",
    keyRoads: ["Barry Drive", "Parkes Way", "Sullivan's Creek Road", "Clunies Ross Street"],
    intro:
      "Acton is home to the Australian National University and the National Museum of Australia, where university construction, museum infrastructure and residential works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Acton university, cultural and residential projects.",
    industries: ["University and education construction", "Cultural and museum infrastructure", "Residential construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Civic", "Reid", "Turner", "O'Connor", "Braddon", "Dickson", "Bruce", "Lyneham", "Hackett", "Ainslie"],
  },
  {
    slug: "ainslie",
    suburb: "Ainslie",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Limestone Avenue", "Ainslie Avenue", "Wakefield Avenue", "Butters Street"],
    intro:
      "Ainslie is a charming inner-north Canberra suburb with heritage character, where residential construction and heritage building refurbishment require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Ainslie residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Braddon", "Reid", "Watson", "Downer", "Hackett", "Dickson", "Lyneham", "Civic", "Turner", "O'Connor"],
  },
  {
    slug: "braddon",
    suburb: "Braddon",
    state: "ACT",
    postcode: "2612",
    council: "ACT Government",
    keyRoads: ["Lonsdale Street", "Mort Street", "Elouera Street", "Cooyong Street"],
    intro:
      "Braddon is Canberra's trendiest inner suburb, a hub of cafés, restaurants and creative industries adjacent to the CBD, where high-density residential development, commercial fitouts and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Braddon residential and commercial projects.",
    industries: ["High-density residential development", "Retail and hospitality fitouts", "Commercial construction", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Civic", "Ainslie", "Reid", "Turner", "Dickson", "Lyneham", "Watson", "Downer", "Hackett", "O'Connor"],
  },
  {
    slug: "dickson",
    suburb: "Dickson",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Antill Street", "Cowper Street", "Badham Street", "Northbourne Avenue"],
    intro:
      "Dickson is a vibrant inner-north Canberra suburb home to Dickson Place shopping precinct and a diverse food culture, where commercial fitouts, residential development and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Dickson commercial and residential projects.",
    industries: ["Retail and hospitality fitouts", "Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Ainslie", "Braddon", "Watson", "Downer", "Hackett", "Lyneham", "O'Connor", "Civic", "Turner", "Reid"],
  },
  {
    slug: "downer",
    suburb: "Downer",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Phillip Avenue", "Downer Place", "Antill Street", "Flemington Road"],
    intro:
      "Downer is an inner-north Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Downer residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Dickson", "Watson", "Ainslie", "Hackett", "Lyneham", "O'Connor", "Braddon", "Civic", "Ngunnawal", "Franklin"],
  },
  {
    slug: "fyshwick",
    suburb: "Fyshwick",
    state: "ACT",
    postcode: "2609",
    council: "ACT Government",
    keyRoads: ["Canberra Avenue", "Barrier Street", "Gladstone Street", "Sheppard Street"],
    intro:
      "Fyshwick is Canberra's major industrial, trade and adult entertainment precinct, where industrial construction, warehouse development and commercial works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Fyshwick industrial and commercial projects.",
    industries: ["Light industrial and warehouse development", "Commercial construction", "Automotive and trade retail", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Barton", "Kingston", "Griffith", "Narrabundah", "Pialligo", "Russell", "Hume", "Queanbeyan", "Symonston", "Jerrabomberra"],
  },
  {
    slug: "hackett",
    suburb: "Hackett",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Zwar Place", "Macfarlane Burnet Avenue", "Ebden Street", "Antill Street"],
    intro:
      "Hackett is an inner-north Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Hackett residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Dickson", "Watson", "Downer", "Ainslie", "Lyneham", "O'Connor", "Braddon", "Civic", "Ngunnawal", "Franklin"],
  },
  {
    slug: "lyneham",
    suburb: "Lyneham",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Condamine Street", "Brigalow Street", "Mouat Street", "Barry Drive"],
    intro:
      "Lyneham is an inner-north Canberra suburb known for its heritage houses and proximity to the city, where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Lyneham residential and infrastructure projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["O'Connor", "Dickson", "Ainslie", "Braddon", "Turner", "Acton", "Watson", "Downer", "Reid", "Civic"],
  },
  {
    slug: "narrabundah",
    suburb: "Narrabundah",
    state: "ACT",
    postcode: "2604",
    council: "ACT Government",
    keyRoads: ["Jerrabomberra Avenue", "Canberra Avenue", "Sturt Avenue", "Flinders Way"],
    intro:
      "Narrabundah is an inner south Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Narrabundah residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Griffith", "Kingston", "Manuka", "Fyshwick", "Barton", "Forrest", "Red Hill", "Pialligo", "Hume", "Queanbeyan"],
  },
  {
    slug: "o-connor",
    suburb: "O'Connor",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Macarthur Avenue", "Miller Street", "Brigalow Street", "Mouat Street"],
    intro:
      "O'Connor is an inner-north Canberra suburb with a heritage character and popular Saturday markets, where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for O'Connor residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Heritage building refurbishment", "Council infrastructure works"],
    nearbySuburbs: ["Lyneham", "Turner", "Acton", "Braddon", "Dickson", "Ainslie", "Reid", "Civic", "Bruce", "Watson"],
  },
  {
    slug: "pialligo",
    suburb: "Pialligo",
    state: "ACT",
    postcode: "2609",
    council: "ACT Government",
    keyRoads: ["Pialligo Avenue", "Fairbairn Avenue", "Majura Road", "Airport Road"],
    intro:
      "Pialligo is a semi-rural suburb adjacent to Canberra Airport, known for its plant nurseries and the Pialligo Estate winery, where airport-related construction, horticultural development and winery works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Pialligo airport, horticultural and winery projects.",
    industries: ["Airport and aviation infrastructure", "Horticultural and winery development", "Rural residential construction", "Utility maintenance", "Road and access maintenance"],
    nearbySuburbs: ["Fyshwick", "Hume", "Queanbeyan", "Russell", "Barton", "Narrabundah", "Kingston", "Jerrabomberra", "Symonston", "Majura"],
  },
  {
    slug: "reid",
    suburb: "Reid",
    state: "ACT",
    postcode: "2612",
    council: "ACT Government",
    keyRoads: ["Limestone Avenue", "National Circuit", "Girrahween Street", "Coranderrk Street"],
    intro:
      "Reid is an inner Canberra suburb adjacent to the city centre and close to the Australian Parliament House precinct, where residential construction and heritage building works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Reid residential and heritage projects.",
    industries: ["Residential construction", "Heritage building refurbishment", "Government-adjacent infrastructure", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Civic", "Braddon", "Turner", "Ainslie", "Barton", "Forrest", "Deakin", "Yarralumla", "Acton", "O'Connor"],
  },
  {
    slug: "russell",
    suburb: "Russell",
    state: "ACT",
    postcode: "2600",
    council: "ACT Government",
    keyRoads: ["Kings Avenue", "Constitution Avenue", "ANZAC Parade", "Fairbairn Avenue"],
    intro:
      "Russell is Australia's major defence precinct, home to the Department of Defence headquarters, where defence facility construction, infrastructure upgrades and adjacent residential works require traffic management plans compliant with ACT Government and Defence requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Russell defence and infrastructure projects.",
    industries: ["Defence and government infrastructure", "Commercial office construction", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Barton", "Kingston", "Fyshwick", "Pialligo", "Narrabundah", "Griffith", "Forrest", "Deakin", "Manuka", "Canberra CBD"],
  },
  {
    slug: "turner",
    suburb: "Turner",
    state: "ACT",
    postcode: "2612",
    council: "ACT Government",
    keyRoads: ["Girrahween Street", "Coranderrk Street", "Northbourne Avenue", "Barry Drive"],
    intro:
      "Turner is an inner Canberra suburb where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Turner residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Reid", "Civic", "Braddon", "O'Connor", "Lyneham", "Acton", "Ainslie", "Dickson", "Bruce", "Watson"],
  },
  {
    slug: "watson",
    suburb: "Watson",
    state: "ACT",
    postcode: "2602",
    council: "ACT Government",
    keyRoads: ["Phillip Avenue", "Aspinall Street", "Antill Street", "Flemington Road"],
    intro:
      "Watson is a northern inner Canberra suburb undergoing significant residential densification, where new apartment construction and the Watson village commercial precinct create demand for traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Watson residential and commercial projects.",
    industries: ["Residential and mixed-use development", "Retail and commercial fitouts", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Dickson", "Downer", "Hackett", "Ainslie", "Lyneham", "O'Connor", "Braddon", "Ngunnawal", "Franklin", "Gungahlin"],
  },
  // Belconnen (additional)
  {
    slug: "bruce",
    suburb: "Bruce",
    state: "ACT",
    postcode: "2617",
    council: "ACT Government",
    keyRoads: ["Ginninderra Drive", "Benjamin Way", "Swain Street", "Dooring Street"],
    intro:
      "Bruce is Belconnen's major employment precinct, home to GIO Stadium, the Australian Institute of Sport and numerous government agencies, where stadium, sports and commercial construction create demand for traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bruce sports, government and commercial projects.",
    industries: ["Sports and entertainment infrastructure", "Government office construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance"],
    nearbySuburbs: ["Belconnen", "Acton", "O'Connor", "Lyneham", "Macquarie", "Page", "Hawker", "Latham", "Turner", "Charnwood"],
  },
  {
    slug: "charnwood",
    suburb: "Charnwood",
    state: "ACT",
    postcode: "2615",
    council: "ACT Government",
    keyRoads: ["Tillyard Drive", "Drake Brockman Drive", "Charnwood Crescent", "Ginninderra Drive"],
    intro:
      "Charnwood is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Charnwood residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Latham", "Florey", "Hawker", "Page", "Macquarie", "Belconnen", "Scullin", "Weetangera", "Kaleen", "Spence"],
  },
  {
    slug: "florey",
    suburb: "Florey",
    state: "ACT",
    postcode: "2615",
    council: "ACT Government",
    keyRoads: ["Ginninderra Drive", "Florey Drive", "Tillyard Drive", "Drake Brockman Drive"],
    intro:
      "Florey is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Florey residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Charnwood", "Latham", "Hawker", "Page", "Macquarie", "Belconnen", "Scullin", "Weetangera", "Kaleen", "Melba"],
  },
  {
    slug: "hawker",
    suburb: "Hawker",
    state: "ACT",
    postcode: "2614",
    council: "ACT Government",
    keyRoads: ["Hawker Place", "Spofforth Street", "Tillyard Drive", "Ginninderra Drive"],
    intro:
      "Hawker is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Hawker residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Florey", "Charnwood", "Latham", "Page", "Macquarie", "Belconnen", "Scullin", "Weetangera", "Kaleen", "Melba"],
  },
  {
    slug: "latham",
    suburb: "Latham",
    state: "ACT",
    postcode: "2615",
    council: "ACT Government",
    keyRoads: ["Latham Place", "Ginninderra Drive", "Tillyard Drive", "Hardwick Crescent"],
    intro:
      "Latham is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Latham residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Charnwood", "Florey", "Hawker", "Page", "Macquarie", "Belconnen", "Scullin", "Weetangera", "Kaleen", "Spence"],
  },
  {
    slug: "macquarie-act",
    suburb: "Macquarie",
    state: "ACT",
    postcode: "2614",
    council: "ACT Government",
    keyRoads: ["Ginninderra Drive", "Macquarie Place", "Bellenden Street", "Kenneth Davenport Place"],
    intro:
      "Macquarie is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Macquarie residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Hawker", "Florey", "Charnwood", "Latham", "Page", "Belconnen", "Bruce", "Scullin", "Weetangera", "Kaleen"],
  },
  {
    slug: "page",
    suburb: "Page",
    state: "ACT",
    postcode: "2614",
    council: "ACT Government",
    keyRoads: ["Page Place", "Ginninderra Drive", "Tillyard Drive", "Moynihan Place"],
    intro:
      "Page is a residential suburb in Belconnen where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Page residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Hawker", "Florey", "Charnwood", "Latham", "Macquarie", "Belconnen", "Scullin", "Weetangera", "Kaleen", "Melba"],
  },
  // Tuggeranong (additional)
  {
    slug: "calwell",
    suburb: "Calwell",
    state: "ACT",
    postcode: "2905",
    council: "ACT Government",
    keyRoads: ["Athlon Drive", "Calwell Place", "Cowlishaw Street", "Drakeford Drive"],
    intro:
      "Calwell is a residential suburb in Tuggeranong where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Calwell residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Erindale", "Theodora", "Chisholm", "Macarthur", "Gilmore", "Isabella Plains", "Kambah", "Gordon", "Greenway", "Tuggeranong"],
  },
  {
    slug: "erindale",
    suburb: "Erindale",
    state: "ACT",
    postcode: "2903",
    council: "ACT Government",
    keyRoads: ["Erindale Drive", "Athlon Drive", "Drakeford Drive", "Sulwood Drive"],
    intro:
      "Erindale is a residential suburb in Tuggeranong where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Erindale residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Calwell", "Kambah", "Chifley", "Mawson", "Theodore", "Greenway", "Gordon", "Chisholm", "Macarthur", "Tuggeranong"],
  },
  {
    slug: "gordon-act",
    suburb: "Gordon",
    state: "ACT",
    postcode: "2906",
    council: "ACT Government",
    keyRoads: ["Gordon Place", "Drakeford Drive", "Athlon Drive", "Cowlishaw Street"],
    intro:
      "Gordon is a residential suburb in Tuggeranong where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Gordon residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Calwell", "Kambah", "Theodore", "Greenway", "Chisholm", "Macarthur", "Gilmore", "Isabella Plains", "Erindale", "Tuggeranong"],
  },
  {
    slug: "greenway",
    suburb: "Greenway",
    state: "ACT",
    postcode: "2900",
    council: "ACT Government",
    keyRoads: ["Athlon Drive", "Greenway Place", "Anketell Street", "Tuggeranong Parkway"],
    intro:
      "Greenway is a Tuggeranong suburb adjacent to the Tuggeranong Town Centre, where residential construction and commercial development require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Greenway residential and commercial projects.",
    industries: ["Residential construction", "Commercial development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Tuggeranong", "Theodore", "Kambah", "Gordon", "Calwell", "Erindale", "Chifley", "Mawson", "Chisholm", "Macarthur"],
  },
  {
    slug: "kambah",
    suburb: "Kambah",
    state: "ACT",
    postcode: "2902",
    council: "ACT Government",
    keyRoads: ["Drakeford Drive", "Sulwood Drive", "Kambah Pool Road", "Marconi Crescent"],
    intro:
      "Kambah is the largest suburb in Tuggeranong, where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Kambah residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Erindale", "Chifley", "Mawson", "Curtin", "Hughes", "Theodore", "Greenway", "Gordon", "Calwell", "Tuggeranong"],
  },
  {
    slug: "theodore",
    suburb: "Theodore",
    state: "ACT",
    postcode: "2905",
    council: "ACT Government",
    keyRoads: ["Theodore Place", "Drakeford Drive", "Cowlishaw Street", "Athlon Drive"],
    intro:
      "Theodore is a residential suburb in Tuggeranong where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Theodore residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Gordon", "Calwell", "Kambah", "Greenway", "Erindale", "Chisholm", "Macarthur", "Gilmore", "Isabella Plains", "Tuggeranong"],
  },
  // Gungahlin (additional)
  {
    slug: "amaroo",
    suburb: "Amaroo",
    state: "ACT",
    postcode: "2914",
    council: "ACT Government",
    keyRoads: ["Horse Park Drive", "Gundaroo Drive", "Baldwin Drive", "Clarrie Hermes Drive"],
    intro:
      "Amaroo is a residential suburb in Gungahlin where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Amaroo residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Gungahlin", "Ngunnawal", "Franklin", "Harrison", "Forde", "Casey", "Moncrieff", "Bonner", "Mitchell", "Taylor"],
  },
  {
    slug: "bonner",
    suburb: "Bonner",
    state: "ACT",
    postcode: "2914",
    council: "ACT Government",
    keyRoads: ["Clarrie Hermes Drive", "Horse Park Drive", "Gundaroo Drive", "Flemington Road"],
    intro:
      "Bonner is a residential suburb in Gungahlin where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Bonner residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Amaroo", "Gungahlin", "Ngunnawal", "Harrison", "Forde", "Casey", "Moncrieff", "Franklin", "Mitchell", "Taylor"],
  },
  {
    slug: "franklin-act",
    suburb: "Franklin",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government",
    keyRoads: ["Hibberson Street", "Anthony Rolfe Avenue", "Gungahlin Drive", "Clarrie Hermes Drive"],
    intro:
      "Franklin is an established Gungahlin suburb with a mix of residential and retail uses, where construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Franklin residential and commercial projects.",
    industries: ["Residential construction", "Commercial and retail development", "Utility maintenance", "Road and footpath maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Gungahlin", "Mitchell", "Ngunnawal", "Harrison", "Forde", "Casey", "Moncrieff", "Amaroo", "Bonner", "Nicholls"],
  },
  {
    slug: "harrison",
    suburb: "Harrison",
    state: "ACT",
    postcode: "2914",
    council: "ACT Government",
    keyRoads: ["Clarrie Hermes Drive", "Anthony Rolfe Avenue", "Hibberson Street", "Flemington Road"],
    intro:
      "Harrison is a residential suburb in Gungahlin where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Harrison residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Gungahlin", "Franklin", "Ngunnawal", "Amaroo", "Bonner", "Forde", "Casey", "Moncrieff", "Mitchell", "Taylor"],
  },
  {
    slug: "taylor",
    suburb: "Taylor",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government",
    keyRoads: ["Gundaroo Drive", "Horse Park Drive", "Clarrie Hermes Drive", "Hibberson Street"],
    intro:
      "Taylor is a newer residential suburb in Gungahlin where residential estate construction and civil infrastructure create demand for traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Taylor residential and civil infrastructure projects.",
    industries: ["Residential subdivision and housing", "Civil and road infrastructure", "Utility maintenance", "Community infrastructure", "Council infrastructure works"],
    nearbySuburbs: ["Gungahlin", "Amaroo", "Bonner", "Ngunnawal", "Harrison", "Forde", "Casey", "Moncrieff", "Franklin", "Mitchell"],
  },
  // Woden Valley (additional)
  {
    slug: "farrer",
    suburb: "Farrer",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government",
    keyRoads: ["Athllon Drive", "Sulwood Drive", "Beasley Street", "Farrer Place"],
    intro:
      "Farrer is a residential suburb in Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Farrer residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Chifley", "Mawson", "Garran", "Hughes", "Philip", "Woden", "Pearce", "Torrens", "Isaacs", "Kambah"],
  },
  {
    slug: "isaacs",
    suburb: "Isaacs",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government",
    keyRoads: ["Athllon Drive", "Isaacs Ridge", "Sulwood Drive", "Groom Street"],
    intro:
      "Isaacs is a residential suburb in Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Isaacs residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Farrer", "Chifley", "Mawson", "Philip", "Woden", "Garran", "Hughes", "Pearce", "Torrens", "Kambah"],
  },
  {
    slug: "pearce-act",
    suburb: "Pearce",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government",
    keyRoads: ["Pearce Drive", "Athllon Drive", "Sulwood Drive", "Beasley Street"],
    intro:
      "Pearce is a residential suburb in Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Pearce residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Farrer", "Chifley", "Mawson", "Garran", "Hughes", "Philip", "Woden", "Torrens", "Isaacs", "Kambah"],
  },
  {
    slug: "torrens",
    suburb: "Torrens",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government",
    keyRoads: ["Athllon Drive", "Torrens Drive", "Beasley Street", "Sulwood Drive"],
    intro:
      "Torrens is a residential suburb in Woden Valley where residential construction and utility works require traffic management plans compliant with ACT Government requirements.",
    bodyPara:
      "Focus Traffic Plans prepares ACT Government-compliant TMPs for Torrens residential and infrastructure projects.",
    industries: ["Residential construction", "Utility maintenance", "Road and footpath maintenance", "Dual occupancy development", "Council infrastructure works"],
    nearbySuburbs: ["Farrer", "Pearce", "Chifley", "Mawson", "Garran", "Hughes", "Philip", "Woden", "Isaacs", "Kambah"],
  },
  // Queanbeyan & Border
  {
    slug: "hume-act",
    suburb: "Hume",
    state: "ACT",
    postcode: "2620",
    council: "ACT Government",
    keyRoads: ["Hume Street", "Sheppard Street", "Canberra Avenue", "Dairy Road"],
    intro:
      "Hume is a light industrial suburb south-east of Canberra, where industrial construction, warehouse development and logistics works require traffic management plans compliant with ACT Government and Transport Canberra requirements.",
    bodyPara:
      "Focus Traffic Plans handles TMP documentation for Hume industrial and logistics projects.",
    industries: ["Light industrial and warehouse development", "Logistics and commercial construction", "Utility maintenance", "Road and access maintenance", "Council infrastructure works"],
    nearbySuburbs: ["Fyshwick", "Pialligo", "Queanbeyan", "Jerrabomberra", "Narrabundah", "Symonston", "Kingston", "Barton", "Russell", "Griffith"],
  },
  {
    slug: "queanbeyan",
    suburb: "Queanbeyan",
    state: "ACT",
    postcode: "2620",
    council: "Queanbeyan-Palerang Regional Council",
    keyRoads: ["Monaro Street", "Crawford Street", "Lowe Street", "Bungendore Road"],
    intro:
      "Queanbeyan is the major city on the NSW-ACT border, effectively part of the Canberra metropolitan area, where residential development, commercial construction and infrastructure upgrades create demand for traffic management plans compliant with Queanbeyan-Palerang Regional Council and Transport for NSW requirements.",
    bodyPara:
      "Focus Traffic Plans prepares Queanbeyan-Palerang Regional Council-compliant TMPs for Queanbeyan residential, commercial and infrastructure projects.",
    industries: ["Residential development", "Commercial and retail construction", "Infrastructure upgrades", "Utility maintenance", "Road and civil construction"],
    nearbySuburbs: ["Jerrabomberra", "Karabar", "Crestwood", "Greenleigh", "Googong", "Fyshwick", "Hume", "Pialligo", "Narrabundah", "Kingston"],
  },


{
    slug: "aldinga",
    suburb: "Aldinga",
    state: "SA",
    postcode: "5173",
    council: "City of Onkaparinga",
    keyRoads: ["Port Road", "Main South Road", "Aldinga Beach Road"],
    intro:
      "Aldinga, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Aldinga with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Seaford", "Christies Beach", "Morphett Vale", "Hallett Cove", "Noarlunga"],
  },

  {
    slug: "avoca-beach",
    suburb: "Avoca Beach",
    state: "NSW",
    postcode: "2251",
    council: "Central Coast Council",
    keyRoads: ["Avoca Drive", "Ocean View Road"],
    intro:
      "Avoca Beach, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Avoca Beach with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Terrigal", "Wamberal", "Gosford", "Copacabana", "Tuggerah"],
  },

  {
    slug: "bella-vista",
    suburb: "Bella Vista",
    state: "NSW",
    postcode: "2153",
    council: "The Hills Shire Council",
    keyRoads: ["Norwest Boulevard", "Elizabeth Macarthur Avenue"],
    intro:
      "Bella Vista, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Bella Vista with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Kellyville", "Castle Hill", "Rouse Hill", "Norwest", "Seven Hills"],
  },

  {
    slug: "bellarine",
    suburb: "Bellarine",
    state: "VIC",
    postcode: "3222",
    council: "City of Greater Geelong",
    keyRoads: ["Bellarine Highway", "High Street Drysdale"],
    intro:
      "Bellarine, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Bellarine with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Geelong CBD", "Ocean Grove", "Portarlington", "Torquay", "Armstrong Creek"],
  },

  {
    slug: "bendigo",
    suburb: "Bendigo",
    state: "VIC",
    postcode: "3550",
    council: "City of Greater Bendigo",
    keyRoads: ["Mitchell Street", "Lake Weeroona Parade"],
    intro:
      "Bendigo, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Bendigo with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Eaglehawk", "Kangaroo Flat", "Strathdale", "Golden Square"],
  },

  {
    slug: "bentleigh",
    suburb: "Bentleigh",
    state: "VIC",
    postcode: "3204",
    council: "City of Glen Eira",
    keyRoads: ["Centre Road", "Jasper Road"],
    intro:
      "Bentleigh, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Bentleigh with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Moorabbin", "Oakleigh", "McKinnon", "Brighton"],
  },

  {
    slug: "birkenhead",
    suburb: "Birkenhead",
    state: "SA",
    postcode: "5015",
    council: "City of Port Adelaide Enfield",
    keyRoads: ["Victoria Road", "Torrens Road"],
    intro:
      "Birkenhead, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Birkenhead with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Port Adelaide", "Woodville", "Semaphore", "Pennington"],
  },

  {
    slug: "bonython",
    suburb: "Bonython",
    state: "ACT",
    postcode: "2905",
    council: "ACT Government (City Services)",
    keyRoads: ["Drakeford Drive", "Sulwood Drive"],
    intro:
      "Bonython, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Bonython with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Gordon", "Calwell", "Isabella Plains"],
  },

  {
    slug: "booragoon",
    suburb: "Booragoon",
    state: "WA",
    postcode: "6154",
    council: "City of Melville",
    keyRoads: ["Canning Highway", "Marmion Street"],
    intro:
      "Booragoon, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Booragoon with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Riverton", "Rossmoyne", "Shelley"],
  },

  {
    slug: "campbell",
    suburb: "Campbell",
    state: "ACT",
    postcode: "2612",
    council: "ACT Government (City Services)",
    keyRoads: ["Constitution Avenue", "Northbourne Avenue"],
    intro:
      "Campbell, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Campbell with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Turner", "Braddon", "Dickson", "Ainslie"],
  },

  {
    slug: "chisholm",
    suburb: "Chisholm",
    state: "ACT",
    postcode: "2905",
    council: "ACT Government (City Services)",
    keyRoads: ["Hinder Street"],
    intro:
      "Chisholm, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Chisholm with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Gilmore", "Richardson"],
  },

  {
    slug: "collingwood-park",
    suburb: "Collingwood Park",
    state: "QLD",
    postcode: "4301",
    council: "Ipswich City Council",
    keyRoads: ["Redbank Plains Road"],
    intro:
      "Collingwood Park, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Collingwood Park with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Redbank Plains", "Ripley", "Springfield"],
  },

  {
    slug: "como",
    suburb: "Como",
    state: "WA",
    postcode: "6152",
    council: "City of South Perth",
    keyRoads: ["Canning Highway", "Henley Street"],
    intro:
      "Como, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Como with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["South Perth", "Manning"],
  },

  {
    slug: "crafers",
    suburb: "Crafers",
    state: "SA",
    postcode: "5152",
    council: "Adelaide Hills Council",
    keyRoads: ["Mount Barker Road"],
    intro:
      "Crafers, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Crafers with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Stirling", "Hahndorf", "Bridgewater"],
  },

  {
    slug: "currambine",
    suburb: "Currambine",
    state: "WA",
    postcode: "6028",
    council: "City of Joondalup",
    keyRoads: ["Mitchell Freeway", "Connolly Drive"],
    intro:
      "Currambine, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Currambine with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Joondalup", "Ocean Reef"],
  },

  {
    slug: "duncraig",
    suburb: "Duncraig",
    state: "WA",
    postcode: "6023",
    council: "City of Joondalup",
    keyRoads: ["Davallia Road"],
    intro:
      "Duncraig, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Duncraig with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Carine", "Kingsley"],
  },

  {
    slug: "dural",
    suburb: "Dural",
    state: "NSW",
    postcode: "2158",
    council: "Hornsby Shire Council / The Hills Shire Council",
    keyRoads: ["Old Northern Road"],
    intro:
      "Dural, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Dural with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Castle Hill", "Galston"],
  },

  {
    slug: "evatt",
    suburb: "Evatt",
    state: "ACT",
    postcode: "2617",
    council: "ACT Government (City Services)",
    keyRoads: ["William Slim Drive"],
    intro:
      "Evatt, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Evatt with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Melba", "Giralang"],
  },

  {
    slug: "fullarton",
    suburb: "Fullarton",
    state: "SA",
    postcode: "5063",
    council: "City of Unley",
    keyRoads: ["Fullarton Road"],
    intro:
      "Fullarton, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Fullarton with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Unley", "Parkside", "Kingston"],
  },

  {
    slug: "giralang",
    suburb: "Giralang",
    state: "ACT",
    postcode: "2617",
    council: "ACT Government (City Services)",
    keyRoads: ["Baldwin Drive"],
    intro:
      "Giralang, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Giralang with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Lyneham", "Kaleen"],
  },

  {
    slug: "glen-osmond",
    suburb: "Glen Osmond",
    state: "SA",
    postcode: "5064",
    council: "City of Burnside",
    keyRoads: ["Portrush Road"],
    intro:
      "Glen Osmond, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Glen Osmond with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Burnside", "Mount Osmond"],
  },

  {
    slug: "grange",
    suburb: "Grange",
    state: "SA",
    postcode: "5022",
    council: "City of Charles Sturt",
    keyRoads: ["Grange Road"],
    intro:
      "Grange, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Grange with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Henley Beach", "Seaton"],
  },

  {
    slug: "hahndorf",
    suburb: "Hahndorf",
    state: "SA",
    postcode: "5245",
    council: "District Council of Mount Barker",
    keyRoads: ["Main Street"],
    intro:
      "Hahndorf, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Hahndorf with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mount Barker", "Crafers"],
  },

  {
    slug: "hastings",
    suburb: "Hastings",
    state: "VIC",
    postcode: "3915",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Marine Parade"],
    intro:
      "Hastings, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Hastings with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Somerville", "Tyabb"],
  },

  {
    slug: "indooroopilly",
    suburb: "Indooroopilly",
    state: "QLD",
    postcode: "4068",
    council: "City of Brisbane",
    keyRoads: ["Station Road"],
    intro:
      "Indooroopilly, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Indooroopilly with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Fig Tree Pocket", "Taringa", "Toowong"],
  },

  {
    slug: "invermay",
    suburb: "Invermay",
    state: "TAS",
    postcode: "7248",
    council: "City of Launceston",
    keyRoads: ["Inveresk Road"],
    intro:
      "Invermay, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Invermay with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["East Launceston", "Youngtown"],
  },

  {
    slug: "ipswich",
    suburb: "Ipswich",
    state: "QLD",
    postcode: "4305",
    council: "Ipswich City Council",
    keyRoads: ["Limestone Street", "Woodend Road"],
    intro:
      "Ipswich, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Ipswich with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Brassall", "Booval", "Springfield", "Ripley"],
  },

  {
    slug: "kensington",
    suburb: "Kensington",
    state: "SA",
    postcode: "5068",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Magill Road"],
    intro:
      "Kensington, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Kensington with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Rose Park", "Trinity Gardens", "Marryatville"],
  },

  {
    slug: "kings-langley",
    suburb: "Kings Langley",
    state: "NSW",
    postcode: "2147",
    council: "Blacktown City Council",
    keyRoads: ["James Circuit"],
    intro:
      "Kings Langley, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Kings Langley with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Kellyville", "Stanhope Gardens"],
  },

  {
    slug: "kings-meadows",
    suburb: "Kings Meadows",
    state: "TAS",
    postcode: "7249",
    council: "City of Launceston",
    keyRoads: ["Hobart Road"],
    intro:
      "Kings Meadows, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Kings Meadows with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Prospect Vale", "South Launceston"],
  },

  {
    slug: "lyons",
    suburb: "Lyons",
    state: "ACT",
    postcode: "2606",
    council: "ACT Government (City Services)",
    keyRoads: ["Melrose Drive"],
    intro:
      "Lyons, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Lyons with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Woden", "Curtin", "Pearce"],
  },

  {
    slug: "macarthur",
    suburb: "Macarthur",
    state: "ACT",
    postcode: "2904",
    council: "ACT Government (City Services)",
    keyRoads: ["Hindmarsh Drive"],
    intro:
      "Macarthur, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Macarthur with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Gilmore"],
  },

  {
    slug: "macclesfield",
    suburb: "Macclesfield",
    state: "SA",
    postcode: "3782",
    council: "Shire of Yarra Ranges",
    keyRoads: ["Macclesfield Road"],
    intro:
      "Macclesfield, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Macclesfield with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Emerald"],
  },

  {
    slug: "macquarie",
    suburb: "Macquarie",
    state: "ACT",
    postcode: "2614",
    council: "ACT Government (City Services)",
    keyRoads: ["Belconnen Way"],
    intro:
      "Macquarie, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Macquarie with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Belconnen", "Cook"],
  },

  {
    slug: "mawson-lakes",
    suburb: "Mawson Lakes",
    state: "SA",
    postcode: "5095",
    council: "City of Salisbury",
    keyRoads: ["Elder Drive"],
    intro:
      "Mawson Lakes, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Mawson Lakes with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Pooraka", "Parafield Gardens"],
  },

  {
    slug: "mckellar",
    suburb: "Mckellar",
    state: "ACT",
    postcode: "2618",
    council: "ACT Government (City Services)",
    keyRoads: ["William Webb Drive"],
    intro:
      "Mckellar, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Mckellar with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Giralang"],
  },

  {
    slug: "mount-eliza",
    suburb: "Mount Eliza",
    state: "VIC",
    postcode: "3930",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Mount Eliza Way"],
    intro:
      "Mount Eliza, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Mount Eliza with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Moorooduc", "Frankston"],
  },

  {
    slug: "mowbray",
    suburb: "Mowbray",
    state: "TAS",
    postcode: "7248",
    council: "City of Launceston",
    keyRoads: ["Vermont Road"],
    intro:
      "Mowbray, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Mowbray with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Invermay", "Newstead"],
  },

  {
    slug: "mudgeeraba",
    suburb: "Mudgeeraba",
    state: "QLD",
    postcode: "4213",
    council: "City of Gold Coast",
    keyRoads: ["Somerset Drive"],
    intro:
      "Mudgeeraba, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Mudgeeraba with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Robina", "Varsity Lakes"],
  },

  {
    slug: "newnham",
    suburb: "Newnham",
    state: "TAS",
    postcode: "7248",
    council: "City of Launceston",
    keyRoads: ["Tamar Street"],
    intro:
      "Newnham, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Newnham with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mowbray", "George Town"],
  },

  {
    slug: "nicholls",
    suburb: "Nicholls",
    state: "ACT",
    postcode: "2913",
    council: "ACT Government (City Services)",
    keyRoads: ["Kelleway Avenue"],
    intro:
      "Nicholls, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Nicholls with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Gungahlin", "Taylor"],
  },

  {
    slug: "noosa",
    suburb: "Noosa",
    state: "QLD",
    postcode: "4567",
    council: "Noosa Council",
    keyRoads: ["David Low Way", "Noosa Parade"],
    intro:
      "Noosa, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Noosa with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Peregian Beach", "Marcoola", "Sunrise Beach"],
  },

  {
    slug: "norwest",
    suburb: "Norwest",
    state: "NSW",
    postcode: "2153",
    council: "The Hills Shire Council",
    keyRoads: ["Norwest Boulevard"],
    intro:
      "Norwest, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Norwest with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Kellyville", "Bella Vista"],
  },

  {
    slug: "ocean-reef",
    suburb: "Ocean Reef",
    state: "WA",
    postcode: "6027",
    council: "City of Joondalup",
    keyRoads: ["Ocean Reef Road"],
    intro:
      "Ocean Reef, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Ocean Reef with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mindarie", "Mullaloo"],
  },

  {
    slug: "pearce",
    suburb: "Pearce",
    state: "ACT",
    postcode: "2607",
    council: "ACT Government (City Services)",
    keyRoads: ["Hindmarsh Drive"],
    intro:
      "Pearce, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Pearce with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mawson", "Chifley"],
  },

  {
    slug: "pennington",
    suburb: "Pennington",
    state: "SA",
    postcode: "5013",
    council: "City of Charles Sturt",
    keyRoads: ["Grand Junction Road"],
    intro:
      "Pennington, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Pennington with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Woodville"],
  },

  {
    slug: "peregian-beach",
    suburb: "Peregian Beach",
    state: "QLD",
    postcode: "4573",
    council: "Sunshine Coast Council",
    keyRoads: ["David Low Way"],
    intro:
      "Peregian Beach, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Peregian Beach with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Coolum Beach", "Noosa Heads"],
  },

  {
    slug: "phillip",
    suburb: "Phillip",
    state: "ACT",
    postcode: "2606",
    council: "ACT Government (City Services)",
    keyRoads: ["O'Hagan Street"],
    intro:
      "Phillip, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Phillip with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mawson"],
  },

  {
    slug: "portsea",
    suburb: "Portsea",
    state: "VIC",
    postcode: "3944",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Point Nepean Road"],
    intro:
      "Portsea, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Portsea with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Rosebud"],
  },

  {
    slug: "quinns-rocks",
    suburb: "Quinns Rocks",
    state: "WA",
    postcode: "6030",
    council: "City of Wanneroo",
    keyRoads: ["Quinns Road"],
    intro:
      "Quinns Rocks, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Quinns Rocks with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Clarkson", "Mindarie"],
  },

  {
    slug: "ripley",
    suburb: "Ripley",
    state: "QLD",
    postcode: "4306",
    council: "Ipswich City Council",
    keyRoads: ["Ripley Valley Road"],
    intro:
      "Ripley, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Ripley with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Springfield"],
  },

  {
    slug: "riverside",
    suburb: "Riverside",
    state: "TAS",
    postcode: "7250",
    council: "City of Launceston",
    keyRoads: ["Rivers Edge Drive"],
    intro:
      "Riverside, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Riverside with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Newnham"],
  },

  {
    slug: "rosebud",
    suburb: "Rosebud",
    state: "VIC",
    postcode: "3939",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Point Nepean Road"],
    intro:
      "Rosebud, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Rosebud with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Dromana", "Rye"],
  },

  {
    slug: "rossmoyne",
    suburb: "Rossmoyne",
    state: "WA",
    postcode: "6148",
    council: "City of Melville",
    keyRoads: ["Riverton Reserve"],
    intro:
      "Rossmoyne, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Rossmoyne with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Bull Creek"],
  },

  {
    slug: "scullin",
    suburb: "Scullin",
    state: "ACT",
    postcode: "2614",
    council: "ACT Government (City Services)",
    keyRoads: ["Southern Cross Drive"],
    intro:
      "Scullin, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Scullin with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Florey", "Page"],
  },

  {
    slug: "shelley",
    suburb: "Shelley",
    state: "WA",
    postcode: "6148",
    council: "City of Melville",
    keyRoads: ["Somerly Drive"],
    intro:
      "Shelley, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Shelley with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Rossmoyne"],
  },

  {
    slug: "somerville",
    suburb: "Somerville",
    state: "VIC",
    postcode: "3912",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Frankston-Flinders Road"],
    intro:
      "Somerville, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Somerville with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Mornington"],
  },

  {
    slug: "sorrento",
    suburb: "Sorrento",
    state: "VIC",
    postcode: "3943",
    council: "Mornington Peninsula Shire",
    keyRoads: ["Ocean Beach Road"],
    intro:
      "Sorrento, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Sorrento with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Blairgowrie"],
  },

  {
    slug: "st-peters",
    suburb: "St Peters",
    state: "SA",
    postcode: "5069",
    council: "City of Norwood Payneham & St Peters",
    keyRoads: ["Stephen Terrace"],
    intro:
      "St Peters, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across St Peters with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Kensington"],
  },

  {
    slug: "stanley",
    suburb: "Stanley",
    state: "TAS",
    postcode: "7331",
    council: "Circular Head Council",
    keyRoads: ["Alexander Terrace"],
    intro:
      "Stanley, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Stanley with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Burnie"],
  },

  {
    slug: "stirling",
    suburb: "Stirling",
    state: "SA",
    postcode: "5152",
    council: "Adelaide Hills Council",
    keyRoads: ["Mount Barker Road"],
    intro:
      "Stirling, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Stirling with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Bridgewater", "Heathfield"],
  },

  {
    slug: "sunshine-coast",
    suburb: "Sunshine Coast",
    state: "QLD",
    postcode: "4567",
    council: "Sunshine Coast Regional Council services",
    keyRoads: ["Bruce Highway", "Nicklin Way", "Tanawha"],
    intro:
      "Sunshine Coast, QLD sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Sunshine Coast with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Maroochydore", "Caloundra", "Mooloolaba", "Buderim"],
  },

  {
    slug: "thornton",
    suburb: "Thornton",
    state: "NSW",
    postcode: "2322",
    council: "Maitland City Council",
    keyRoads: ["Nelson Street"],
    intro:
      "Thornton, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Thornton with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Maitland", "Beresfield"],
  },

  {
    slug: "trigg",
    suburb: "Trigg",
    state: "WA",
    postcode: "6029",
    council: "City of Stirling",
    keyRoads: ["West Coast Drive"],
    intro:
      "Trigg, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Trigg with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Karrinyup", "Scarborough"],
  },

  {
    slug: "wanniassa",
    suburb: "Wanniassa",
    state: "ACT",
    postcode: "2903",
    council: "ACT Government (City Services)",
    keyRoads: ["Sulwood Drive"],
    intro:
      "Wanniassa, ACT sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Wanniassa with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Erindale"],
  },

  {
    slug: "wheelers-hill",
    suburb: "Wheelers Hill",
    state: "VIC",
    postcode: "3150",
    council: "City of Monash",
    keyRoads: ["Ferntree Gully Road"],
    intro:
      "Wheelers Hill, VIC sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Wheelers Hill with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Glen Waverley", "Mulgrave"],
  },

  {
    slug: "willetton",
    suburb: "Willetton",
    state: "WA",
    postcode: "6155",
    council: "City of Canning",
    keyRoads: ["Garden Street"],
    intro:
      "Willetton, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Willetton with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Bull Creek"],
  },

  {
    slug: "winthrop",
    suburb: "Winthrop",
    state: "WA",
    postcode: "6150",
    council: "City of Melville",
    keyRoads: ["South Street"],
    intro:
      "Winthrop, WA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Winthrop with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Bull Creek"],
  },

  {
    slug: "woodville",
    suburb: "Woodville",
    state: "SA",
    postcode: "5011",
    council: "City of Charles Sturt",
    keyRoads: ["Port Road"],
    intro:
      "Woodville, SA sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Woodville with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Port Adelaide"],
  },

  {
    slug: "woy-woy",
    suburb: "Woy Woy",
    state: "NSW",
    postcode: "2256",
    council: "Central Coast Council",
    keyRoads: ["Brick Wharf Road"],
    intro:
      "Woy Woy, NSW sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Woy Woy with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Umina Beach", "Gosford"],
  },

  {
    slug: "youngtown",
    suburb: "Youngtown",
    state: "TAS",
    postcode: "7249",
    council: "City of Launceston",
    keyRoads: ["Inveresk Road"],
    intro:
      "Youngtown, TAS sees ongoing upgrades to local roads, services and suburban development — all of which routinely need compliant traffic guidance schemes, TMPs and road occupancy approvals.",
    bodyPara:
      "Focus Traffic Plans supports contractors and developers across Youngtown with permit-ready TMP and TGS documentation aligned to your local council and state road authority.",
    industries: ["Residential construction", "Commercial and retail works", "Utility and trenching upgrades", "Road resurfacing & maintenance", "Events and crane lift zones"],
    nearbySuburbs: ["Kings Meadows"],
  },

  {
    slug: "canberra-cbd",
    suburb: "Canberra CBD",
    state: "ACT",
    postcode: "2601",
    council: "ACT Government (City Services)",
    keyRoads: ["Northbourne Avenue", "Parkes Way", "Constitution Avenue", "London Circuit"],
    intro:
      "Canberra CBD is the nation's capital and a growing city centre, with ongoing government, commercial and light-rail-associated works requiring compliant traffic management plan documentation.",
    bodyPara:
      "Focus Traffic Plans prepares ACT-compliant TMP/TGS packs for Canberra CBD projects and fast-turnaround approvals where needed.",
    industries: ["Government projects", "Light rail precinct works", "Commercial fitouts", "Residential construction", "Utility upgrades", "Road maintenance"],
    nearbySuburbs: ["Civic", "Braddon", "Reid", "Barton", "Manuka", "Kingston"],
  },

  {
    slug: "hobart-cbd",
    suburb: "Hobart CBD",
    state: "TAS",
    postcode: "7000",
    council: "Hobart City Council",
    keyRoads: ["Macquarie Street", "Elizabeth Street", "Davey Street", "Liverpool Street"],
    intro:
      "Hobart CBD concentrates steep streets, harbour traffic and high pedestrian flows — TMPs and pedestrian control plans here must satisfy Hobart City Council and TasNetworks-related road approvals.",
    bodyPara:
      "Focus Traffic Plans provides Hobart-aligned TMP/TGS packages for CBD roadworks and building sites.",
    industries: ["Waterfront precinct works", "Heritage façade upgrades", "Commercial construction", "Events", "Road maintenance"],
    nearbySuburbs: ["Sandy Bay", "Battery Point", "North Hobart", "South Hobart", "Rosny Park"],
  },
];

/** Quick lookup: slug → location data */
export const locationBySlug = Object.fromEntries(
  locations.map((l) => [l.slug, l])
);

/**
 * Set of suburb names (lowercased) that have a dedicated location page.
 * Used by LocationsSection to decide whether to link to a page or /contact.
 */
export const suburbsWithPages = new Set(
  locations.map((l) => l.suburb.toLowerCase())
);

/**
 * Returns the /locations/:slug URL for a given suburb name, or null if no page exists.
 */
export function locationPageUrl(suburb) {
  const match = locations.find(
    (l) => l.suburb.toLowerCase() === suburb.toLowerCase()
  );
  return match ? `/locations/${match.slug}` : null;
}

export default locations;
